import React, { useMemo } from 'react';
import { type SyoLib, utils as syoUtils } from '@tildev-corp/syo-bilan';

type FrontV2Props = {
  lesionnel: SyoLib.LesionnelAvantV2;
};
type BackV2Props = {
  lesionnel: SyoLib.LesionnelArriereV2;
};
type FrontV2HandRightProps = {
  lesionnel: SyoLib.LesionnelMainDroiteAvantV2;
};
type BackV2HandRightProps = {
  lesionnel: SyoLib.LesionnelMainDroiteArriereV2;
};
type FrontV2HandLeftProps = {
  lesionnel: SyoLib.LesionnelMainGaucheAvantV2;
};
type BackV2HandLeftProps = {
  lesionnel: SyoLib.LesionnelMainGaucheArriereV2;
};
type FrontV2FootRightProps = {
  lesionnel: SyoLib.LesionnelPiedDroitAvantV2;
};
type BackV2FootRightProps = {
  lesionnel: SyoLib.LesionnelPiedDroitArriereV2;
};
type FrontV2FootLeftProps = {
  lesionnel: SyoLib.LesionnelPiedGaucheAvantV2;
};
type BackV2FootLeftProps = {
  lesionnel: SyoLib.LesionnelPiedGaucheArriereV2;
};
type FrontV2HeadProps = {
  lesionnel: SyoLib.LesionnelAvantTeteV2;
};

export function FrontV2({ lesionnel }: FrontV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_vector'>
        <path
          id='avant_coude_droit'
          d='M292 642L214 614.5L202 633L189.5 650L173 673L222.5 694L266.5 719.5L275.5 698L279 688L280.5 676.5L292 642Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_droit)}
        />
        <path
          id='avant_epaule_droit'
          d='M259.5 381L251.5 397.5L246 415L337 437.5L337.5 433V430.5L336.5 428L346 403.5L356 378L376 324H352.5H340L326.5 326L312 329.5L301 336L289 344L281 352.5L274 360.5L259.5 381Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_droit)}
        />
        <path
          id='avant_flanc_gauche'
          d='M665 813H554.5V680H652L652.5 700.5L653.5 721.5L655.5 734.5L658.5 748.5L660.5 769.5V780L662 792L665 813Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_gauche)}
        />
        <path
          id='avant_bassin_droit'
          d='M313 1010L311 1027.5L435 1044.5L444 957H504.5V925H326.213L325.5 932L322 951L319.5 970L315.5 991.5L313 1010Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_droit)}
        />
        <path
          id='avant_main_droit'
          d='M147 932.5L78.6 904.5L73.5 910L62.5 912.5L52.5 916.5L37.5 927L27.5 938L16 954L5 968.5L1 974.5L3.5 980.5L10 981.5L16 980L24 973.5L38.5 959.5L39.5 967L35 980L29 993.5L21 1011L15.5 1025.5L6.5 1046.5L4.5 1054L6 1058.5L9 1059L13.5 1055L22.5 1043.5L35 1028L48 1010.5L52.5 1011L51.5 1018L44.5 1038.5L38.2 1057L30.5 1081.5L32.5 1088.5L37.5 1090.5L43 1087.5L47 1081.5L55 1066L60.5 1051.5L67 1035L71 1025L76.5 1015L79 1015.5L80.5 1018L81 1023L79.5 1033L77.5 1043L72.5 1068.5L69.5 1084.5L70 1094.5L74 1098L79.5 1096.5L81.5 1092.5L85.5 1088L87 1082.5L93 1056.5L96.5 1040.5L101 1021L103.5 1019L107.5 1019.5L108.5 1025L109 1049L111 1072.5L113.5 1076.5L118.5 1077L121.5 1076L124 1073L125 1063.5L125.5 1040L126 1028L127 1016L129 1008L132 998L137.5 980L144.5 956.5L147 932.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_droit)}
        />
        <path
          id='avant_hypocondre_droit'
          d='M363 679L362 663L358.5 635.5L352 609L344.5 584L333.5 556.5L336.5 546V534.5H454.5V679H363Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_droit)}
        />
        <path
          id='avant_main_gauche'
          d='M930 895L866.5 918L864.5 918.5L865.5 931L868 945L871 956.5L873.5 966.5L877.5 980L880 992L883 1004L887.5 1015L889.5 1066.5L891.5 1073L897 1077L901 1076L903.5 1073.5L905 1064.5L906 1048.5V1034.5V1021L909.5 1019L913 1021L917.5 1039.5L920 1051L922.5 1063L927 1079.5L928 1087L932 1094L935.5 1096.5L940 1098L943.5 1096.5L944.5 1093V1086.5L942.5 1070L938.5 1052L935 1034.5L933.5 1024.5V1016.5L936.5 1015L939.5 1017.5L947.5 1033L954 1049L962 1068.5L966.5 1079.5L972 1088L977.5 1091L980.5 1090L983.5 1086.5L982 1076L977 1059.5L971.5 1043.5L967.5 1033L962.5 1016.5L962 1010.5L965.5 1010L970.5 1014.5L977.5 1024.5L990.5 1041.5L996.5 1049L1003.5 1056.5L1007.5 1059L1009.5 1057.5V1051.5L1007.5 1046L1002 1033L997 1020.5L988.5 1000L982 986L977 972L973.5 963L974 961.5L976 959.5L981 965L985.5 970.5L996.5 979L1005 981.5L1009.5 981L1011.5 979L1012.5 974.5L1008 967.5L995.5 951L986 936L981 930.5L974 924.5L965.5 918L954 912L944.5 911L940 909.5L937 906L930 895Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_gauche)}
        />
        <path
          id='avant_pied_droit'
          d='M369 1810H289.5L290.7 1819.5L292 1838L289.2 1850.1L282.7 1866.8L261.6 1895.7L255 1906.5L250.5 1921.5V1930L252.5 1937L258 1943.5L265.5 1946.9L273 1948.5L279 1948.9L289 1948.5L298 1946.9L305 1945.5H311L315 1948.5L320.5 1951.5L327 1953H333.5L340.5 1949.5L345 1944.5L347.9 1938.7L352.5 1926L354.5 1919.5L355.5 1912.5L356 1905.5V1898L354 1893L354.5 1888L356 1881L359 1874.8L361.5 1868.4V1860.4V1847L363 1836L366.5 1823.5L369.5 1817.5L369 1810Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_droit)}
        />
        <path
          id='avant_pied_gauche'
          d='M725 1813.5L645.5 1813.3L646 1819.5L648.5 1827.5L651.5 1835.5L653 1845L653.5 1854.5V1872.5L658 1884L659 1894.9V1911.5L661 1921.5L665.5 1936.5L670.5 1947L679.5 1953H688L699 1950L702 1947L706.5 1945L713.5 1947L719 1948L724 1948.5L731 1949.2L738 1948.1L750 1947L758.5 1941.5L762 1936.5L764.5 1925.6L762.5 1915.1L757.5 1905.1L753.5 1896.1L746.5 1887.6L736.5 1873.5L730 1863L725 1851.6L722 1838.6L723.5 1827.1L724 1819.6L725 1813.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_gauche)}
        />
        <path
          id='avant_epaule_gauche'
          d='M675.5 426.5L658 375.5L641.5 325L652 324L670.5 325L687.5 326L703 331L715.5 337.5L725 344L734.5 353L742.5 364L750.5 374.5L757.5 386L763.5 399L766 406.5L767 413L675.5 426.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_gauche)}
        />
        <path
          id='avant_coude_gauche'
          d='M798.5 613.5L718 634L726.5 656L733.5 678.5L738.5 694.5L745 709.5L843 678.5L821.5 644.5L798.5 613.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_gauche)}
        />
        <path
          id='avant_tete'
          d='M519.5 2.5L505 2L491.5 3.5L474.5 7.5L457 18.5L444 31.5L433.5 52.5L429.5 66.5L427 80.5L425.5 98.5L426.5 119L419.5 117.5L414.5 118.5L412 123.5L411.5 131.5L413 154.5L415.5 160.5L418.5 166L423 170L428 171.5L434 166L436.5 178L437.5 186.5L441.5 196L445 203L450.5 210L456.5 217L465.5 223L478 228L495 232L511.5 233L528.5 231.5L542.5 226L557 216.5L565.5 207.5L572 194.5L574 187L575.5 180L577.5 166.5L585 171.5L593 166.5L598 157.5L599 147L600 135L599.5 120.5L595 117.5H590.5L586 119L586.5 107L586 81.5L584.5 70L581.5 59L579.5 50.5L575.5 42.5L571.5 34L565.5 25.5L558.5 18.5L549.5 11.5L536.5 6L519.5 2.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <path
          id='avant_genou_gauche'
          d='M689.5 1314.5L567.5 1322.5L571 1347L573.5 1371L576 1383.5L580.5 1396L588.5 1414L595.5 1428.5L601.5 1446L604 1459.5L711 1446L696 1406L693.5 1392.5L692.5 1373.5L692 1356.5L689.5 1314.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_gauche)}
        />
        <path
          id='avant_genou_droit'
          d='M448.5 1320.5L325 1312L323 1344L322 1377.5L320.5 1393.5L319 1403.5L311 1424L300.5 1451.5L410 1466L411.5 1451.5L415.5 1438.5L421 1424.5L427.5 1411.5L438 1385L441.5 1366.5L448.5 1320.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_droit)}
        />
        <path
          id='avant_cuisse_gauche'
          d='M702.5 1029.5L515.2 1054V1099.5L521.5 1126.5L536 1185L545.5 1220.5L551.5 1239L555 1258.5L561 1290L566.5 1321.5L689.5 1313.5L688.5 1271L691.5 1244L694.5 1217L698.5 1175L700.5 1133.5L702.5 1092L704 1060.5L702.5 1029.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_gauche)}
        />
        <path
          id='avant_jambe_droit'
          d='M409.5 1466.5L300 1452L294 1471L289 1511L287.5 1551L289 1591.5L297 1677L299.5 1707V1734H345H363.5L376.5 1689.5L390 1633L405.5 1583L411.5 1546.5L409.5 1466.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_droit)}
        />
        <path
          id='avant_cuisse_droit'
          d='M325 1311L448.5 1320L456.5 1270L468 1220.5L476.5 1189L484.5 1158L494.5 1126L497.5 1102L499.5 1078.5L500 1054.5L310.5 1028L310 1043.5L311.5 1110.5L313.5 1139L314.5 1167L319 1218L325 1258L326 1284L325 1311Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_droit)}
        />
        <path
          id='avant_jambe_gauche'
          d='M711.5 1446.5L603.5 1460.5L605 1480.5L604 1501.5L602 1522.5V1543L604.5 1562.5L609 1583L623 1630L634.5 1675L640 1696.5L646 1717L651.5 1733.5H714.5L716 1698L719.5 1663.5L722.5 1623.5L724.5 1600.5L725.5 1577L727 1539.5L725 1513L723 1486.5L722 1476.5L718.5 1467.5L711.5 1446.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_gauche)}
        />
        <path
          id='avant_cheville_gauche'
          d='M651 1785.5L654.5 1777.5L657 1770.5L657.5 1760L654.5 1748.5L651 1734H714.5L714 1752L714.5 1765.5L718 1775L722 1788L723.5 1798.5L725.5 1812.5H645V1808.5L647.5 1798L651 1785.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_gauche)}
        />
        <path
          id='avant_genital'
          d='M436 1044.5L444.5 958H564.5L570 1046L515 1053.2L515.5 1034L514.5 1026.25L513.5 1018.5L510.5 1015.5L507 1014.5L504 1015L501.5 1017.5L498.5 1033.5L499.5 1053.5L436 1044.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genital)}
        />
        <path
          id='avant_avant_bras_gauche'
          d='M843.5 679L745 710.5L755 732L767 754.5L776 770.5L785 787L803 811L818.5 832.5L835 856L898 833L887.5 808.5L877 785.5L871.5 771.5L867.5 755.5L864 742L861.5 728L857.5 715L854 703L849 691L843.5 679Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_gauche)}
        />
        <path
          id='avant_cou'
          d='M465 223.5L452.5 214.5V255L452 261.5L449.3 268L432.8 285.8L409.8 300.2L387.8 315.6L378.3 319.6L369 323L644 324L624.5 314.5L604.1 301.2L587.1 290.3L573.5 277.5L563.1 263.6L562.1 244.8V229V212.5L551.5 221.5L538.5 228L528 232L517 233L508 233.5H499.5L489.5 232L481 230L473 227.5L465 223.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cou)}
        />
        <path
          id='avant_bras_droit'
          d='M336 438L245.5 416L245 425.5L244 434V448L245.5 481L246 496.5L244.5 505.5L242.5 513L235.5 533L230.5 553L223 591.5L214.5 614L293.5 641.5L314 597.5L323 577.5L333 557.5L336.5 547V525.5L335.5 492.5L336.5 465L337.5 448L336 438Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_droit)}
        />
        <path
          id='avant_cheville_droit'
          d='M292 1790L297 1774L300 1766V1755.5V1735H363L358 1756.5V1771.5L360 1777L364 1789.5L367 1799.5L369 1809.5H289L292 1790Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_droit)}
        />
        <path
          id='avant_avant_bras_droit'
          d='M221 694.5L173 674L164.5 689L154 717.5L149 742.5L140 778.5L125 811.5L112 842L140 853L173 866L194 833.5L219 801.5L233 783L243 760.5L265.5 719.5L221 694.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_droit)}
        />
        <path
          id='avant_hypocondre_gauche'
          d='M555 679V534.5H676.5L678 550L681.5 556L677.5 565.5L671.5 580.5L664 607L658.5 633L653.5 659L652 679H555Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_gauche)}
        />
        <path
          id='avant_bras_gauche'
          d='M766 414L676.5 427L676 433.5V440L677 452.5L678 479V517.5V536.5V548.5L681 556L685 564L689 573.5L698.5 593L707.5 613.5L718 633.5L799 612.5L795.5 605.5L790.5 588.5L786 563.5L782.5 549L780 536L774 518L768.5 498L770 465V438.5L766 414Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_gauche)}
        />
        <path
          id='avant_poignet_droit'
          d='M111.5 842.5L79 904L148 932L149 920.5L150 906L162.5 882L173 867L111.5 842.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_droit)}
        />
        <path
          id='avant_fosse_iliaque_gauche'
          d='M554.5 924V814H667L671.5 832L675 851.5L678.5 866L680.5 880.5L682 891L684 902L687.5 924H554.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_gauche)}
        />
        <path
          id='avant_flanc_droit'
          d='M454.5 813H348L351 796.5L354.5 773L356.5 753L358.5 735.5L362 712.4L363 694.5V680H454.5V813Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_droit)}
        />
        <path
          id='avant_fosse_iliaque_droit'
          d='M341.5 843.5L347.5 813.9H454.5V924H327.5L331 897L335 878.5L337.5 863L341.5 843.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_droit)}
        />
        <path
          id='avant_ombilicale'
          d='M554 813V680H505H457H455V813H554Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_ombilicale)}
        />
        <path
          id='avant_epigastrique'
          d='M554 534.5H455V679H554V534.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epigastrique)}
        />
        <path
          id='avant_buste_gauche'
          d='M505 533.5L507.5 324.5L640.5 325L649 350.5L657 375L671.5 417.5L676 430L675.5 433.5V440L676 453.5L676.5 480L677 507V533.5H505Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_gauche)}
        />
        <path
          id='avant_poignet_gauche'
          d='M852 881.5L836 856.5L899 833.5L914 862L922 877.5L930 894L865 918L864.5 906L861 897.5L852 881.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_gauche)}
        />
        <path
          id='avant_bassin_gauche'
          d='M505.5 925V957H565.5L571 1046L703 1028.5L702 1015L700.5 1006L700 1001L699 993L698 985L693.5 961L690.5 940.5L687.34 925H505.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_gauche)}
        />
        <path
          id='avant_buste_droit'
          d='M504 533.5H335.5V519.5V504L336 478.5L337 452V438.5L338 426L357.5 376.5L367 351L371.5 338.5L377 324L506.5 324.5L504 533.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_droit)}
        />
        <path
          id='avant_hypogastrique'
          d='M554 813.5L455.5 814L455 924H554V813.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypogastrique)}
        />
        <g id='Mannequin global V2'>
          <g id='Homme'>
            <g id='tete'>
              <path
                id='mannequin_tete'
                d='M586 119C586 119 602.6 0.899942 507.5 1.99995C412.4 3.09995 426.5 116.5 426.5 116.5L436.8 181.5C436.8 181.5 442.8 232.5 507.2 233C571.6 233.5 575.4 180 575.4 180L586 119Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='oreilles'>
              <path
                id='mannequin_oreille_gauche'
                d='M586 119C586 119 601 111.9 600 129.4C600 129.4 600.3 144.8 598.6 154.2C596.9 163.5 584.4 181 577.9 164.9'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_droite'
                d='M425.9 119C425.9 119 410.9 111.9 411.9 129.4C411.9 129.4 411.6 144.8 413.3 154.2C415 163.6 427.5 181 434 164.9'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='corps'>
              <g id='Calque 13'>
                <path
                  id='mannequin_corps_15'
                  d='M399.9 476.8C402.33 476.8 404.3 475.725 404.3 474.4C404.3 473.075 402.33 472 399.9 472C397.47 472 395.5 473.075 395.5 474.4C395.5 475.725 397.47 476.8 399.9 476.8Z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_14'
                  d='M614 477.2C616.651 477.2 618.8 475.991 618.8 474.5C618.8 473.009 616.651 471.8 614 471.8C611.349 471.8 609.2 473.009 609.2 474.5C609.2 475.991 611.349 477.2 614 477.2Z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_13'
                  d='M444 616.5L483 593'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_12'
                  d='M531 593L568 615'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_11'
                  d='M507.6 773.7C510.03 773.7 512 770.297 512 766.1C512 761.903 510.03 758.5 507.6 758.5C505.17 758.5 503.2 761.903 503.2 766.1C503.2 770.297 505.17 773.7 507.6 773.7Z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_10'
                  d='M470.3 526.5C470.3 526.5 409.6 539.1 359 497.3C359 497.3 341.7 464.7 338.8 431.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_9'
                  d='M38.5 959.5C38.5 959.5 41.2 962.2 39.5 967C37.8 971.8 29 993.5 29 993.5L6.50003 1046.5C6.50003 1046.5 -1.19997 1070.8 16 1051.6L37.8 1024L44.9 1013.5C44.9 1013.5 56.3 1000.7 51.5 1018C46.7 1035.3 39.1 1053.4 39.1 1053.4L32 1077.8C32 1077.8 29 1088.6 34 1090.1C34 1090.1 41 1095 48.6 1077.6L72.7 1020.9C72.7 1020.9 81.7 1006.2 81 1022.9L77.5 1042.9L71.4 1072.2L69.6 1086.3C69.6 1086.3 69.2 1095.7 74 1097.8C74 1097.8 81.7 1099.3 85.5 1087.8L90.1 1069.2L99.2 1028.7C99.2 1028.7 99.7 1019.9 104.7 1018.6C104.7 1018.6 109.4 1018.6 108.7 1029.2L108.8 1051.9C108.8 1051.9 108 1078.2 116.3 1077.1C116.3 1077.1 125.4 1078.3 125.3 1057.7L125.9 1025.4C125.9 1025.4 126.5 1018 127.2 1015.8C127.9 1013.6 133.7 992.8 133.7 992.8C133.7 992.8 147.4 944.1 148.1 933.3L150 906C150 906 151.2 898.8 164.5 878L186.4 845L204.8 820.4C204.8 820.4 221.7 798.2 231.1 785.2L260 730.7C260 730.7 276.2 699.6 279.8 682.4C279.8 682.4 284.7 655.2 298.9 629.5L312.5 601.6L332.8 556.4L336.4 549.6L335.7 496.4L338.8 438.8C338.8 438.8 341.7 422.4 327.6 421.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_8'
                  d='M332.9 556.2C332.9 556.2 340.3 570.1 347.8 596.7C355.3 623.3 362.2 667 362.2 667C362.2 667 363.7 703.3 357.7 744.7C357.7 744.7 354.6 785.5 345.1 824.5C335.6 863.5 323.6 944.2 323.6 944.2C323.6 944.2 312.1 1014 311.9 1018.2C311.7 1022.4 308.4 1061.2 313 1132.2C317.6 1203.2 321.9 1240.6 321.9 1240.6C321.9 1240.6 328 1258.2 325.1 1310.9C322.1 1363.6 320.6 1395.3 320.6 1395.3C320.6 1395.3 323 1395.3 310.6 1426.1C298.2 1456.9 292.2 1478.4 292.2 1478.4C292.2 1478.4 286.9 1532.3 287.8 1552.9C288.7 1573.5 289.2 1590.9 297.1 1688.9C297.1 1688.9 299.5 1693 300 1767.1C300 1767.1 291.1 1783.9 289.1 1809.4C289.1 1809.4 289.3 1819.4 291.8 1834.5C294.2 1849.6 282.8 1866.7 282.8 1866.7L261.7 1895.6C261.7 1895.6 241.5 1923.8 254.8 1940.2C268.1 1956.6 308.7 1944.6 308.7 1944.6C308.7 1944.6 336.1 1966.7 348.1 1938.6C360.1 1910.5 354.4 1893.2 354.4 1893.2C354.4 1893.2 354.2 1881.7 361.7 1868.4C361.7 1868.4 362.1 1863.3 361.7 1860.4C361.3 1857.5 359.5 1839.8 367.7 1822.1C367.7 1822.1 375.1 1812.5 357.9 1772.2C357.9 1772.2 355.7 1763.1 359.7 1748.5C363.7 1733.9 376.7 1689.4 376.7 1689.4L396.1 1616.3L405.6 1585C405.6 1585 415.1 1549.5 411.7 1516.3C408.3 1483.1 410.9 1457.6 410.9 1457.6C410.9 1457.6 410.8 1445.8 422.7 1420.9C434.6 1396 439.5 1385.2 441.5 1364.5C443.5 1343.8 453.2 1291.3 453.2 1291.3L464.1 1235C464.1 1235 493.7 1132.4 493.1 1128.1C493.1 1128.1 500.7 1102.1 500.1 1054.3C500.1 1054.3 495.6 1012.9 507.1 1014.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_7'
                  d='M452.5 212.5L451.7 245.3L452.5 259.7C452.5 259.7 450.5 267 444.9 273C439.3 279 430.9 288.1 414 297.7C397.1 307.3 402.3 307.6 374.5 322.2C374.5 322.2 370.6 325.6 336.1 324.9C336.1 324.9 305.3 324.1 278 355.3C278 355.3 249.2 389.8 246.4 416.1C246.4 416.1 241.9 443 244.4 473.1L245.8 490.7C245.8 490.7 247.4 502.8 237.2 526.8C237.2 526.8 233 539.2 228.9 563.2L221.6 594.6C221.6 594.6 217.9 612 205.5 626.4C205.5 626.4 192.2 643.9 177 666.5C177 666.5 171.8 673 163.1 695.9C163.1 695.9 157.3 708.2 153.2 729.5C153.2 729.5 145.7 765 139.9 778.7C134.1 792.4 121.1 821.4 121.1 821.4C121.1 821.4 113.2 838.5 109.5 845.2C105.7 852 90.5 881.4 90.5 881.4L76.1 908.8C76.1 908.8 72.2 911.5 63 911.6C53.8 911.7 31.2 932.7 31.2 932.7C31.2 932.7 30.2 933.4 15.6 955.3L6.10004 968.3C6.10004 968.3 -6.39996 984.3 14 980.4C14 980.4 24.1 976.1 33.2 964.7C34.3 963.3 35.7 962 37.2 960.8C37.6 960.5 38.1 960.1 38.6 959.8C39 959.5 39.5 959.2 39.9 958.9C50.5 952.2 65.6 950.5 65.6 950.5'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_6'
                  d='M544.3 526.5C544.3 526.5 605 539.1 655.6 497.3C655.6 497.3 672.9 464.7 675.8 431.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_5'
                  d='M976.1 959.5C976.1 959.5 973.4 962.2 975.1 967C976.8 971.8 985.6 993.5 985.6 993.5L1008.1 1046.5C1008.1 1046.5 1015.8 1070.8 998.6 1051.6L976.8 1024L969.7 1013.5C969.7 1013.5 958.3 1000.7 963.1 1018C967.9 1035.3 975.5 1053.4 975.5 1053.4L982.6 1077.8C982.6 1077.8 985.6 1088.6 980.6 1090.1C980.6 1090.1 973.6 1095 966 1077.6L941.9 1020.9C941.9 1020.9 932.9 1006.2 933.6 1022.9L937.1 1042.9L943.2 1072.2L945 1086.3C945 1086.3 945.4 1095.7 940.6 1097.8C940.6 1097.8 932.9 1099.3 929.1 1087.8L924.5 1069.2L915.4 1028.7C915.4 1028.7 914.9 1019.9 909.9 1018.6C909.9 1018.6 905.2 1018.6 905.9 1029.2L905.8 1051.9C905.8 1051.9 906.6 1078.2 898.3 1077.1C898.3 1077.1 889.2 1078.3 889.3 1057.7L888.7 1025.4C888.7 1025.4 888.1 1018 887.4 1015.8C886.7 1013.6 880.9 992.8 880.9 992.8C880.9 992.8 867.2 944.1 866.5 933.3L864.4 905.8C864.4 905.8 863.2 898.6 849.9 877.8L828 844.8L809.6 820.2C809.6 820.2 792.7 798 783.3 785L754.4 730.5C754.4 730.5 738.2 699.4 734.6 682.2C734.6 682.2 729.7 655 715.5 629.3L702 601.4L681.7 556.2L678.1 549.4L678.8 496.2L675.7 438.6C675.7 438.6 672.8 422.2 686.9 421.1'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_4'
                  d='M681.7 556.2C681.7 556.2 674.3 570.1 666.8 596.7C659.3 623.3 652.4 667 652.4 667C652.4 667 650.9 703.3 656.9 744.7C656.9 744.7 660 785.5 669.5 824.5C679 863.5 691 944.2 691 944.2C691 944.2 702.5 1014 702.7 1018.2C702.9 1022.4 706.2 1061.2 701.6 1132.2C696.9 1203.1 692.7 1240.6 692.7 1240.6C692.7 1240.6 686.6 1258.2 689.5 1310.9C692.5 1363.6 694 1395.3 694 1395.3C694 1395.3 691.6 1395.3 704 1426.1C716.4 1456.9 722.4 1478.4 722.4 1478.4C722.4 1478.4 727.7 1532.3 726.8 1552.9C725.9 1573.5 725.4 1590.9 717.5 1688.9C717.5 1688.9 715.1 1693 714.6 1767.1C714.6 1767.1 723.5 1783.9 725.5 1809.4C725.5 1809.4 725.3 1819.4 722.8 1834.5C720.4 1849.6 731.8 1866.7 731.8 1866.7L752.9 1895.6C752.9 1895.6 773.1 1923.8 759.8 1940.2C746.5 1956.6 705.9 1944.6 705.9 1944.6C705.9 1944.6 678.5 1966.7 666.5 1938.6C654.5 1910.5 660.2 1893.2 660.2 1893.2C660.2 1893.2 660.4 1881.7 652.9 1868.4C652.9 1868.4 652.5 1863.3 652.9 1860.4C653.3 1857.5 655.1 1839.8 646.9 1822.1C646.9 1822.1 639.5 1812.5 656.7 1772.2C656.7 1772.2 658.9 1763.1 654.9 1748.5C650.9 1733.9 637.9 1689.4 637.9 1689.4L618.5 1616.3L609 1585C609 1585 599.5 1549.5 602.9 1516.3C606.3 1483.1 603.7 1457.6 603.7 1457.6C603.7 1457.6 603.8 1445.8 591.9 1420.9C580 1396 575.1 1385.2 573.1 1364.5C571.1 1343.8 561.4 1291.3 561.4 1291.3L550.5 1235C550.5 1235 520.9 1132.4 521.5 1128.1C521.5 1128.1 513.9 1102.1 514.5 1054.3C514.5 1054.3 519 1012.9 507.5 1014.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_3'
                  d='M562.1 212.5L562.9 245.3L562.1 259.7C562.1 259.7 564.1 267 569.7 273C575.4 279 583.7 288.1 600.6 297.7C617.4 307.3 612.3 307.6 640.1 322.2C640.1 322.2 644 325.6 678.5 324.9C678.5 324.9 709.3 324.1 736.6 355.3C736.6 355.3 765.4 389.8 768.2 416.1C768.2 416.1 772.7 443 770.2 473.1L768.8 490.7C768.8 490.7 767.2 502.8 777.4 526.8C777.4 526.8 781.6 539.2 785.7 563.2L793 594.6C793 594.6 796.7 612 809.1 626.4C809.1 626.4 822.4 643.9 837.6 666.5C837.6 666.5 842.8 673 851.5 695.9C851.5 695.9 857.3 708.2 861.4 729.5C861.4 729.5 868.9 765 874.7 778.7C880.5 792.4 893.5 821.4 893.5 821.4C893.5 821.4 901.4 838.5 905.1 845.2C908.8 851.9 924.1 881.4 924.1 881.4L938.5 908.8C938.5 908.8 942.4 911.5 951.6 911.6C960.8 911.7 983.4 932.7 983.4 932.7C983.4 932.7 984.4 933.4 999 955.3L1008.5 968.3C1008.5 968.3 1021 984.3 1000.6 980.4C1000.6 980.4 990.5 976.1 981.4 964.7C980.3 963.3 978.9 962 977.4 960.8C977 960.5 976.5 960.1 976 959.8C975.6 959.5 975.1 959.2 974.7 958.9C964.1 952.2 949 950.5 949 950.5'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <g id='Calque 14'>
                  <path
                    id='mannequin_corps_2'
                    d='M418 333L477.8 334.5C477.8 334.5 491.9 333.7 489.7 343.6'
                    stroke='black'
                    strokeWidth='3'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    id='mannequin_corps_1'
                    d='M594.9 333L535.1 334.5C535.1 334.5 521 333.7 523.2 343.6'
                    stroke='black'
                    strokeWidth='3'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
              </g>
            </g>
            <g id='bouche'>
              <path
                id='mannequin_bouche_2'
                d='M539.1 182.9C501.6 191.2 475.5 183.3 475.5 183.3L503 176.1L507.1 177L512.1 176.1L539.1 182.9Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='bouche_1'>
                <path
                  id='mannequin_bouche_1'
                  d='M475.4 183.3C475.4 183.3 503.9 213.8 539 182.9'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='yeux'>
              <path
                id='mannequin_yeux_4'
                d='M456.1 104C456.1 104 471.3 85.8999 489 104C489 104 471.7 115.5 456.1 104Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_2'
                d='M472.5 109C475.041 109 477.1 106.09 477.1 102.5C477.1 98.91 475.041 95.9999 472.5 95.9999C469.96 95.9999 467.9 98.91 467.9 102.5C467.9 106.09 469.96 109 472.5 109Z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
              <path
                id='mannequin_yeux_2'
                d='M559.3 103.9C559.3 103.9 544.1 85.7999 526.4 103.9C526.4 103.9 543.7 115.4 559.3 103.9Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_1'
                d='M542.9 108.9C545.441 108.9 547.5 105.99 547.5 102.4C547.5 98.8101 545.441 95.8999 542.9 95.8999C540.36 95.8999 538.3 98.8101 538.3 102.4C538.3 105.99 540.36 108.9 542.9 108.9Z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
            </g>
            <g id='sourcils'>
              <path
                id='mannequin_sourcil_2'
                d='M455.6 78.1999C455.6 78.1999 472.7 71.2999 489.5 73.3999'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_sourcil_1'
                d='M559.9 78.1999C559.9 78.1999 542.8 71.2999 526 73.3999'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='nez'>
              <path
                id='mannequin_nez_4'
                d='M497.6 131.3L494.3 137.6L491 142.1C491 142.1 486.3 149.2 491.9 153.6'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_3'
                d='M517.4 131.8L520.7 138.1L524 142.6C524 142.6 528.7 149.7 523.1 154.1'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_2'
                d='M496 149.2C496 149.2 498.2 151.3 503 151'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_1'
                d='M519.3 149.2C519.3 149.2 517.1 151.3 512.3 151'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2({ lesionnel }: BackV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_vector'>
        <path
          id='arriere_lombaire_gauche'
          d='M359.5 728C359.5 728 360 724.5 361.005 714.5H506.972L506.045 832.302H343L346.5 816L350.5 797.5L354.5 769.5L357 749L359.5 728Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_gauche)}
        />
        <path
          id='arriere_poignet_droit'
          d='M860 895.5L848.724 875.078L905 846.5L916.06 865.473L925.5 884L938.5 908.5L869 946L866.5 937L865 924L864 907L860 895.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_droit)}
        />
        <path
          id='arriere_cheville_droit'
          d='M714 1724H648L657 1758.5L656.5 1771.5L651.5 1785.5L648.5 1794L646 1807.5L646.5 1821L648.5 1808.97L651.5 1801L658.5 1792.5L667.5 1787C670.5 1786 677 1785.5 680.5 1785.5C684.21 1785.5 686.403 1785.09 690 1786C692.711 1786.68 701.548 1790.16 704 1791.5C707.087 1793.19 712.262 1799.79 715 1802C718.215 1804.6 723.205 1816.38 723.5 1820.5L725.076 1816V1804L723 1792.5L719.5 1779L714 1767V1724Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_droit)}
        />
        <path
          id='arriere_jambe_gauche'
          d='M410 1489.1H291L287.5 1535.5V1557L289 1583L292.5 1633.5L296 1670.5L298 1699.5L299 1714.5V1725.5H332.039H365.931L368.5 1717L371 1708L375.5 1692L384.403 1655.05L397.5 1610L408.019 1572.83L410.5 1551.5L412 1531L410.5 1508.5L410 1489.1Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_gauche)}
        />
        <path
          id='arriere_pied_gauche'
          d='M292 1837L290 1823L292 1818L295 1811L299.5 1802L307 1794.5L315 1789L323 1786.5L332 1785L342 1786.5L350.5 1790L359 1799L363 1809.5L364 1821L363 1834L350 1934L345 1944.5L339.5 1950.5L329.5 1953L317 1950.5L308 1945L285 1948.5H272L261.5 1945.5L254.5 1941L251 1935L250 1926L251 1918L254.5 1908L259 1899.5L280 1870.5L288 1857L291 1845.5L292 1837Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_gauche)}
        />
        <path
          id='arriere_coude_droit'
          d='M731.608 671.863L727 655.5L807.5 625L815.5 634.5L830 655L840.5 670L848 687.5L750 722L743 708.5L735.5 687.5L731.608 671.863Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_droit)}
        />
        <path
          id='arriere_bassin_gauche'
          d='M506 919H327L328 914.5L329 909.5L330.5 899.5L333.5 880L337.5 861L343 833H506V919Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_gauche)}
        />
        <path
          id='arriere_coude_gauche'
          d='M286.5 656.5L211.5 618L191 647L180.5 661L171 677L260 730L272 704.5L279 684L280.894 673.869L286.5 656.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_gauche)}
        />
        <path
          id='arriere_tete'
          d='M412.5 121.5L411.5 129.5L412 149L413.5 157L416.5 163.5L421 169L426.579 171.979L430.5 170.5L434 165.5L436.5 182L442.965 199.146L452.965 215.146H562V210.5L567.5 203.5L572 195L574.5 185.5L578 166L580.5 170L585 172L592 167.5L597 159L599.5 145V123L596 118.5L589 117.847L585 120.5L586.5 105L586 85.5L584.5 71.5L581.5 57L576.5 44.5L572.044 35.5343L563 23L553 14.5L540.5 8L529.5 4.5L514 2H502L492.5 3L483 5L467.793 10.5329L455 19L444 31.5L437 44L430 63.5L426 84L425 102.5L427.113 120.354L422 117.847L415.5 118.5L412.5 121.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <path
          id='arriere_genou_droit'
          d='M692 1377H574L578.5 1390.5L583.5 1403.5L594.5 1427.5L600.5 1441.5L604 1460.5L604.702 1488.5H723.5L722 1478.5L712 1447.5L695.5 1406L693.923 1395L692 1377Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_droit)}
        />
        <path
          id='arriere_nuque'
          d='M561.744 216.116H452L451.5 236L452 261L447 270.5L439.5 278.5L430 286L420 294.5L408.5 300.5L606 300L590 290.5L576 278L569.5 272L564.5 265.5L562 258.5L562.5 242L561.744 216.116Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_nuque)}
        />
        <path
          id='arriere_cuisse_gauche'
          d='M496.956 1101H310.5L312.047 1125.5L315.565 1169.5L320 1224.5L321.5 1240.5L324.5 1257.5L326 1292L323 1346L321.5 1376H439L442.689 1351.22L451.231 1305.1L459.27 1255.96L478.364 1185.77L496.956 1108.56V1101Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_gauche)}
        />
        <path
          id='arriere_buste_gauche'
          d='M506.5 560.22H344.586H336.5L334 556L336.5 549L335.5 496L338.5 443.5L349.5 414.5L380.5 333L383.5 317.5L393 311.5L408 301.5L506.5 301.249V348.5V418.5V479V518V535V560.22Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_gauche)}
        />
        <path
          id='arriere_fesse_gauche'
          d='M506.177 920H327.5L322.5 947.5L318.5 974.5L311.5 1017L311 1100H497L499.5 1079.5V1051.5V1024L502 1015.5L506 1013.5V984L506.177 920Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_gauche)}
        />
        <path
          id='arriere_epaule_gauche'
          d='M338 442.5L246 417L248.5 405L253.5 393L266 371.5L278 355L287.5 345.5L299 337L307 332.5L315.5 329L324 326.5L332.5 325H350.5L369 324L382.5 318.5L380 332L338 442.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_gauche)}
        />
        <path
          id='arriere_bras_gauche'
          d='M244 432L246 418L337.5 443L335 500L336.5 548L332 557.5L328.5 564.5L324.5 574.5L317 590.5L301.5 623L293 639L286.5 655.5L212 617L219 603L222.5 589.5L229 560L232 546L235.5 531.5L241 517L244.5 502L246 494L245.219 485.5L243.5 470V453.5L244 432Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_gauche)}
        />
        <path
          id='arriere_avant_bras_gauche'
          d='M260 731L171 678L158.795 703.449L153.77 727.014L144.5 765.5L138 783.5L129.5 801.5L121.5 821L112 840L104 854.5L163.5 879L166.5 875L179.5 855L193.5 835L209 814L224.5 794L230.5 785.5L235.5 776L243.5 761.5L250 748.5L260 731Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_gauche)}
        />
        <path
          id='arriere_cuisse_droit'
          d='M693 1376H574.5L570.316 1345.21L567 1321.5L562.5 1299L556.5 1265.5L551 1237.5L546.5 1221.5L536 1183.5L529 1160L525.5 1143.5L521 1126.5L517.5 1109.5L516.5 1101H703.5L700 1154.5L693.5 1232.5L689.5 1260.5L688.5 1287L690.406 1337.68L693 1376Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_droit)}
        />
        <path
          id='arriere_jambe_droit'
          d='M723.5 1489H605.489L602 1524.5L602.5 1548L605.489 1570L609 1585.5L615.5 1605.5L620 1623.5L624.08 1639.01L630 1658.5L636 1681.5L641.5 1702L643.5 1708.5L645.5 1717L647.058 1723H715.027V1708.5L716.534 1691.65L720.554 1656.56L724.574 1621.46L725.5 1606.5L727.588 1540.74L726.583 1519.18L724.071 1504.14L723.5 1489Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_droit)}
        />
        <path
          id='arriere_genou_gauche'
          d='M438.5 1377H321L320.5 1397L314.5 1416.5L306.5 1436.46L291.5 1477.5L291 1488.1H409.024L409.5 1470.5L412 1446.5L419 1427L429 1407L436 1389.5L438.5 1377Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_gauche)}
        />
        <path
          id='arriere_bassin_droit'
          d='M507 919L506.5 833L671 832.5L680 880L686.5 919H507Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_droit)}
        />
        <path
          id='arriere_poignet_gauche'
          d='M163 879.5L104 855.5L95.5 871L87.5 885.5L82 897L76 908.5L68.5 911.5L60.5 912L145 950.5L147.5 935.5L150 905L163 879.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_gauche)}
        />
        <path
          id='arriere_main_droit'
          d='M874.5 970.5L869.174 946.597L938.5 909.5L944.5 911L953 911.5L959 914L970.5 922L981.5 931L990 941.5L996 950.5L1005.5 964L1011.5 973L1012.5 977.7L1009.98 980H1004.5L998.5 979.5L991.5 974.5L978.5 962L975 959L974 964.5L978.5 977.7L981.5 985.5L986.5 996.5L991.5 1009L997.414 1022.82L1001.94 1034.86L1006.46 1043.38L1009.5 1050.5V1054.5V1058L1006.46 1059L1000 1053.5L991 1043L980 1028L969 1013L964.251 1009H961.5L962 1014.5L964.5 1025L969.778 1040.87L975 1052.5L979 1066.5L981 1073.5L983 1080L983.5 1085L982.5 1088.5L978 1090.5L972.5 1089L965.5 1078L959.5 1064L953.5 1048.5L946.162 1032.35L940.5 1019L936.113 1014.5L933 1018L934.5 1028L936.113 1038.87L938.5 1051L941.64 1065.94L943.5 1076.5L944.5 1087.5L943.65 1093L941.64 1097.5L937 1097L932.5 1094.5L928.576 1088.5L925.561 1075.47L921.5 1059L917.5 1038.87L914 1023L911 1019H908L905.5 1024V1038.87V1061L903.5 1071L900 1077L895 1076.5L890 1069L888 1023L886 1011L880 991.5L874.5 970.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_droit)}
        />
        <path
          id='arriere_bras_droit'
          d='M685.5 565.5L677.5 549L678.5 498L676.5 447.5L769.5 433.5L770.5 447.5V467.5L768.5 491L769.5 503L778.5 530L784.5 556L790 583L795.5 603L800.5 614L807.5 624L726.5 655L722 643L716.5 632.5L703.5 606L694.5 585.5L685.5 565.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_droit)}
        />
        <path
          id='arriere_epaule_droit'
          d='M769.5 432.5L675.5 447L624.5 312.5L635.5 318.5L647 323L672 324H685.5L698 327.5L718.5 337.5L735.5 353.5L750.5 374.5L767.5 409.5L769.5 432.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_droit)}
        />
        <path
          id='arriere_cheville_gauche'
          d='M299.5 1767V1726.5H365.5L360 1745L357 1761.5V1771.5L360 1780.5L364.5 1792L367.5 1802.5L368.5 1812.5L367.5 1820.5L363.5 1827V1819.5L362 1807.5L358 1798L351 1791L340.5 1786L330 1785L319 1787.5L308.5 1793L299.5 1802.5L294 1812.5L290.5 1825.5L289 1816.5L289.5 1804.5L291.5 1791L296 1776.5L299.5 1767Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_gauche)}
        />
        <path
          id='arriere_main_gauche'
          d='M50.5 917L59.5 912.5L144.5 951L139 971L134.5 989.5L130 1005.5L127 1015L126 1023L124.5 1063.94L123.5 1070.5L120 1075.5L116.5 1077H113.5L110.5 1072L109 1063.94L108.5 1056.5V1044.88V1032.5L108 1022L105 1018.5L102.5 1019.5L98.5 1031L96.5 1039L94 1050L91.9664 1061.93L89 1073.5L85.5 1087L83 1093L78.5 1097L75 1098L71.5 1096L70 1092.5L69.5 1086.5L70 1080L71.5 1070.5L74 1058.42L76.3899 1044.88L78.5 1035.86L81 1020.5L79.5 1015L76.3899 1016.5L72.8727 1020.5L70.5 1026.33L67 1034.5L63 1042.5L55.5 1060L50.5 1072L45.7394 1082.5L39 1090.5H34L31.5 1088L30.5 1083.5L31.5 1078.5L33.6802 1072.96L36 1063.94L39 1053L42.9541 1043L45.7394 1035.86L48 1028.5L49.7591 1021.82L52.5 1011.5L51 1009L45 1013L39 1022.5L29 1034.5L20.5 1046L13 1054.5L8 1058.5L4.5 1058.42V1055V1050L7.5 1043L10 1037L12.5 1031L17.5 1020.5L22.5 1009L28 996L40 965L39 959.5L33 964L24.9605 973.025L18.5 977.5L13.5 980.5L9 981.21L4.5 980.5L2 978.5V973.5L6.5 967.673L13 958.5L19 950.5L24.5 941L31 932.5L41.5 924.5L50.5 917Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_gauche)}
        />
        <path
          id='arriere_dorsal_gauche'
          d='M344.5 586L335.5 564L334.5 561H506.5L507 713.5H361V708L361.5 668.5L360.5 657L355.5 633L351 610L344.5 586Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_gauche)}
        />
        <path
          id='arriere_buste_droit'
          d='M507.5 560V301.249L607.5 301L623.5 312.5L662 413.5L675 447.5L677 475L678.5 502L677 549L680.5 556.5L679.5 559.5L674.5 560H507.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_droit)}
        />
        <path
          id='arriere_dorsal_droit'
          d='M508 713.5L507.5 561.213L674.5 561L679.5 560.5L677 565L668.5 590.5L659.5 628.5L656 644L652.5 667V701L653 713L508 713.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_droit)}
        />
        <path
          id='arriere_avant_bras_droit'
          d='M762.5 746L750 723L848.5 688L853.5 701L858.23 716.485L864.5 743L869 763.5L877 784.5L905 846L848 874.5L828 845L811.5 822.5L793 798.5L782.5 784.5L772 764.5L762.5 746Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_droit)}
        />
        <path
          id='arriere_pied_droit'
          d='M651 1859.5L647.5 1825.5V1816L649.5 1803.5L653.5 1797L659 1792L666.5 1788L675 1785.5H685.5L697.5 1789L708.5 1795L716.5 1804.5L724.5 1818.5L722.5 1831.5V1845L727.5 1859.5L744 1883.5L758.5 1904.5L763.5 1921.5V1933L757 1943L745 1948.5H725.5L705 1944.5L693 1952.5H680.5L670 1946.5L662.5 1930L661 1920.5L651 1859.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_droit)}
        />
        <path
          id='arriere_fesse_droit'
          d='M687 920H507V1000.5V1014L512 1017L515 1025.5V1051.5V1078.5L517 1100H703L703.5 1076.5V1053L703 1030L702 1015.5L699 996L696.5 981.5L693.5 965L691 947L688.5 931.5L687 920Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_droit)}
        />
        <path
          id='arriere_lombaire_droit'
          d='M508 714.5L507 832L671 831.5L669 824.5L666.5 812L664 799L661.5 783.5L659.5 766.5L657.5 753.5L656 739L654.5 726.5L653 714L508 714.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_droit)}
        />
        <path
          id='arriere_colonne_haut'
          d='M521 217H492V300H521V217Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_haut)}
        />
        <path
          id='arriere_colonne_milieu_bas'
          d='M521.3 588.979H492.1V813.298H521.3V588.979Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_bas)}
        />
        <path
          id='arriere_colonne_milieu_haut'
          d='M521 322H492V573H521V322Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_haut)}
        />
        <path
          id='arriere_colonne_bas'
          d='M521.3 832.127H492.1V990.882H521.3V832.127Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_bas)}
        />
        <g id='Mannequin global V2'>
          <g id='Homme arri&#195;&#168;re'>
            <g id='t&#195;&#170;te   copie'>
              <path
                id='mannequin_corps_11'
                d='M561.79 211.202C573.99 196.602 575.19 180.002 575.19 180.002L585.69 119.002C585.69 119.002 602.29 0.902012 507.19 2.00201C412.09 3.10201 426.19 116.502 426.19 116.502L436.49 181.502C436.49 181.502 438.49 198.102 452.19 212.502'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='oreilles   copie'>
              <path
                id='mannequin_oreille_droit'
                d='M585.69 119.002C585.69 119.002 600.69 111.902 599.69 129.402C599.69 129.402 599.99 144.802 598.29 154.202C596.59 163.502 584.09 181.002 577.59 164.902'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_gauche'
                d='M425.59 119.002C425.59 119.002 410.59 111.902 411.59 129.402C411.59 129.402 411.29 144.802 412.99 154.202C414.69 163.602 427.19 181.002 433.69 164.902'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='corps   copie'>
              <g id='Calque 13   copie 2'>
                <path
                  id='mannequin_corps_8'
                  d='M38.1903 959.502C38.1903 959.502 40.8903 962.202 39.1903 967.002C37.4903 971.802 28.6903 993.502 28.6903 993.502L6.19034 1046.5C6.19034 1046.5 -1.50966 1070.8 15.6903 1051.6L37.4903 1024L44.5903 1013.5C44.5903 1013.5 55.9903 1000.7 51.1903 1018C46.3903 1035.3 38.7903 1053.4 38.7903 1053.4L31.6903 1077.8C31.6903 1077.8 28.6903 1088.6 33.6903 1090.1C33.6903 1090.1 40.6903 1095 48.2903 1077.6L72.3903 1020.9C72.3903 1020.9 81.3903 1006.2 80.6903 1022.9L77.1903 1042.9L71.0903 1072.2L69.2903 1086.3C69.2903 1086.3 68.8903 1095.7 73.6903 1097.8C73.6903 1097.8 81.3903 1099.3 85.1903 1087.8L89.7903 1069.2L98.8903 1028.7C98.8903 1028.7 99.3903 1019.9 104.39 1018.6C104.39 1018.6 109.09 1018.6 108.39 1029.2L108.49 1051.9C108.49 1051.9 107.69 1078.2 115.99 1077.1C115.99 1077.1 125.09 1078.3 124.99 1057.7L125.59 1025.4C125.59 1025.4 126.19 1018 126.89 1015.8C127.59 1013.6 133.39 992.802 133.39 992.802C133.39 992.802 147.09 944.102 147.79 933.302L149.69 906.002C149.69 906.002 150.89 898.802 164.19 878.002L186.09 845.002L204.49 820.402C204.49 820.402 221.39 798.202 230.79 785.202L259.69 730.702C259.69 730.702 275.89 699.602 279.49 682.402C279.49 682.402 284.39 655.202 298.59 629.502L312.19 601.602L332.49 556.402L336.09 549.602L335.39 496.402L338.49 438.802C338.49 438.802 341.39 422.402 327.29 421.302'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_7'
                  d='M363.69 1831.6C364.59 1828.5 365.69 1825.3 367.19 1822.1C367.19 1822.1 374.59 1812.5 357.39 1772.2C357.39 1772.2 355.19 1763.1 359.19 1748.5C363.19 1733.9 376.19 1689.4 376.19 1689.4L395.59 1616.3L405.09 1585C405.09 1585 414.59 1549.5 411.19 1516.3C407.79 1483.1 410.39 1457.6 410.39 1457.6C410.39 1457.6 410.29 1445.8 422.19 1420.9C434.09 1396 438.99 1385.2 440.99 1364.5C442.99 1343.8 452.69 1291.3 452.69 1291.3L463.59 1235C463.59 1235 493.19 1132.4 492.59 1128.1C492.59 1128.1 500.19 1102.1 499.59 1054.3C499.59 1054.3 495.09 1012.9 506.59 1014.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_6'
                  d='M332.59 556.202C332.59 556.202 339.99 570.102 347.49 596.702C354.99 623.302 361.89 667.002 361.89 667.002C361.89 667.002 363.39 703.302 357.39 744.702C357.39 744.702 354.29 785.502 344.79 824.502C335.29 863.502 323.29 944.202 323.29 944.202C323.29 944.202 311.79 1014 311.59 1018.2C311.39 1022.4 308.09 1061.2 312.69 1132.2C317.29 1203.2 321.59 1240.6 321.59 1240.6C321.59 1240.6 327.69 1258.2 324.79 1310.9C321.79 1363.6 320.29 1395.3 320.29 1395.3C320.29 1395.3 322.69 1395.3 310.29 1426.1C297.89 1456.9 291.89 1478.4 291.89 1478.4C291.89 1478.4 286.59 1532.3 287.49 1552.9C288.39 1573.5 288.89 1590.9 296.79 1688.9C296.79 1688.9 299.19 1693 299.69 1767.1C299.69 1767.1 290.79 1783.9 288.79 1809.4C288.79 1809.4 288.99 1819.4 291.49 1834.5C293.89 1849.6 282.49 1866.7 282.49 1866.7L261.39 1895.6C261.39 1895.6 241.19 1923.8 254.49 1940.2C267.79 1956.6 308.39 1944.6 308.39 1944.6C308.39 1944.6 335.79 1966.7 347.79 1938.6'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_5'
                  d='M452.19 212.502L451.39 245.302L452.19 259.702C452.19 259.702 450.19 267.002 444.59 273.002C438.99 279.002 430.59 288.102 413.69 297.702C396.79 307.302 401.99 307.602 374.19 322.202C374.19 322.202 370.29 325.602 335.79 324.902C335.79 324.902 304.99 324.102 277.69 355.302C277.69 355.302 248.89 389.802 246.09 416.102C246.09 416.102 241.59 443.002 244.09 473.102L245.49 490.702C245.49 490.702 247.09 502.802 236.89 526.802C236.89 526.802 232.69 539.202 228.59 563.202L221.29 594.602C221.29 594.602 217.59 612.002 205.19 626.402C205.19 626.402 191.89 643.902 176.69 666.502C176.69 666.502 171.49 673.002 162.79 695.902C162.79 695.902 156.99 708.202 152.89 729.502C152.89 729.502 145.39 765.002 139.59 778.702C133.79 792.402 120.79 821.402 120.79 821.402C120.79 821.402 112.89 838.502 109.19 845.202C105.39 852.002 90.1903 881.402 90.1903 881.402L75.7903 908.802C75.7903 908.802 71.8903 911.502 62.6903 911.602C53.4903 911.702 30.8903 932.702 30.8903 932.702C30.8903 932.702 29.8903 933.402 15.2903 955.302L5.79034 968.302C5.79034 968.302 -6.70966 984.302 13.6903 980.402C13.6903 980.402 23.7903 976.102 32.8903 964.702C33.9903 963.302 35.3903 962.002 36.8903 960.802C37.2903 960.502 37.7903 960.102 38.2903 959.802C38.6903 959.502 39.1903 959.202 39.5903 958.902C50.1903 952.202 65.2903 950.502 65.2903 950.502'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_4'
                  d='M975.79 959.502C975.79 959.502 973.09 962.202 974.79 967.002C976.49 971.802 985.29 993.502 985.29 993.502L1007.79 1046.5C1007.79 1046.5 1015.49 1070.8 998.29 1051.6L976.49 1024L969.39 1013.5C969.39 1013.5 957.99 1000.7 962.79 1018C967.59 1035.3 975.19 1053.4 975.19 1053.4L982.29 1077.8C982.29 1077.8 985.29 1088.6 980.29 1090.1C980.29 1090.1 973.29 1095 965.69 1077.6L941.59 1020.9C941.59 1020.9 932.59 1006.2 933.29 1022.9L936.79 1042.9L942.89 1072.2L944.69 1086.3C944.69 1086.3 945.09 1095.7 940.29 1097.8C940.29 1097.8 932.59 1099.3 928.79 1087.8L924.19 1069.2L915.09 1028.7C915.09 1028.7 914.59 1019.9 909.59 1018.6C909.59 1018.6 904.89 1018.6 905.59 1029.2L905.49 1051.9C905.49 1051.9 906.29 1078.2 897.99 1077.1C897.99 1077.1 888.89 1078.3 888.99 1057.7L888.39 1025.4C888.39 1025.4 887.79 1018 887.09 1015.8C886.39 1013.6 880.59 992.802 880.59 992.802C880.59 992.802 866.89 944.102 866.19 933.302L864.09 905.802C864.09 905.802 862.89 898.602 849.59 877.802L827.69 844.802L809.29 820.202C809.29 820.202 792.39 798.002 782.99 785.002L754.09 730.502C754.09 730.502 737.89 699.402 734.29 682.202C734.29 682.202 729.39 655.002 715.19 629.302L701.69 601.402L681.39 556.202L677.79 549.402L678.49 496.202L675.39 438.602C675.39 438.602 672.49 422.202 686.59 421.102'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_3'
                  d='M647.59 1824C647.29 1823.4 647.09 1822.8 646.79 1822.1C646.79 1822.1 639.39 1812.5 656.59 1772.2C656.59 1772.2 658.79 1763.1 654.79 1748.5C650.79 1733.9 637.79 1689.4 637.79 1689.4L618.39 1616.3L608.89 1585C608.89 1585 599.39 1549.5 602.79 1516.3C606.19 1483.1 603.59 1457.6 603.59 1457.6C603.59 1457.6 603.69 1445.8 591.79 1420.9C579.89 1396 574.99 1385.2 572.99 1364.5C570.99 1343.8 561.29 1291.3 561.29 1291.3L550.39 1235C550.39 1235 520.79 1132.4 521.39 1128.1C521.39 1128.1 513.79 1102.1 514.39 1054.3C514.39 1054.3 518.89 1012.9 507.39 1014.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_2'
                  d='M681.39 556.202C681.39 556.202 673.99 570.102 666.49 596.702C658.99 623.302 652.09 667.002 652.09 667.002C652.09 667.002 650.59 703.302 656.59 744.702C656.59 744.702 659.69 785.502 669.19 824.502C678.69 863.502 690.69 944.202 690.69 944.202C690.69 944.202 702.19 1014 702.39 1018.2C702.59 1022.4 705.89 1061.2 701.29 1132.2C696.59 1203.1 692.39 1240.6 692.39 1240.6C692.39 1240.6 686.29 1258.2 689.19 1310.9C692.19 1363.6 693.69 1395.3 693.69 1395.3C693.69 1395.3 691.29 1395.3 703.69 1426.1C716.09 1456.9 722.09 1478.4 722.09 1478.4C722.09 1478.4 727.39 1532.3 726.49 1552.9C725.59 1573.5 725.09 1590.9 717.19 1688.9C717.19 1688.9 714.79 1693 714.29 1767.1C714.29 1767.1 723.19 1783.9 725.19 1809.4C725.19 1809.4 724.99 1819.4 722.49 1834.5C720.09 1849.6 731.49 1866.7 731.49 1866.7L752.59 1895.6C752.59 1895.6 772.79 1923.8 759.49 1940.2C746.19 1956.6 705.59 1944.6 705.59 1944.6C705.59 1944.6 678.19 1966.7 666.19 1938.6C663.59 1932.6 661.89 1927 660.69 1922.1'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_1'
                  d='M561.79 211.202L562.59 244.002L561.79 258.402C561.79 258.402 563.79 265.702 569.39 271.702C575.09 277.702 583.39 286.802 600.29 296.402C617.19 306.002 611.99 306.302 639.79 321.002C639.79 321.002 643.69 324.402 678.19 323.702C678.19 323.702 708.99 322.902 736.29 354.102C736.29 354.102 765.09 388.702 767.89 415.002C767.89 415.002 772.39 442.002 769.89 472.102L768.49 489.702C768.49 489.702 766.89 501.802 777.09 525.902C777.09 525.902 781.29 538.302 785.39 562.302L792.69 593.702C792.69 593.702 796.39 611.102 808.79 625.602C808.79 625.602 822.09 643.102 837.29 665.802C837.29 665.802 842.49 672.402 851.19 695.202C851.19 695.202 856.99 707.502 861.09 728.802C861.09 728.802 868.59 764.302 874.39 778.102C880.19 791.802 893.19 820.902 893.19 820.902C893.19 820.902 901.09 838.002 904.79 844.802C908.59 851.602 923.79 881.102 923.79 881.102L938.19 908.502C938.19 908.502 942.09 911.202 951.29 911.302C960.49 911.402 983.09 932.402 983.09 932.402C983.09 932.402 984.09 933.102 998.69 955.002L1008.19 968.002C1008.19 968.002 1020.69 984.102 1000.29 980.102C1000.29 980.102 990.19 975.802 981.09 964.302C979.99 962.902 978.59 961.602 977.09 960.402C976.69 960.102 976.19 959.702 975.69 959.402C975.29 959.102 974.79 958.802 974.39 958.502C963.79 951.802 948.69 950.002 948.69 950.002'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <path
              id='mannequin_corps_10'
              d='M290.49 1825.2C298.69 1784.5 330.49 1785 330.49 1785C330.49 1785 366.89 1781.8 363.39 1825.9C359.89 1870 349.49 1934.5 349.49 1934.5C349.49 1934.5 349.29 1936.5 346.89 1940.7C344.49 1944.9 346.89 1940.7 346.89 1940.7'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='mannequin_corps_9'
              d='M661.99 1927.2C661.99 1927.2 651.09 1865.9 647.39 1824C643.69 1782.1 681.99 1785.2 681.99 1785.2C681.99 1785.2 715.49 1784.7 724.09 1823.4'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2Female({ lesionnel }: FrontV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_vector_f'>
        <path
          id='avant_coude_droit'
          d='M292 643L214 615.5L204 634.5L194 653L181 677.5L222.5 695L266.5 720.5L275.5 699L279 689L281.5 677.5L292 643Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_droit)}
        />
        <path
          id='avant_epaule_droit'
          d='M269 383L262 400.5L256.5 418L338 439V433L337 427L346 404.5L356 379L376 325H352.5H340L326.5 327.5L311 334.5L301.5 341.5L296 347L288.5 354L280 365.5L269 383Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_droit)}
        />
        <path
          id='avant_flanc_gauche'
          d='M667 814H554.5V681H652L652.5 701.5L654 722.5L655.5 735.5L657.5 749.5L660 770.5L661 781L662.5 793L667 814Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_gauche)}
        />
        <path
          id='avant_bassin_droit'
          d='M313 1011L311.5 1028.5L435 1045.5L444 958H504.5V926H326.5L325.5 933L322.5 952L319.5 971L315.5 992L313 1011Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_droit)}
        />
        <path
          id='avant_main_droit'
          d='M147 933.5L78.6 905.5L73.5 911L62.5 913.5L52.5 917.5L37.5 928L27.5 939L16 955L5 969.5L1 975.5L3.5 981.5L10 982.5L16 981L24 974.5L38.5 960.5L39.5 968L35 981L29 994.5L21 1012L15.5 1026.5L6.5 1047.5L4.5 1055L6 1059.5L9 1060L13.5 1056L22.5 1044.5L35 1029L48 1011.5L52.5 1012L51.5 1019L44.5 1039.5L38.2 1058L30.5 1082.5L32.5 1089.5L37.5 1091.5L43 1088.5L47 1082.5L55 1067L60.5 1052.5L67 1036L71 1026L76.5 1016L79 1016.5L80.5 1019L81 1024L79.5 1034L77.5 1044L72.5 1069.5L69.5 1085.5L70 1095.5L74 1099L79.5 1097.5L81.5 1093.5L85.5 1089L87 1083.5L93 1057.5L96.5 1041.5L99.5 1027L103 1025.5H106.5L108.5 1029L109 1050L111 1073.5L113.5 1077.5L118.5 1078L121.5 1077L124 1074L125 1064.5L125.5 1041L126 1029L127 1017L129 1009L132 999L137.5 981L144.5 957.5L147 933.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_droit)}
        />
        <path
          id='avant_hypocondre_droit'
          d='M363 680L362 664L358.5 636.5L352 610L343.5 585L335.5 561.5L332 556V554.5H341L454.5 555V680H363Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_droit)}
        />
        <path
          id='avant_main_gauche'
          d='M931 895.5L866.5 919L865.5 919.25L866.5 931.75L868 945.5L871 957L873.5 967L877.5 981L880.5 993L884 1005L887.5 1017.5L888.5 1025L889.5 1067L891.5 1074L896.5 1078L901 1077L903.5 1073.5L906 1063V1035L907 1022L909.5 1019.5L913 1022L917.5 1037.5L920.5 1052L923 1063.5L927 1079.5L928.5 1087.5L932 1095L935.5 1097.5L940 1099L942.5 1097.5L944.5 1094V1087.5L942.5 1071.5L938.5 1053L935 1035.5L933.5 1025V1017.5L936.5 1016L939.5 1018.5L946.5 1032.5L953.5 1050L962 1069.5L972 1089L977.5 1092L980.5 1091L983.5 1087.5L982 1077L977 1061L972 1044.5L967.5 1034L962 1018V1011.5L965.5 1011L974.5 1021L986 1036.5L997 1050L1003 1057.5L1007.5 1060L1009.5 1059V1053L1007.5 1046.5L1002 1034L997 1021.5L988 1001.5L982 987L978 976L975.5 970.5L974.5 964.5L976.5 960.5L981 966L986 971L996.5 979.5L1005 982.5L1009.5 982L1011.5 979.5L1012.5 975.5L1008 969L995.5 952L984.5 935L977.5 928L963.5 918L954 912.5L944.5 912L940 910.5L937 907L931 895.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_gauche)}
        />
        <path
          id='avant_pied_droit'
          d='M369 1811H289.5V1820.5L292 1839L290.5 1851L282.7 1867.8L261.6 1896.7L255 1907.5L250.5 1922.5L250 1930.5L252.5 1938L257 1944.5L265.5 1947.9L273 1949.9H279H290.5L298.5 1947.9L308.5 1945.5L313.5 1949L324 1953L333.5 1954L340 1951L347.9 1939.7L352 1930L354 1921L355.5 1913L356 1906.5L355 1899V1889.5L359 1875.8L361.5 1869.4V1861.4V1847.5L363.5 1836.5L366 1826.5L369 1819V1811Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_droit)}
        />
        <path
          id='avant_pied_gauche'
          d='M725 1814.3H645.5L646 1820.5L648.5 1828.5L651.5 1836.5L653 1846L653.5 1855.5L653 1867L656.5 1878L660.5 1890.5L659 1901.5V1911L660.5 1923L665.5 1938L670.5 1948L679.5 1954L688.5 1954.1L699 1951L702.5 1948L705.5 1946.6H709L715.5 1948L724 1949.5L731 1950.2L738.5 1949.5L750 1948L757.5 1944L761.5 1939.5L763.5 1934L764.5 1926.6L762.5 1916.1L758.5 1906L753.5 1897.1L746.5 1888.6L737 1875.5L729.5 1864L725 1852.6L722 1839.6L723.5 1828.1L725 1820.5V1814.3Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_gauche)}
        />
        <path
          id='avant_epaule_gauche'
          d='M676.5 437.5L657 379.5L641.5 326L652 325L670.5 324.5L687.5 327L702 333.5L712.5 341.5L722.5 351L730 359.5L738.5 371L744.5 382.5L750 395.5L754.5 407L760.5 426L676.5 437.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_gauche)}
        />
        <path
          id='avant_coude_gauche'
          d='M799.5 614L718 635L723 646L727 657L731 668L733.5 679.5L738 695.5L745 710.5L836 682L817 646.5L799.5 614Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_gauche)}
        />
        <path
          id='avant_tete'
          d='M522.5 43.5L513 32.5L507.5 27.5L485 51L466.5 64.5L445.5 74L427.5 76L426.5 85L425.5 101L426.5 119.5L421 119H415.5L412 124V139.5L413 154.5L417 164L423 171L429 173L434 167L436 179L437.5 186.5L441 197L445 204L451 212.5L457.5 218.5L465 223.5L477 229L495 233L511.5 234L528.5 231.5L543 227.5L557.5 217L564.5 209L571.5 195.5L574 188L575.5 181L576.5 173L578 166.5L581.5 170.5L586 173L590 170.5L593.5 167L598 160L600.5 152L601 136V128.5L599.517 122L597 120L592 118.5L586 120L587 107.5L586 82.5L585 75L575.5 74L566 71.5L559.5 68.5L544 60L533 52.5L522.5 43.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <path
          id='avant_genou_gauche'
          d='M689.5 1315L567.5 1323.79L571.5 1348.29L574 1372L576.5 1384.5L580.5 1397L588.5 1414L595.5 1429.5L601.5 1447.5L604.5 1460.5L710.5 1447L696 1407L693.5 1393.5L692.5 1374.5L692 1357.5L689.5 1315Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_gauche)}
        />
        <path
          id='avant_genou_droit'
          d='M448.5 1321.5L325 1313L322.5 1345L322 1378.5L319 1404.5L311 1425L299.5 1452L410 1467V1452L415.5 1439.5L428.5 1412.5L438.5 1386L441.5 1367.5L448.5 1321.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_droit)}
        />
        <path
          id='avant_cuisse_gauche'
          d='M702.5 1030.5L515.2 1055L516.5 1100L521.5 1127.5L536 1186L546.5 1221.5L551.5 1239L555 1259L561 1290.5L567 1323L689.5 1314.5L688.5 1293L689.5 1272L690.5 1257L693 1241.5L695 1218.5L698.5 1176L701.5 1134.5L703.5 1093.5L704 1061.5L702.5 1030.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_gauche)}
        />
        <path
          id='avant_jambe_droit'
          d='M409.5 1467.5L300 1453L294 1472L289 1512L287.5 1552L289 1592.5L297 1678L299.5 1708V1735H345H363.5L376.5 1690.5L390 1634L405.5 1584L411.5 1547.5L409.5 1467.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_droit)}
        />
        <path
          id='avant_cuisse_droit'
          d='M325 1312L448.5 1321L456.5 1271L468 1221.5L476.5 1190L484.5 1159L494.5 1127L497.5 1103L499.5 1079.5L500 1055.5L310.5 1029L310 1044.5L311.5 1111.5L313.5 1140L314.5 1168L319 1219L325 1259L326 1285L325 1312Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_droit)}
        />
        <path
          id='avant_jambe_gauche'
          d='M711.5 1447.5L604 1461L605 1495.5L602.5 1521.5V1544L604.5 1563.5L609 1584L623 1631L634 1676.5L640 1698L646 1719L650.5 1734.5H715L716.5 1699L719.5 1664.5L721 1644L723 1624L725.5 1578L726.5 1558.5V1540L725 1514L723 1488.5L721.5 1478L718.5 1468.5L711.5 1447.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_gauche)}
        />
        <path
          id='avant_cheville_gauche'
          d='M651 1786.5L655 1777L657 1770V1761L654.5 1749L650.5 1735.5H715V1753L714.5 1768L719.5 1782L722.5 1789L724.5 1799.5L725.5 1813.5H645L645.5 1809.5L647.5 1799L651 1786.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_gauche)}
        />
        <path
          id='avant_genital'
          d='M436 1045.5L444.5 959H564.5L570 1047L515 1054.2L515.5 1035L515 1026.5L513 1018.5L510 1015.5H505L502 1018.5L499.5 1026.5V1035V1054.5L436 1045.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genital)}
        />
        <path
          id='avant_avant_bras_gauche'
          d='M836.5 682.5L745 711.5L755 733L767 755.5L775.5 771.5L784 788L802 812L818.5 833.5L835 857L898 834L887 810L878 786.5L872 772L867 757L862 743L856 728.5L851.5 716.5L846.5 705L841 693.5L836.5 682.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_gauche)}
        />
        <path
          id='avant_cou'
          d='M464 224L459 221L459.5 256L459 270L455 283.5L447 291L432.5 301.5L418 311.5L391 317.5L378 320L358 322.5L355.5 324L666.5 325L656 323L623.5 318L594.5 311L579.5 301L565.5 290.5L560.5 285L556.5 278.5L554.5 266V248V220.5L546.5 225.5L538 229.5L527.5 233L516.5 234.5L508 234.9L499.5 234.5L489 233L479.5 231L471.5 228L464 224Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cou)}
        />
        <path
          id='avant_bras_droit'
          d='M336 439L256 418.5L253.5 429L251.5 439.5L249 452.5L246 482.5V492L243.5 506.5L242.5 514L238.5 534.5L234 555L224 592.5L214.5 615L293.5 642.5L315 599L324 578.5L331.5 557.5L334 546.5L335.5 526.5L336.5 509.5V493.5L337 466L337.5 449L338.5 439.5L336 439Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_droit)}
        />
        <path
          id='avant_cheville_droit'
          d='M292 1791L296.5 1776L300 1768V1756.5V1736H363L358 1757.5V1772.5L365 1791.5L368 1804L369 1810.5H289L292 1791Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_droit)}
        />
        <path
          id='avant_avant_bras_droit'
          d='M221.5 695.5L180.5 678.203L173.5 693.5L160.5 723.5L152.5 744L139 779.5L126 813L112 843L140 854L173 867L194.5 835.5L219 802.5L233 784L244.5 761.5L265.5 720.5L221.5 695.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_droit)}
        />
        <path
          id='avant_hypocondre_gauche'
          d='M555 680V555H679.5L680.5 561.92L682 567.976V574.031L672 593.927L664 617.716L658.5 640.64L654 662.699L652 680H555Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_gauche)}
        />
        <path
          id='avant_bras_gauche'
          d='M760.5 427L720.5 432.5L676 438.5L678 479L679 533.5L683 556.5L688.5 572.5L697.5 592.5L707.5 614.5L718 634.5L799 613.5L795.5 606.5L790.5 589.5L783 565L779 550L777 536.5L773.5 519.5L770 499L767 471L766 455.5L763 440L760.5 427Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_gauche)}
        />
        <path
          id='avant_poignet_droit'
          d='M111.5 843.5L79 905L148 933L149 921.5L150 907L162.5 883L173 868L111.5 843.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_droit)}
        />
        <path
          id='avant_fosse_iliaque_gauche'
          d='M554.5 925V815H667L671 832.5L675 852L678 867L680.5 881L688 925H554.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_gauche)}
        />
        <path
          id='avant_flanc_droit'
          d='M454.5 814H348L351 797.5L354.5 774L356.5 754L358.5 736.5L362 713.4L363 695.5V681H454.5V814Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_droit)}
        />
        <path
          id='avant_fosse_iliaque_droit'
          d='M341.5 844.5L347.5 814.9H454.5V925H326.772L331 898L334.5 879.5L337.5 864L341.5 844.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_droit)}
        />
        <path
          id='avant_ombilicale'
          d='M554 814V681H505H457H455V814H554Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_ombilicale)}
        />
        <path
          id='avant_epigastrique'
          d='M554 555H455V680H554V555Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epigastrique)}
        />
        <path
          id='avant_buste_gauche'
          d='M504 554L506.515 325L640.288 325.548L648.837 353.488L656.884 380.333L675.5 437.5L678.5 494.5V524.5L682 554H504Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_gauche)}
        />
        <path
          id='avant_poignet_gauche'
          d='M852 882.5L835.5 857.5L898 835L913 863.5L921 879L930 895L865.5 918.5L864.5 909L862 899L852 882.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_gauche)}
        />
        <path
          id='avant_bassin_gauche'
          d='M505.5 926V958H565.5L571 1047L703.5 1029.5L702.5 1016L701 1007L700 1001.5L697.5 985.5L693.5 962L690.5 941.5L688 926H505.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_gauche)}
        />
        <path
          id='avant_buste_droit'
          d='M503.5 554L332.5 553.5L335 538.697L336 521.5L336.5 507.5L336 494.5L337.5 465L338 450L339 436.5L337.5 428L355.5 382L366 354.5L371 340.85L376.5 325L506 325.547L503.5 554Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_droit)}
        />
        <path
          id='avant_hypogastrique'
          d='M554 814.5L455.5 815L455 925H554V814.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypogastrique)}
        />
        <g id='Mannequin global V2'>
          <g id='Femme devant'>
            <g id='corps F'>
              <path
                id='mannequin_36'
                d='M507.6 774.7C510.03 774.7 512 771.297 512 767.1C512 762.903 510.03 759.5 507.6 759.5C505.17 759.5 503.2 762.903 503.2 767.1C503.2 771.297 505.17 774.7 507.6 774.7Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_35'
                d='M38.5 960.5C38.5 960.5 41.2 963.2 39.5 968C37.8 972.8 29 994.5 29 994.5L6.6 1047.3C6.5 1047.5 6.5 1047.6 6.4 1047.8C5.6 1050.3 -0.199998 1070.7 15.9 1052.7C16 1052.6 16 1052.5 16.1 1052.5L37.7 1025.1C37.8 1025 37.8 1024.9 37.9 1024.8L44.8 1014.7C44.9 1014.5 45.1 1014.3 45.2 1014.1C46.9 1012.3 55.9 1003.2 51.5 1018.9C47 1035.1 40.1 1051.9 39.2 1054.1C39.1 1054.3 39.1 1054.4 39 1054.6L31.9 1078.8C31.9 1078.8 28.9 1089.6 33.9 1091.1C33.9 1091.1 40.9 1096 48.5 1078.6L72.5 1022.3C72.6 1022 72.7 1021.8 72.9 1021.6C74.3 1019.5 81.5 1009 81 1023.6C81 1023.8 81 1024.1 80.9 1024.3L77.5 1044L71.4 1073.2C71.4 1073.3 71.4 1073.5 71.3 1073.6L69.6 1087.3C69.6 1087.5 69.6 1087.6 69.6 1087.8C69.6 1089 69.6 1094 71.7 1097C72.8 1098.6 74.8 1099.3 76.8 1098.9C79.4 1098.3 83.1 1096.2 85.5 1089.3C85.5 1089.2 85.6 1089 85.6 1088.9L90.2 1070.5L99.2 1030.3C99.2 1030.1 99.3 1029.9 99.3 1029.7C99.3 1029.6 99.3 1029.5 99.3 1029.4C99.9 1023.3 109.1 1024 108.7 1030.1C108.7 1030.2 108.7 1030.3 108.7 1030.4C108.7 1030.5 108.7 1030.6 108.7 1030.7L108.8 1053.3C108.8 1053.3 108 1079.6 116.3 1078.5C116.3 1078.5 125.4 1079.7 125.3 1059.1L125.9 1027C125.9 1026.9 125.9 1026.8 125.9 1026.7C126 1025.7 126.5 1019.3 127.2 1017.2C127.9 1015 133.7 994.2 133.7 994.2C133.7 994.2 147.4 945.5 148.1 934.7L150.2 907.5C150.2 907.2 150.3 907 150.3 906.7C150.8 904.9 153.3 897 164.7 879.1L186.6 846.2C186.6 846.1 186.7 846.1 186.8 846L205.1 821.5C205.1 821.5 221.8 799.6 231.2 786.5C231.3 786.3 231.4 786.1 231.5 786L260.3 731.7C260.3 731.7 276.5 700.6 280.1 683.4C280.1 683.4 285 656.2 299.2 630.5L312.8 602.6L328.9 566.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_34'
                d='M332.9 557.2C332.9 557.2 340.3 571.1 347.8 597.7C355.3 624.3 362.2 668 362.2 668C362.2 668 363.7 704.3 357.7 745.7C357.7 745.7 354.6 786.5 345.1 825.5C335.6 864.5 323.6 945.2 323.6 945.2C323.6 945.2 312.1 1015 311.9 1019.2C311.7 1023.4 308.4 1062.2 313 1133.2C317.6 1204.2 321.9 1241.6 321.9 1241.6C321.9 1241.6 328 1259.2 325.1 1311.9C322.1 1364.6 320.6 1396.3 320.6 1396.3C320.6 1396.3 323 1396.3 310.6 1427.1C298.2 1457.9 292.2 1479.4 292.2 1479.4C292.2 1479.4 286.9 1533.3 287.8 1553.9C288.7 1574.5 289.2 1591.9 297.1 1689.9C297.1 1689.9 299.5 1694 300 1768.1C300 1768.1 291.1 1784.9 289.1 1810.4C289.1 1810.4 289.3 1820.4 291.8 1835.5C294.2 1850.6 282.8 1867.7 282.8 1867.7L261.7 1896.6C261.7 1896.6 241.5 1924.8 254.8 1941.2C268.1 1957.6 308.7 1945.6 308.7 1945.6C308.7 1945.6 336.1 1967.7 348.1 1939.6C360.1 1911.5 354.4 1894.2 354.4 1894.2C354.4 1894.2 354.2 1882.7 361.7 1869.4C361.7 1869.4 362.1 1864.3 361.7 1861.4C361.3 1858.5 359.5 1840.8 367.7 1823.1C367.7 1823.1 375.1 1813.5 357.9 1773.2C357.9 1773.2 355.7 1764.1 359.7 1749.5C363.7 1734.9 376.7 1690.4 376.7 1690.4L396.1 1617.3L405.6 1586C405.6 1586 415.1 1550.5 411.7 1517.3C408.3 1484.1 410.9 1458.6 410.9 1458.6C410.9 1458.6 410.8 1446.8 422.7 1421.9C434.6 1397 439.5 1386.2 441.5 1365.5C443.5 1344.8 453.2 1292.3 453.2 1292.3L464.1 1236C464.1 1236 493.7 1133.4 493.1 1129.1C493.1 1129.1 500.7 1103.1 500.1 1055.3C500.1 1055.3 495.6 1013.9 507.1 1015.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_33'
                d='M85.6 891.7L76.1 909.7C76.1 909.7 72.2 912.4 63 912.5C53.8 912.6 31.2 933.6 31.2 933.6C31.2 933.6 30.2 934.3 15.6 956.2L6.09997 969.2C6.09997 969.2 -6.40003 985.2 14 981.3C14 981.3 24.1 977 33.2 965.6C34.3 964.2 35.7 962.9 37.2 961.7C37.6 961.4 38.1 961 38.6 960.7C39 960.4 39.5 960.1 39.9 959.8C50.5 953.1 65.6 951.4 65.6 951.4'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_32'
                d='M976.1 960.5C976.1 960.5 973.4 963.2 975.1 968C976.8 972.8 985.6 994.5 985.6 994.5L1008.1 1047.5C1008.1 1047.5 1015.8 1071.8 998.6 1052.6L976.8 1025L969.7 1014.5C969.7 1014.5 958.3 1001.7 963.1 1019C967.9 1036.3 975.5 1054.4 975.5 1054.4L982.6 1078.8C982.6 1078.8 985.6 1089.6 980.6 1091.1C980.6 1091.1 973.6 1096 966 1078.6L941.9 1021.9C941.9 1021.9 932.9 1007.2 933.6 1023.9L937.1 1043.9L943.2 1073.2L945 1087.3C945 1087.3 945.4 1096.7 940.6 1098.8C940.6 1098.8 932.9 1100.3 929.1 1088.8L924.5 1070.2L915.4 1029.7C915.4 1029.7 914.9 1020.9 909.9 1019.6C909.9 1019.6 905.2 1019.6 905.9 1030.2L905.8 1052.9C905.8 1052.9 906.6 1079.2 898.3 1078.1C898.3 1078.1 889.2 1079.3 889.3 1058.7L888.7 1026.4C888.7 1026.4 888.1 1019 887.4 1016.8C886.7 1014.6 880.9 993.8 880.9 993.8C880.9 993.8 867.2 945.1 866.5 934.3L864.4 906.8C864.4 906.8 863.2 899.6 849.9 878.8L828 845.8L809.6 821.2C809.6 821.2 792.7 799 783.3 786L754.4 731.5C754.4 731.5 738.2 700.4 734.6 683.2C734.6 683.2 729.7 656 715.5 630.3L702 602.4L686.1 567'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_31'
                d='M507.6 1015.5C519.1 1014.1 514.6 1055.5 514.6 1055.5C514 1103.2 521.6 1129.3 521.6 1129.3C521 1133.6 550.6 1236.2 550.6 1236.2L561.5 1292.5C561.5 1292.5 571.3 1344.9 573.2 1365.7C575.2 1386.4 580.1 1397.2 592 1422.1C603.9 1447 603.8 1458.8 603.8 1458.8C603.8 1458.8 606.4 1484.3 603 1517.5C599.6 1550.7 609.1 1586.2 609.1 1586.2L618.6 1617.5L638 1690.6C638 1690.6 651 1735.1 655 1749.7C659 1764.3 656.8 1773.4 656.8 1773.4C639.6 1813.7 647 1823.3 647 1823.3C655.2 1841 653.4 1858.8 653 1861.6C652.6 1864.5 653 1869.6 653 1869.6C660.5 1882.9 660.3 1894.4 660.3 1894.4C660.3 1894.4 654.5 1911.7 666.6 1939.8C678.7 1967.9 706 1945.8 706 1945.8C706 1945.8 746.6 1957.8 759.9 1941.4C773.2 1925 753 1896.8 753 1896.8L731.9 1867.9C731.9 1867.9 720.4 1850.7 722.9 1835.7C725.3 1820.6 725.6 1810.6 725.6 1810.6C723.6 1785.1 714.7 1768.3 714.7 1768.3C715.1 1694.3 717.6 1690.1 717.6 1690.1C725.6 1592.2 726 1574.8 726.9 1554.1C727.8 1533.5 722.5 1479.6 722.5 1479.6C722.5 1479.6 716.5 1458.1 704.1 1427.3C691.7 1396.5 694.1 1396.5 694.1 1396.5C694.1 1396.5 692.5 1364.8 689.6 1312.1C686.6 1259.4 692.8 1241.8 692.8 1241.8C692.8 1241.8 697 1204.3 701.7 1133.4C706.4 1062.5 703 1023.7 702.8 1019.4C702.6 1015.2 691.1 945.4 691.1 945.4C691.1 945.4 679.1 864.7 669.6 825.7C660.1 786.7 657 745.9 657 745.9C651 704.4 652.5 668.2 652.5 668.2C652.5 668.2 659.5 624.4 666.9 597.9C674.4 571.3 681.8 557.4 681.8 557.4L683 555.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_30'
                d='M928.8 891.9L938.2 909.7C938.2 909.7 942.1 912.4 951.3 912.5C960.5 912.6 983.2 933.5 983.2 933.5C983.2 933.5 984.2 934.2 998.9 956.1L1008.5 969.1C1008.5 969.1 1021 985.1 1000.6 981.2C1000.6 981.2 990.5 976.9 981.4 965.5C980.3 964.1 978.9 962.8 977.4 961.6C977 961.3 976.5 960.9 976 960.6C975.6 960.3 975.1 960 974.7 959.7C964 953.1 948.9 951.3 948.9 951.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='Calque 14   copie'>
                <path
                  id='Vector'
                  d='M418 334L477.8 335.5C477.8 335.5 491.9 334.7 489.7 344.6'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='Vector_2'
                  d='M594.9 334L535.1 335.5C535.1 335.5 521 334.7 523.2 344.6'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <g id='Calque 25'>
                <path
                  id='mannequin_29'
                  d='M459.7 219.9V261.8C459.7 261.8 460.5 271.1 455.6 281.8C450.6 292.4 418 311.1 418 311.1C418 311.1 390.9 320.4 327.7 326.8C327.7 326.8 251.4 344.3 245.9 491.7C245.9 491.7 235.4 566.1 218.3 605.9C201.2 645.7 179.4 668.2 146.1 760.7C112.8 853.2 85.6 891.7 85.6 891.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_28'
                  d='M554.8 220.1V262C554.8 262 554 271.3 558.9 282C563.9 292.6 596.5 311.3 596.5 311.3C596.5 311.3 623.6 320.6 686.8 327C686.8 327 763.1 344.5 768.6 491.9C768.6 491.9 779.1 566.3 796.2 606.1C813.3 645.9 835.1 668.4 868.4 760.9C901.7 853.4 928.8 892.1 928.8 892.1'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <g id='Calque 27'>
                <path
                  id='mannequin_27'
                  d='M355.2 450.8C355.2 450.8 334.7 549.6 413.2 551.1C413.2 551.1 461.3 558.8 475.9 517.3'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_26'
                  d='M606.2 501.6C608.63 501.6 610.6 499.988 610.6 498C610.6 496.012 608.63 494.4 606.2 494.4C603.77 494.4 601.8 496.012 601.8 498C601.8 499.988 603.77 501.6 606.2 501.6Z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_25'
                  d='M659.5 451C659.5 451 680 549.8 601.5 551.3C601.5 551.3 553.4 559 538.8 517.5'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <g id='Calque 26'>
                  <path
                    id='mannequin_24'
                    d='M408.5 501.4C410.93 501.4 412.9 499.788 412.9 497.8C412.9 495.812 410.93 494.2 408.5 494.2C406.07 494.2 404.1 495.812 404.1 497.8C404.1 499.788 406.07 501.4 408.5 501.4Z'
                    stroke='black'
                    strokeWidth='3'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
              </g>
              <path
                id='mannequin_23'
                d='M327.7 422.1C327.7 422.1 339.9 422.1 338.9 439.4C338 456.7 336 493.6 336 493.6C336 493.6 338.8 536.6 328.7 566.6'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_22'
                d='M687.1 422.5C687.1 422.5 674.9 422.5 675.9 439.8C676.9 457.1 678.8 494 678.8 494C678.8 494 676 537 686.1 567'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='t&#195;&#170;te F'>
              <path
                id='mannequin_21'
                d='M429.8 66.3C423.4 92.8 426.5 117.5 426.5 117.5L436.8 182.5C436.8 182.5 442.8 233.5 507.2 234C571.6 234.5 575.4 181 575.4 181L585.9 120C585.9 120 589.6 94 583.6 66.4'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_21_2'
                d='M507.5 3.00006C507.5 3.00006 386.8 -16.6999 389.4 118.6C392.1 253.8 376.1 276.4 376.1 276.4L455.5 281.7'
                stroke='black'
                strokeWidth='3'
              />
              <path
                id='mannequin_20'
                d='M559.4 281.7L638.8 276.4C638.8 276.4 622.8 253.8 625.5 118.6C628.2 -16.5999 507.5 3.00012 507.5 3.00012V25.2001'
                stroke='black'
                strokeWidth='3'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='Calque 56'>
                <path
                  id='mannequin_19'
                  d='M507.5 27.4001C507.5 27.4001 472.3 74.6001 429.5 76.1001'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_18'
                  d='M507.5 26.1001C507.5 26.1001 542.7 73.3001 585.5 74.8001'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='oreilles F'>
              <path
                id='mannequin_oreille_gauche'
                d='M587 120C587 120 602 112.9 601 130.4C601 130.4 601.3 145.8 599.6 155.2C597.9 164.5 585.4 182 578.9 165.9'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_droit'
                d='M425.9 120C425.9 120 410.9 112.9 411.9 130.4C411.9 130.4 411.6 145.8 413.3 155.2C415 164.6 427.5 182 434 165.9'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='bouche   copie'>
              <path
                id='mannequin_17'
                d='M539.1 183.9C501.6 192.2 475.5 184.3 475.5 184.3L503 177.1L507.1 178L512.1 177.1L539.1 183.9Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='Calque 6   copie'>
                <path
                  id='mannequin_16'
                  d='M475.4 184.3C475.4 184.3 503.9 214.8 539 183.9'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='yeux F'>
              <path
                id='mannequin_15'
                d='M456.1 105C456.1 105 471.3 86.9 489 105C489 105 471.7 116.5 456.1 105Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_2'
                d='M472.5 110C475.04 110 477.1 107.09 477.1 103.5C477.1 99.9101 475.04 97 472.5 97C469.959 97 467.9 99.9101 467.9 103.5C467.9 107.09 469.959 110 472.5 110Z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
              <path
                id='mannequin_14'
                d='M559.3 104.9C559.3 104.9 544.1 86.8 526.4 104.9C526.4 104.9 543.7 116.4 559.3 104.9Z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_1'
                d='M542.9 109.9C545.441 109.9 547.5 106.99 547.5 103.4C547.5 99.8102 545.441 96.9 542.9 96.9C540.359 96.9 538.3 99.8102 538.3 103.4C538.3 106.99 540.359 109.9 542.9 109.9Z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
              <g id='Calque 57'>
                <path
                  id='mannequin_13'
                  d='M450.6 99.3L456.1 105'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_12'
                  d='M456.5 96.4L460.5 100.6'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_11'
                  d='M463.2 94.6L466.1 97.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_10'
                  d='M470.1 94.4L473 97.4'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_9'
                  d='M564.7 99.4L559.2 105.1'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_8'
                  d='M558.9 96.5L554.9 100.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_7'
                  d='M552.2 94.7001L549.2 97.8001'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_6'
                  d='M545.3 94.4L542.3 97.5'
                  stroke='black'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='sourcils F'>
              <path
                id='mannequin_5'
                d='M455.6 79.2C455.6 79.2 472.7 72.3 489.5 74.4'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_4'
                d='M559.9 79.2C559.9 79.2 542.8 72.3 526 74.4'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='nez   copie'>
              <path
                id='mannequin_3'
                d='M497.6 132.3L494.3 138.6L491 143.1C491 143.1 486.3 150.2 491.9 154.6'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_3_2'
                d='M517.4 132.8L520.7 139.1L524 143.6C524 143.6 528.7 150.7 523.1 155.1'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_2'
                d='M496 150.2C496 150.2 498.2 152.3 503 152'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_1'
                d='M519.3 150.2C519.3 150.2 517.1 152.3 512.3 152'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2Female({ lesionnel }: BackV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_vector_f'>
        <path
          id='arriere_lombaire_gauche'
          d='M360.5 728C360.5 728 361 724.5 362.005 714.5H507.972L507.045 832.302H344L347.5 816L351.5 797.5L355.5 769.5L358 749L360.5 728Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_gauche)}
        />
        <path
          id='arriere_poignet_droit'
          d='M860.5 896L848 875.5L904.5 847.5L914 866L924.5 885L938 909L868.5 946.5L867.5 936.5L866 923.5L865 906.5L860.5 896Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_droit)}
        />
        <path
          id='arriere_cheville_droit'
          d='M715 1724H649L658 1758.5L657.5 1771.5L652.5 1785.5L649.5 1794L647 1807.5L647.5 1821L649.5 1808.97L652.5 1801L659.5 1792.5L668.5 1787C671.5 1786 678 1785.5 681.5 1785.5C685.21 1785.5 687.403 1785.09 691 1786C693.711 1786.68 702.548 1790.16 705 1791.5C708.087 1793.19 713.262 1799.79 716 1802C719.215 1804.6 724.205 1816.38 724.5 1820.5L726.076 1816V1804L724 1792.5L720.5 1779L715 1767V1724Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_droit)}
        />
        <path
          id='arriere_jambe_gauche'
          d='M411 1489.1H292L288.5 1535.5V1557L290 1583L293.5 1633.5L297 1670.5L299 1699.5L300 1714.5V1725.5H333.039H366.931L369.5 1717L372 1708L376.5 1692L385.403 1655.05L398.5 1610L409.019 1572.83L411.5 1551.5L413 1531L411.5 1508.5L411 1489.1Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_gauche)}
        />
        <path
          id='arriere_pied_gauche'
          d='M293 1837L291 1823L293 1818L296 1811L300.5 1802L308 1794.5L316 1789L324 1786.5L333 1785L343 1786.5L351.5 1790L360 1799L364 1809.5L365 1821L364 1834L351 1934L346 1944.5L340.5 1950.5L330.5 1953L318 1950.5L309 1945L286 1948.5H273L262.5 1945.5L255.5 1941L252 1935L251 1926L252 1918L255.5 1908L260 1899.5L281 1870.5L289 1857L292 1845.5L293 1837Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_gauche)}
        />
        <path
          id='arriere_coude_droit'
          d='M732.608 671.863L728 655.5L806 626L811.5 636.5L823 658L831 673L840 690.668L751 722L744 708.5L736.5 687.5L732.608 671.863Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_droit)}
        />
        <path
          id='arriere_bassin_gauche'
          d='M507 919H328L329 914.5L330 909.5L331.5 899.5L334.5 880L338.5 861L344 833H507V919Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_gauche)}
        />
        <path
          id='arriere_coude_gauche'
          d='M287.5 656.5L212.5 618L196.5 648.5L187.5 665.5L179 681L261 730L273 704.5L280 684L281.894 673.869L287.5 656.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_gauche)}
        />
        <path
          id='arriere_tete'
          d='M413.5 121.5L412.5 129.5L413 149L414.5 157L417.5 163.5L422 169L427.579 171.979L431.5 170.5L435 165.5L437.5 182L443.965 199.146L453.965 215.146H563V210.5L568.5 203.5L573 195L575.5 185.5L579 166L581.5 170L586 172L593 167.5L598 159L600.5 145V123L597 118.5L590 117.847L586 120.5L587.5 105L587 85.5L585.5 71.5L582.5 57L577.5 44.5L573.044 35.5343L564 23L554 14.5L541.5 8L530.5 4.5L515 2H503L493.5 3L484 5L468.793 10.5329L456 19L445 31.5L438 44L431 63.5L427 84L426 102.5L428.113 120.354L423 117.847L416.5 118.5L413.5 121.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <path
          id='arriere_genou_droit'
          d='M693 1377H575L579.5 1390.5L584.5 1403.5L595.5 1427.5L601.5 1441.5L605 1460.5L605.702 1488.5H724.5L723 1478.5L713 1447.5L696.5 1406L694.923 1395L693 1377Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_droit)}
        />
        <path
          id='arriere_nuque'
          d='M559.936 215.51H456.936L456.436 235.394L456.936 257.894V270.394L455.436 280.894L451.936 286.894L443.436 294.394L434.936 299.894H579.936L569.436 291.894L559.936 280.894V270.394V257.894V247V229V215.51Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_nuque)}
        />
        <path
          id='arriere_cuisse_gauche'
          d='M497.956 1101H311.5L313.047 1125.5L316.565 1169.5L321 1224.5L322.5 1240.5L325.5 1257.5L327 1292L324 1346L322.5 1376H440L443.689 1351.22L452.231 1305.1L460.27 1255.96L479.364 1185.77L497.956 1108.56V1101Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_gauche)}
        />
        <path
          id='arriere_buste_gauche'
          d='M507.5 560.22H345.586H334.5L331.5 556.5L334.5 544L336 520.5V493.5L338.5 445.5L350.5 414.5L381.5 333L384.5 318.5L400.5 315.5L419.5 310L433 301.249H507.5V348.5V418.5V479V518V535V560.22Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_gauche)}
        />
        <path
          id='arriere_fesse_gauche'
          d='M507.177 920H328.5L323.5 947.5L319.5 974.5L312.5 1017L312 1100H498L500.5 1079.5V1051.5V1024L503 1015.5L507 1013.5V984L507.177 920Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_gauche)}
        />
        <path
          id='arriere_epaule_gauche'
          d='M339 442.5L256 419.5L260 405.5L264 395L273 377L283.5 360.5L293 349L301.5 341L309 336L317 331L325 327.5L336.5 326L351.5 324L370 321L383.5 318.5L381 332L339 442.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_gauche)}
        />
        <path
          id='arriere_bras_gauche'
          d='M252.5 434L256.5 420L338.5 443L336 500V523.5L333 547.5L331.5 556L329.5 564.5L325.5 574.5L318 590.5L302.5 623L294.5 639.5L287.5 655.5L213 617.5L220 603L224.5 589.5L232 562L236 546.5L239 531.5L242 517L244 502L245.5 494L246.219 485.5L247 470L249 454L252.5 434Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_gauche)}
        />
        <path
          id='arriere_avant_bras_gauche'
          d='M261 731L178.5 681.871L167 707.5L158 729L144.5 765.5L137.5 783.5L130.5 801.5L122.5 821L113.5 840L106 855L164.5 879L167.5 875L180.5 855L194.5 835L210 814L225.5 794L231.5 785.5L236.5 776L244.5 761.5L251 748.5L261 731Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_gauche)}
        />
        <path
          id='arriere_cuisse_droit'
          d='M694 1376H575.5L571.316 1345.21L568 1321.5L563.5 1299L557.5 1265.5L552 1237.5L547.5 1221.5L537 1183.5L530 1160L526.5 1143.5L522 1126.5L518.5 1109.5L517.5 1101H704.5L701 1154.5L694.5 1232.5L690.5 1260.5L689.5 1287L691.406 1337.68L694 1376Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_droit)}
        />
        <path
          id='arriere_jambe_droit'
          d='M724.5 1489H606.489L603 1524.5L603.5 1548L606.489 1570L610 1585.5L616.5 1605.5L621 1623.5L625.08 1639.01L631 1658.5L637 1681.5L642.5 1702L644.5 1708.5L646.5 1717L648.058 1723H716.027V1708.5L717.534 1691.65L721.554 1656.56L725.574 1621.46L726.5 1606.5L728.588 1540.74L727.583 1519.18L725.071 1504.14L724.5 1489Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_droit)}
        />
        <path
          id='arriere_genou_gauche'
          d='M439.5 1377H322L321.5 1397L315.5 1416.5L307.5 1436.46L292.5 1477.5L292 1488.1H410.024L410.5 1470.5L413 1446.5L420 1427L430 1407L437 1389.5L439.5 1377Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_gauche)}
        />
        <path
          id='arriere_bassin_droit'
          d='M508 919L507.5 833L672 832.5L681 880L687.5 919H508Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_droit)}
        />
        <path
          id='arriere_poignet_gauche'
          d='M164 879.5L105 855.5L96.5 871L88.5 885.5L83 897L77 908.5L69.5 911.5L61.5 912L146 950.5L148.5 935.5L151 905L164 879.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_gauche)}
        />
        <path
          id='arriere_main_droit'
          d='M875.5 970.5L870.174 946.597L939.5 909.5L945.5 911L954 911.5L960 914L971.5 922L982.5 931L991 941.5L997 950.5L1006.5 964L1012.5 973L1013.5 977.7L1010.98 980H1005.5L999.5 979.5L992.5 974.5L979.5 962L976 959L975 964.5L979.5 977.7L982.5 985.5L987.5 996.5L992.5 1009L998.414 1022.82L1002.94 1034.86L1007.46 1043.38L1010.5 1050.5V1054.5V1058L1007.46 1059L1001 1053.5L992 1043L981 1028L970 1013L965.251 1009H962.5L963 1014.5L965.5 1025L970.778 1040.87L976 1052.5L980 1066.5L982 1073.5L984 1080L984.5 1085L983.5 1088.5L979 1090.5L973.5 1089L966.5 1078L960.5 1064L954.5 1048.5L947.162 1032.35L941.5 1019L937.113 1014.5L934 1018L935.5 1028L937.113 1038.87L939.5 1051L942.64 1065.94L944.5 1076.5L945.5 1087.5L944.65 1093L942.64 1097.5L938 1097L933.5 1094.5L929.576 1088.5L926.561 1075.47L922.5 1059L918.5 1038.87L915 1023L912 1019H909L906.5 1024V1038.87V1061L904.5 1071L901 1077L896 1076.5L891 1069L889 1023L887 1011L881 991.5L875.5 970.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_droit)}
        />
        <path
          id='arriere_bras_droit'
          d='M685.5 566L681.5 549L679 523.5V498L676.5 448L762.5 434.734L764.5 448.5L767 467.5L768.5 491L770.5 503L775.5 531.5L781 557L788.5 584L795.5 604.5L800.5 615L805.5 625.5L727 655L722 644L717 632.5L704 606.5L694.5 586L685.5 566Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_droit)}
        />
        <path
          id='arriere_epaule_droit'
          d='M761.5 433.888L676.5 447L627.5 318.5L636.5 320L650 322.5L673 325.5L687 327L701.5 333.5L716 344.5L729 358L735.5 367L742 378L749 391L756 410.5L759.5 422L761.5 433.888Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_droit)}
        />
        <path
          id='arriere_cheville_gauche'
          d='M300.5 1767V1726.5H366.5L361 1745L358 1761.5V1771.5L361 1780.5L365.5 1792L368.5 1802.5L369.5 1812.5L368.5 1820.5L364.5 1827V1819.5L363 1807.5L359 1798L352 1791L341.5 1786L331 1785L320 1787.5L309.5 1793L300.5 1802.5L295 1812.5L291.5 1825.5L290 1816.5L290.5 1804.5L292.5 1791L297 1776.5L300.5 1767Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_gauche)}
        />
        <path
          id='arriere_main_gauche'
          d='M51.5 917L60.5 912.5L145.5 951L140 971L135.5 989.5L131 1005.5L128 1015L127 1023L125.5 1037V1063.94L124.5 1070.5L121 1075.5L117.5 1077H114.5L111.5 1072L110 1063.94L109.5 1056.5V1044.88V1032.5L108.5 1027L103.5 1024.5L100 1027L99.5 1031L97.5 1039L95 1050L92.9664 1061.93L90 1073.5L86.5 1087L84 1093L79.5 1097L76 1098L72.5 1096L71 1092.5L70.5 1086.5L71 1080L72.5 1070.5L75 1058.42L77.3899 1044.88L79.5 1035.86L82 1020.5L80.5 1017.5L77.3899 1016.5L73.8727 1020.5L71.5 1026.33L68 1034.5L64 1042.5L56.5 1060L51.5 1072L46.7394 1082.5L40 1090.5H35L32.5 1088L31.5 1083.5L32.5 1078.5L34.6802 1072.96L37 1063.94L40 1053L43.9541 1043L46.7394 1035.86L49 1028.5L50.7591 1021.82L53.5 1011.5L52 1009L46 1013L40 1022.5L30 1034.5L21.5 1046L14 1054.5L9 1058.5L5.5 1058.42V1055V1050L8.5 1043L11 1037L13.5 1031L18.5 1020.5L23.5 1009L29 996L40 965L38 961L34 964L25.9605 973.025L19.5 977.5L14.5 980.5L10 981.21L5.5 980.5L3 978.5V973.5L7.5 967.673L14 958.5L20 950.5L25.5 941L32 932.5L42.5 924.5L51.5 917Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_gauche)}
        />
        <path
          id='arriere_dorsal_gauche'
          d='M345.5 586L336.5 564L335.5 561H507.5L508 713.5H362V708L362.5 668.5L361.5 657L356.5 633L352 610L345.5 586Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_gauche)}
        />
        <path
          id='arriere_buste_droit'
          d='M508.5 560V301.249L580.5 300.5L593.5 310L607.5 314L626.5 318.5L663 413.5L676 447.5L678 475L679.5 502L678 549L681.5 556.5L680.5 559.5L675.5 560H508.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_droit)}
        />
        <path
          id='arriere_dorsal_droit'
          d='M509 713.5L508.5 561.213L675.5 561L680.5 560.5L678 565L669.5 590.5L660.5 628.5L657 644L653.5 667V701L654 713L509 713.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_droit)}
        />
        <path
          id='arriere_avant_bras_droit'
          d='M762 746.5L750.5 723L840.5 691.182L845.5 704.182L853.5 722L862 743.5L869.5 764L877.5 785L903.5 847L848 874.5L828 846L811 822.5L793 799L782.5 785L772.5 765L762 746.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_droit)}
        />
        <path
          id='arriere_pied_droit'
          d='M652 1859.5L648.5 1825.5V1816L650.5 1803.5L654.5 1797L660 1792L667.5 1788L676 1785.5H686.5L698.5 1789L709.5 1795L717.5 1804.5L725.5 1818.5L723.5 1831.5V1845L728.5 1859.5L745 1883.5L759.5 1904.5L764.5 1921.5V1933L758 1943L746 1948.5H726.5L706 1944.5L694 1952.5H681.5L671 1946.5L663.5 1930L662 1920.5L652 1859.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_droit)}
        />
        <path
          id='arriere_fesse_droit'
          d='M688 920H508V1000.5V1014L513 1017L516 1025.5V1051.5V1078.5L518 1100H704L704.5 1076.5V1053L704 1030L703 1015.5L700 996L697.5 981.5L694.5 965L692 947L689.5 931.5L688 920Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_droit)}
        />
        <path
          id='arriere_lombaire_droit'
          d='M509 714.5L508 832L672 831.5L670 824.5L667.5 812L665 799L662.5 783.5L660.5 766.5L658.5 753.5L657 739L655.5 726.5L654 714L509 714.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_droit)}
        />
        <path
          id='arriere_colonne_haut'
          d='M493.5 216.5H521.5V301H493.5V216.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_haut)}
        />
        <path
          id='arriere_colonne_milieu_bas'
          d='M493.6 589.5H521.8V811H493.6V589.5Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_bas)}
        />
        <path
          id='arriere_colonne_milieu_haut'
          d='M493.6 321H521.8V572.8H493.6V321Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_haut)}
        />
        <path
          id='arriere_colonne_bas'
          d='M493.6 832.7H521.8V985.2H493.6V832.7Z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_bas)}
        />
        <g id='Mannequin global V2'>
          <g id='Femme arri&#195;&#168;re'>
            <g id='corps F   copie'>
              <path
                id='mannequin_14'
                d='M290.7 1826C298.9 1785.3 330.7 1785.8 330.7 1785.8C330.7 1785.8 367.1 1782.6 363.6 1826.7C360.1 1870.8 349.7 1935.3 349.7 1935.3C349.7 1935.3 349.5 1937.3 347.1 1941.5C344.7 1945.7 347.1 1941.5 347.1 1941.5'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_13'
                d='M38.5 960.5C38.5 960.5 41.2 963.2 39.5 968C37.8 972.8 29 994.5 29 994.5L6.6 1047.3C6.5 1047.5 6.5 1047.6 6.4 1047.8C5.6 1050.3 -0.199998 1070.7 15.9 1052.7C16 1052.6 16 1052.5 16.1 1052.5L37.7 1025.1C37.8 1025 37.8 1024.9 37.9 1024.8L44.8 1014.7C44.9 1014.5 45.1 1014.3 45.2 1014.1C46.9 1012.3 55.9 1003.2 51.5 1018.9C47 1035.1 40.1 1051.9 39.2 1054.1C39.1 1054.3 39.1 1054.4 39 1054.6L31.9 1078.8C31.9 1078.8 28.9 1089.6 33.9 1091.1C33.9 1091.1 40.9 1096 48.5 1078.6L72.5 1022.3C72.6 1022 72.7 1021.8 72.9 1021.6C74.3 1019.5 81.5 1009 81 1023.6C81 1023.8 81 1024.1 80.9 1024.3L77.5 1044L71.4 1073.2C71.4 1073.3 71.4 1073.5 71.3 1073.6L69.6 1087.3C69.6 1087.5 69.6 1087.6 69.6 1087.8C69.6 1089 69.6 1094 71.7 1097C72.8 1098.6 74.8 1099.3 76.8 1098.9C79.4 1098.3 83.1 1096.2 85.5 1089.3C85.5 1089.2 85.6 1089 85.6 1088.9L90.2 1070.5L99.2 1030.3C99.2 1030.1 99.3 1029.9 99.3 1029.7C99.3 1029.6 99.3 1029.5 99.3 1029.4C99.9 1023.3 109.1 1024 108.7 1030.1C108.7 1030.2 108.7 1030.3 108.7 1030.4C108.7 1030.5 108.7 1030.6 108.7 1030.7L108.8 1053.3C108.8 1053.3 108 1079.6 116.3 1078.5C116.3 1078.5 125.4 1079.7 125.3 1059.1L125.9 1027C125.9 1026.9 125.9 1026.8 125.9 1026.7C126 1025.7 126.5 1019.3 127.2 1017.2C127.9 1015 133.7 994.2 133.7 994.2C133.7 994.2 147.4 945.5 148.1 934.7L150.2 907.5C150.2 907.2 150.3 907 150.3 906.7C150.8 904.9 153.3 897 164.7 879.1L186.6 846.2C186.6 846.1 186.7 846.1 186.8 846L205.1 821.5C205.1 821.5 221.8 799.6 231.2 786.5C231.3 786.3 231.4 786.1 231.5 786L260.3 731.7C260.3 731.7 276.5 700.6 280.1 683.4C280.1 683.4 285 656.2 299.2 630.5L312.8 602.6L328.9 566.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_12'
                d='M364.7 1830.4C365.5 1828 366.4 1825.6 367.5 1823.1C367.5 1823.1 374.9 1813.5 357.7 1773.2C357.7 1773.2 355.5 1764.1 359.5 1749.5C363.5 1734.9 376.5 1690.4 376.5 1690.4L395.9 1617.3L405.4 1586C405.4 1586 414.9 1550.5 411.5 1517.3C408.1 1484.1 410.7 1458.6 410.7 1458.6C410.7 1458.6 410.6 1446.8 422.5 1421.9C434.4 1397 439.3 1386.2 441.3 1365.5C443.3 1344.8 453 1292.3 453 1292.3L463.9 1236C463.9 1236 493.5 1133.4 492.9 1129.1C492.9 1129.1 500.5 1103.1 499.9 1055.3C499.9 1055.3 495.4 1013.9 506.9 1015.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_11'
                d='M332.9 557.2C332.9 557.2 340.3 571.1 347.8 597.7C355.3 624.3 362.2 668 362.2 668C362.2 668 363.7 704.3 357.7 745.7C357.7 745.7 354.6 786.5 345.1 825.5C335.6 864.5 323.6 945.2 323.6 945.2C323.6 945.2 312.1 1015 311.9 1019.2C311.7 1023.4 308.4 1062.2 313 1133.2C317.6 1204.2 321.9 1241.6 321.9 1241.6C321.9 1241.6 328 1259.2 325.1 1311.9C322.1 1364.6 320.6 1396.3 320.6 1396.3C320.6 1396.3 323 1396.3 310.6 1427.1C298.2 1457.9 292.2 1479.4 292.2 1479.4C292.2 1479.4 286.9 1533.3 287.8 1553.9C288.7 1574.5 289.2 1591.9 297.1 1689.9C297.1 1689.9 299.5 1694 300 1768.1C300 1768.1 291.1 1784.9 289.1 1810.4C289.1 1810.4 289.3 1820.4 291.8 1835.5C294.2 1850.6 282.8 1867.7 282.8 1867.7L261.7 1896.6C261.7 1896.6 241.5 1924.8 254.8 1941.2C268.1 1957.6 308.7 1945.6 308.7 1945.6C308.7 1945.6 333.6 1965.7 346.4 1943.2'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_10'
                d='M85.6 891.7L76.1 909.7C76.1 909.7 72.2 912.4 63 912.5C53.8 912.6 31.2 933.6 31.2 933.6C31.2 933.6 30.2 934.3 15.6 956.2L6.1 969.2C6.1 969.2 -6.4 985.2 14 981.3C14 981.3 24.1 977 33.2 965.6C34.3 964.2 35.7 962.9 37.2 961.7C37.6 961.4 38.1 961 38.6 960.7C39 960.4 39.5 960.1 39.9 959.8C50.5 953.1 65.6 951.4 65.6 951.4'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_9'
                d='M976.1 960.5C976.1 960.5 973.4 963.2 975.1 968C976.8 972.8 985.6 994.5 985.6 994.5L1008.1 1047.5C1008.1 1047.5 1015.8 1071.8 998.6 1052.6L976.8 1025L969.7 1014.5C969.7 1014.5 958.3 1001.7 963.1 1019C967.9 1036.3 975.5 1054.4 975.5 1054.4L982.6 1078.8C982.6 1078.8 985.6 1089.6 980.6 1091.1C980.6 1091.1 973.6 1096 966 1078.6L941.9 1021.9C941.9 1021.9 932.9 1007.2 933.6 1023.9L937.1 1043.9L943.2 1073.2L945 1087.3C945 1087.3 945.4 1096.7 940.6 1098.8C940.6 1098.8 932.9 1100.3 929.1 1088.8L924.5 1070.2L915.4 1029.7C915.4 1029.7 914.9 1020.9 909.9 1019.6C909.9 1019.6 905.2 1019.6 905.9 1030.2L905.8 1052.9C905.8 1052.9 906.6 1079.2 898.3 1078.1C898.3 1078.1 889.2 1079.3 889.3 1058.7L888.7 1026.4C888.7 1026.4 888.1 1019 887.4 1016.8C886.7 1014.6 880.9 993.8 880.9 993.8C880.9 993.8 867.2 945.1 866.5 934.3L864.4 906.8C864.4 906.8 863.2 899.6 849.9 878.8L828 845.8L809.6 821.2C809.6 821.2 792.7 799 783.3 786L754.4 731.5C754.4 731.5 738.2 700.4 734.6 683.2C734.6 683.2 729.7 656 715.5 630.3L702 602.4L686.1 567'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_8'
                d='M662.5 1928.3C663.6 1931.9 664.9 1935.7 666.7 1939.7C678.7 1967.8 706.1 1945.7 706.1 1945.7C706.1 1945.7 746.7 1957.7 760 1941.3C773.3 1924.9 753.1 1896.7 753.1 1896.7L732 1867.8C732 1867.8 720.5 1850.6 723 1835.6C725.4 1820.5 725.7 1810.5 725.7 1810.5C723.7 1785 714.8 1768.2 714.8 1768.2C715.2 1694.2 717.7 1690 717.7 1690C725.7 1592.1 726.1 1574.7 727 1554C727.9 1533.4 722.6 1479.5 722.6 1479.5C722.6 1479.5 716.6 1458 704.2 1427.2C691.8 1396.4 694.2 1396.4 694.2 1396.4C694.2 1396.4 692.6 1364.7 689.7 1312C686.7 1259.3 692.9 1241.7 692.9 1241.7C692.9 1241.7 697.1 1204.2 701.8 1133.3C706.5 1062.4 703.1 1023.6 702.9 1019.3C702.7 1015.1 691.2 945.3 691.2 945.3C691.2 945.3 679.2 864.6 669.7 825.6C660.2 786.6 657.1 745.8 657.1 745.8C651.1 704.3 652.6 668.1 652.6 668.1C652.6 668.1 659.6 624.3 667 597.8C674.5 571.2 681.9 557.3 681.9 557.3L683.1 555.2'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_7'
                d='M507.6 1015.5C519.1 1014.1 514.6 1055.5 514.6 1055.5C514 1103.2 521.6 1129.3 521.6 1129.3C521 1133.6 550.6 1236.2 550.6 1236.2L561.5 1292.5C561.5 1292.5 571.3 1344.9 573.2 1365.7C575.2 1386.4 580.1 1397.2 592 1422.1C603.9 1447 603.8 1458.8 603.8 1458.8C603.8 1458.8 606.4 1484.3 603 1517.5C599.6 1550.7 609.1 1586.2 609.1 1586.2L618.6 1617.5L638 1690.6C638 1690.6 651 1735.1 655 1749.7C659 1764.3 656.8 1773.4 656.8 1773.4C639.6 1813.7 647 1823.3 647 1823.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_6'
                d='M928.8 891.9L938.2 909.7C938.2 909.7 942.1 912.4 951.3 912.5C960.5 912.6 983.2 933.5 983.2 933.5C983.2 933.5 984.2 934.2 998.9 956.1L1008.5 969.1C1008.5 969.1 1021 985.1 1000.6 981.2C1000.6 981.2 990.5 976.9 981.4 965.5C980.3 964.1 978.9 962.8 977.4 961.6C977 961.3 976.5 960.9 976 960.6C975.6 960.3 975.1 960 974.7 959.7C964 953.1 948.9 951.3 948.9 951.3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='Calque 25   copie'>
                <path
                  id='mannequin_16'
                  d='M455.6 281.7C450.6 292.3 418 311 418 311C418 311 390.9 320.3 327.7 326.7C327.7 326.7 251.4 344.2 245.9 491.6C245.9 491.6 235.4 566 218.3 605.8C201.2 645.6 179.4 668.1 146.1 760.6C112.8 853.1 85.6 891.7 85.6 891.7'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_15'
                  d='M558.9 281.9C563.9 292.5 596.5 311.2 596.5 311.2C596.5 311.2 623.6 320.5 686.8 326.9C686.8 326.9 763.1 344.4 768.6 491.8C768.6 491.8 779.1 566.2 796.2 606C813.3 645.8 835.1 668.3 868.4 760.8C901.7 853.3 928.8 892 928.8 892'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <path
                id='mannequin_5'
                d='M327.7 422.1C327.7 422.1 339.9 422.1 338.9 439.4C338 456.7 336 493.6 336 493.6C336 493.6 338.8 536.6 328.7 566.6'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_4'
                d='M687.1 422.5C687.1 422.5 674.9 422.5 675.9 439.8C676.9 457.1 678.8 494 678.8 494C678.8 494 676 537 686.1 567'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_3'
                d='M662.2 1928C662.2 1928 651.3 1866.7 647.6 1824.8C643.9 1782.9 682.2 1786 682.2 1786C682.2 1786 715.7 1785.5 724.3 1824.2'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='t&#195;&#170;te F   copie'>
              <path
                id='mannequin_2'
                d='M455.6 281.7H559.5L638.9 276.4C638.9 276.4 622.9 253.8 625.6 118.6C628.3 -16.6 507.5 2.99999 507.5 2.99999'
                stroke='black'
                strokeWidth='3'
              />
              <path
                id='mannequin_1'
                d='M507.5 3C507.5 3 386.8 -16.7 389.4 118.6C392.1 253.8 376.1 276.4 376.1 276.4L455.5 281.7'
                stroke='black'
                strokeWidth='3'
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2Baby({ lesionnel }: FrontV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_vector'>
        <path
          id='avant_coude_droit'
          d='M294.8,812.3l-130.1-45.8l-9,26l-4.3,13.7l-11,41.4l115.9,16.9l8.5-14.7l5.7-7
	l6.9-10.9L294.8,812.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_droit)}
        />
        <path
          id='avant_epaule_droit'
          d='M253.2,609.8l-3.5,4.2l-8.9,11.3l98.2,23.6l12.7-65.2l9.1-46.7l-16,5.3L321,553.2
	l-14.3,8.5l-12,8.4l-9,7.1l-11.2,9.9l-8.6,8.5l-6.2,6.6L253.2,609.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_droit)}
        />
        <path
          id='avant_bassin_droit'
          d='M252,1219.6l-5.5,36.4h184.7l10-97.6h67.4v-37.3H286.8l-3.5,7.9l-8.3,19.4
	l-7.8,19.9l-8.6,25.7L252,1219.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_droit)}
        />
        <path
          id='avant_main_droit'
          d='M221.3,1003.5c-0.8,2.2-0.5,5,0.1,7.2c4.5,16.9,9.8,33.5,13.5,50.6c2,9.3-4.4,13.8-13.2,9.7
		c-7.6-3.6-14.6-8.6-22-13.1c-8.4,6.7-12.5,30.3-6.7,39.8c2.2,3.6,4.5,7.3,5.9,11.3c2.6,7.8-0.7,12.8-9,13.6
		c-4.2,0.4-8.6,0.4-12.8-0.1c-14.9-2.1-28.6-7.5-41.3-15.5c-5.6-3.6-9.1-8.5-10.1-15.2c-3.5-24-3.4-47.5,8.8-69.5
		c0.9-1.6,1.6-3.5,2.9-4.5c7.9-6.4,6.5-14.2,4.9-23L221.3,1003.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_droit)}
        />
        <path
          id='avant_hypocondre_droit'
          d='M299.1,998.6l-1.7-29l-1.5-31.9l0.1-33.3l2.8-26.4l3.7-24l2.4-14.5l1.9-11.3
	l146.7,0.3l-0.1,170.2L299.1,998.6L299.1,998.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_droit)}
        />
        <path
          id='avant_main_gauche'
          d='M871.2,993.2c-1.2,5.5-0.7,9.4,3.2,13.9c12.1,14.2,15.6,31.6,16,49.7c0.2,8.9-1.2,17.9-2,26.8
		c-0.5,6.3-4,10.8-9.1,14.2c-14,9.2-29.2,15.7-45.9,15.8c-8.5,0.1-17.5-3.3-25.5-6.8c-7-3.1-6.3-7.3-1.1-13.1
		c5.8-6.4,11.3-13.3,15.6-20.7c3.8-6.6,2.4-13.9-2.2-20.3c-2.4-3.3-4.8-3.8-8.5-1.2c-6.8,4.7-14,8.8-21.2,12.9
		c-4.4,2.5-7.4,0.9-8-4.1c-0.5-4-1.7-8.3-0.8-12c3.7-14.7,8.1-29.3,12.2-43.9c0.7-2.4,1.7-5.5,0.7-7.3L871.2,993.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_gauche)}
        />
        <path
          id='avant_pied_droit'
          d='M434.8,1628.4c1.1,3.2,2.7,6.3,4.6,9c8.8,12.7,13.1,26.5,13.1,41.7c0,10.5-5.4,18.9-12.7,25.2
	c-10.6,9.3-22.4,17.1-33.7,25.5c-7.7,5.7-16,10.7-23.1,17.1c-9.1,8.3-18.7,15.1-30.7,18.8c-4.8,1.4-8.7,5.8-13,8.8
	c-4.4,3.1-8.4,6.9-13.2,9c-8,3.5-13-0.5-11.7-9.1c0.8-4.8,3-9.3,4.7-13.9c0.9-2.3,2.7-4.4,3-6.7c2.9-23.8,14.4-44.3,24.5-65.3
	c1.1-2.2,2-4.5,3.1-6.7c4-7.9,3.4-14.4-0.4-21.6L434.8,1628.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_droit)}
        />
        <path
          id='avant_pied_gauche'
          d='M671.9,1658.5l-84.2-30.5c-1.6,3.8-6.8,11.7-9.8,15.2c-2.3,2.6-3.7,6.2-4.8,9.6
	c-8.4,26.4-6,38,10.8,54c7.3,6.9,15.2,13.5,24,18.4c13.5,7.5,25.9,16,36.6,27.1c2.7,2.9,6.2,5.6,9.8,7c12.7,5.1,25,10.2,34.6,20.7
	c3.6,4,10.2,6.9,15.3,2.8c5.1-4.1,2.8-10.4,0.7-15.7c-2-5-4.7-9.7-6.5-14.7c-4.8-14.2-8.7-28.7-13.9-42.7
	c-3.8-10.3-9.4-19.9-13.9-29.9c-3.1-6.8-3.5-13,0.1-19.3'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_gauche)}
        />
        <path
          id='avant_epaule_gauche'
          d='M768.6,611.4l3.5,4.2l8.9,11.3l-100.6,24.2l-11.2-65.8l-8.1-46.7l16,5.3l23.8,10.9
	l13.7,9.3l11.3,8.1l9.3,7.4l11.4,9.9l9.3,7.7l6.2,6.6L768.6,611.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_gauche)}
        />
        <path
          id='avant_coude_gauche'
          d='M725.9,812.4l129.5-46.1l6.5,23.2l3.7,14l8.4,44.2l-112.5,17.2l-3.3-10.8
	l-10.3-13.6l-8.1-10.7L725.9,812.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_gauche)}
        />
        <path
          id='avant_tete'
          d='M420.2,515.4l19.9,10.6l137.9-1.7l13.9-8.9c0,0,31.1-11.5,50.9-48.7l11.1-20.6l3-11.2l5.2-24.9
	l5.2-28.7l7-42.6l0.3-15.7l-0.5-15.2l-3.5-26.3l-5-25l-5-22.2l-5.4-18.8l-7.2-18.4l-9.2-17.2l-9.8-13.3l-8.7-8.9l-9.2-7.6l-13.1-8.4
	l-20.7-9.3l-16.4-5l-20.7-4.1c0,0-20.3-3.4-39.3-2.6c-19,0.9-29.4,2-29.4,2s-23.8,1.5-49.9,14c-26.1,12.4-37.8,28.8-37.8,28.8
	s-17.9,16.1-31.4,57.9c-13.5,41.8-13.2,83.9-13.2,83.9l0.2,28.4l9.7,60.1l7.8,40.1l3.4,12.6l10.8,21.6c0,0,10.7,21.7,24.6,31.4
	S420.2,515.4,420.2,515.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <polyline
          id='avant_genou_gauche'
          points='775.7,1458.2 771,1466.9 619.8,1445.6 624.6,1433.6 628.1,1423.7 627.9,1416.1
	625.4,1409.3 788.6,1396.3 787.9,1404.8 784.7,1426.2 781.4,1440.1 775.7,1458.2 '
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_gauche)}
        />
        <polyline
          id='avant_genou_droit'
          points='246.8,1458.2 251.5,1466.9 402.7,1445.5 397.8,1433.6 394.4,1423.7 394.6,1416
	397.1,1409.3 233.8,1396.3 234.5,1404.8 237.8,1426.2 241.1,1440.1 246.8,1458.2 '
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_droit)}
        />
        <path
          id='avant_cuisse_gauche'
          d='M788.6,1396.3c1.5-22.6,1.5-15.3-0.2-37c-2.7-34.5-8.8-68.8-12.4-103.2H553.5
	c3.2,6.9,6.4,13.9,9.7,20.9c20.6,44.2,41.3,88.3,62.2,132.3c2.4,4.9,0.7-4.8,0,0L788.6,1396.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_gauche)}
        />
        <path
          id='avant_jambe_droit'
          d='M348.5,1659.2c-17.2-26.9-33.7-54.4-48.1-83c-17.1-34.1-32.3-69.3-47-104.5
	c-6.5-15.6,1.1,11.6-1.9-4.8l151.2-21.4c0.3,2-0.9-2.1,0,0c18.4,50.1,22.2,86.5,27.1,139.7c1.2,13.2,2.3,26.5,4.3,39.6
	c0.2,1,0.4,2.1,0.6,3.2L348.5,1659.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_droit)}
        />
        <path
          id='avant_cuisse_droit'
          d='M233.8,1396.3c-1.5-22.6-1.5-15.3,0.2-37c2.7-34.5,8.8-68.8,12.4-103.2h222.5
	c-3.2,6.9-6.4,13.9-9.7,20.9c-20.6,44.2-41.3,88.3-62.2,132.3c-2.4,4.9-0.7-4.8,0,0L233.8,1396.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_droit)}
        />
        <path
          id='avant_jambe_gauche'
          d='M671.9,1658.5c17.2-26.9,35.8-53.7,50.1-82.3c17.1-34.1,32.3-69.3,47-104.5
	c6.5-15.6-1.1,11.6,1.9-4.8l-151.2-21.4c-0.3,2,0.9-2.1,0,0c-18.4,50.1-22.2,86.5-27.1,139.7c-1.2,13.2-2.3,26.5-4.3,39.6
	c-0.2,1-0.4,2.1-0.6,3.2L671.9,1658.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_gauche)}
        />
        <path
          id='avant_genital'
          d='M431.1,1256.1l10.6-96.5h133.7l6,96.4h-28.2l-13.7-30.6l-25.5-0.2l-31.1,0.2l-13.9,30.8
	h-37.9V1256.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genital)}
        />
        <path
          id='avant_avant_bras_gauche'
          d='M816.5,856.6l58.9-9.3l2.7,18.7l1.5,16.8l0.7,17.7v14l-0.4,12.4l-2.7,31
	l-6.1,35.4l-30.4,1.5l-28,1.4l-18.2,0.9l-9.4-21.9l-3.4-9.2l-4.8-16l-4-17.9l-3.1-15.8l-2.6-14.5l-3.9-22.5l-2-14.3L816.5,856.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_gauche)}
        />
        <path
          id='avant_cou'
          d='M360.9,537l-21.8,111.9l341.2,2.2L660.8,537c0,0-16-6.5-55.8-12.2l-193.6,1.5L360.9,537z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cou)}
        />
        <path
          id='avant_bras_droit'
          d='M339.1,648.9l-98.2-23.6l-10,13.6L220.6,654l-10.4,16.6l-3.3,5.5l-2.8,4.9l-3.8,6.8
	l-4.9,8.1l-5.5,11.9l-9.1,19.4l-16.1,39.3l130,45.7l8.6-11l8.2-11.1l2.6-13.1l2.6-13.2l2.1-11l2.1-10.7l1.4-7.4l2.8-14.3l2.4-12.5
	l5.4-27.8l2.8-14.4L339.1,648.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_droit)}
        />
        <path
          id='avant_avant_bras_droit'
          d='M199.6,856.2l-59.2-8.6l-3.6,24.4l-1.5,16.8l-0.7,17.7v14l0.4,12.4l2.7,31
	l4.6,30.9l32.3,3.6l27.8,3.1l19,2.1l8.5-22.3l3.4-9.2l4.8-16l4-17.9l3.1-15.8l2.6-14.5l3.9-22.5l4.8-20.7L199.6,856.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_droit)}
        />
        <path
          id='avant_hypocondre_gauche'
          d='M563.7,998.6l-0.1-170.2h148.3l1.2,9.3l2.1,7l2.5,12.8l2.7,13.8l4.2,24.1
	l2.3,29l-0.5,32l-3,42.2L563.7,998.6L563.7,998.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_gauche)}
        />
        <path
          id='avant_bras_gauche'
          d='M680.5,651l100.4-24.2l17.7,22.7l9.9,15.3l9.9,17l3.2,5.9l2.7,5.2l2.8,6.5l4.9,8.1
	l5.5,11.9l7.5,19.7l9.9,27.3l-128,45.8l-6.2-7l-3-3.8l-8.4-10.9l-6.3-6.3l-3-17.3l-1.3-7.7l-1.5-9.1l-2-11.9l-2.7-15.8l-4.4-25.9
	l-3.2-18.5L680.5,651z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_gauche)}
        />
        <path
          id='avant_fosse_iliaque_gauche'
          d='M563.7,1121.1V998.6h159.7l-1.9,21.4l-2,22.5l-1.2,14.4l-1.1,18.2l1.1,6.6
	l5.5,13.4l12.7,28L563.7,1121.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_gauche)}
        />
        <path
          id='avant_fosse_iliaque_droit'
          d='M302.1,1035.8l-3-37.2h154.2v122.5H286.8l10.8-24.1l5-16.5l1.8-15.3
	l-0.3-9.4L302.1,1035.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_droit)}
        />
        <path
          id='avant_epigastrique'
          d='M563.6,828.4H453.4l-0.1,170.2h110.4L563.6,828.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epigastrique)}
        />
        <path
          id='avant_buste_gauche'
          d='M511.4,828.1l0.3-179.1l168.5,2.2L703,784.4l8.9,44.1L511.4,828.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_gauche)}
        />
        <path
          id='avant_bassin_gauche'
          d='M508.6,1121.1v37.3h67.9l4.9,97.5h194.1l-4.6-27.1l-4.9-23.5l-1.7-7l-2.1-7.7
	l-2.5-8.4l-2.2-6.6l-2.2-6.4l-5.4-14.3l-5.9-14.6l-7.5-17.3L508.6,1121.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_gauche)}
        />
        <path
          id='avant_buste_droit'
          d='M511.6,828.1H306.8l3-20.7l1.8-17.2L339.1,649h172.6L511.6,828.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_droit)}
        />
        <path
          id='avant_hypogastrique'
          d='M563.7,998.6H453.4l-0.6,122.5l110.8,0.1L563.7,998.6L563.7,998.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypogastrique)}
        />
        <path
          id='mannequin_oreille_gauche'
          d='M674.3,337.4c0,0-14.3,91.7-21,109.7c0,0,6.8,4.1,14.3,1.4c7.6-2.8,15.8-12.6,18.8-25.3c5.9-25,14.3-52.1,14.3-52.1s7.2-31.2-2.1-34.9c-3.3-1.3-9.7-5.1-13.5-4.9C678.1,331.8,674.3,337.4,674.3,337.4z'
          stroke='black'
          strokeWidth='3'
          strokeMiterlimit='10'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <path
          id='mannequin_oreille_droite'
          d='M339.2,335c0,0,14,93.6,20.7,111.6c-3.8,1.3-16.9,2.9-22.8,0.1c-5-2.4-8-13.3-9.1-23.4c-2.8-25.5-12.2-52.2-12.2-52.2s-2.6-34.8,6.8-38.5C332,328.7,339.2,335,339.2,335z'
          stroke='black'
          strokeWidth='3'
          strokeMiterlimit='10'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <g id='Mannequin global V2'>
          <g id='Baby'>
            <g id='avant_nourisson'>
              <path
                id='silhouette'
                d='M578.1,524.4c1.4-1.6,28.9,2.3,33.3,2.6c12.4,0.8,24.8,3.1,36.8,6.3c38,10.1,71.5,31.5,100.2,58
		c40.6,37.3,69.1,83,90.6,133.4c19.7,46.1,32.5,94.3,38.8,144c5.3,41.9,2.1,83.5-6.6,124.7c-1.2,5.5-0.7,9.4,3.2,13.9
		c12.1,14.2,15.6,31.6,16,49.7c0.2,8.9-1.2,17.9-2,26.8c-0.5,6.3-4,10.8-9.1,14.2c-14,9.2-29.2,15.7-45.9,15.8
		c-8.5,0.1-17.5-3.3-25.5-6.8c-7-3.1-6.3-7.3-1.1-13.1c5.8-6.4,11.3-13.3,15.6-20.7c3.8-6.6,2.4-13.9-2.2-20.3
		c-2.4-3.3-4.8-3.8-8.5-1.2c-6.8,4.7-14,8.8-21.2,12.9c-4.4,2.5-7.4,0.9-8-4.1c-0.5-4-1.7-8.3-0.8-12c3.7-14.7,8.1-29.3,12.2-43.9
		c0.7-2.4,1.7-5.5,0.7-7.3c-13.8-26-20.1-54.2-25-82.9c-2.8-16.4-5-32.9-8.2-49.2c-1.1-5.5-3.7-11.2-7-15.7
		c-16-21.4-32.5-42.5-48.8-63.6c-0.4-0.5-1.1-0.7-2.5-1.5c1.8,9,3.6,17.3,5.2,25.6c5.1,26,10.5,52,15.1,78.1
		c5.8,33.1,3.4,66.4,0.9,99.5c-2.1,27.8-5.1,55.5-7.1,83.3c-0.4,5.5,0.9,11.7,3.2,16.7c15.9,35,32.7,69.7,42.9,106.8
		c6.2,22.6,9.9,46,13.5,69.3c4.5,29.1,8.6,58.3,11.1,87.5c4.4,51.1-6.4,99.7-27.7,146.1c-20.3,44.3-41.5,88.2-66.7,130
		c-6.1,10.2-12.6,20.3-20.2,29.4c-6.3,7.6-6.4,14.9-2.7,23.1c4.6,10,10.1,19.6,13.9,29.9c5.2,14,9.2,28.5,13.9,42.7
		c1.7,5.1,4.5,9.7,6.5,14.7c2.1,5.3,4.3,11.6-0.7,15.7c-5.1,4.1-11.6,1.2-15.3-2.8c-9.6-10.5-21.9-15.6-34.6-20.7
		c-3.6-1.5-7.1-4.1-9.8-7c-10.7-11.2-23.1-19.7-36.6-27.1c-8.7-4.8-16.7-11.4-24-18.4c-16.8-16-19.2-27.6-10.8-54
		c1.1-3.4,2.5-7,4.8-9.6c9.8-11.3,10.8-25.1,12.4-39c3.6-31.5,7.3-62.9,11.9-94.3c4.2-28.8,13.4-56.3,24.6-83.2
		c2-4.9,2-9.2-0.3-14.1c-25.9-55.1-51.6-110.2-77.4-165.4c-3.5-7.5-6.7-15.2-9.7-22c-18.9,0-37.4,0-56.6,0
		c-7.5,16.4-15.5,34-23.6,51.5c-20.6,44.2-41.3,88.3-62.2,132.3c-3.3,7-4.1,13.3-1,20.5c21.3,48.7,28.6,100.4,33.6,152.7
		c1.2,13,2.3,26,4.3,38.9c0.9,5.5,3.2,11.3,6.4,15.9c8.8,12.7,13.1,26.5,13.1,41.7c0,10.5-5.4,18.9-12.7,25.2
		c-10.6,9.3-22.4,17.1-33.7,25.5c-7.7,5.7-16,10.7-23.1,17.1c-9.1,8.3-18.7,15.1-30.7,18.8c-4.8,1.4-8.7,5.8-13,8.8
		c-4.4,3.1-8.4,6.9-13.2,9c-8,3.5-13-0.5-11.7-9.1c0.8-4.8,3-9.3,4.7-13.9c0.9-2.3,2.7-4.4,3-6.7c2.9-23.8,14.4-44.3,24.5-65.3
		c1.1-2.2,2-4.5,3.1-6.7c4.9-9.6,2.9-17.1-3.3-26.5c-17.3-26.4-34.1-53.5-48.5-81.5c-17.2-33.5-32.6-68-47.4-102.7
		c-15.2-35.5-20.7-73.3-17.6-111.6c2.8-35.8,9.3-71.3,12.8-107c5.2-52.7,25.7-100.3,47.5-147.4c7.7-16.7,11.6-32.5,9.5-51.5
		c-4.5-40.6-6.5-81.5-8.2-122.4c-1.3-31.1,4.4-61.8,9.5-92.4c2.6-15.9,5.2-31.8,6.5-48.2c-2.7,3.7-5.4,7.5-8.2,11.1
		c-12.8,16.3-25.4,32.6-38.5,48.6c-6.7,8.1-10.1,17.2-11.9,27.4c-4.6,26.3-8.8,52.8-15,78.7c-3.9,16.3-11.2,31.7-16.7,47.6
		c-0.8,2.2-0.5,5,0.1,7.2c4.5,16.9,9.8,33.5,13.5,50.6c2,9.3-4.4,13.8-13.2,9.7c-7.6-3.6-14.6-8.6-22-13.1
		c-8.4,6.7-12.5,30.3-6.7,39.8c2.2,3.6,4.5,7.3,5.9,11.3c2.6,7.8-0.7,12.8-9,13.6c-4.2,0.4-8.6,0.4-12.8-0.1
		c-14.9-2.1-28.6-7.5-41.3-15.5c-5.6-3.6-9.1-8.5-10.1-15.2c-3.5-24-3.4-47.5,8.8-69.5c0.9-1.6,1.6-3.5,2.9-4.5
		c7.9-6.4,6.5-14.2,4.9-23c-9.9-55.9-11.8-111.9,3.1-167.2c20.7-76.6,52.3-148.2,102.2-210.8c23.7-29.7,53.9-54.2,88.6-69.9
		c17.7-8,36.5-13.7,55.6-17c16.9-2.9,34.5-0.7,51.1-3.7c-3.3,0.6-16.4-8-19.7-9.5c-9.1-4.1-17.9-8.7-26-14.5
		c-19.1-13.7-25.6-32.6-36.2-52.4c-1.4-2.6,0,0-0.9-3.1c-13.1,5-28.4,0.6-30.2-10c-2.4-14.3-4.5-30.8-4.5-30.8
		c-1.2-8.6-8.1-26.4-9.4-34.8c-2.7-17.5-4.2-50.5,23.4-36c0-4.6,0,0-0.1-4.6c-1.9-63.8,10.3-147.1,67.8-185.6
		c26.6-17.8,59.8-23.6,91.3-24.2c29.4-0.6,61.4,3.5,88.6,15.3c17.3,7.5,33.3,18.9,45,33.8c17.2,21.8,25.8,49,31.6,75.8
		c6,27.6,12.4,56.6,11.5,84.9c-0.1,2.2-0.4,4.4-0.4,7.1c1.7,0,6-9.7,17.5-4.8c14.1,6,12.1,19.1,10.7,30.4
		c-2.7,13.5-7,22.5-10.3,35.1c-3.4,12.8-2,23.4-8.5,34.2c-6.9,11.5-16.2,16-16.2,16c-9,2-13.5-2.7-14.3-1.4
		c-8.1,15.4-17.7,32.9-29.9,45.9c-6.3,6.7-13.4,12.5-21.4,17.1C593.8,514.8,584.6,517,578.1,524.4z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
            </g>
            <g id='tete'>
              <path
                id='mannequin_tete'
                d='M420.2,515.4l19.9,10.6l137.9-1.7l13.9-8.9c0,0,31.1-11.5,50.9-48.7l11.1-20.6l3-11.2l5.2-24.9
	l5.2-28.7l7-42.6l0.3-15.7l-0.5-15.2l-3.5-26.3l-5-25l-5-22.2l-5.4-18.8l-7.2-18.4l-9.2-17.2l-9.8-13.3l-8.7-8.9l-9.2-7.6l-13.1-8.4
	l-20.7-9.3l-16.4-5l-20.7-4.1c0,0-20.3-3.4-39.3-2.6c-19,0.9-29.4,2-29.4,2s-23.8,1.5-49.9,14c-26.1,12.4-37.8,28.8-37.8,28.8
	s-17.9,16.1-31.4,57.9c-13.5,41.8-13.2,83.9-13.2,83.9l0.2,28.4l9.7,60.1l7.8,40.1l3.4,12.6l10.8,21.6c0,0,10.7,21.7,24.6,31.4
	S420.2,515.4,420.2,515.4z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
            </g>
            <g id='corps'>
              <path
                id='téton_droit'
                d='M412.6,786.9c2,0,3.7-0.9,3.7-2s-1.6-2-3.7-2c-2,0-3.7,0.9-3.7,2S410.6,786.9,412.6,786.9z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
              <path
                id='téton_gauche'
                d='M602.2,787.1c2.2,0,4-1,4-2.3c0-1.2-1.8-2.3-4-2.3s-4,1-4,2.3S600,787.1,602.2,787.1z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
              {/*<path
								id="nombril"
								d="M508.1,1034.1c2,0,3.7-2.8,3.7-6.4s-1.6-6.4-3.7-6.4c-2,0-3.7,2.8-3.7,6.4
	S506.1,1034.1,508.1,1034.1z"
								stroke="black"
								strokeWidth="3"
								strokeMiterlimit="10"
							/>*/}
            </g>
            <g id='bouche'>
              <path
                id='mannequin_bouche_2'
                d='M555.1,440.2c-50.9,11.3-86.4,0.5-86.4,0.5l37.3-9.8l5.6,1.2l6.8-1.2L555.1,440.2z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='bouche_1'>
                <path
                  id='mannequin_bouche_1'
                  d='M468.6,440.8c0,0,38.7,41.4,86.4-0.5'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='yeux'>
              <path
                id='mannequin_yeux_droit'
                d='M416.1,320.5c0,0,23.5,22.1,60.2,0'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
              <path
                id='mannequin_yeux_gauche'
                d='M546.5,320.5c0,0,23.5,22.1,60.2,0'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
            </g>
            <g id='sourcils'>
              <path
                id='mannequin_sourcil_2'
                d='M416.8,270.8c0,0,31.3-12.6,62-8.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_sourcil_1'
                d='M607.5,270.8c0,0-31.3-12.6-62-8.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='nez'>
              <path
                id='mannequin_nez_4'
                d='M495.3,353.3l-5.5,10.4l-5.5,7.5c0,0-7.8,11.8,1.5,19.1'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_3'
                d='M528.1,354.1l5.5,10.4l5.5,7.5c0,0,7.8,11.8-1.5,19.1'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_2'
                d='M492.7,383c0,0,3.6,3.5,11.6,3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_1'
                d='M531.3,383c0,0-3.6,3.5-11.6,3'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2Baby({ lesionnel }: BackV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_vector'>
        <path
          id='arriere_oreille_gauche'
          d='M329.5,364.5c0,0,14,93.6,20.7,111.6c-3.8,1.3-16.9,2.9-22.8,0.1
	c-5-2.4-8-13.3-9.1-23.4c-2.8-25.5-12.2-52.2-12.2-52.2s-2.6-34.8,6.8-38.5C322.3,358.2,329.5,364.5,329.5,364.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <path
          id='arriere_oreille_droite'
          d='M664.6,366.9c0,0-14.3,91.7-21,109.7c0,0,6.8,4.1,14.3,1.4c7.6-2.8,15.8-12.6,18.8-25.3
	c5.9-25,14.3-52.1,14.3-52.1s7.2-31.2-2.1-34.9c-3.3-1.3-9.7-5.1-13.5-4.9C668.4,361.3,664.6,366.9,664.6,366.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <path
          id='arriere_lombaire_gauche'
          d='M288.9,1020.5l-1-16.4l195.2,0.9v106.5l-190.7,0.6l2.2-16.5l-2.3-30.3L290,1038
	l-0.5-7.4L288.9,1020.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_gauche)}
        />
        <path
          id='arriere_jambe_gauche'
          d='M338.8,1688.7c-17.2-26.9-33.7-54.4-48.1-83c-17.1-34.1-32.3-69.3-47-104.5
	c-6.5-15.6,1.1,11.6-1.9-4.8L393,1475c0.3,2-0.9-2.1,0,0c18.4,50.1,22.2,86.5,27.1,139.7c1.2,13.2,2.3,26.5,4.3,39.6
	c0.2,1,0.4,2.1,0.6,3.2L338.8,1688.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_gauche)}
        />
        <path
          id='arriere_pied_gauche'
          d='M425,1657.9c1.1,3.2,2.7,6.3,4.6,9c8.8,12.7,13.1,26.5,13.1,41.7
	c0,10.5-5.4,18.9-12.7,25.2c-10.6,9.3-22.4,17.1-33.7,25.5c-7.7,5.7-16,10.7-23.1,17.1c-9.1,8.3-18.7,15.1-30.7,18.8
	c-4.8,1.4-8.7,5.8-13,8.8c-4.4,3.1-8.4,6.9-13.2,9c-8,3.5-13-0.5-11.7-9.1c0.8-4.8,3-9.3,4.7-13.9c0.9-2.3,2.7-4.4,3-6.7
	c2.9-23.8,14.4-44.3,24.5-65.3c1.1-2.2,2-4.5,3.1-6.7c4-7.9,3.4-14.4-0.4-21.6L425,1657.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_gauche)}
        />
        <path
          id='arriere_coude_droit'
          d='M716.1,841.9l129.5-46.1l6.5,23.2l3.7,14l8.4,44.2l-112.5,17.2l-3.3-10.8l-10.3-13.6
	l-8.1-10.7L716.1,841.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_droit)}
        />
        <path
          id='arriere_bassin_gauche'
          d='M483.1,1189.9H260.5l7.2-17.7l7.1-16.3l11.1-24.5l6.6-19.3h190.7V1189.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_gauche)}
        />
        <path
          id='arriere_coude_gauche'
          d='M285,841.8L155,796l-9,26l-4.3,13.7l-11,41.4L246.6,894l8.5-14.7l5.7-7l6.9-10.9
	L285,841.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_gauche)}
        />
        <path
          id='arriere_tete'
          d='M410.3,544.6H582c0,0,31.1-11.5,50.9-48.7l11.1-20.6l3-11.2l5.2-24.9l5.2-28.7l7-42.6l0.3-15.7
	l-0.5-15.2l-3.5-26.3l-5-25l-5-22.2l-5.4-18.8l-7.2-18.4l-9.2-17.2l-9.8-13.3l-8.7-8.9l-9.2-7.6l-13.1-8.4l-20.7-9.3l-16.4-5
	l-20.7-4.1c0,0-20.3-3.4-39.3-2.6s-29.4,2-29.4,2s-23.8,1.5-49.9,14c-26.1,12.4-37.8,28.8-37.8,28.8s-17.9,16.1-31.4,57.9
	c-13.5,41.8-13.2,83.9-13.2,83.9l0.2,28.4l9.7,60.1l7.8,40.1l3.4,12.6l10.8,21.6c0,0,10.7,21.7,24.6,31.4S410.3,544.6,410.3,544.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <polyline
          id='arriere_genou_droit'
          points='766,1487.7 761.2,1496.4 610,1475.1 614.9,1463.1 618.3,1453.2 618.1,1445.6
	615.6,1438.8 778.9,1425.8 778.2,1434.3 774.9,1455.7 771.6,1469.6 766,1487.7 '
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_droit)}
        />
        <path
          id='arriere_nuque'
          d='M410.3,544.6H582l-13.7,9.4l39,3l15.4,2.2l27,6.9l10.6,55.2l-88.3,0.2l-61.9-0.2l0,0V548
	l-27.1-0.2l0.5,73.5h-69H391h-50.5l10.7-54.8l22.6-5.6l24-3.2l32.5-1.7L410.3,544.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_nuque)}
        />
        <path
          id='arriere_cuisse_gauche'
          d='M224.1,1425.8c-1.5-22.6-1.5-15.3,0.2-37c2.7-34.5,8.8-68.8,12.4-103.2l222.5,0
	c-3.2,6.9-6.4,13.9-9.7,20.9c-20.6,44.2-41.3,88.3-62.2,132.3c-2.4,4.9-0.7-4.8,0,0L224.1,1425.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_gauche)}
        />
        <path
          id='arriere_buste_gauche'
          d='M483.1,865.4H350.2l-54.4-0.2l5.3-37.2l1.9-13.9l5.8-30l11.1-57l9.5-48.8l3-15.3
	l2.3-11.6l2.2-11.4l3.7-18.8h143.1l-0.5,52.7v63.3V792v35.3v15.4V865.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_gauche)}
        />
        <path
          id='arriere_fesse_gauche'
          d='M483.4,1190.8l-222.9-0.9l-9.5,26.7l-6.8,24.2l-5.4,27.6l-2,17.2l195.3,0l27.2,0
	l3.7-8.5l4.8-10.6l5.3-11.7l10.2,0.9V1190.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_gauche)}
        />
        <path
          id='arriere_epaule_gauche'
          d='M243.5,639.3l-3.5,4.2l-8.9,11.3l98.2,23.6l12.7-65.2l9.1-46.7l-16,5.3l-23.8,10.9
	l-14.3,8.5l-12,8.4l-9,7.1l-11.2,9.9l-8.6,8.5l-6.2,6.6L243.5,639.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_gauche)}
        />
        <path
          id='arriere_bras_gauche'
          d='M329.3,678.4l-98.2-23.6l-10,13.6l-10.3,15.1l-10.4,16.6l-3.3,5.5l-2.8,4.9l-3.8,6.8
	l-4.9,8.1l-5.5,11.9l-9.1,19.4L155,796l130,45.7l8.6-11l8.2-11.1l2.6-13.1l2.6-13.2l2.1-11l2.1-10.7l1.4-7.4l2.8-14.3l2.4-12.5
	l5.4-27.8l2.8-14.4L329.3,678.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_gauche)}
        />
        <path
          id='arriere_avant_bras_gauche'
          d='M189.9,885.7l-59.2-8.6l-3.6,24.4l-1.5,16.8l-0.7,17.7v14l0.4,12.4l2.7,31
	l4.6,30.9l32.3,3.6l27.8,3.1l19,2.1l8.5-22.3l3.4-9.2l4.8-16l4-17.9l3.1-15.8l2.6-14.5l3.9-22.5l4.8-20.7L189.9,885.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_gauche)}
        />
        <path
          id='arriere_cuisse_droit'
          d='M778.9,1425.8c1.5-22.6,1.5-15.3-0.2-37c-2.7-34.5-8.8-68.8-12.4-103.2l-222.5,0
	c3.2,6.9,6.4,13.9,9.7,20.9c20.6,44.2,41.3,88.3,62.2,132.3c2.4,4.9,0.7-4.8,0,0L778.9,1425.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_droit)}
        />
        <path
          id='arriere_jambe_droit'
          d='M662.2,1688c17.2-26.9,35.8-53.7,50.1-82.3c17.1-34.1,32.3-69.3,47-104.5
	c6.5-15.6-1.1,11.6,1.9-4.8L610,1475.1c-0.3,2,0.9-2.1,0,0c-18.4,50.1-22.2,86.5-27.1,139.7c-1.2,13.2-2.3,26.5-4.3,39.6
	c-0.2,1-0.4,2.1-0.6,3.2L662.2,1688z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_droit)}
        />
        <polyline
          id='arriere_genou_gauche'
          points='237,1487.7 241.8,1496.4 393,1475 388.1,1463.1 384.6,1453.2 384.9,1445.5
	387.4,1438.8 224.1,1425.8 224.8,1434.3 228.1,1455.7 231.3,1469.6 237,1487.7 '
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_gauche)}
        />
        <path
          id='arriere_bassin_droit'
          d='M510.7,1189.9l-0.5-77.8l198.2-1.5l22.3,50.9l11.4,27.7L510.7,1189.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_droit)}
        />
        <path
          id='arriere_main_droit'
          d='M861.5,1022.7c-1.2,5.5-0.7,9.4,3.2,13.9c12.1,14.2,15.6,31.6,16,49.7c0.2,8.9-1.2,17.9-2,26.8
		c-0.5,6.3-4,10.8-9.1,14.2c-14,9.2-29.2,15.7-45.9,15.8c-8.5,0.1-17.5-3.3-25.5-6.8c-7-3.1-6.3-7.3-1.1-13.1
		c5.8-6.4,11.3-13.3,15.6-20.7c3.8-6.6,2.4-13.9-2.2-20.3c-2.4-3.3-4.8-3.8-8.5-1.2c-6.8,4.7-14,8.8-21.2,12.9
		c-4.4,2.5-7.4,0.9-8-4.1c-0.5-4-1.7-8.3-0.8-12c3.7-14.7,8.1-29.3,12.2-43.9c0.7-2.4,1.7-5.5,0.7-7.3L861.5,1022.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_droit)}
        />
        <path
          id='arriere_bras_droit'
          d='M670.8,680.5l100.4-24.2l17.7,22.7l9.9,15.3l9.9,17l3.2,5.9l2.7,5.2l2.8,6.5l4.9,8.1
	l5.5,11.9l7.5,19.7l9.9,27.3l-128,45.8l-6.2-7l-3-3.8l-8.4-10.9l-6.3-6.3l-3-17.3l-1.3-7.7l-1.5-9.1l-2-11.9l-2.7-15.8l-4.4-25.9
	l-3.2-18.5L670.8,680.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_droit)}
        />
        <path
          id='arriere_epaule_droit'
          d='M758.8,640.9l3.5,4.2l8.9,11.3l-100.6,24.2l-11.2-65.8l-8.1-46.7l16,5.3l23.8,10.9
	l13.7,9.3l11.3,8.1l9.3,7.4l11.4,9.9l9.3,7.7l6.2,6.6L758.8,640.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_droit)}
        />
        <path
          id='arriere_main_gauche'
          d='M211.6,1033c-0.8,2.2-0.5,5,0.1,7.2c4.5,16.9,9.8,33.5,13.5,50.6c2,9.3-4.4,13.8-13.2,9.7
		c-7.6-3.6-14.6-8.6-22-13.1c-8.4,6.7-12.5,30.3-6.7,39.8c2.2,3.6,4.5,7.3,5.9,11.3c2.6,7.8-0.7,12.8-9,13.6
		c-4.2,0.4-8.6,0.4-12.8-0.1c-14.9-2.1-28.6-7.5-41.3-15.5c-5.6-3.6-9.1-8.5-10.1-15.2c-3.5-24-3.4-47.5,8.8-69.5
		c0.9-1.6,1.6-3.5,2.9-4.5c7.9-6.4,6.5-14.2,4.9-23L211.6,1033z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_gauche)}
        />
        <path
          id='arriere_dorsal_gauche'
          d='M288.8,909.2l3.6-23.6l3.4-20.3l187.3,0.9v137.9H287.9l-1.5-30.8l-0.8-21.5l1-23.7
	L288.8,909.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_gauche)}
        />
        <path
          id='arriere_buste_droit'
          d='M510.7,865.2l-0.5-243.9h150.2l10.1,59.2l6.2,36.2l3.1,17.9l2.8,16.2l3.1,18.4
	l5.9,34.6l3.6,19.2l8.4,42.2h-55.1L510.7,865.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_droit)}
        />
        <path
          id='arriere_dorsal_droit'
          d='M510.7,1005V865.9l138.4-0.2l54.6-0.5l6,30.3l2.1,10.9l2,11l0.9,5.8l1.6,14.4
	l1.1,22.4l-1.7,43.5L510.7,1005z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_droit)}
        />
        <path
          id='arriere_avant_bras_droit'
          d='M806.7,886.1l58.9-9.3l2.7,18.7l1.5,16.8l0.7,17.7v14l-0.4,12.4l-2.7,31
	l-6.1,35.4l-30.4,1.5l-28,1.4l-18.2,0.9l-9.4-21.9l-3.4-9.2l-4.8-16l-4-17.9l-3.1-15.8l-2.6-14.5l-3.9-22.5l-2-14.3L806.7,886.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_droit)}
        />
        <path
          id='arriere_pied_droit'
          d='M662.2,1688l-84.2-30.5c-1.6,3.8-6.8,11.7-9.8,15.2c-2.3,2.6-3.7,6.2-4.8,9.6
	c-8.4,26.4-6,38,10.8,54c7.3,6.9,15.2,13.5,24,18.4c13.5,7.5,25.9,16,36.6,27.1c2.7,2.9,6.2,5.6,9.8,7c12.7,5.1,25,10.2,34.6,20.7
	c3.6,4,10.2,6.9,15.3,2.8c5.1-4.1,2.8-10.4,0.7-15.7c-2-5-4.7-9.7-6.5-14.7c-4.8-14.2-8.7-28.7-13.9-42.7
	c-3.8-10.3-9.4-19.9-13.9-29.9c-3.1-6.8-3.5-13,0.1-19.3'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_droit)}
        />
        <path
          id='arriere_fesse_droit'
          d='M742,1189.2l-231.4,1.6v64.7l19.1-0.7l6.7,15.4l7.3,15.3h147.9l74.6,0l-8.2-43
	L750,1212L742,1189.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_droit)}
        />
        <path
          id='arriere_lombaire_droit'
          d='M510.7,1005.4l-0.5,105.8l198.2-0.6l-0.9-10.3l2.2-26.9l3.3-36.7l2.6-33.2
	L510.7,1005.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_droit)}
        />
        <path
          id='arriere_colonne_haut'
          d='M510.2,548l-27.1-0.2l0.5,82.3h26.2L510.2,548z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_haut)}
        />
        <path
          id='arriere_colonne_milieu_bas'
          d='M510,891.5h-26.4v202.9H510V891.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_bas)}
        />
        <path
          id='arriere_colonne_milieu_haut'
          d='M509.8,650h-26.2v227h26.2V650z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_haut)}
        />
        <path
          id='arriere_colonne_bas'
          d='M510,1111.3h-26.4v143.6H510V1111.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_bas)}
        />
        <g id='Mannequin nourisson global V2'>
          <g id='arriere_nourisson'>
            <path
              id='silhouette'
              d='M568.4,553.9c1.4-1.6,28.9,2.3,33.3,2.6c12.4,0.8,24.8,3.1,36.8,6.3c38,10.1,71.5,31.5,100.2,58
		c40.6,37.3,69.1,83,90.6,133.4c19.7,46.1,32.5,94.3,38.8,144c5.3,41.9,2.1,83.5-6.6,124.7c-1.2,5.5-0.7,9.4,3.2,13.9
		c12.1,14.2,15.6,31.6,16,49.7c0.2,8.9-1.2,17.9-2,26.8c-0.5,6.3-4,10.8-9.1,14.2c-14,9.2-29.2,15.7-45.9,15.8
		c-8.5,0.1-17.5-3.3-25.5-6.8c-7-3.1-6.3-7.3-1.1-13.1c5.8-6.4,11.3-13.3,15.6-20.7c3.8-6.6,2.4-13.9-2.2-20.3
		c-2.4-3.3-4.8-3.8-8.5-1.2c-6.8,4.7-14,8.8-21.2,12.9c-4.4,2.5-7.4,0.9-8-4.1c-0.5-4-1.7-8.3-0.8-12c3.7-14.7,8.1-29.3,12.2-43.9
		c0.7-2.4,1.7-5.5,0.7-7.3c-13.8-26-20.1-54.2-25-82.9c-2.8-16.4-5-32.9-8.2-49.2c-1.1-5.5-3.7-11.2-7-15.7
		c-16-21.4-32.5-42.5-48.8-63.6c-0.4-0.5-1.1-0.7-2.5-1.5c1.8,9,3.6,17.3,5.2,25.6c5.1,26,10.5,52,15.1,78.1
		c5.8,33.1,3.4,66.4,0.9,99.5c-2.1,27.8-5.1,55.5-7.1,83.3c-0.4,5.5,0.9,11.7,3.2,16.7c15.9,35,32.7,69.7,42.9,106.8
		c6.2,22.6,9.9,46,13.5,69.3c4.5,29.1,8.6,58.3,11.1,87.5c4.4,51.1-6.4,99.7-27.7,146.1c-20.3,44.3-41.5,88.2-66.7,130
		c-6.1,10.2-12.6,20.3-20.2,29.4c-6.3,7.6-6.4,14.9-2.7,23.1c4.6,10,10.1,19.6,13.9,29.9c5.2,14,9.2,28.5,13.9,42.7
		c1.7,5.1,4.5,9.7,6.5,14.7c2.1,5.3,4.3,11.6-0.7,15.7c-5.1,4.1-11.6,1.2-15.3-2.8c-9.6-10.5-21.9-15.6-34.6-20.7
		c-3.6-1.5-7.1-4.1-9.8-7c-10.7-11.2-23.1-19.7-36.6-27.1c-8.7-4.8-16.7-11.4-24-18.4c-16.8-16-19.2-27.6-10.8-54
		c1.1-3.4,2.5-7,4.8-9.6c9.8-11.3,10.8-25.1,12.4-39c3.6-31.5,7.3-62.9,11.9-94.3c4.2-28.8,13.4-56.3,24.6-83.2
		c2-4.9,2-9.2-0.3-14.1c-25.9-55.1-51.6-110.2-77.4-165.4c-3.5-7.5-6.7-15.2-9.7-22c-18.9,0-37.4,0-56.6,0
		c-7.5,16.4-15.5,34-23.6,51.5c-20.6,44.2-41.3,88.3-62.2,132.3c-3.3,7-4.1,13.3-1,20.5c21.3,48.7,28.6,100.4,33.6,152.7
		c1.2,13,2.3,26,4.3,38.9c0.9,5.5,3.2,11.3,6.4,15.9c8.8,12.7,13.1,26.5,13.1,41.7c0,10.5-5.4,18.9-12.7,25.2
		c-10.6,9.3-22.4,17.1-33.7,25.5c-7.7,5.7-16,10.7-23.1,17.1c-9.1,8.3-18.7,15.1-30.7,18.8c-4.8,1.4-8.7,5.8-13,8.8
		c-4.4,3.1-8.4,6.9-13.2,9c-8,3.5-13-0.5-11.7-9.1c0.8-4.8,3-9.3,4.7-13.9c0.9-2.3,2.7-4.4,3-6.7c2.9-23.8,14.4-44.3,24.5-65.3
		c1.1-2.2,2-4.5,3.1-6.7c4.9-9.6,2.9-17.1-3.3-26.5c-17.3-26.4-34.1-53.5-48.5-81.5c-17.2-33.5-32.6-68-47.4-102.7
		c-15.2-35.5-20.7-73.3-17.6-111.6c2.8-35.8,9.3-71.3,12.8-107c5.2-52.7,25.7-100.3,47.5-147.4c7.7-16.7,11.6-32.5,9.5-51.5
		c-4.5-40.6-6.5-81.5-8.2-122.4c-1.3-31.1,4.4-61.8,9.5-92.4c2.6-15.9,5.2-31.8,6.5-48.2c-2.7,3.7-5.4,7.5-8.2,11.1
		c-12.8,16.3-25.4,32.6-38.5,48.6c-6.7,8.1-10.1,17.2-11.9,27.4c-4.6,26.3-8.8,52.8-15,78.7c-3.9,16.3-11.2,31.7-16.7,47.6
		c-0.8,2.2-0.5,5,0.1,7.2c4.5,16.9,9.8,33.5,13.5,50.6c2,9.3-4.4,13.8-13.2,9.7c-7.6-3.6-14.6-8.6-22-13.1
		c-8.4,6.7-12.5,30.3-6.7,39.8c2.2,3.6,4.5,7.3,5.9,11.3c2.6,7.8-0.7,12.8-9,13.6c-4.2,0.4-8.6,0.4-12.8-0.1
		c-14.9-2.1-28.6-7.5-41.3-15.5c-5.6-3.6-9.1-8.5-10.1-15.2c-3.5-24-3.4-47.5,8.8-69.5c0.9-1.6,1.6-3.5,2.9-4.5
		c7.9-6.4,6.5-14.2,4.9-23c-9.9-55.9-11.8-111.9,3.1-167.2c20.7-76.6,52.3-148.2,102.2-210.8c23.7-29.7,53.9-54.2,88.6-69.9
		c17.7-8,36.5-13.7,55.6-17c16.9-2.9,34.5-0.7,51.1-3.7c-3.3,0.6-16.4-8-19.7-9.5c-9.1-4.1-17.9-8.7-26-14.5
		c-19.1-13.7-25.6-32.6-36.2-52.4c-1.4-2.6,0,0-0.9-3.1c-13.1,5-28.4,0.6-30.2-10c-2.4-14.3-4.5-30.8-4.5-30.8
		c-1.2-8.6-8.1-26.4-9.4-34.8c-2.7-17.5-4.2-50.5,23.4-36c0-4.6,0,0-0.1-4.6c-1.9-63.8,10.3-147.1,67.8-185.6
		c26.6-17.8,59.8-23.6,91.3-24.2c29.4-0.6,61.4,3.5,88.6,15.3c17.3,7.5,33.3,18.9,45,33.8c17.2,21.8,25.8,49,31.6,75.8
		c6,27.6,12.4,56.6,11.5,84.9c-0.1,2.2-0.4,4.4-0.4,7.1c1.7,0,6-9.7,17.5-4.8c14.1,6,12.1,19.1,10.7,30.4
		c-2.7,13.5-7,22.5-10.3,35.1c-3.4,12.8-2,23.4-8.5,34.2c-6.9,11.5-16.2,16-16.2,16c-9,2-13.5-2.7-14.3-1.4
		c-8.1,15.4-17.7,32.9-29.9,45.9c-6.3,6.7-13.4,12.5-21.4,17.1C584,544.3,574.8,546.5,568.4,553.9z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2Child({ lesionnel }: FrontV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_vector'>
        <path
          id='avant_coude_droit'
          d='M330.5,719.4l-64.8-22.6l-9.3,14.3l-9.3,13.4l-11.8,18.4l37,15.4l34,19.7l7-16.6
			l3.2-7.4l5-12L330.5,719.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_droit)}
        />
        <path
          id='avant_epaule_droit'
          d='M308.2,528.7l-3.4,8.2l-2.9,8.3l50.2,12.4l9.1,2.3l1.6,0.5l1,0.4l3.2,0.9
			l24.2-63.1l2.1-28.4l-10.6,4.2l-20,4.4l-11.3,4.3l-8.9,4.8l-9,6.5l-9.2,9l-5.4,6.7l-6.6,10.4L308.2,528.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_droit)}
        />
        <path
          id='avant_flanc_gauche'
          d='M653.5,891.9l-110.3-0.8V783.6h111.6l0.4,16.8l0.4,17.5l0.4,10.6v9.2v17.2
			l-0.6,13.9l-0.7,10L653.5,891.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_gauche)}
        />
        <path
          id='avant_bassin_droit'
          d='M349.3,1050.5l-0.7,15.6l98.2,14.4l7.5-72.7h48.9v-27.1H354.9l-0.5,6l-1.4,15.6
			l-1.4,15.7l-1.2,17.7L349.3,1050.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_droit)}
        />
        <path
          id='avant_main_droit'
          d='M213.8,942.8l-52.9-21.7l-3.9,4.3l-6.5,1.9l-7.7,3.1l-11.6,8.1l-7.7,8.5l-8.9,12.4
			l-8.5,11.2l-3.1,4.6l1.9,4.6l5,0.8l4.6-1.2l6.2-5l11.2-10.8l0.8,5.8l-3.5,10.1l-4.6,10.4l-6.2,13.5l-4.3,11.2l-7,16.2l-1.5,5.8
			l1.2,3.5l2.3,0.4l3.5-3.1l7-8.9l9.7-12l10.1-13.5l3.5,0.4l-0.8,5.4l-5.4,15.9l-4.9,14.3l-6,19l1.5,5.4l3.9,1.5l4.3-2.3l3.1-4.6
			l6.2-12l4.3-11.2l3-12.8l3.1-7.7l4.3-7.7l1.9,0.4l1.2,1.9l0.4,3.9l-1.2,7.7l-1.5,7.7l-3.9,19.7l-2.3,12.4l0.4,7.7l3.1,2.7l4.3-1.2
			l1.5-3.1l3.1-3.5l1.2-4.3l4.6-20.1l2.7-12.4l3.5-15.1l1.9-1.5l3.1,0.4l0.8,4.3l0.4,18.6l1.5,18.2l1.9,3.1l3.9,0.4l2.3-0.8l1.9-2.3
			l0.8-7.4l0.4-18.2l0.4-9.3l0.8-9.3l1.5-6.2l2.3-7.7l4.3-13.9l5.4-18.2L213.8,942.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_droit)}
        />
        <path
          id='avant_hypocondre_droit'
          d='M354.6,782.8l0.9-18.7l1.1-22.8l1.1-23.5l0.8-18.2l1.2-17.3l-0.1-8.6l0.1-7.6
			h102.6v116.7H354.6L354.6,782.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_droit)}
        />
        <path
          id='avant_main_gauche'
          d='M801.8,943.2l52.9-21.7l3.9,4.3l6.5,1.9l7.7,3.1l11.6,8.1l7.7,8.5l8.9,12.4
			l8.5,11.2l3.1,4.6l-1.9,4.6l-5,0.8l-4.6-1.2l-6.2-5L883.7,964l-0.8,5.8l3.5,10.1l4.6,10.4l6.2,13.5l4.3,11.2l7,16.2l1.5,5.8
			l-1.2,3.5l-2.3,0.4l-3.5-3.1l-7-8.9l-9.7-12l-10.1-13.5l-3.5,0.4l0.8,5.4l5.4,15.9l4.9,14.3l6,19l-1.5,5.4l-3.9,1.5l-4.3-2.3
			l-3.1-4.6l-6.2-12l-4.3-11.2l-3-12.8l-3.1-7.7l-4.3-7.7l-1.9,0.4l-1.2,1.9l-0.4,3.9l1.2,7.7l1.5,7.7l3.9,19.7l2.3,12.4l-0.4,7.7
			l-3.1,2.7l-4.3-1.2l-1.5-3.1l-3.1-3.5l-1.2-4.3l-4.6-20.1l-2.7-12.4l-3.5-15.1l-1.9-1.5l-3.1,0.4l-0.8,4.3l-0.4,18.6l-1.5,18.2
			l-1.9,3.1l-3.9,0.4l-2.3-0.8l-1.9-2.3l-0.8-7.4l-0.4-18.2l-0.4-9.3l-0.8-9.3l-1.5-6.2l-2.3-7.7l-4.3-13.9l-5.4-18.2L801.8,943.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_main_gauche)}
        />
        <path
          id='avant_pied_droit'
          d='M392,1698.9l-62.4,0.4l0.2,7.6l0.5,15l-0.9,8.9l-8.9,16.9l-15.1,25.6l-6.1,11.9
			l-1.8,6.1l-0.2,3.8l3.5,6.1l4,5.3l6,4.2l4.5,1l5.8-0.1l8.6-1.1l6.8-1.2l5.5,0.8l4,0.6l4.2,0.7l4.5,1l4.8,1.7l5.6,1l5.2-3.4
			l4.1-3.5l2.4-6.1l3.7-8.9l2.1-5.2l0.7-5.5v-5.9v-6.1l-0.1-4.1l0.5-4.1l1.1-5.6l0.9-4.9l0.9-5.2l1.1-6.5l1.4-10.6l1.2-9.3l1.4-10
			l0.4-5L392,1698.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_droit)}
        />
        <path
          id='avant_pied_gauche'
          d='M680.2,1702.1l-62.7-0.2l-0.2,4.8l0.5,6.5l0.7,6.3l1.1,8l1.3,7.8l2.6,14.3l1.9,9.5
			l1.9,8.9l3.1,12.9l3.8,13.8l4.2,11.9l2.9,5.6l3,2.6l8.1-1.5l6.4-1.6l4.4-1.8l3.6-1.6l5.8,0.8l4.2,0.6l4,0.5l6.2,0.6l7.7-0.1
			l7.1-1.5l7.1-3.8l3.4-5.4l0.8-7.5l-1.6-8.1l-3.3-8.5l-3.6-7.1l-5.7-9.4l-7-10l-7.7-10.4l-1.7-6.4l-1.2-10.6l-0.6-9.2l-0.1-6
			L680.2,1702.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_pied_gauche)}
        />
        <path
          id='avant_epaule_gauche'
          d='M707.3,529.1l3.4,8.2l2.9,8.3L663.4,558l-9.1,2.3l-1.6,0.5l-1,0.4l-5.6,1.6
			L628,508.9l-1.6-10.2l-4.1-28.1l10.6,4.2l20,4.4l11.3,4.3l8.9,4.8l9,6.5l9.2,9l5.4,6.7l6.6,10.4L707.3,529.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epaule_gauche)}
        />
        <path
          id='avant_coude_gauche'
          d='M685.1,719.8l64.8-22.6l9.3,14.3l9.3,13.4l11.8,18.4l-37,15.4l-34,19.7l-7-16.6
			l-3.2-7.4l-5-12L685.1,719.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_coude_gauche)}
        />
        <path
          id='avant_tete'
          d='M521.6,108.5l-17.9-0.6l-16.7,1.9l-21,4.9l-21.6,13.6l-16,16l-13,25.9l-4.9,17.3
			l-3.1,17.3l-1.9,22.2l1.2,25.3l-8.6-1.9l-6.2,1.2l-3.1,6.2l-0.6,9.9l1.9,28.4l3.1,7.4l3.7,6.8l5.6,4.9l6.2,1.9l7.4-6.8l3.1,14.8
			l1.2,10.5l4.9,11.7l4.3,8.6l6.8,8.6l7.4,8.6l11.1,7.4l15.4,6.2l21,4.9l20.4,1.2l21-1.9l17.3-6.8l17.9-11.7l10.5-11.1l8-16l2.5-9.3
			l1.9-8.6l2.5-16.7l6.8,6.4l11.1-8l5.7-10.9l1.8-15.2l-0.1-12.9l-1-14.1l-2.9-2.9l-5.9-1.3l-5.1,0.3l0.6-14.8l-0.6-31.5l-1.9-14.2
			l-3.7-13.6l-2.5-10.5l-4.9-9.9l-4.9-10.5l-7.4-10.5l-8.6-8.6l-11.1-8.6l-16-6.8L521.6,108.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_tete)}
        />
        <path
          id='avant_genou_gauche'
          d='M650,1298.6l-95.6,6.5l2.8,19.8l2.7,19.1l1.3,10.4l4.2,10l5.7,14.6l4.5,13.6
			l3.4,12.8l2.3,10.6l82.4-10.4l-3.7-17.1l-1.7-16.1l-0.9-11l-2-15.3l-1.8-13.6L650,1298.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_gauche)}
        />
        <path
          id='avant_genou_droit'
          d='M459.5,1303.5l-105.6-7.3l0.1,6l-0.4,20.2l-0.9,15l-1.5,11.3l-2.6,12.7l-2,8.3
			l-4.4,16.3l-6,22.9l91,12l3.5-11.7l3.2-9.8l4-11.7l4-11.4l7.1-21l4.9-17.1l3.8-18L459.5,1303.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genou_droit)}
        />
        <path
          id='avant_cuisse_gauche'
          d='M662.4,1068.1L511.1,1088l1,36.7l5.1,21.8l12.2,47.2l7.6,27.3l4.5,16.5l4,18.1
			l4.6,23l4.2,25.5l95.6-6.2l0.1-17.4l2.2-17.1l3.1-21.8l1.8-21.9l1.6-34.1l1.2-14.2l2.5-20.4l1.2-15.9l0.6-18.2l-0.4-23.8
			L662.4,1068.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_gauche)}
        />
        <path
          id='avant_jambe_droit'
          d='M427.1,1421.6l-91.1-12.1l-3.4,17.8l-1.2,16.5l-0.8,21.5l-0.5,26.8l0.4,30.6
			l0.7,16l1.5,22.3l2.9,30.8l1.7,24.2l0.5,21.8h36.7h16.9l3.5-18.2l4.5-18.7l9.6-29.6l4.6-18.6l3.3-17.9l3.5-19.3l2.8-20.4l2.2-20.1
			l1.4-17.4l0.9-20.7L427.1,1421.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_droit)}
        />
        <path
          id='avant_cuisse_droit'
          d='M354.1,1295.6l105.5,7.4l0.8-16.8l1.1-13.2l2.1-13.9l4.1-19.5l4.4-16.9l7.2-24.8
			l7.5-25.6l6.7-26.1l4.3-19.5l1.6-19l-0.2-19.5L348.6,1066l-0.6,13.7l-0.8,24.3l0.2,29.5l1.2,23l1.3,22.7l0.9,10.7l1.1,16.9
			l0.7,13.6l1.1,32.8l0.4,22.9L354.1,1295.6L354.1,1295.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cuisse_droit)}
        />
        <path
          id='avant_jambe_gauche'
          d='M663.8,1405.8l-82.4,11.2l2.1,16.3l0.4,16.6l-0.1,9.5l0.6,8.4l1.6,15l2.5,16.4
			l2.8,16.5l8,37l9,37.6l4.7,17.4l4.6,16.6l3.3,13.3h52.3l0.6-28.7l4.3-31.3l2-28.8l0.7-18.7l0.8-19.1l1.6-30.3l-3.3-20.7l-4.9-17.9
			l-2.6-8.1l-3.5-10.3L663.8,1405.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_jambe_gauche)}
        />
        <path
          id='avant_cheville_gauche'
          d='M620.2,1679.5l0.2-7.1l0.5-5.3l1.6-8.7l1-4.3l-0.5-5.3l-0.9-5.4l-1.1-5.1
			l52.1-0.5l0.9,14.4l1,10.7l1,8.1l2.7,10.8l0.9,8.3l0.6,11.2h-62.7l0.9-3.4l1.3-8.2L620.2,1679.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_gauche)}
        />
        <path
          id='avant_genital'
          d='M446.8,1080.5l7.9-71.9h96.9l4.6,73.6l-45.1,5.9l-1.2-17.3l-0.8-6.1l-1.1-5.7l-0.9-2.8
			l-0.8-1.4l-0.8-0.5l-1,0.1l-0.7,0.4l-0.6,0.6l-1.1,2l-1.1,4.3l-1,7.9l-0.6,18.7L446.8,1080.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_genital)}
        />
        <path
          id='avant_avant_bras_gauche'
          d='M744.5,759.1l36.1-15.4l8.9,15.7l6.9,17.5l4.6,19.5l2.6,16.9l3.2,10.9
			l10.8,26.1l11.2,23l-21.7,8.5l-26.3,11.1l-16-22.7l-9.8-15.6l-1.3-2.9l-7-10l-10.4-15.4l-9.8-15.6l-4.2-7l-6.6-11.9l-6.4-13.4
			L744.5,759.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_gauche)}
        />
        {/**/}
        <path
          id='avant_cou'
          d='M461.1,383.1l-10.7-5.5l2.1,3.2l0.5,4.4l-0.5,4.3l-1.3,5.5l-1.3,4.5l-3.2,8.9l-5.4,10.9
			l-5.1,7.9l-11.6,15.2l-9.7,11l-8.4,7.8l-6.4,4.9l-6.8,4.1l229,0.4l-15.6-9.1l-16.1-12.6l-12-13.2l-9-14.2l-6.1-14.1l-3.8-13.7
			l-1.5-8.6l-0.3-5.9l-8,5.2l-11.8,4.6l-5.5,2.1l-8,0.7l-7.1,0.6l-5.9,0.5l-13.2-0.8l-6.8-0.4l-3.7-0.8l-15.5-3.6L461.1,383.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cou)}
        />
        <path
          id='avant_bras_droit'
          d='M367,561.8l-65.1-16.5l-2.6,9.8l-2.7,13L294,585l-1.6,9.5l-1.9,11.1l-1.2,7
			l-1.5,5.8l-5.4,15.5l-3.9,15.5l-7.9,29.4l-4.4,17.8l64.4,23l4.6-13.2l3.9-11.2l4-11.4l7-15.5l7.8-16.9l2.4,0.3l0.2-7.1V628
			l0.9-26.3l0.2-17.2l0.9-10.7L367,561.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_droit)}
        />
        <path
          id='avant_cheville_droit'
          d='M329.8,1689.9l1.8-6.8l3-12.4l1.2-7.3l1-8.6l0.9-16.2l53.4-0.2l-1.7,12.5
			l-0.2,6.9l0.5,12l0.8,10.6l1,10.4l0.3,8.2l-62.4-0.3L329.8,1689.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_cheville_droit)}
        />
        <path
          id='avant_avant_bras_droit'
          d='M271.1,758.7L235,743.3l-8.9,15.7l-6.9,17.5l-4.6,19.5l-2.6,16.9l-3.2,10.9
			L198,849.9l-11.2,23l21.7,8.5l26.3,11.1l16-22.7l9.8-15.6l1.3-2.9l7-10l10.4-15.4l9.8-15.6l4.2-7l6.6-11.9l6.4-13.4L271.1,758.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_avant_bras_droit)}
        />
        <path
          id='avant_hypocondre_gauche'
          d='M543.5,782.8V666.1h108.3v6.5v5.1l0.1,9.5l0.2,9.8l0.4,15.5l0.6,19.5
			l0.7,22.8l0.9,28.8L543.5,782.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypocondre_gauche)}
        />
        <path
          id='avant_bras_gauche'
          d='M646.2,562.8l67.5-17.2l2.6,9.8l2.7,13l2.6,16.9l1.6,9.5l1.9,11.1l1.2,7l1.5,5.8
			l5.4,15.5l3.9,15.5l7.9,29.4l4.4,17.8l-64.4,23l-4.6-13.2l-3.9-11.2l-4-11.4l-7-15.5L652.8,651l-0.7,0.1v-6.9l-0.3-15.7l-0.5-25.9
			l-0.5-22.4l0.4-3L646.2,562.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bras_gauche)}
        />
        <path
          id='avant_poignet_droit'
          d='M186.3,873.2l-25.1,47.6l52.6,21.4l0.9-8.7l1.4-11.1l9.9-17.3l8.7-12.5
			L186.3,873.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_droit)}
        />
        <path
          id='avant_fosse_iliaque_gauche'
          d='M543.1,980.7v-88.9h110.3l-1.4,15.4l-1.3,15.7l-0.5,10.9l0.1,11.7
			l0.2,8.4l0.5,9.8l1.5,18.2L543.1,980.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_gauche)}
        />
        <path
          id='avant_flanc_droit'
          d='M462.3,891.1l-109.5,0.8l-0.3-5.2l-0.4-9.3l-0.1-14.6v-19.7l0.6-19.3l0.7-16.4
			l1.3-24.5l107.7,0.8V891.1L462.3,891.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_flanc_droit)}
        />
        <path
          id='avant_fosse_iliaque_droit'
          d='M355.2,919l-2.3-27.2l109.5-0.1v88.9H354.9l1.3-21.6l0.2-12.8l-0.3-13.1
			L355.2,919z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_fosse_iliaque_droit)}
        />
        <path
          id='avant_ombilicale'
          d='M542.7,891.1V783.6h-39.6h-38.8h-1.6V891L542.7,891.1L542.7,891.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_ombilicale)}
        />
        <path
          id='avant_epigastrique'
          d='M542.7,666.1h-80v116.7h80L542.7,666.1L542.7,666.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_epigastrique)}
        />
        <path
          id='avant_buste_gauche'
          d='M504.6,665.9l1.5-194.6l115.8-0.9l6.2,38.5l6.9,21l12.4,36.4l3.9,10.7l-0.4,3v5.6
			l0.4,11.6l0.4,22.7l0.4,23.2v22.7L504.6,665.9L504.6,665.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_gauche)}
        />
        <path
          id='avant_poignet_gauche'
          d='M829.2,873.6l25.1,47.6l-52.6,21.4l-0.9-8.7l-1.4-11.1l-9.9-17.3l-8.7-12.5
			L829.2,873.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_poignet_gauche)}
        />
        <path
          id='avant_bassin_gauche'
          d='M503.1,980.7v27.1h49.3l3.8,74.4l106.2-14l-1.1-13.5l-0.7-7.7l-0.3-3.7l-0.6-6.5
			l-0.6-6.4l-0.7-5.5l-1.1-6.9l-1.2-8.3l-2.1-15.4l-1.4-12.3L503.1,980.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_bassin_gauche)}
        />
        <path
          id='avant_buste_droit'
          d='M504.8,665.9H360.3v-12v-13.3l0.4-21.9l0.9-22.7v-11.6l0.9-10.7l16.7-42.4
			l8.1-21.9l3.9-10.7l2.1-28.4l113.9,1L504.8,665.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_buste_droit)}
        />
        <path
          id='avant_hypogastrique'
          d='M542.7,891.5l-79.6,0.4l-0.4,88.9h80L542.7,891.5L542.7,891.5z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.avant_hypogastrique)}
        />
        <path
          id='mannequin_oreille_gauche'
          d='M1060.2-334c0,0,15-7.1,14,10.4c0,0,0.3,15.4-1.4,24.8
							c-1.7,9.3-14.2,26.8-20.7,10.7'
          stroke='black'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill={syoUtils.colorFiller(lesionnel.avant_oreille_gauche)}
        />
        <path
          id='mannequin_oreille_droite'
          d='M900.1-334c0,0-15-7.1-14,10.4c0,0-0.3,15.4,1.4,24.8
							c1.7,9.4,14.2,26.8,20.7,10.7'
          stroke='black'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill={syoUtils.colorFiller(lesionnel.avant_oreille_droit)}
        />
        <g id='Mannequin global V2'>
          <g id='enfant_front'>
            <g id='silhouette'>
              <path
                id='mannequin_silhouette'
                d='M651.9,651.1c0,13.9-0.3,27.9,0.1,41.8c1.3,51.4,3.6,102.8,4,154.2c0.2,23.6-3,47.3-4.8,70.9
				c-2.8,35.8,2.3,76.5,7.6,108.8c4.2,44.1,8.1,85.8,3,130.6c-5.9,35.8-2.1,70.5-9.5,106c-7.5,36.3,4.1,72.6,6.1,109.2
				c2.7,50.5,29.4,77,24.3,127.6c-2.4,23.8-1.3,65-6.1,88.5c-5,24.8-3.5,59.1-0.4,82.4c7,16.4,1.4,61,9.7,71.2
				c7.8,9.5,38.2,48.8,23,63.5c-11.9,9.3-29.1,4.2-42,2.8c-3.6,1.6-3.1,2.9-21.8,6.5c-10.6,2-30.1-102.5-27.5-113
				c5.1-20.8,0.3-26,5.9-46.7c2.2-8.2-15.6-64.1-16.6-72.2c-7.5-29.4-24.5-99.7-22.9-133.3c0-34-6.9-59-22.6-95.4
				c-12.4-97.7-19.8-116.9-36.4-177c-0.2-7.3-12.3-45.4-12.7-52.6c-0.4-7.8-0.1-70.6-7-70.5c-7.9,0.2-5.4,43.7-5.6,49.5
				c-2.3,61.1-37.6,125-39.2,186.1c-1.4,52.8-18.2,79-33.2,131.2c3.1,21.6-5.8,122-24.3,169.1c-4.9,12.5-13.7,53.8-13.5,66
				c0.6,26.5,4.4,41.9,2.6,54c-2.3,16.9-3.1,24.7-6.1,41.5c-2.6,14.6-2.8,10.9-2.4,24.8c0.4,14.1-1.2,11.3-8.9,31.5
				c-12.9,11.8-10.4,5.4-24.3,3.2c-18.5-2.9-10.8-1.6-29.1,0.3c-12.7,1.4-17-4.4-23-15.3c-6.8-6.2,26.4-52.2,31.3-64.6
				c3.1-8-2.6-41.6,2.3-48.6c9.9-32.8,5.8-70.9,2.9-103.5c-5.3-48.9-5.4-93.4-2.9-141.9c1.8-33.8,18.4-68,21.2-101.6
				c2.7-33.3,0.6-115.5-2.5-151.1c-4.1-64-4-67.6-1.2-132.5c1.3-29.6,5.3-59,6.8-88.6c0.9-17.2,0.3-34.7-1.5-51.9
				c-4.2-39.9-2.6-79.8-0.4-119.7c2.5-46.9,4.4-93.7,6.5-140.6c-0.9-0.1-1.8-0.2-2.7-0.4l-13.7,29.6l-7.7,21.1
				c-7.4,23.5-30.3,75.9-30.3,75.9c-11.7,28.3-44.4,73.2-44.4,73.2c-4.6,12.6-41.7,58.3-45.7,71.1c-0.4,6.4-3.3,30.3-3.7,34.1
				c-0.6,6.1-3.7,15.7-3.7,15.7s-0.9,2.9-5.2,17.2c-2.8,9.2-4.5,15.5-5.8,25.4c-1.3,9.8-0.4,24.5-1.1,30.8c-0.6,6.1-2.2,8.5-4.9,9.2
				c-8,2-7.4-23.2-7.3-29.7c0.1-7.5,0.6-14.5-3.6-14.9c-4.4-0.4-11.5,40.4-13.5,48.8c-4.6,13.7-9,11.2-10.1,12
				c-4.5-1-3.4-9.3-3.4-9.3c-1.4-1.7,13.2-52.9,6.5-54.7c-4.5-1.2-20.4,57.5-26.9,57.3c0,0-6.4,1.5-7.8-6.1
				c-0.5-2.8,25.8-65.3,13.5-54.9c0,0-19.8,23.7-23.8,30.7c-10.8,12.6-9.9,2.9-9.9,2.9c0.8-11.4,28.5-68.6,27.1-67.3l-0.8-5.8
				c0,0-15.8,16.8-22.1,17c-16.6,0.5,4.6-21.3,5.6-22.7c23.5-36.9,35.5-23.2,45.8-37.3c0.1-2.1,51.4-88.9,51.7-115.1
				c6.9-43.4,16.8-55.4,53.1-109.3c9.6-40.7,23.6-81.7,29.7-123c7-47.7,28.6-87.1,75.9-96.9c28.6-2.4,46.7-25.1,63.2-47.2
				c9.5-12.8,15.7-27.1,18.2-42.7c0.5-3.3-0.6-8.4-2.9-10.3c-13.8-5.1-23.1-25.6-29.7-40.7c-2.3-5.2-4.3-25.3-4.3-25.3
				s-3.8,7.9-10.7,5.8c-2.8-0.9-12.1-3.3-15.2-20c-0.9-4.8-1.4-14.7-1.9-22.9c-0.5-8.9-0.8-19.1,6.2-22.1c3.5-1.5,12.3,1.1,12.3,1.1
				c-2-22.6-1.2-45.4,3.7-64.8c4.1-16.3,11.6-30,17.1-41.6c9.1-12,23.9-23.8,41-31.8c32.9-5.9,39.9-9.8,72.3-1.6
				c27.8,8.9,39.1,24.2,46.2,37.9c7,11.5,14.2,28.6,16.5,55.6c0.5,3-0.6,46.8-0.6,46.8s5-1.2,10.7,0.5c0.5,0.7,3.3,0.8,5.1,7
				c-0.2,19.8-0.2,18.9-0.2,18.9c0,0.6-0.1,6.6-1.8,18c-0.7,4.7-6.8,14.2-7.1,14.5c-13.3,10.9-16.5-0.9-16.5-0.9
				c-1.4,14.4-2.8,9.3-5.1,25c-2.2,8.1-5.2,17-10.1,23.4c-6.7,8.6-8.7,13.1-17.7,18c-2.9,1.6-2.5,4.1-2,7.7
				c5.1,38.1,26.1,65,59.3,83c13,7,14.7,6.5,32,10.5c12.9,2.1,30.7,12.8,41.8,25.5c7.1,8.1,13.3,19.1,18,30
				c7.4,17.3,8.5,28.9,11.1,44c2.1,9.5,3.8,23.6,5.6,33.5c0.6,3.2,0.8,4,1.8,7.2c1.9,5.9,4,10.3,5.7,16.5
				c3.6,13.2,6.5,25.3,10.2,38.7c1.3,4.7,4.8,18,5.8,22.9c0,0,2.6,3.9,6.5,9.9c4.2,6.6,20.4,29.8,24.5,37c1.2,2,8.2,13.8,10.9,20.9
				c1.7,4.3,6.1,17.6,7.7,24.1c1.3,5.4,3.6,18.8,4.5,24.6c0.9,5.6,4.2,13.3,6.2,18.2l16.5,36.6l9.2,17.4l19.2,36.1l3.9,4.3l7,2.1
				l7.3,2.9l11.6,8.1l8.8,10l18.1,24.9c1.4,3.2-0.1,6.6-3.1,7c-3.5,0.4-2.5,0.2-7.2-0.9c-1.5-0.4-17.4-15.9-17.4-15.9l-0.8,5.8
				l3.5,10.1c0,0,10.4,22.9,10.5,23.2c0,0,10.3,25.4,12.6,32.1c1.6,4.5-1.6,6.4-4.4,4.5c-2.2-1.4-5.4-6.2-8-9.5
				c-3.8-4.7-20.1-25.2-20.7-26.8l-3.5,0.4l0.8,5.4c0,0,16.3,47.8,16.2,49.1c-0.1,5.6-1.3,6.4-5.4,7c-5,0.7-13.5-19-13.5-19
				l-4.3-11.2l-3-12.8c-1.8-7.1-6.7-14.4-6.7-14.4c-3.8-2.8-4.1,4.2-4.1,4.2l8.8,48.5c0,0,0.5,6.8-0.4,7.7c-7.4,7.8-12-5-12-5
				l-12-51.8l-1.9-1.5l-3.1,0.4l-0.4,1.9l-0.2,1.2l-0.2,1.1c-0.6,8.4-0.4,17-0.4,17l-1.6,19.7l-1.9,3.1l-3.9,0.4l-1-0.3l-0.9-0.3
				c-0.4-0.1-2.1-0.2-2.5-4.4c-0.4-4.1-0.9-14.3-0.8-16c0.3-4-1.3-26.2-1.3-26.2s-13.4-45-13.5-46c-0.7-4.6-0.7-7-1.2-11.2
				c-1.5-13.2-3.1-27.9-3.1-27.9s-7.9-14.4-9.9-17.3c-4.7-7-6.3-9.1-11.7-16.9c-7.9-11.2-17.5-24.4-22.3-33.2
				c-2.8-5-5.7-9.2-6.1-9.7c-3.8-5-15.6-23.5-18.9-28.5c-10.3-15.5-16.4-27.3-21.2-38.6c-3.8-9.1-8.7-20.6-8.7-20.6
				c-4.2-10-11.2-26-15.5-38.1c-3.9-11.1-8.8-27.4-12.6-35.7c-4.1-9.1-7-15.5-7-15.5c-2.7-3.7-12.7-17.6-12.7-17.6
				C652.5,651,652.2,651,651.9,651.1z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
              />
            </g>
            <g id='tete'>
              <path
                id='mannequin_tete'
                d='M602.3,251.7c0,0,20.3-144.8-96.2-143.4s-99.3,140.4-99.3,140.4l12.6,79.7
				c0,0,7.4,62.5,86.3,63.1s83.6-65,83.6-65L602.3,251.7z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_droite'
                d='M406.1,253.8c0,0-17.9-8.5-16.7,12.4c0,0-0.4,18.4,1.7,29.6
				c2,11.2,16.9,31.9,24.7,12.8L406.1,253.8z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_gauche_'
                d='M602,253.8c0,0,17.9-8.5,16.7,12.4c0,0,0.4,18.4-1.7,29.6
			c-2,11.1-16.9,31.9-24.7,12.8L602,253.8z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='corps'>
              <g id='Calque 13'>
                <path
                  id='mannequin_corps_15'
                  d='M423.3,632.4c2,0,3.7-0.9,3.7-2s-1.6-2-3.7-2c-2,0-3.7,0.9-3.7,2
			C419.7,631.5,421.3,632.4,423.3,632.4z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_14'
                  d='M590.9,630.4c2.2,0,4-1,4-2.3s-1.8-2.3-4-2.3s-4,1-4,2.3S588.7,630.4,590.9,630.4
			z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='mannequin_corps_13'
                  d='M501.9,878.5c2,0,3.7-2.8,3.7-6.4c0-3.5-1.6-6.4-3.7-6.4c-2,0-3.7,2.8-3.7,6.4
			C498.2,875.6,499.8,878.5,501.9,878.5z'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='bouche'>
              <path
                id='mannequin_bouche_2'
                d='M539.6,329.4c-36.7,8.1-62.2,0.4-62.2,0.4l26.9-7l4,0.9l4.9-0.9L539.6,329.4z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <g id='bouche_1'>
                <path
                  id='mannequin_bouche_1'
                  d='M477.3,329.8c0,0,27.9,29.8,62.2-0.4'
                  stroke='black'
                  strokeWidth='3'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
            </g>
            <g id='yeux'>
              <path
                id='mannequin_yeux_4'
                d='M444.1,251.4c0,0,18.3-21.8,39.6,0C483.7,251.4,462.9,265.2,444.1,251.4z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_2'
                d='M463.8,257.4c3.1,0,5.5-3.5,5.5-7.8s-2.5-7.8-5.5-7.8
				c-3.1,0-5.5,3.5-5.5,7.8S460.8,257.4,463.8,257.4z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
              <path
                id='mannequin_yeux_2'
                d='M568.4,251.3c0,0-18.3-21.8-39.6,0C528.7,251.3,549.6,265.1,568.4,251.3z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_yeux_globe_1'
                d='M548.6,257.3c3.1,0,5.5-3.5,5.5-7.8s-2.5-7.8-5.5-7.8
				c-3.1,0-5.5,3.5-5.5,7.8S545.6,257.3,548.6,257.3z'
                fill='black'
                stroke='black'
                strokeMiterlimit='10'
              />
            </g>
            <g id='sourcils'>
              <path
                id='mannequin_sourcil_2'
                d='M444.6,218.6c0,0,20.6-8.3,40.8-5.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_sourcil_1'
                d='M570.1,218.6c0,0-20.6-8.3-40.8-5.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <g id='nez'>
              <path
                id='mannequin_nez_4'
                d='M495.1,272.9l-4,7.6l-4,5.4c0,0-5.7,8.5,1.1,13.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_3'
                d='M519,273.5l4,7.6l4,5.4c0,0,5.7,8.5-1.1,13.8'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_2'
                d='M493.2,294.5c0,0,2.6,2.5,8.4,2.2'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_nez_1'
                d='M521.3,294.5c0,0-2.6,2.5-8.4,2.2'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2Child({ lesionnel }: BackV2Props) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_vector'>
        <path
          id='arriere_lombaire_gauche'
          d='M358,834.1c0,0-0.8-3.7,0-12l138.1,0.8v98.1H358l-1.1-24.7l-0.4-21.1l0.4-27.9
	l0.2-7.1L358,834.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_gauche)}
        />
        <path
          id='arriere_poignet_droit'
          d='M833.6,889.8l25.1,47.6l-52.6,21.4l-0.9-8.7l-1.4-11.1l-9.9-17.3l-8.7-12.5
		L833.6,889.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_droit)}
        />
        <path
          id='arriere_cheville_droit'
          d='M334.2,1706.1l1.8-6.8l3-12.4l1.2-7.3l1-8.6l0.9-16.2l53.4-0.2l-1.7,12.5
		l-0.2,6.9l0.5,12l0.8,10.6l1,10.4l0.7,8.4l-3.4-4.4l-5.6-5.1l-9.2-4.7l-9.4-1.9l-9.1-0.1l-7.9,2l-7.4,3l-7.9,6l-2.5,5.4
		L334.2,1706.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_droit)}
        />
        <path
          id='arriere_jambe_gauche'
          d='M668.2,1422l-82.4,11.2l2.1,16.3l0.4,16.6l-0.1,9.5l0.6,8.4l1.6,15l2.5,16.4
		l2.8,16.5l8,37l9,37.6l4.7,17.4l4.6,16.6l3.3,13.3h52.3l0.6-28.7l4.3-31.3l2-28.8l0.7-18.7l0.8-19.1l1.6-30.3l-3.3-20.7l-4.9-17.9
		l-2.6-8.1l-3.5-10.3L668.2,1422z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_gauche)}
        />
        <path
          id='arriere_pied_gauche'
          d='M674.3,1707l-4.4-2.8l-4.7-1.2l-4.3-0.6l-5.6-0.3l-4.6,0.4l-4.4,0.8l-5.3,1.1
		l-4.6,1.7l-4,2.1c-3,1.9-6.3,4-9.7,5.8l-1.1,8.8l0.5,6.5l0.7,6.3l1.1,8l1.3,7.8l2.6,14.3l1.9,9.5l1.9,8.9l3.1,12.9l3.8,13.8
		l4.2,11.9l2.9,5.6l3,2.6l8.1-1.5l6.4-1.6l4.4-1.8l3.6-1.6l5.8,0.8l4.2,0.6l4,0.5l6.2,0.6l7.7-0.1l7.1-1.5l7.1-3.8l3.4-5.4l0.8-7.5
		l-1.6-8.1l-3.3-8.5l-3.6-7.1l-5.7-9.4l-7-10l-7.7-10.4l-1.7-6.4l-1.2-10.6l-0.6-9.2l-0.5-10.7l0,0
		C683.5,1716.1,677.2,1709.8,674.3,1707z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_gauche)}
        />
        <path
          id='arriere_coude_droit'
          d='M689.5,736l64.8-22.6l9.3,14.3l9.3,13.4l11.8,18.4l-37,15.4l-34,19.7l-7-16.6
		l-3.2-7.4l-5-12L689.5,736z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_droit)}
        />
        <path
          id='arriere_bassin_gauche'
          d='M496.1,993.3H359l0.8-3.7l0.8-4.2l-0.9-7.9l1.2-16.6l-0.8-20.2l-2.2-19.6l138.1,0.6
	V993.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_gauche)}
        />
        <path
          id='arriere_coude_gauche'
          d='M334.9,735.6L270.1,713l-9.3,14.3l-9.3,13.4l-11.8,18.4l37,15.4l34,19.7l7-16.6
		l3.2-7.4l5-12L334.9,735.6z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_coude_gauche)}
        />
        <path
          id='arriere_tete'
          d='M526,124.7l-17.9-0.6l-16.7,1.9l-21,4.9l-21.6,13.6l-16,16l-13,25.9l-4.9,17.3l-3.1,17.3
		l-1.9,22.2l1.2,25.3l-8.6-1.9l-6.2,1.2l-3.1,6.2l-0.6,9.9l1.9,28.4l3.1,7.4l3.7,6.8l5.6,4.9l6.2,1.9l7.4-6.8l3.1,14.8l1.2,10.5
		l4.9,11.7l4.3,8.6l6.8,8.6l7.4,8.6l11.1,7.4l15.4,6.2l21,4.9l20.4,1.2l21-1.9l17.3-6.8l17.9-11.7l10.5-11.1l8-16l2.5-9.3l1.9-8.6
		l2.5-16.7l9.3,6.2l9.9-6.2l6.2-11.1l1.2-13l1.2-14.8l-0.6-17.9l-5.6-3.7h-5.6l-5.6,1.9l0.6-14.8l-0.6-31.5l-1.9-14.2l-3.7-13.6
		l-2.5-10.5l-4.9-9.9l-4.9-10.5l-7.4-10.5l-8.6-8.6l-11.1-8.6l-16-6.8L526,124.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_tete)}
        />
        <path
          id='arriere_genou_droit'
          d='M463.9,1319.7l-105.6-7.3l0.1,6l-0.4,20.2l-0.9,15l-1.5,11.3l-2.6,12.7l-2,8.3
		l-4.4,16.3l-6,22.9l91,12l3.5-11.7l3.2-9.8l4-11.7l4-11.4l7.1-21l4.9-17.1l3.8-18L463.9,1319.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_droit)}
        />
        <path
          id='arriere_nuque'
          d='M456.9,395.1l14.9,6.6l19.7,5.1l24.5,2.2l21-1.9l24.7-12l2.3,13.9l7,22.4l8.1,14.8
	l11.9,14.7l20.2,16.6l-90.2,0.5v-70.3h-25v69.9l-86.1,0.5l11-10.3l8.4-9.7l6.3-8.1l6.6-9.1l9.5-18l4.6-15.2L456.9,395.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_nuque)}
        />
        <path
          id='arriere_cuisse_gauche'
          d='M666.8,1084.3l-151.3,19.9l1,36.7l5.1,21.8l12.2,47.2l7.6,27.3l4.5,16.5l4,18.1
		l4.6,23l4.2,25.5l95.6-6.2l0.1-17.4l2.2-17.1l3.1-21.8l1.8-21.9l1.6-34.1l1.2-14.2l2.5-20.4l1.2-15.9l0.6-18.2l-0.4-23.8
		L666.8,1084.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_gauche)}
        />
        <path
          id='arriere_buste_gauche'
          d='M496.1,694.4H373.7h-6.7l-2.1-3.5l0.1-30.1l1-51.7l1-19.1l9.7-25.7l19-49.5l1.4-18.9
	l0.7-9.5l12.2-8.3l86.1,0.3V518v58.3v50.4v32.5v14.2V694.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_gauche)}
        />
        <path
          id='arriere_fesse_gauche'
          d='M496.3,994.1H359.4l-1.7,23.2l-1.7,19.1l-1.3,16.7l-1.7,29l96.3,14.2l54.3,8
	l0.9-14.5l0.5-9.1l2-8.3l1.1-0.6v-18.2h-11.8V994.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_gauche)}
        />
        <path
          id='arriere_epaule_gauche'
          d='M312.6,544.9l-3.4,8.2l-2.9,8.3l50.2,12.4l9.1,2.3l1.6,0.5l1,0.4l3.2,0.9
		l24.2-63.1l2.1-28.4l-10.6,4.2l-20,4.4l-11.3,4.3l-8.9,4.8l-9,6.5l-9.2,9l-5.4,6.7l-6.6,10.4L312.6,544.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_gauche)}
        />
        <path
          id='arriere_bras_gauche'
          d='M371.4,578l-65.1-16.5l-2.6,9.8l-2.7,13l-2.6,16.9l-1.6,9.5l-1.9,11.1l-1.2,7
		l-1.5,5.8l-5.4,15.5l-3.9,15.5L275,695l-4.4,17.8l64.4,23l4.6-13.2l3.9-11.2l4-11.4l7-15.5l7.8-16.9l2.4,0.3l0.2-7.1v-16.6
		l0.9-26.3l0.2-17.2l0.9-10.7L371.4,578z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_gauche)}
        />
        <path
          id='arriere_avant_bras_gauche'
          d='M275.5,774.9l-36.1-15.4l-8.9,15.7l-6.9,17.5l-4.6,19.5l-2.6,16.9l-3.2,10.9
		l-10.8,26.1l-11.2,23l21.7,8.5l26.3,11.1l16-22.7l9.8-15.6l1.3-2.9l7-10l10.4-15.4l9.8-15.6l4.2-7l6.6-11.9l6.4-13.4L275.5,774.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_gauche)}
        />
        <path
          id='arriere_cuisse_droit'
          d='M358.5,1311.8l105.5,7.4l0.8-16.8l1.1-13.2l2.1-13.9l4.1-19.5l4.4-16.9l7.2-24.8
		l7.5-25.6l6.7-26.1l4.3-19.5l1.6-19l-0.2-19.5L353,1082.2l-0.6,13.7l-0.8,24.3l0.2,29.5l1.2,23l1.3,22.7l0.9,10.7l1.1,16.9
		l0.7,13.6l1.1,32.8l0.4,22.9V1311.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cuisse_droit)}
        />
        <path
          id='arriere_jambe_droit'
          d='M431.5,1437.8l-91.1-12.1l-3.4,17.8l-1.2,16.5l-0.8,21.5l-0.5,26.8l0.4,30.6l0.7,16
		l1.5,22.3l2.9,30.8l1.7,24.2l0.5,21.8h36.7h16.9l3.5-18.2l4.5-18.7l9.6-29.6l4.6-18.6l3.3-17.9l3.5-19.3l2.8-20.4l2.2-20.1
		l1.4-17.4l0.9-20.7L431.5,1437.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_jambe_droit)}
        />
        <path
          id='arriere_genou_gauche'
          d='M654.4,1314.8l-95.6,6.5l2.8,19.8l2.7,19.1l1.3,10.4l4.2,10l5.7,14.6l4.5,13.6
		l3.4,12.8l2.3,10.6l82.4-10.4l-3.7-17.1l-1.7-16.1l-0.9-11l-2-15.3l-1.8-13.6L654.4,1314.8z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_genou_gauche)}
        />
        <path
          id='arriere_bassin_droit'
          d='M521.5,993.2l-0.4-71.7l135.6-0.4l-1.9,37.6l1.9,35.3L521.5,993.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bassin_droit)}
        />
        <path
          id='arriere_poignet_gauche'
          d='M190.7,889.4L165.6,937l52.6,21.4l0.9-8.7l1.4-11.1l9.9-17.3l8.7-12.5
		L190.7,889.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_poignet_gauche)}
        />
        <path
          id='arriere_main_droit'
          d='M806.2,959.4l52.9-21.7l3.9,4.3l6.5,1.9l7.7,3.1l11.6,8.1l7.7,8.5l8.9,12.4l8.5,11.2
		l3.1,4.6l-1.9,4.6l-5,0.8l-4.6-1.2l-6.2-5l-11.2-10.8l-0.8,5.8l3.5,10.1l4.6,10.4l6.2,13.5l4.3,11.2l7,16.2l1.5,5.8l-1.2,3.5
		l-2.3,0.4l-3.5-3.1l-7-8.9l-9.7-12l-10.1-13.5l-3.5,0.4l0.8,5.4l5.4,15.9l4.9,14.3l6,19l-1.5,5.4l-3.9,1.5l-4.3-2.3l-3.1-4.6
		l-6.2-12l-4.3-11.2l-3-12.8l-3.1-7.7l-4.3-7.7l-1.9,0.4l-1.2,1.9l-0.4,3.9l1.2,7.7l1.5,7.7l3.9,19.7l2.3,12.4l-0.4,7.7l-3.1,2.7
		l-4.3-1.2l-1.5-3.1l-3.1-3.5l-1.2-4.3l-4.6-20.1l-2.7-12.4l-3.5-15.1l-1.9-1.5l-3.1,0.4l-0.8,4.3l-0.4,18.6l-1.5,18.2l-1.9,3.1
		l-3.9,0.4l-2.3-0.8l-1.9-2.3l-0.8-7.4l-0.4-18.2l-0.4-9.3l-0.8-9.3l-1.5-6.2l-2.3-7.7l-4.3-13.9l-5.4-18.2L806.2,959.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_droit)}
        />
        <path
          id='arriere_bras_droit'
          d='M650.6,579l67.5-17.2l2.6,9.8l2.7,13l2.6,16.9l1.6,9.5l1.9,11.1l1.2,7l1.5,5.8
		l5.4,15.5l3.9,15.5l7.9,29.4l4.4,17.8l-64.4,23l-4.6-13.2l-3.9-11.2l-4-11.4l-7-15.5l-12.7-17.6l-0.7,0.1v-6.9l-0.3-15.7l-0.5-25.9
		l-0.5-22.4l0.4-3L650.6,579z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_bras_droit)}
        />
        <path
          id='arriere_epaule_droit'
          d='M711.7,545.3l3.4,8.2l2.9,8.3l-50.2,12.4l-9.1,2.3l-1.6,0.5l-1,0.4l-5.6,1.6
		l-18.1-53.9l-1.6-10.2l-4.1-28.1l10.6,4.2l20,4.4l11.3,4.3l8.9,4.8l9,6.5l9.2,9l5.4,6.7l6.6,10.4L711.7,545.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_epaule_droit)}
        />
        <path
          id='arriere_cheville_gauche'
          d='M624.6,1695.7l0.2-7.1l0.5-5.3l1.6-8.7l1-4.3l-0.5-5.3l-0.9-5.4l-1.1-5.1
		l52.1-0.5l0.9,14.4l1,10.7l1,8.1l2.7,10.8l0.9,8.3l0.6,12c0,0-8.6-12.2-15.7-14.5l-4.2-0.9l-7.2-0.9l-6.7,0.6l-8.7,1.7
		c-9.1,1.9-19.8,11.6-19.3,9.9l0,0l1.3-8.2L624.6,1695.7z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_cheville_gauche)}
        />
        <path
          id='arriere_main_gauche'
          d='M218.2,959l-52.9-21.7l-3.9,4.3l-6.5,1.9l-7.7,3.1l-11.6,8.1l-7.7,8.5l-8.9,12.4
		l-8.5,11.2l-3.1,4.6l1.9,4.6l5,0.8l4.6-1.2l6.2-5l11.2-10.8l0.8,5.8l-3.5,10.1l-4.6,10.4l-6.2,13.5l-4.3,11.2l-7,16.2l-1.5,5.8
		l1.2,3.5l2.3,0.4l3.5-3.1l7-8.9l9.7-12l10.1-13.5l3.5,0.4l-0.8,5.4l-5.4,15.9l-4.9,14.3l-6,19l1.5,5.4l3.9,1.5l4.3-2.3l3.1-4.6
		l6.2-12l4.3-11.2l3-12.8l3.1-7.7l4.3-7.7l1.9,0.4l1.2,1.9l0.4,3.9l-1.2,7.7l-1.5,7.7l-3.9,19.7l-2.3,12.4l0.4,7.7l3.1,2.7l4.3-1.2
		l1.5-3.1l3.1-3.5l1.2-4.3l4.6-20.1l2.7-12.4l3.5-15.1l1.9-1.5l3.1,0.4l0.8,4.3l0.4,18.6l1.5,18.2l1.9,3.1l3.9,0.4l2.3-0.8l1.9-2.3
		l0.8-7.4l0.4-18.2l0.4-9.3l0.8-9.3l1.5-6.2l2.3-7.7l4.3-13.9l5.4-18.2L218.2,959z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_main_gauche)}
        />
        <path
          id='arriere_dorsal_gauche'
          d='M363,718.3l0.8-18.9l1.4-4.4h130.8v127.1H358l1.8-33.7l0.5-9.6l0.6-11.9l0.6-13.3
	l0.5-11.7L363,718.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_gauche)}
        />
        <path
          id='arriere_buste_droit'
          d='M521.5,694.2V478.6l71.2-0.2l18.6-1l15.4,9.3l5.7,38.3l23.2,68.3l0.6,51.3l1.1,22.1
	l-1.1,15l0,7.3l0,5.5l-7.7-0.4L521.5,694.2z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_buste_droit)}
        />
        <path
          id='arriere_dorsal_droit'
          d='M521.5,822.9V694.8l134.7-0.2v8v20.6l1.3,22.2l0.8,23.9l0.6,20.2l0.6,20.2l0.3,12.6
	L521.5,822.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_dorsal_droit)}
        />
        <path
          id='arriere_avant_bras_droit'
          d='M748.9,775.3l36.1-15.4l8.9,15.7l6.9,17.5l4.6,19.5l2.6,16.9l3.2,10.9
		l10.8,26.1l11.2,23l-21.7,8.5l-26.3,11.1l-16-22.7l-9.8-15.6l-1.3-2.9l-7-10l-10.4-15.4l-9.8-15.6l-4.2-7l-6.6-11.9l-6.4-13.4
		L748.9,775.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_avant_bras_droit)}
        />
        <path
          id='arriere_pied_droit'
          d='M396.4,1715.1L396.4,1715.1c-18.9-28.2-61.1-13-62.4,0.4l0.2,7.6l0.5,15l-0.9,8.9
		l-8.9,16.9l-15.1,25.6l-6.1,11.9l-1.8,6.1l-0.2,3.8l3.5,6.1l4,5.3l6,4.2l4.5,1l5.8-0.1l8.6-1.1l6.8-1.2l5.5,0.8l4,0.6l4.2,0.7
		l4.5,1l4.8,1.7l5.6,1l5.2-3.4l4.1-3.5l2.4-6.1l3.7-8.9l2.1-5.2l0.7-5.5v-5.9v-6.1l-0.1-4.1l0.5-4.1l1.1-5.6l0.9-4.9l0.9-5.2
		l1.1-6.5l1.4-10.6l1.2-9.3l1.4-10l0.4-5L396.4,1715.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_pied_droit)}
        />
        <path
          id='arriere_fesse_droit'
          d='M656.7,994.1H521.5v59.6H509v18.7l0.7-1.9l2.5,3.2l0.7,6l1.8,8.5l0.9,15.9l151.3-19.9
	l-2.6-31.1l-2.3-18.3l-2.1-14.3l-1.7-13.5L656.7,994.1z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_fesse_droit)}
        />
        <path
          id='arriere_lombaire_droit'
          d='M521.5,823.3l-0.4,97.4l135.6,0.4l1.4-15l1.1-13.1l1.2-29.8l-0.1-13l-0.5-12.4
	v-15.5L521.5,823.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_lombaire_droit)}
        />
        <path
          id='arriere_colonne_haut'
          d='M520.6,408.4h-24.2v69.2h24.2V408.4z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_haut)}
        />
        <path
          id='arriere_colonne_milieu_bas'
          d='M520.9,718.3h-24.3v186.9h24.3V718.3z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_bas)}
        />
        <path
          id='arriere_colonne_milieu_haut'
          d='M520.6,495.9h-24.2V705h24.2V495.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_milieu_haut)}
        />
        <path
          id='arriere_colonne_bas'
          d='M520.9,920.9h-24.3v132.3h24.3V920.9z'
          stroke='black'
          fill={syoUtils.colorFiller(lesionnel.arriere_colonne_bas)}
        />
        <g id='Mannequin global V2'>
          <g id='enfant_arriere'>
            <g id='oreilles'>
              <path
                id='mannequin_oreille_droit'
                d='M607.7,268.2c0,0,17.9-8.5,16.7,12.4c0,0,0.4,18.4-1.7,29.6c-2,11.1-16.9,31.9-24.7,12.8
		L607.7,268.2z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='mannequin_oreille_gauche'
                d='M410.5,270c0,0-17.9-8.5-16.7,12.4c0,0-0.4,18.4,1.7,29.6
			c2,11.2,16.9,31.9,24.7,12.8L410.5,270z'
                stroke='black'
                strokeWidth='3'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <path
              id='silhouette'
              d='M656.3,667.3c0,13.9-0.3,27.9,0.1,41.8c1.3,51.4,3.6,102.8,4,154.2c0.2,23.6-3,47.3-4.8,70.9
			c-2.8,35.8,2.3,76.5,7.6,108.8c4.2,44.1,8.1,85.8,3,130.6c-5.9,35.8-2.1,70.5-9.5,106c-7.5,36.3,4.1,72.6,6.1,109.2
			c2.7,50.5,29.4,77,24.3,127.6c-2.4,23.8-1.3,65-6.1,88.5c-5,24.8-3.5,59.1-0.4,82.4c7,16.4,1.4,61,9.7,71.2
			c7.8,9.5,38.2,48.8,23,63.5c-11.9,9.3-29.1,4.2-42,2.8c-3.6,1.6-3.1,2.9-21.8,6.5c-10.6,2-30.1-102.5-27.5-113
			c5.1-20.8,0.3-26,5.9-46.7c2.2-8.2-15.6-64.1-16.6-72.2c-7.5-29.4-24.5-99.7-22.9-133.3c0-34-6.9-59-22.6-95.4
			c-12.4-97.7-19.8-116.9-36.4-177c-0.2-7.3-12.3-45.4-12.7-52.6c-0.4-7.8-0.1-70.6-7-70.5c-7.9,0.2-5.4,43.7-5.6,49.5
			c-2.3,61.1-37.6,125-39.2,186.1c-1.4,52.8-18.2,79-33.2,131.2c3.1,21.6-5.8,122-24.3,169.1c-4.9,12.5-13.7,53.8-13.5,66
			c0.6,26.5,4.4,41.9,2.6,54c-2.3,16.9-3.1,24.7-6.1,41.5c-2.6,14.6-2.8,10.9-2.4,24.8c0.4,14.1-1.2,11.3-8.9,31.5
			c-12.9,11.8-10.4,5.4-24.3,3.2c-18.5-2.9-10.8-1.6-29.1,0.3c-12.7,1.4-17-4.4-23-15.3c-6.8-6.2,26.4-52.2,31.3-64.6
			c3.1-8-2.6-41.6,2.3-48.6c9.9-32.8,5.8-70.9,2.9-103.5c-5.3-48.9-5.4-93.4-2.9-141.9c1.8-33.8,18.4-68,21.2-101.6
			c2.7-33.3,0.6-115.5-2.5-151.1c-4.1-64-4-67.6-1.2-132.5c1.3-29.6,5.3-59,6.8-88.6c0.9-17.2,0.3-34.7-1.5-51.9
			c-4.2-39.9-2.6-79.8-0.4-119.7c2.5-46.9,4.4-93.7,6.5-140.6c-0.9-0.1-1.8-0.2-2.7-0.4l-13.7,29.6l-7.7,21.1
			c-7.4,23.5-30.3,75.9-30.3,75.9c-11.7,28.3-44.4,73.2-44.4,73.2c-4.6,12.6-41.7,58.3-45.7,71.1c-0.4,6.4-3.3,30.3-3.7,34.1
			c-0.6,6.1-3.7,15.7-3.7,15.7s-0.9,2.9-5.2,17.2c-2.8,9.2-4.5,15.5-5.8,25.4c-1.3,9.8-0.4,24.5-1.1,30.8c-0.6,6.1-2.2,8.5-4.9,9.2
			c-8,2-7.4-23.2-7.3-29.7c0.1-7.5,0.6-14.5-3.6-14.9c-4.4-0.4-11.5,40.4-13.5,48.8c-4.6,13.7-9,11.2-10.1,12
			c-4.5-1-3.4-9.3-3.4-9.3c-1.4-1.7,13.2-52.9,6.5-54.7c-4.5-1.2-20.4,57.5-26.9,57.3c0,0-6.4,1.5-7.8-6.1
			c-0.5-2.8,25.8-65.3,13.5-54.9c0,0-19.8,23.7-23.8,30.7c-10.8,12.6-9.9,2.9-9.9,2.9c0.8-11.4,28.5-68.6,27.1-67.3l-0.8-5.8
			c0,0-15.8,16.8-22.1,17c-16.6,0.5,4.6-21.3,5.6-22.7c23.5-36.9,35.5-23.2,45.8-37.3c0.1-2.1,51.4-88.9,51.7-115.1
			c6.9-43.4,16.8-55.4,53.1-109.3c9.6-40.7,23.6-81.7,29.7-123c7-47.7,28.6-87.1,75.9-96.9c28.6-2.4,46.7-25.1,63.2-47.2
			c9.5-12.8,15.7-27.1,18.2-42.7c0.5-3.3-0.6-8.4-2.9-10.3c-13.8-5.1-23.1-25.6-29.7-40.7c-2.3-5.2-4.3-25.3-4.3-25.3
			s-3.8,7.9-10.7,5.8c-2.8-0.9-12.1-3.3-15.2-20c-0.9-4.8-1.4-14.7-1.9-22.9c-0.5-8.9-0.8-19.1,6.2-22.1c3.5-1.5,12.3,1.1,12.3,1.1
			c-2-22.6-1.2-45.4,3.7-64.8c4.1-16.3,11.6-30,17.1-41.6c9.1-12,23.9-23.8,41-31.8c32.9-5.9,39.9-9.8,72.3-1.6
			c27.8,8.9,39.1,24.2,46.2,37.9c7,11.5,14.2,28.6,16.5,55.6c0.5,3,0,46.3,0,46.3s5.4-3.6,11.1-1.9c0.5,0.7,5.6,2.8,5.6,3.7
			c-0.2,19.8,0.5,19.3,0.5,19.3c0,0.6-0.7,11.8-2.4,23.2c-0.7,4.7-5.8,14-6.1,14.3c-13.3,10.9-19.1,0-19.1,0
			c-1.4,14.4-0.3,10.9-4.3,25.3c-2.2,8.1-4.6,17-9.5,23.4c-6.7,8.6-10.1,12.8-19.1,17.7c-2.9,1.6-2.5,4.1-2,7.7
			c5.1,38.1,26.1,65,59.3,83c13,7,14.7,6.5,32,10.5c12.9,2.1,30.7,12.8,41.8,25.5c7.1,8.1,13.3,19.1,18,30
			c7.4,17.3,8.5,28.9,11.1,44c2.1,9.5,3.8,23.6,5.6,33.5c0.6,3.2,0.8,4,1.8,7.2c1.9,5.9,4,10.3,5.7,16.5
			c3.6,13.2,6.5,25.3,10.2,38.7c1.3,4.7,4.8,18,5.8,22.9c0,0,2.6,3.9,6.5,9.9c4.2,6.6,20.4,29.8,24.5,37c1.2,2,8.2,13.8,10.9,20.9
			c1.7,4.3,6.1,17.6,7.7,24.1c1.3,5.4,3.6,18.8,4.5,24.6c0.9,5.6,4.2,13.3,6.2,18.2l16.5,36.6l9.2,17.4l19.2,36.1l3.9,4.3l7,2.1
			l7.3,2.9l11.6,8.1l8.8,10l18.1,24.9c1.4,3.2-0.1,6.6-3.1,7c-3.5,0.4-2.5,0.2-7.2-0.9c-1.5-0.4-17.4-15.9-17.4-15.9l-0.8,5.8
			l3.5,10.1c0,0,10.4,22.9,10.5,23.2c0,0,10.3,25.4,12.6,32.1c1.6,4.5-1.6,6.4-4.4,4.5c-2.2-1.4-5.4-6.2-8-9.5
			c-3.8-4.7-20.1-25.2-20.7-26.8l-3.5,0.4l0.8,5.4c0,0,16.3,47.8,16.2,49.1c-0.1,5.6-1.3,6.4-5.4,7c-5,0.7-13.5-19-13.5-19
			l-4.3-11.2l-3-12.8c-1.8-7.1-6.7-14.4-6.7-14.4c-3.8-2.8-4.1,4.2-4.1,4.2l8.8,48.5c0,0,0.5,6.8-0.4,7.7c-7.4,7.8-12-5-12-5
			l-12-51.8l-1.9-1.5l-3.1,0.4l-0.4,1.9l-0.2,1.2l-0.2,1.1c-0.6,8.4-0.4,17-0.4,17l-1.6,19.7l-1.9,3.1l-3.9,0.4l-1-0.3l-0.9-0.3
			c-0.4-0.1-2.1-0.2-2.5-4.4c-0.4-4.1-0.9-14.3-0.8-16c0.3-4-1.3-26.2-1.3-26.2s-13.4-45-13.5-46c-0.7-4.6-0.7-7-1.2-11.2
			c-1.5-13.2-3.1-27.9-3.1-27.9s-7.9-14.4-9.9-17.3c-4.7-7-6.3-9.1-11.7-16.9c-7.9-11.2-17.5-24.4-22.3-33.2c-2.8-5-5.7-9.2-6.1-9.7
			c-3.8-5-15.6-23.5-18.9-28.5c-10.3-15.5-16.4-27.3-21.2-38.6c-3.8-9.1-8.7-20.6-8.7-20.6c-4.2-10-11.2-26-15.5-38.1
			c-3.9-11.1-8.8-27.4-12.6-35.7c-4.1-9.1-7-15.5-7-15.5c-2.7-3.7-12.7-17.6-12.7-17.6C656.9,667.2,656.6,667.2,656.3,667.3z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2HandRight({ lesionnel }: FrontV2HandRightProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_hand_right_vector'>
        <g id='mannequin_front_hand_right_global_v2'>
          <g id='avant_droit_contour_main'>
            <path
              id='Vector'
              d='M590.8 1606.3C584.5 1601.8 570.4 1586.9 564.1 1582.5C557.5 1577.9 552 1572.2 546 1566.9C531.7 1554.4 521.5 1538.7 511.3 1522.9C499.8 1505.3 488.2 1487.7 476.5 1470.2C439.2 1414.6 401 1359.6 363.8 1303.9C342.9 1269.8 322.1 1235.2 304.4 1199.9C288.2 1167.6 266.3 1129.9 252.7 1096.3C239.4 1063.4 225.4 1041.9 213.1 1006C208.6 992.8 203.8 981 200.6 967.3C197.8 955.3 188.2 930.9 202.5 905.2C209.4 892.8 228 883.5 239.2 880.6C261.7 875 275.3 879.9 286.3 883C319.5 892.4 350.9 918.1 367.7 948.1C384.5 978.1 401.4 1009 418.3 1038.5C427.1 1053.8 435.3 1067.4 446.2 1081.2C469 1110.1 482.3 1148.5 519.6 1161.7C528.8 1165 535.2 1160.5 541.4 1154C551.4 1143.5 560.8 1132.1 566.2 1118.7C572.6 1102.8 572.8 1085.3 573.7 1068.2C575.8 1025.9 543.6 605.5 542.2 591.7C540.1 571.5 540.1 378.4 542.1 367.1C543.7 358.1 546.6 348.7 551.6 341.2C567.9 316.6 600.6 296.6 630.7 306.9C644.2 311.5 655.5 321.6 663.3 333.6C672.5 347.9 679.4 367.5 682.6 384.1C685.1 396.9 690.4 466.9 690.2 488.7C690.1 515.1 702.4 674.8 704.9 689.4C710.3 721.2 728.2 875 740.1 892.1C742.6 895.7 745.4 899 748.4 902.1C754.1 908.1 759 908.3 764.8 902.4C772.9 894.2 777.9 883.9 778.7 872.6C780.3 848.6 782.6 706.1 782.5 677.7C782.4 661.3 786 382.7 788.3 359.4C793 311.7 799.4 293.8 819.2 272.9C833.4 257.9 848.9 256.3 872.4 257C881.8 257.3 891.9 259.3 900.1 263.8C908.4 268.4 921 282.6 924.7 302C928.1 319.5 928.5 337.5 930.1 355.3C931.3 369.2 932.2 383.2 933.1 397.1C934.2 414.7 934.7 432.4 936.2 449.9C937.5 465.6 938.1 497 938.1 497C938.1 497 939.5 601.4 940.4 631.3C941.1 656.6 941 682.2 941.5 707.6C942.1 735.2 938.8 817.6 940.7 831.4C942 840.6 944.3 849.7 947.2 858.6C950.7 869.5 958.3 871.8 968.1 865.6C978.6 859 983.5 848.1 987.8 837.4C996.3 816.3 1000.3 794.2 1002.2 771.5C1003.8 752.8 1007.4 734.4 1009 715.7C1010.9 693.6 1014.2 669.8 1017.6 647.8C1019.6 635 1039 512 1043.8 488.8C1045.3 481.3 1052.7 436.7 1055.2 421.9C1057.2 409.8 1059.8 397.7 1062.5 385.7C1066.3 368.8 1070.1 351.5 1080.3 337.3C1094.7 317.2 1118.5 305.5 1144.5 317.5C1156.8 323.2 1164.1 334.6 1169.7 346.5C1181.1 370.8 1176.1 486.9 1173.9 516.4C1171.3 552.1 1167.6 605.5 1166.9 641.3C1166.5 659.4 1163.8 690.3 1163.5 693.1C1161.9 710.8 1154.9 765.7 1153.8 774.3C1151.5 791.7 1142.7 829.8 1137.2 858.9L1126 923.9C1124.5 937.8 1125.6 939 1125.9 946.6C1126.2 954.9 1130.3 960.7 1138.1 963.9C1142.3 965.6 1146.5 967.5 1150.5 969.5C1155.1 971.8 1159.5 970.9 1162.2 967.2C1169.4 957.6 1219.2 851.3 1236.3 807.6C1241.4 794.6 1255.6 764.9 1264.3 743.2C1275.6 715.2 1287.1 687.1 1296.3 658.4C1303.4 636.1 1314.3 617.5 1333.9 604.8C1351 593.8 1370.7 593.9 1386 607.2C1394.4 614.5 1399.7 628 1400.9 633.8C1403.7 648 1404.2 661.7 1402.6 675.7C1400.8 690.9 1398.2 706 1395.4 721C1393.1 733.5 1390.4 746 1387 758.3C1382.3 775.4 1377.5 792.5 1371.6 809.2C1364.7 828.5 1356.5 847.2 1348.9 866.3C1339.3 890.4 1330.6 914.9 1320 938.5C1309.9 960.9 1295.5 990.2 1286.6 1013.1C1275.4 1041.9 1275 1041.4 1271.9 1061C1267.4 1089.6 1264.6 1117.1 1262.1 1145.9C1259.4 1176.6 1254.8 1207.1 1253.2 1237.8C1251.9 1262.9 1244.7 1361.1 1238.4 1385.2C1229.2 1420.6 1221.7 1457.2 1207.4 1491C1193.1 1524.7 1181.4 1557.3 1161.4 1588.1C1157.6 1594 1148.2 1618.6 1143.8 1623.9'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_2'
              d='M590.8 1606.3C590.8 1606.3 704.9 1760.6 684 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_3'
              d='M1143.9 1623.5C1143.9 1623.5 1081.7 1789.5 1129.3 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_front_hand_right_zones'>
          <path
            id='avant_droit_paume'
            d='M568.797 960.5C568.912 962.348 569.026 964.182 569.138 966M569.138 966C572.316 1017.44 574.269 1056.73 573.7 1068.2C572.8 1085.3 572.6 1102.8 566.2 1118.7C560.8 1132.1 551.4 1143.5 541.4 1154C535.2 1160.5 528.8 1165 519.6 1161.7C512.888 1159.32 506.953 1156.13 501.6 1152.33C499.151 1150.59 496.824 1148.72 494.6 1146.74L501.1 1154L499.6 1155L504.1 1157.5L507.1 1160L510.1 1163L512.6 1167L514.6 1172L515.6 1177V1182L514.6 1188L513.6 1193L511.6 1198.5L509.6 1203.5L506.6 1209L502.6 1215.5L499.6 1220L496.1 1224.5L492.1 1229.5L488.1 1234L484.6 1237.5L479.1 1243L471.6 1249.5L464.1 1255.5L455.6 1261.5L446.1 1267.5L435.6 1273.5L424.1 1279L416.1 1282L407.1 1285L394.6 1288L385.1 1289L379.6 1289.5L373.1 1289L366.6 1288L359.6 1285.5L355.1 1283L350.6 1279L347.6 1274.5L346.253 1275C352.049 1284.68 357.921 1294.31 363.8 1303.9C401 1359.6 439.2 1414.6 476.5 1470.2C488.2 1487.7 499.8 1505.3 511.3 1522.9C521.5 1538.7 531.7 1554.4 546 1566.9C552 1572.2 557.5 1577.9 564.1 1582.5C570.4 1586.9 584.5 1601.8 590.8 1606.3L630.6 1637.5L663.1 1657.5L701.1 1674.5L748.1 1690.5L778.1 1697L812.6 1701L844.6 1703L863.6 1702.5L882.1 1701.5L917.6 1698L947.1 1693.5L975.1 1687.5L1013.1 1677L1058.6 1661.5L1082.6 1652L1105.6 1642L1143.8 1623.9C1148.2 1618.6 1157.6 1594 1161.4 1588.1C1181.4 1557.3 1193.1 1524.7 1207.4 1491C1221.7 1457.2 1229.2 1420.6 1238.4 1385.2C1244.7 1361.1 1251.9 1262.9 1253.2 1237.8C1254.8 1207.1 1259.4 1176.6 1262.1 1145.9C1264.6 1117.1 1267.4 1089.6 1271.9 1061C1274.24 1046.22 1275.04 1042.87 1280.1 1029.75L1272.6 1038L1264.6 1044L1255.6 1048L1245.6 1050.5L1235.1 1051.5L1222.6 1051L1211.1 1048.5L1199.6 1044.5L1191.1 1040L1181.1 1033L1172.6 1025.5L1165.1 1016L1160.1 1005.5L1157.6 998.5L1156.6 991V986.5L1157.1 980.5L1159.1 974L1162.2 967.2C1159.5 970.9 1155.1 971.8 1150.5 969.5C1146.5 967.5 1142.3 965.6 1138.1 963.9C1130.3 960.7 1126.2 954.9 1125.9 946.6C1125.6 939 1124.5 937.8 1126 923.9L1128.69 908.299L1124.6 921L1120.6 928L1117.6 932L1112.6 937.5L1107.1 941.5L1100.6 945.5L1091.6 949.5L1081.6 952.5L1072.1 954.5L1059.6 955.5L1047.1 954.5L1034.1 952.5L1020.6 948.5L1005.6 942L994.1 935L985.1 927.5L980.1 922L975.1 915.5L970.6 908L967.6 900.5L966.6 896L966.1 890.5V884.5L966.6 880L968.1 875L969.6 871L971.6 866.5L973.6 863.5L976.1 860.5L978.1 856.218C975.417 859.819 972.182 863.034 968.1 865.6C958.3 871.8 950.7 869.5 947.2 858.6L948.6 865L951.6 868L953.6 870.5L956.1 873.5L957.6 876L959.6 880.5L961.6 887L962.1 891.5V895L961.1 901.5L959.1 909L954.6 917L948.6 925L940.6 932.5L930.6 939.5L922.6 944L914.6 948L899.6 953.5L884.1 957.5L870.6 959.5L859.1 960H844.6L832.6 958.5L823.6 957L814.6 954.5L804.1 950.5L795.1 946L787.1 940.5L780.6 934L774.6 926L771.6 918.5L770.1 912V908V904L770.6 901L772.1 895.5L774.1 889.464C771.772 894.169 768.633 898.52 764.8 902.4C759 908.3 754.1 908.1 748.4 902.1L752.6 906.5L754.1 908.5L755.6 911L756.6 914L757.6 917L758.1 920V923V926.5L757.6 929.5L756.6 934.5L754.1 940L750.1 946.5L746.6 951.5L742.6 955.5L738.1 960L733.1 964.5L728.1 968L721.6 972.5L717.1 975L711.1 978.5L704.6 981.5L696.6 985L689.1 987.5L681.6 990L674.1 992L665.1 994L653.1 996L640.6 997H625.1L614.6 996L603.6 993.5L593.1 990L583.6 985L578.1 980.5L573.1 975L569.6 968L569.138 966Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_paume)}
          />
          <path
            id='avant_droit_poignet_droit'
            d='M590.8 1606.3L628.8 1670.1L659.6 1735.4C659.6 1735.4 671.2 1771.3 675.8 1783.4C682.8 1801.8 687.1 1849.2 686.4 1855.2C685.7 1861.2 684 1886.3 684 1886.3C766.1 1886.3 848.2 1886.7 930.4 1886.6C996.1 1886.5 1061.4 1885 1126.9 1881.2C1126.9 1881.2 1122.3 1877.4 1119.7 1860.6C1119 1856.2 1116.3 1846.2 1115.6 1841.4C1114 1830.9 1113.8 1818.7 1112.5 1809.6C1110.7 1797.3 1112.4 1785.4 1112.5 1784.7C1112.7 1782.4 1116.6 1743.8 1116.7 1741.1C1116.8 1738.4 1121.9 1709.5 1121.9 1709.5L1129.6 1674.4L1143.6 1624.5L1112.6 1639.3C1112.6 1639.3 1099.7 1645.2 1089.1 1649.6C1080.7 1653.1 1076.2 1654.9 1071.4 1656.9C1066.7 1658.8 1068.5 1658.2 1059.6 1661.5C1049.8 1665.2 1027.8 1672 1019.1 1675.5C1010 1679.1 997.5 1681.6 985.9 1685C974.2 1688.4 959.2 1691.2 959.2 1691.2C959.2 1691.2 944.7 1695 921.6 1698C906.3 1700 878.8 1702.3 871.9 1702.7C866.4 1703 852.4 1703.2 844.4 1703.1C837.1 1703 811.6 1701.3 811.6 1701.3L779.5 1697.4L748.6 1690.9C748.6 1690.9 721.9 1681.5 708.9 1677.7C697.1 1674.3 670 1660.5 666 1659.1C662 1657.7 633.3 1638.8 631.3 1638.2C629.3 1637.6 590.8 1606.3 590.8 1606.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_poignet_droit)}
          />
          <g id='mannequin_front_hand_right_doigts'>
            <g id='mannequin_front_hand_right_pouce'>
              <path
                id='avant_droit_phalange_pouce_proximale'
                d='M494.3 1147.4L485.9 1138.8L474.9 1124.6L460.7 1102.8L452.3 1090.2L436.9 1069.4L426.4 1053.1C426.4 1053.1 427.5 1059.6 427.3 1063C427.1 1066.4 426.5 1070.2 426.1 1071.8C425.7 1073.4 424.1 1079.3 420.9 1084.5C417.7 1089.6 411.9 1098.3 405.6 1103.8C399.3 1109.3 393.7 1114.2 387.5 1118C381.3 1121.8 378.9 1123.2 378.9 1123.2C378.9 1123.2 366.3 1130 360.9 1131.6C355.4 1133.3 349 1136.1 341.6 1137.7C334.2 1139.3 319 1142.3 308.2 1141.3C297.4 1140.2 292.9 1140.1 283.1 1136.3C273.3 1132.5 269.4 1127.9 269.4 1127.9L264 1122.6L295.2 1182.3L320.9 1231.5L346.5 1275.8L345.7 1271.2C345.7 1271.2 344.6 1268.3 344.2 1263.1C343.8 1257.9 345.5 1250.9 345.5 1250.9C345.5 1250.9 346.8 1245 350.4 1237.6C354 1230.2 358.6 1223.6 358.6 1223.6L364.8 1215.3C364.8 1215.3 367.2 1212.1 371.3 1207.8C375.3 1203.6 381 1198.1 381 1198.1C381 1198.1 391.2 1188.8 392.9 1187.9C394.6 1187 396.2 1185.2 400.7 1182.1C405.2 1179 404 1179.8 404 1179.8L410 1175.9L415.5 1172.5L421 1169.4L426.4 1166.5L431.9 1163.8L437.2 1161.4L442.1 1159.4L448.3 1157.2L453.6 1155.5L460 1153.8L465.8 1152.6L473.3 1151.5L478.6 1151.1H485.8L491.5 1151.7L497.1 1153L503 1155.3L494.3 1147.4Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_pouce_proximale)}
              />
              <path
                id='avant_droit_phalange_pouce_distale'
                d='M400.6 1006.6L384.3 977.2L372.5 956L362.5 938.8L346.9 919.8L342.8 924.5L332 937.2L325.7 943.8C322.9 946.6 319.9 949.4 319.9 949.4L315 953.7L302.7 963.4L292.6 970.4L280.1 977.9L269.6 983.4L259.8 987.9L237.9 996.3L225.1 999.8L211.8 1002.6L226.1 1038.3L240.9 1069.3L260.1 1112.8C260.1 1112.8 256.2 1101.3 261.4 1088.6C266.6 1075.9 272.9 1069.3 272.9 1069.3C272.9 1069.3 278.8 1061.9 285.4 1056.8C291.9 1051.6 295.7 1048.9 295.7 1048.9C295.7 1048.9 304.2 1043.1 310.6 1040C317 1036.9 323 1034.3 323 1034.3C323 1034.3 330.8 1030.8 341.5 1028.1C352.3 1025.3 359.4 1024.6 359.4 1024.6C359.4 1024.6 370.5 1023 382.3 1024.1C394.1 1025.2 399.6 1027.5 399.6 1027.5C399.6 1027.5 409.1 1030.3 418.1 1037.5L400.6 1006.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_pouce_distale)}
              />
              <path
                id='avant_droit_articulation_pouce_interne'
                d='M457.371 1260.26C502.184 1229.22 526.148 1186.21 510.897 1164.19C495.645 1142.17 446.952 1149.48 402.139 1180.52C357.326 1211.56 333.362 1254.57 348.614 1276.59C363.866 1298.61 412.558 1291.3 457.371 1260.26Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_pouce_interne)}
              />
              <path
                id='avant_droit_articulation_pouce_externe'
                d='M362.366 1130.59C407.561 1112.41 435.512 1076.08 424.797 1049.43C414.082 1022.79 368.758 1015.92 323.564 1034.1C278.369 1052.27 250.418 1088.6 261.133 1115.25C271.848 1141.89 317.172 1148.76 362.366 1130.59Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_pouce_externe)}
              />
              <path
                id='avant_droit_ongle_pouce'
                d='M216.2 1001.8C216.2 1001.8 290.4 990.2 340.2 927.6L345.9 920.8C345.9 920.8 335.6 908.8 324.9 901.8C314.2 894.8 292.1 886 292.1 886C292.1 886 285.4 878 252.5 878.5C219.6 879 202.5 905.3 202.5 905.3C202.5 905.3 191.9 915.3 193.6 940C195.1 961.8 211.9 1002.6 211.9 1002.6L216.2 1001.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_pouce)}
              />
            </g>
            <g id='mannequin_front_hand_right_auriculaire'>
              <path
                id='avant_droit_phalange_auriculaire_proximale'
                d='M1170.6 952.3L1185.3 922.2L1205 880.1L1221.2 843.2L1235 810.6L1234.7 816.8C1234.7 816.8 1233.8 823.2 1236 831.9C1238.2 840.6 1242.8 847.6 1242.8 847.6C1242.8 847.6 1248.7 856.8 1254.6 861.5C1260.4 866.2 1262.3 867.5 1262.3 867.5C1262.3 867.5 1269.8 872.6 1277.7 875.6C1285.6 878.6 1291.2 879.5 1291.2 879.5C1291.2 879.5 1296.7 880.8 1305.6 880.9C1314.4 881 1322.7 878.6 1322.7 878.6C1322.7 878.6 1329.3 877.1 1337 872.4C1344.8 867.7 1351.1 859.6 1351.1 859.6L1348.8 867L1328.9 918.3L1299.8 983.1L1285.5 1016.7L1285.7 1012.4C1285.7 1012.4 1286.4 1007 1285.4 1001.2C1284.4 995.4 1283.1 992.1 1283.1 992.1C1283.1 992.1 1280.4 984.4 1276.9 979.6C1273.4 974.7 1272.6 973.7 1272.6 973.7C1272.6 973.7 1268.5 968.8 1265.8 966.4C1263.1 964 1260 961.5 1260 961.5C1260 961.5 1255.5 958 1251.5 955.8C1247.5 953.6 1243.7 951.7 1243.7 951.7C1243.7 951.7 1236 948.1 1231.5 947.2C1231.5 947.2 1225.5 945.5 1222.9 945.2C1222.9 945.2 1216.2 944.1 1212.1 944.1C1208 944.1 1206.3 944.1 1206.3 944.1C1206.3 944.1 1202.5 944.1 1197.3 945C1192 945.9 1186.4 947.9 1186.4 947.9C1186.4 947.9 1180.8 949.8 1175.4 953.5C1170 957.1 1167.3 960.4 1167.3 960.4L1170.5 952.5L1170.6 952.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_auriculaire_proximale)}
              />
              <path
                id='avant_droit_phalange_auriculaire_mediane'
                d='M1390.9 741.9L1386.8 760.4L1377.4 791.9L1369.9 814.1L1358.3 843.4L1357.8 840.1C1357.8 840.1 1358.5 836.9 1357.6 829.2C1356.7 821.5 1353 814.3 1353 814.3C1353 814.3 1349.7 807.1 1344.3 801.1C1339 795.1 1335.7 792.7 1335.7 792.7C1335.7 792.7 1328.7 786.9 1320.9 783.3C1313.1 779.7 1310 779 1310 779C1310 779 1303.2 776.3 1290.3 775.5C1277.4 774.8 1266.4 778.9 1266.4 778.9C1266.4 778.9 1259.3 781 1252.4 786.2C1245.5 791.4 1241.3 797.3 1241.3 797.3L1242.2 794.5L1252.9 770.5L1264.8 742.6L1274.5 718.4L1277.5 710.1L1278.1 714L1277.9 718.4L1278.2 722.6L1278.9 725.3L1280.1 728.9L1282.4 733.7L1285 737.8L1290.1 744L1293 746.8C1299.1 753.3 1312 759.4 1312 759.4L1318 762L1325.1 764.4C1325.1 764.4 1330.5 765.9 1331.5 766L1338 767.1L1343.9 767.7C1343.9 767.7 1348.1 767.8 1351 767.8C1354 767.8 1360.8 766.7 1360.8 766.7L1364.5 765.9L1368.3 764.8L1372.2 763.3L1375.3 761.8L1379 759.6L1383 756.4L1386.2 752.8L1388.6 748.8L1390.9 741.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_auriculaire_mediane)}
              />
              <path
                id='avant_droit_phalange_auriculaire_distale'
                d='M1391.3 741.8L1395.4 723.1L1400.5 694L1401.6 683.2C1392.7 684.5 1375.5 684.2 1375.5 684.2C1375.5 684.2 1373.9 684.1 1359.4 683C1344.9 681.9 1327.5 675.5 1327.5 675.5C1327.5 675.5 1326 674.9 1317.8 671.3C1309.5 667.6 1299.3 658.7 1299.3 658.7L1297.4 657L1278.1 709.9L1282.5 703.2L1285 700.1L1288.4 696.9L1293 693.8L1298.1 691.3L1303.2 689.5L1309.3 688.1L1314 687.5L1319 687.2C1319 687.2 1327.8 687.3 1328.9 687.6L1339.1 689.2C1339.1 689.2 1347.3 691.6 1348.7 692.1C1350.4 692.7 1363.2 698.2 1367 701.1C1370.3 703.6 1374.3 705.6 1378.8 710.8C1378.8 710.8 1385 715.2 1390 728.7C1392.2 734.7 1391.3 741.8 1391.3 741.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_auriculaire_distale)}
              />
              <path
                id='avant_droit_articulation_auriculaire_interne'
                d='M1282.63 1023.52C1293.52 997.427 1274.83 964.788 1240.88 950.623C1206.94 936.458 1170.59 946.131 1159.7 972.228C1148.81 998.325 1167.5 1030.96 1201.45 1045.13C1235.39 1059.29 1271.74 1049.62 1282.63 1023.52Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_auriculaire_interne)}
              />
              <path
                id='avant_droit_articulation_auriculaire_mediane'
                d='M1355.21 850.728C1365.35 824.334 1347.16 792.788 1314.58 780.268C1282 767.747 1247.37 778.994 1237.23 805.388C1227.08 831.782 1245.27 863.328 1277.85 875.848C1310.43 888.368 1345.07 877.121 1355.21 850.728Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_auriculaire_mediane)}
              />
              <path
                id='avant_droit_articulation_auriculaire_externe'
                d='M1279.2 709.5C1285.6 689.5 1315.7 681.3 1346.3 691.2C1376.9 701.1 1396.5 725.3 1390 745.2C1383.6 765.2 1353.5 773.4 1322.9 763.5C1292.4 753.7 1272.8 729.5 1279.2 709.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_auriculaire_externe)}
              />
              <path
                id='avant_droit_ongle_auriculaire'
                d='M1297 656.8C1297 656.8 1300 644.1 1309 630.8C1314.4 622.8 1323 615.5 1331.3 608.2C1354.5 587.8 1383.3 604.1 1390.6 612.5C1398 620.9 1408.5 654.4 1401.2 683C1401.2 683.1 1333.7 692.5 1297 656.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_auriculaire)}
              />
            </g>
            <g id='mannequin_front_hand_right_annulaire'>
              <path
                id='avant_droit_phalange_annulaire_proximale'
                d='M992.6 823.9L996.4 809.7L999.8 791.5L1004 754.7L1010.1 703.5L1016.8 652.8L1021.9 618.2C1021.9 618.2 1023.6 626.5 1023.9 627.6C1024.2 628.6 1026.9 635.8 1029.3 639.3C1031.8 642.7 1034.6 647.6 1045.2 655.2C1055.7 662.8 1066 665.6 1066 665.6L1073.3 667.7L1082.7 669.6C1082.7 669.6 1094.2 671.3 1102.1 670.7C1110 670.1 1118.5 668.7 1118.5 668.7C1118.5 668.7 1131.3 666.3 1141.1 660.4C1150.9 654.5 1152 652.9 1152 652.9C1152 652.9 1157.8 648 1161.5 641.9C1165.2 635.8 1166.6 629.2 1166.6 629.2L1166.8 639.2L1165.2 670.6L1162.9 698.5L1160.6 719.2L1157.3 746.5L1153.8 773.9L1151.3 789.3L1146.7 812.1L1142 834.5L1135.3 869.3L1131.1 893.5L1128.6 908.1L1127.9 904.6C1127.9 904.6 1128.1 900.3 1126.6 893.9C1125 887.5 1121.5 881.1 1121.5 881.1C1121.5 881.1 1119.3 876.8 1116.1 873C1112.9 869.2 1109.3 865.4 1109.3 865.4C1109.3 865.4 1106 861.7 1100.3 857.8C1094.6 853.9 1092.4 852.6 1092.4 852.6C1092.4 852.6 1087.3 849.4 1080.2 846.4C1073 843.4 1070.4 842.8 1070.4 842.8C1070.4 842.8 1061.8 839.6 1048.8 838.1C1035.8 836.6 1025.4 837.8 1025.4 837.8C1025.4 837.8 1017 838.3 1006.1 841.7C995.2 845.1 988 850.3 988 850.3L977.4 858.2L984.5 845.6L990.2 831.4L992.6 823.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_annulaire_proximale)}
              />
              <path
                id='avant_droit_phalange_annulaire_mediane'
                d='M1175.6 488.6L1175.1 501.1L1172.2 544L1170.1 576.3L1168 616.2C1168 616.2 1165.8 606.2 1158.7 596.7C1151.6 587.2 1140.4 580.8 1140.4 580.8C1140.4 580.8 1132.5 575 1114.2 570.6C1095.9 566.2 1080 568.9 1080 568.9C1080 568.9 1064.6 569.9 1053.7 576.2C1042.8 582.5 1035.2 588.9 1035.2 588.9C1035.2 588.9 1028.3 596.1 1025 603.4C1021.7 610.7 1027.8 586 1027.8 586L1038 523L1047.3 470L1047.6 479L1048.6 484.4L1051 490.4L1055.6 497.3L1061.4 503.4L1069 509.2L1077.8 514.1L1085 517.2L1092.1 519.5L1100.9 521.6L1108 522.6L1115.1 523.1H1123.3L1127.5 522.8L1131.9 522.3L1135.9 521.6L1142.2 520.1L1148.1 518.1L1153.1 515.9L1157.9 513.2L1161.9 510.4L1165.6 507.1L1168.9 503.2L1171.4 499.2L1173.2 495.1L1175.6 488.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_annulaire_mediane)}
              />
              <path
                id='avant_droit_phalange_annulaire_distale'
                d='M1174.5 488.5L1175.2 472.4L1175.9 438.4V412.5L1174.8 402.9C1174.8 402.9 1137.6 415.1 1107.5 411.8C1077.4 408.5 1059.5 395.5 1059.5 395.5L1049.3 452L1046.2 469.7L1049.7 465.5C1049.7 465.5 1052.6 460.3 1053 459.7C1054.9 456.8 1059.2 453.1 1059.2 453.1L1062.9 450.3L1068.2 447.2L1073.5 444.8L1078.4 443.1L1082.7 441.9L1087.7 440.9C1087.7 440.9 1092.1 440.2 1095.1 439.9C1099.1 439.5 1102.9 439.5 1103.7 439.5C1107.4 439.6 1115.8 440.3 1116.6 440.4C1121.7 441 1127.9 442.6 1129.2 443C1136.2 444.9 1142.3 447.7 1142.3 447.7C1142.3 447.7 1150.3 451.8 1153 453.5C1161.8 459.2 1167 466.1 1167 466.1L1170.2 470.8L1172.9 476.5L1174.6 481.6L1174.5 488.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_annulaire_distale)}
              />
              <path
                id='avant_droit_articulation_annulaire_interne'
                d='M1127.05 912.954C1133.67 881.667 1103.19 848.731 1058.99 839.388C1014.79 830.046 973.6 847.835 966.987 879.122C960.374 910.408 990.845 943.345 1035.05 952.687C1079.25 962.03 1120.44 944.241 1127.05 912.954Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_annulaire_interne)}
              />
              <path
                id='avant_droit_articulation_annulaire_mediane'
                d='M1167.42 623.978C1169.19 595.758 1138.18 570.85 1098.17 568.346C1058.15 565.841 1024.28 586.688 1022.51 614.908C1020.75 643.129 1051.75 668.036 1091.77 670.541C1131.78 673.045 1165.66 652.198 1167.42 623.978Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_annulaire_mediane)}
              />
              <path
                id='avant_droit_articulation_annulaire_externe'
                d='M1174.31 490.24C1177.42 467.7 1151.61 445.516 1116.65 440.692C1081.69 435.868 1050.83 450.229 1047.71 472.77C1044.6 495.31 1070.42 517.493 1105.38 522.317C1140.34 527.142 1171.2 512.78 1174.31 490.24Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_annulaire_externe)}
              />
              <path
                id='avant_droit_ongle_annulaire'
                d='M1060.3 395.6C1060.3 395.6 1064.1 363.9 1083.3 333.7C1102.6 303.5 1145.5 312.1 1155.2 325.1C1159.3 330.5 1167.1 339.4 1171.6 353.1C1176.1 366.7 1177.4 385 1175.5 403.1C1175.6 403 1112.5 428.9 1060.3 395.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_annulaire)}
              />
            </g>
            <g id='mannequin_front_hand_right_majeur'>
              <path
                id='avant_droit_phalange_majeur_proximale'
                d='M778.8 865.3L781.3 757.3L782.6 637.4V618L785.2 621.6C785.2 621.6 790.7 634.2 803.7 641.9C816.7 649.6 823.8 651.2 823.8 651.2C823.8 651.2 841.6 658.4 870.6 655.3C899.5 652.2 917.3 638.6 917.3 638.6C917.3 638.6 937.4 625.8 939.5 605.6L941.1 689.6L940.3 783.5L940 824L941 834.2L946.1 855.1L949.1 865C949.1 865 940.6 855.6 922.7 849.1C904.8 842.6 888.1 842 888.1 842C888.1 842 864.8 840.3 845.9 844.9C827 849.5 823.2 851.4 823.2 851.4C823.2 851.4 804.7 858.5 793.3 867.6C781.9 876.7 775.5 887.2 775.5 887.2L778.8 865.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_majeur_proximale)}
              />
              <path
                id='avant_droit_phalange_majeur_mediane'
                d='M934.9 441.3L935.5 450.7L936.8 477.2L937.9 536.9L938.6 582.3L937.7 592.8L935.2 586.3C935.2 586.3 927.2 568.5 901.5 559.6C875.9 550.7 857.3 553.5 857.3 553.5C857.3 553.5 830.4 554 807.3 568.4C784.2 582.8 782.4 599.5 782.4 599.5L783.2 556.1L784.1 496.7L785.2 441.2L786.9 449.1L788.7 452.8L792.4 458.2L796.8 462.8C796.8 462.8 798.3 464.5 801.9 466.8C805.2 469 802.8 467.4 809.2 471.2C815.7 475 817.9 475 830 478.8C846.2 483.9 869.5 482 869.5 482L877.4 481.2L882.1 480.5C882.1 480.5 882.1 480.5 883.9 480.2C886.7 479.7 886.2 479.8 886.2 479.8C886.2 479.8 886.2 479.8 889.1 479.2C894.6 478 891.2 478.6 893.6 478.1C897 477.3 898.3 476.7 898.3 476.7L902.2 475.4C902.2 475.4 904.5 474.5 907.9 473.1C911.7 471.5 916.8 468.5 918.2 467.4C926.5 461.4 928.4 458.4 928.4 458.4L931.9 453.3L933.9 448.7C936.8 447.4 934.9 441.3 934.9 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_majeur_mediane)}
              />
              <path
                id='avant_droit_phalange_majeur_distale'
                d='M935.1 441.3L932.8 403.3L929.1 346.5L918.8 350.1L910.1 352.7L899.6 355.3L889.9 357.3L880.1 358.9L860.6 360.8L841.9 360.5L824 358.1L810.2 354.5L800 350.7L789.1 345.3L787.5 371.7L785.7 412.3L785.1 441.5C785.1 441.5 786.8 433.4 787 432.9C787.7 431.2 789.6 427.8 789.6 427.8C789.6 427.8 795.3 420.7 795.8 420.5C796.3 420.3 802.1 415.4 803.3 414.7C804.5 414 811.5 410.2 811.5 410.2L822 406L830.5 403.6L837.4 402.2L846.6 400.9L855.4 400.3H864.1C864.1 400.3 878.5 401.4 880.9 401.9C888.9 403.4 891.7 404.2 892.5 404.4C892.9 404.5 896.1 405.3 899.4 406.5C901.9 407.4 905.8 409 905.8 409C905.8 409 908.8 410 913.4 412.7C916.8 414.8 919.3 416.7 920.4 417.3C923.1 418.6 927 423.8 928 424.5C929 425.2 933.5 433.4 933.5 433.4L935.1 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_majeur_distale)}
              />
              <path
                id='avant_droit_articulation_majeur_interne'
                d='M872.866 959.056C925.734 952.784 965.501 921.647 961.688 889.51C957.876 857.373 911.928 836.404 859.06 842.676C806.193 848.948 766.426 880.084 770.238 912.222C774.051 944.359 819.999 965.327 872.866 959.056Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_majeur_interne)}
              />
              <path
                id='avant_droit_articulation_majeur_mediane'
                d='M863.916 655.791C907.362 653.285 941.261 628.368 939.633 600.14C938.004 571.911 901.464 551.059 858.018 553.565C814.572 556.072 780.672 580.988 782.301 609.217C783.929 637.446 820.47 658.298 863.916 655.791Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_majeur_mediane)}
              />
              <path
                id='avant_droit_articulation_majeur_externe'
                d='M860.3 482.5C901.556 482.5 935 464.054 935 441.3C935 418.546 901.556 400.1 860.3 400.1C819.044 400.1 785.6 418.546 785.6 441.3C785.6 464.054 819.044 482.5 860.3 482.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_majeur_externe)}
              />
              <path
                id='avant_droit_ongle_majeur'
                d='M791.2 346C791.2 346 790 322.8 798.4 305.4C803.4 294.9 807 289.4 815.8 276.8C838.3 244.9 886.4 258.4 900 264.2C920.3 272.7 930.7 306.5 929.3 346.6C929.4 346.6 850 378.9 791.2 346Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_majeur)}
              />
            </g>
            <g id='mannequin_front_hand_right_index'>
              <path
                id='avant_droit_phalange_index_proximale'
                d='M703.2 674.5L709.1 718.4L716.3 770.6L722.2 810.2L729.6 853.4L734.8 876.7L737.7 885.9L747.1 899.5C747.1 899.5 738 891.8 725.1 888.5C712.2 885.2 705.1 885 705.1 885C705.1 885 693.6 884.1 688.9 884.6C684.2 885.1 678.9 884.9 674.3 885.7C674.3 885.7 663.3 887 658.5 888.4C658.5 888.4 643.2 892 638.7 893.8C638.7 893.8 626.8 897.7 618.8 901.8C618.8 901.8 607 907.4 600.1 912.4C600.1 912.4 590.7 918.7 584.1 925.5C577.6 932.3 575.9 935.3 575.9 935.3L572.3 941.4L568.3 950.9L566.2 921.9L564 889.1L560.8 843.2L558.6 812.6L555.2 765.6L552.6 730.7L549.7 691.4L548.4 674.8L550.2 675.5C550.2 675.5 552.2 681.3 556.4 685.9C560.6 690.4 564.6 694 564.6 694C564.6 694 568.9 697.6 575.2 700.9C581.6 704.2 584.5 705.1 584.5 705.1C584.5 705.1 588.1 706.9 599.6 709.3C611.1 711.7 623.9 711.2 623.9 711.2C623.9 711.2 639.9 710.6 648.8 707.8C657.7 705 662.3 704.1 672.5 698.4C682.7 692.7 688.2 686.6 688.2 686.6C688.2 686.6 695.7 678.9 698.3 671.8C700.9 664.7 701.5 662.1 701.5 662.1L703.2 674.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_index_proximale)}
              />
              <path
                id='avant_droit_phalange_index_mediane'
                d='M540.3 490V521.1L540.8 565.3L542.5 599.2L545.6 638.4L547 659L549.2 651.9C549.2 651.9 551.4 642.2 560.8 633.4C570.1 624.6 578.6 620.4 578.6 620.4C578.6 620.4 588.8 614.5 604.8 611.1C620.8 607.7 633.4 608.8 633.4 608.8C633.4 608.8 650.5 609.2 665.4 615.3C680.4 621.4 687.1 628.3 687.1 628.3C687.1 628.3 690.6 631.1 694.3 636.3C698 641.5 700.5 647.5 700.5 647.5V646.6L695.7 585.1L691.8 528.9L690.1 498.5L689.5 481.5C689.5 481.5 691.9 487.6 686.9 494.7C681.9 501.8 680.6 503.3 680.6 503.3C680.6 503.3 670.9 514 653.6 519.8C636.2 525.6 617.8 527 617.8 527C617.8 527 600.4 528.4 584.9 524.7C569.4 521.1 563.6 517.6 563.6 517.6C563.6 517.6 541.8 507.9 540.8 490.1'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_index_mediane)}
              />
              <path
                id='avant_droit_phalange_index_distale'
                d='M690.1 481.6L689.4 460.7L686.7 420.8C686.7 420.8 685.9 408.4 683.4 392.4L677.9 396.7L663.4 403.1L650.2 407.3L637 410.5L622.6 412.9L613.3 413.8L601.4 414.3L588.8 413.9L580.6 413.1L571.1 411.5L555.3 407.3L547.7 404.5L541.4 401.8L541 431.4V490C541 490 539.7 486.3 543.3 478.3L545.3 474.2L548.9 469.4L553 465.4L558.3 461.3L563.2 458.2L568.9 455.2L574.9 452.5L579.9 450.6L587 448.5L595 446.7L601.9 445.5L608.6 444.7L614 444.3L621 444.1L627.8 444.3L636.6 445.1C636.6 445.1 641.5 445.9 643.5 446.2C645.5 446.5 651.1 448 652.1 448.2C653.2 448.4 660.8 451 660.8 451L666.6 453.5L672.3 456.6L676.3 459.3C681.1 462.5 684.8 467.6 684.8 467.6L687.6 472.2L689.3 476.8L690.1 481.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_index_distale)}
              />
              <path
                id='avant_droit_articulation_index_interne'
                d='M676.44 991.334C728.462 977.643 764.71 944.03 757.401 916.256C750.092 888.482 701.994 877.065 649.972 890.755C597.949 904.445 561.701 938.059 569.01 965.833C576.319 993.607 624.417 1005.02 676.44 991.334Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_index_interne)}
              />
              <path
                id='avant_droit_articulation_index_mediane'
                d='M627.723 711.285C670.177 708.835 703.272 683.966 701.643 655.737C700.015 627.508 664.279 606.609 621.825 609.059C579.372 611.508 546.276 636.378 547.905 664.607C549.534 692.836 585.27 713.734 627.723 711.285Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_index_mediane)}
              />
              <path
                id='avant_droit_articulation_index_externe'
                d='M617.747 526.808C658.932 524.432 691.257 504.091 689.947 481.376C688.636 458.66 654.186 442.172 613.001 444.549C571.815 446.925 539.49 467.266 540.801 489.981C542.111 512.697 576.561 529.185 617.747 526.808Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_index_externe)}
              />
              <path
                id='avant_droit_ongle_index'
                d='M541 401.8C541 401.8 534.8 376.6 551.6 341.3C568.4 306 622.3 300.7 634.8 308.6C658.5 323.5 683.7 352.5 682.9 392.3C682.7 397.5 605.6 432.6 541 401.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_index)}
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2HandRight({ lesionnel }: BackV2HandRightProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_hand_right_vector'>
        <g id='mannequin_back_hand_right_zones'>
          <g id='mannequin_back_hand_right_doigts'>
            <g id='mannequin_back_hand_right_auriculaire'>
              <path
                id='arriere_droit_phalange_auriculaire_distale'
                d='M206.8 741.8L202.7 723.1L197.6 694L193.6 671.4C193.1 651.9 195.5 638.2 195.5 638.2C195.5 638.2 202.2 609 218.1 602.8C223.8 600.6 232.4 596.5 241.1 597.6C253.3 599.2 265.2 606.8 265.2 606.8C265.2 606.8 274.5 613 279.7 619.6C285.2 626.6 295.9 645.7 295.9 645.7L300.9 657L320.2 709.9L315.8 703.2L313.3 700.1L309.9 696.9L305.3 693.8L300.2 691.3L295.1 689.5L289 688.1L284.3 687.5L279.3 687.2C279.3 687.2 270.5 687.3 269.4 687.6L259.2 689.2C259.2 689.2 251 691.6 249.6 692.1C247.9 692.7 235.1 698.2 231.3 701.1C228 703.6 224 705.6 219.5 710.8C219.5 710.8 213.3 715.2 208.3 728.7C205.9 734.7 206.8 741.8 206.8 741.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_auriculaire_distale)}
              />
              <path
                id='arriere_droit_phalange_auriculaire_mediane'
                d='M207.2 741.9L211.3 760.4L220.7 791.9L228.2 814.1L239.8 843.4L240.3 840.1C240.3 840.1 239.6 836.9 240.5 829.2C241.4 821.5 245.1 814.3 245.1 814.3C245.1 814.3 248.4 807.1 253.8 801.1C259.1 795.1 262.4 792.7 262.4 792.7C262.4 792.7 269.4 786.9 277.2 783.3C285 779.7 288.1 779 288.1 779C288.1 779 294.9 776.3 307.8 775.5C320.7 774.8 331.7 778.9 331.7 778.9C331.7 778.9 338.8 781 345.7 786.2C352.6 791.4 356.8 797.3 356.8 797.3L355.9 794.5L345.2 770.5L333.3 742.6L323.6 718.4L320.6 710.1L320 714L320.2 718.4L319.9 722.6L319.2 725.3L318 728.9L315.7 733.7L313.1 737.8L308 744L305.1 746.8C299 753.3 286.1 759.4 286.1 759.4L280.1 762L273 764.4C273 764.4 267.6 765.9 266.6 766L260 767L254.1 767.6C254.1 767.6 249.9 767.7 247 767.7C244 767.7 237.2 766.6 237.2 766.6L233.5 765.8L229.7 764.7L225.8 763.2L222.7 761.7L219 759.5L215 756.3L211.8 752.7L209.4 748.7L207.2 741.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_auriculaire_mediane)}
              />
              <path
                id='arriere_droit_phalange_auriculaire_proximale'
                d='M427.5 952.3L412.8 922.2L393.1 880.1L377 843.1L363.2 810.5L363.5 816.7C363.5 816.7 364.4 823.1 362.2 831.8C360 840.5 355.4 847.5 355.4 847.5C355.4 847.5 349.5 856.7 343.6 861.4C337.8 866.1 335.9 867.4 335.9 867.4C335.9 867.4 328.4 872.5 320.5 875.5C312.6 878.5 307 879.4 307 879.4C307 879.4 301.5 880.7 292.6 880.8C283.8 880.9 275.5 878.5 275.5 878.5C275.5 878.5 268.9 877 261.2 872.3C253.4 867.6 247.1 859.5 247.1 859.5L249.4 866.9L269.3 918.2L298.4 983L312.7 1016.6L312.5 1012.3C312.5 1012.3 311.8 1006.9 312.8 1001.1C313.8 995.4 315.1 992 315.1 992C315.1 992 317.8 984.3 321.3 979.5C324.8 974.7 325.6 973.6 325.6 973.6C325.6 973.6 329.7 968.7 332.4 966.3C335.1 963.9 338.2 961.4 338.2 961.4C338.2 961.4 342.7 957.9 346.7 955.7C350.7 953.5 354.5 951.6 354.5 951.6C354.5 951.6 362.2 948 366.7 947.1C366.7 947.1 372.7 945.4 375.3 945.1C375.3 945.1 382 944 386.1 944C390.2 944 391.9 944 391.9 944C391.9 944 395.7 944 400.9 944.9C406.1 945.8 411.8 947.8 411.8 947.8C411.8 947.8 417.4 949.7 422.8 953.4C428.2 957 430.9 960.3 430.9 960.3L427.7 952.4L427.5 952.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_auriculaire_proximale)}
              />
              <path
                id='arriere_droit_articulation_auriculaire_interne'
                d='M395.717 1045.16C429.663 1031 448.354 998.358 437.465 972.261C426.575 946.164 390.229 936.491 356.282 950.656C322.336 964.821 303.645 997.46 314.534 1023.56C325.424 1049.65 361.77 1059.33 395.717 1045.16Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_auriculaire_interne)}
              />
              <path
                id='arriere_droit_articulation_auriculaire_mediane'
                d='M320.12 875.764C352.699 863.244 370.888 831.698 360.745 805.304C350.602 778.911 315.969 767.664 283.389 780.184C250.809 792.704 232.62 824.25 242.763 850.644C252.906 877.038 287.54 888.285 320.12 875.764Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_auriculaire_mediane)}
              />
              <path
                id='arriere_droit_articulation_auriculaire_externe'
                d='M318.9 709.5C312.5 689.5 282.4 681.3 251.8 691.2C221.2 701.1 201.6 725.3 208.1 745.2C214.5 765.2 244.6 773.4 275.2 763.5C305.7 753.7 325.3 729.5 318.9 709.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_auriculaire_externe)}
              />
            </g>
            <g id='mannequin_back_hand_right_annulaire'>
              <path
                id='arriere_droit_phalange_annulaire_distale'
                d='M422.6 488.5L421.9 472.4L421.2 438.4L420.5 405.8L422.4 371.7C422.4 371.7 422.5 331.1 454.8 316.9C464.9 312.4 472.8 310.8 491.1 316.4C501.9 319.7 510.5 328.8 518.5 339.9C528.9 354.3 537.7 395.5 537.7 395.5L547.9 452L551 469.7L547.5 465.5C547.5 465.5 544.6 460.3 544.2 459.7C542.3 456.8 538 453.1 538 453.1L534.3 450.3L529 447.2L523.7 444.8L518.8 443.1L514.5 441.9L509.5 440.9C509.5 440.9 505.1 440.2 502.1 439.9C498.1 439.5 494.3 439.5 493.5 439.5C489.8 439.6 481.4 440.3 480.6 440.4C475.5 441 469.3 442.6 468 443C461 444.9 454.9 447.7 454.9 447.7C454.9 447.7 446.9 451.8 444.2 453.5C435.4 459.2 430.2 466.1 430.2 466.1L427 470.8L424.3 476.5L422.6 481.6V488.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_annulaire_distale)}
              />
              <path
                id='arriere_droit_phalange_annulaire_mediane'
                d='M422.5 488.6L423 501.1L425.9 544L428 576.3L430.1 616.2C430.1 616.2 432.3 606.2 439.4 596.7C446.5 587.2 457.7 580.8 457.7 580.8C457.7 580.8 465.6 575 483.9 570.6C502.2 566.2 518.1 568.9 518.1 568.9C518.1 568.9 533.5 569.9 544.4 576.2C555.4 582.5 563 589 563 589C563 589 569.9 596.2 573.2 603.5C576.5 610.8 570.4 586.1 570.4 586.1L560.1 523L550.8 470L550.5 479L549.5 484.4L547.1 490.4L542.5 497.3L536.7 503.4L529.1 509.2L520.3 514.1L513.1 517.2L506 519.5L497.2 521.6L490.1 522.6L483 523.1H474.8L470.6 522.8L466.2 522.3L462.2 521.6L455.9 520.1L450 518.1L445 515.9L440.2 513.2L436.2 510.4L432.5 507.1L429.2 503.2L426.7 499.2L424.9 495.1L422.5 488.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_annulaire_mediane)}
              />
              <path
                id='arriere_droit_phalange_annulaire_proximale'
                d='M605.5 823.9L601.7 809.7L598.3 791.5L594.1 754.7L588 703.5L581.3 652.8L576.2 618.2C576.2 618.2 574.5 626.5 574.2 627.6C573.9 628.6 571.2 635.8 568.8 639.3C566.3 642.7 563.5 647.6 552.9 655.2C542.3 662.8 532.1 665.6 532.1 665.6L524.8 667.7L515.4 669.6C515.4 669.6 503.9 671.3 496 670.7C488 670.1 479.6 668.7 479.6 668.7C479.6 668.7 466.8 666.3 457 660.4C447.2 654.5 446.1 652.9 446.1 652.9C446.1 652.9 440.3 648 436.6 641.9C432.9 635.8 431.5 629.2 431.5 629.2L431.3 639.2L432.9 670.6L435.2 698.5L437.5 719.2L440.8 746.5L444.3 773.9L446.8 789.3L451.4 812.1L456.1 834.5L462.8 869.3L467 893.5L469.5 908.1L470.2 904.6C470.2 904.6 470 900.3 471.5 893.9C473.1 887.5 476.6 881.1 476.6 881.1C476.6 881.1 478.8 876.8 482 873C485.2 869.2 488.8 865.4 488.8 865.4C488.8 865.4 492.1 861.7 497.8 857.8C503.5 853.9 505.7 852.6 505.7 852.6C505.7 852.6 510.8 849.4 517.9 846.4C525.1 843.4 527.7 842.8 527.7 842.8C527.7 842.8 536.3 839.6 549.3 838.1C562.3 836.6 572.7 837.8 572.7 837.8C572.7 837.8 581.1 838.3 592 841.7C602.9 845.1 610.1 850.3 610.1 850.3L620.7 858.2L613.6 845.6L607.9 831.4L605.5 823.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_annulaire_proximale)}
              />
              <path
                id='arriere_droit_articulation_annulaire_interne'
                d='M561.938 952.812C606.139 943.469 636.61 910.533 629.997 879.246C623.384 847.96 582.191 830.171 537.99 839.513C493.789 848.856 463.318 881.792 469.931 913.079C476.544 944.365 517.737 962.154 561.938 952.812Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_annulaire_interne)}
              />
              <path
                id='arriere_droit_articulation_annulaire_mediane'
                d='M506.275 670.469C546.29 667.965 577.298 643.057 575.531 614.837C573.765 586.617 539.894 565.77 499.878 568.274C459.863 570.779 428.855 595.686 430.622 623.907C432.388 652.127 466.259 672.974 506.275 670.469Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_annulaire_mediane)}
              />
              <path
                id='arriere_droit_articulation_annulaire_externe'
                d='M491.735 522.184C526.695 517.36 552.513 495.176 549.403 472.636C546.292 450.096 515.43 435.734 480.471 440.559C445.512 445.383 419.693 467.566 422.804 490.106C425.914 512.647 456.776 527.008 491.735 522.184Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_annulaire_externe)}
              />
            </g>
            <g id='mannequin_back_hand_right_majeur'>
              <path
                id='arriere_droit_phalange_majeur_distale'
                d='M662 441.3L664.3 403.3L668 346.5L670.4 315.7L673.9 296.4L679.4 282L693 266.2L704.5 260.9L722.3 257.2L738.9 257.3L759.6 260.3L772.9 268.4L785.7 282L794.8 296.3L802.8 318.9L807.9 345.2L809.5 371.6L811.3 412.2L811.9 441.4C811.9 441.4 810.2 433.3 810 432.8C809.3 431.1 807.4 427.7 807.4 427.7C807.4 427.7 801.7 420.6 801.2 420.4C800.7 420.2 794.9 415.3 793.7 414.6C792.5 413.9 785.5 410.1 785.5 410.1L775 405.9L766.5 403.5L759.6 402.1L750.4 400.8L741.6 400.2H732.9C732.9 400.2 718.5 401.3 716.1 401.8C708.1 403.3 705.3 404.1 704.5 404.3C704.1 404.4 700.9 405.2 697.6 406.4C695.1 407.3 691.2 408.9 691.2 408.9C691.2 408.9 688.2 409.9 683.6 412.6C680.2 414.7 677.7 416.6 676.6 417.2C673.9 418.5 670 423.7 669 424.4C668 425.1 663.5 433.3 663.5 433.3L662 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_majeur_distale)}
              />
              <path
                id='arriere_droit_phalange_majeur_mediane'
                d='M663.2 441.3L662.6 450.7L661.3 477.2L660.2 536.9L659.5 582.3L660.4 592.8L662.9 586.3C662.9 586.3 670.9 568.5 696.6 559.6C722.2 550.7 740.8 553.5 740.8 553.5C740.8 553.5 767.7 554 790.8 568.4C813.9 582.8 815.7 599.5 815.7 599.5L814.9 556.1L814 496.7L812.9 441.2L811.2 449.1L809.4 452.8L805.7 458.2L801.3 462.8C801.3 462.8 799.8 464.5 796.2 466.8C792.9 469 795.3 467.4 788.9 471.2C782.4 475 780.2 475 768.1 478.8C751.9 483.9 728.6 482 728.6 482L720.7 481.2L716 480.5C716 480.5 716 480.5 714.2 480.2C711.4 479.7 711.9 479.8 711.9 479.8C711.9 479.8 711.9 479.8 709 479.2C703.5 478 706.9 478.6 704.5 478.1C701.1 477.3 699.8 476.7 699.8 476.7L695.9 475.4C695.9 475.4 693.6 474.5 690.2 473.1C686.4 471.5 681.3 468.5 679.9 467.4C671.6 461.4 669.7 458.4 669.7 458.4L666.2 453.3L664.2 448.7C661.3 447.4 663.2 441.3 663.2 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_majeur_mediane)}
              />
              <path
                id='arriere_droit_phalange_majeur_proximale'
                d='M819.3 865.3L816.8 757.3L815.5 637.4V618L812.9 621.6C812.9 621.6 807.4 634.2 794.4 641.9C781.4 649.6 774.3 651.2 774.3 651.2C774.3 651.2 756.5 658.4 727.5 655.3C698.6 652.2 680.8 638.6 680.8 638.6C680.8 638.6 660.7 625.8 658.6 605.6L657 689.6L657.8 783.5L658 824.1L657 834.3L651.9 855.2L648.9 865.1C648.9 865.1 657.4 855.7 675.3 849.2C693.2 842.8 709.9 842.1 709.9 842.1C709.9 842.1 733.2 840.4 752.1 845C771 849.6 774.8 851.5 774.8 851.5C774.8 851.5 793.3 858.6 804.7 867.7C816.1 876.8 822.5 887.3 822.5 887.3L819.3 865.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_majeur_proximale)}
              />
              <path
                id='arriere_droit_articulation_majeur_interne'
                d='M826.739 913.115C830.505 881.362 790.702 850.536 737.834 844.265C684.966 837.993 639.055 858.65 635.288 890.403C631.521 922.157 671.325 952.982 724.193 959.254C777.06 965.526 822.972 944.869 826.739 913.115Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_majeur_interne)}
              />
              <path
                id='arriere_droit_articulation_majeur_mediane'
                d='M815.729 609.223C817.358 580.994 783.458 556.078 740.012 553.571C696.566 551.064 660.026 571.916 658.397 600.145C656.768 628.374 690.668 653.29 734.114 655.797C777.56 658.304 814.1 637.452 815.729 609.223Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_majeur_mediane)}
              />
              <path
                id='arriere_droit_articulation_majeur_externe'
                d='M737.8 482.5C779.056 482.5 812.5 464.054 812.5 441.3C812.5 418.546 779.056 400.1 737.8 400.1C696.544 400.1 663.1 418.546 663.1 441.3C663.1 464.054 696.544 482.5 737.8 482.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_majeur_externe)}
              />
            </g>
            <g id='mannequin_back_hand_right_index'>
              <path
                id='arriere_droit_phalange_index_distale'
                d='M907 481.6L907.7 460.7L910.4 420.8C910.4 420.8 911.2 408.4 913.7 392.4L916.3 376.2L923.8 351.4L937.6 328.4L953.3 313.6L971.8 304.7H989.9L1003.9 308.1L1017.6 314.7L1027.4 321.6L1041 335.2L1050.1 350L1055.1 367.4L1055.9 402.1L1056.3 431.7V490.3C1056.3 490.3 1057.6 486.6 1054 478.6L1052 474.5L1048.4 469.7L1044.3 465.7L1039 461.6L1034.1 458.5L1028.4 455.5L1022.4 452.8L1017.4 450.9L1010.3 448.8L1002.3 447L995.4 445.8L988.7 445L983.3 444.6L976.3 444.4L969.5 444.6L960.7 445.4C960.7 445.4 955.8 446.2 953.8 446.5C951.8 446.8 946.2 448.3 945.2 448.5C944.1 448.7 936.5 451.3 936.5 451.3L930.7 453.8L925 456.9L921 459.6C916.2 462.8 912.5 467.9 912.5 467.9L909.7 472.5L908 477.1L907 481.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_index_distale)}
              />
              <path
                id='arriere_droit_phalange_index_mediane'
                d='M1057.8 490V521.1L1057.3 565.3L1055.6 599.2L1052.5 638.4L1051.1 659L1048.9 651.9C1048.9 651.9 1046.7 642.2 1037.3 633.4C1028 624.6 1019.5 620.4 1019.5 620.4C1019.5 620.4 1009.3 614.5 993.3 611.1C977.3 607.7 964.7 608.8 964.7 608.8C964.7 608.8 947.6 609.2 932.7 615.3C917.7 621.4 911 628.3 911 628.3C911 628.3 907.5 631.1 903.8 636.3C900.1 641.5 897.6 647.5 897.6 647.5V646.6L902.4 585.1L906.3 528.9L908 498.5L908.6 481.5C908.6 481.5 906.2 487.6 911.2 494.7C916.2 501.8 917.5 503.3 917.5 503.3C917.5 503.3 927.2 514 944.5 519.8C961.9 525.6 980.3 527 980.3 527C980.3 527 997.7 528.4 1013.2 524.7C1028.7 521.1 1034.5 517.6 1034.5 517.6C1034.5 517.6 1056.3 507.9 1057.3 490.1'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_index_mediane)}
              />
              <path
                id='arriere_droit_phalange_index_proximale'
                d='M894.9 674.5L889 718.4L881.8 770.6L875.9 810.2L868.5 853.4L863.3 876.7L860.4 885.9L851 899.5C851 899.5 860.1 891.8 873 888.5C885.9 885.2 893 885 893 885C893 885 904.5 884.1 909.2 884.6C913.9 885.1 919.2 884.9 923.8 885.7C923.8 885.7 934.8 887 939.6 888.4C939.6 888.4 954.9 892 959.4 893.8C959.4 893.8 971.3 897.7 979.3 901.8C979.3 901.8 991.1 907.4 998 912.4C998 912.4 1007.4 918.7 1014 925.5C1020.5 932.3 1022.2 935.3 1022.2 935.3L1025.8 941.4L1029.8 950.9L1031.9 921.9L1034.1 889.1L1037.3 843.2L1039.5 812.6L1042.9 765.6L1045.5 730.7L1048.4 691.4L1049.7 674.8L1047.9 675.5C1047.9 675.5 1045.9 681.3 1041.7 685.9C1037.5 690.5 1033.5 694 1033.5 694C1033.5 694 1029.2 697.6 1022.9 700.9C1016.5 704.2 1013.6 705.1 1013.6 705.1C1013.6 705.1 1010 706.9 998.5 709.3C987 711.7 974.2 711.2 974.2 711.2C974.2 711.2 958.2 710.6 949.3 707.8C940.4 705 935.8 704.1 925.6 698.4C915.4 692.7 909.9 686.6 909.9 686.6C909.9 686.6 902.4 678.9 899.8 671.8C897.2 664.7 896.6 662.1 896.6 662.1L894.9 674.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_index_proximale)}
              />
              <path
                id='arriere_droit_articulation_index_interne'
                d='M1027.98 966.384C1035.18 939.038 998.841 905.771 946.818 892.08C894.796 878.39 846.789 889.461 839.592 916.808C832.396 944.154 868.735 977.421 920.758 991.112C972.78 1004.8 1020.79 993.731 1027.98 966.384Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_index_interne)}
              />
              <path
                id='arriere_droit_articulation_index_mediane'
                d='M1050.17 664.729C1051.8 636.5 1018.7 611.631 976.247 609.181C933.793 606.732 898.058 627.63 896.429 655.859C894.8 684.088 927.895 708.958 970.349 711.407C1012.8 713.857 1048.54 692.958 1050.17 664.729Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_index_mediane)}
              />
              <path
                id='arriere_droit_articulation_index_externe'
                d='M1057.27 490.123C1058.58 467.407 1026.25 447.066 985.065 444.69C943.88 442.314 909.43 458.802 908.119 481.517C906.809 504.233 939.134 524.574 980.319 526.95C1021.5 529.326 1055.95 512.838 1057.27 490.123Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_index_externe)}
              />
            </g>
            <g id='mannequin_back_hand_right_pouce'>
              <path
                id='arriere_droit_phalange_pouce_proximale'
                d='M1102.7 1146.8L1111.1 1138.2L1122.1 1124L1136.3 1102.2L1144.7 1089.6L1160.1 1068.8L1170.6 1052.5C1170.6 1052.5 1169.5 1059 1169.7 1062.4C1169.9 1065.8 1170.5 1069.6 1170.9 1071.2C1171.3 1072.8 1172.9 1078.7 1176.1 1083.9C1179.3 1089 1185.1 1097.7 1191.4 1103.2C1197.7 1108.8 1203.3 1113.6 1209.5 1117.4C1215.7 1121.2 1218.1 1122.6 1218.1 1122.6C1218.1 1122.6 1230.7 1129.4 1236.1 1131C1241.6 1132.7 1248 1135.5 1255.4 1137.1C1262.8 1138.7 1278 1141.7 1288.8 1140.7C1299.6 1139.6 1304.1 1139.5 1313.9 1135.7C1323.7 1131.9 1327.6 1127.3 1327.6 1127.3L1333 1122L1301.8 1181.7L1276.1 1230.9L1250.5 1275.2L1251.3 1270.6C1251.3 1270.6 1252.4 1267.7 1252.8 1262.5C1253.2 1257.3 1251.5 1250.3 1251.5 1250.3C1251.5 1250.3 1250.2 1244.4 1246.6 1237C1243 1229.6 1238.4 1223 1238.4 1223L1232.2 1214.7C1232.2 1214.7 1229.8 1211.5 1225.7 1207.2C1221.6 1202.9 1216 1197.5 1216 1197.5C1216 1197.5 1205.8 1188.2 1204.1 1187.3C1202.4 1186.4 1200.8 1184.6 1196.3 1181.5C1191.8 1178.4 1193 1179.2 1193 1179.2L1187 1175.3L1181.5 1171.9L1176 1168.8L1170.6 1165.9L1165.1 1163.2L1159.8 1160.8L1154.9 1158.8L1148.7 1156.6L1143.4 1154.9L1137 1153.2L1131.2 1152L1123.7 1150.9L1118.4 1150.5H1111.2L1105.5 1151.1L1099.9 1152.4L1094 1154.7L1102.7 1146.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_pouce_proximale)}
              />
              <path
                id='arriere_droit_phalange_pouce_distale'
                d='M1196.1 1008.1L1212.4 978.7L1224.2 957.4L1234.2 940.2L1244 927.2L1256.4 914.4C1256.4 914.4 1274.2 897 1298.8 887.2C1323.4 877.4 1342.5 878.2 1342.5 878.2C1342.5 878.2 1363.8 879.1 1381.9 892C1400 905 1401 923.1 1401 923.1C1401 923.1 1404.7 942.7 1395.4 971.2C1386.1 999.7 1382.5 1009.9 1382.5 1009.9L1370.4 1039.6L1355.6 1070.6L1336.4 1114.1C1336.4 1114.1 1340.3 1102.6 1335.1 1089.9C1329.9 1077.2 1323.6 1070.6 1323.6 1070.6C1323.6 1070.6 1317.7 1063.2 1311.1 1058.1C1304.6 1052.9 1300.8 1050.2 1300.8 1050.2C1300.8 1050.2 1292.3 1044.4 1285.9 1041.3C1279.5 1038.2 1273.5 1035.6 1273.5 1035.6C1273.5 1035.6 1265.7 1032.1 1255 1029.4C1244.2 1026.6 1237.1 1025.9 1237.1 1025.9C1237.1 1025.9 1226 1024.3 1214.2 1025.4C1202.4 1026.5 1196.9 1028.8 1196.9 1028.8C1196.9 1028.8 1187.4 1031.6 1178.4 1038.8L1196.1 1008.1Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_pouce_distale)}
              />
              <path
                id='arriere_droit_articulation_pouce_interne'
                d='M1248.55 1276.64C1263.81 1254.62 1239.47 1211.35 1194.21 1180C1148.94 1148.65 1099.88 1141.08 1084.63 1163.1C1069.38 1185.12 1093.71 1228.39 1138.97 1259.74C1184.24 1291.1 1233.3 1298.66 1248.55 1276.64Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_pouce_interne)}
              />
              <path
                id='arriere_droit_articulation_pouce_externe'
                d='M1335.77 1115.86C1346.32 1089.62 1318.19 1053.6 1272.94 1035.41C1227.7 1017.21 1182.47 1023.73 1171.92 1049.97C1161.37 1076.2 1189.49 1112.22 1234.74 1130.42C1279.98 1148.61 1325.22 1142.09 1335.77 1115.86Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_pouce_externe)}
              />
            </g>
          </g>
          <path
            id='arriere_droit_poignet_droit'
            d='M1006.3 1606.3L968.3 1670.1L937.5 1735.4C937.5 1735.4 925.9 1771.3 921.3 1783.4C914.3 1801.8 910 1849.2 910.7 1855.2C911.4 1861.2 913.1 1886.3 913.1 1886.3C831 1886.3 748.9 1886.7 666.7 1886.6C601 1886.5 535.7 1885 470.2 1881.2C470.2 1881.2 474.8 1877.4 477.4 1860.6C478.1 1856.2 480.8 1846.2 481.5 1841.4C483.1 1830.9 483.3 1818.7 484.6 1809.6C486.4 1797.3 484.7 1785.4 484.6 1784.7C484.4 1782.4 480.5 1743.8 480.4 1741.1C480.3 1738.4 475.2 1709.5 475.2 1709.5L467.5 1674.4L453.5 1624.5L484.5 1639.3C484.5 1639.3 497.4 1645.2 508 1649.6C516.4 1653.1 520.9 1654.9 525.7 1656.9C530.4 1658.8 528.6 1658.2 537.5 1661.5C547.3 1665.2 569.3 1672 578 1675.5C587.1 1679.1 599.6 1681.6 611.2 1685C622.9 1688.4 637.9 1691.2 637.9 1691.2C637.9 1691.2 652.4 1695 675.5 1698C690.8 1700 718.3 1702.3 725.2 1702.7C730.7 1703 744.7 1703.2 752.7 1703.1C760 1703 785.5 1701.3 785.5 1701.3L817.6 1697.4L848.5 1690.9C848.5 1690.9 875.2 1681.5 888.2 1677.7C900 1674.3 927.1 1660.5 931.1 1659.1C935.1 1657.8 963.8 1638.8 965.8 1638.2C967.8 1637.6 1006.3 1606.3 1006.3 1606.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_poignet_droit)}
          />
          <path
            id='arriere_droit_thenar'
            d='M1090.85 1494.05C1149.86 1369.22 1130.27 1236.15 1047.08 1196.82C963.892 1157.5 848.618 1226.81 789.606 1351.64C730.594 1476.47 750.192 1609.55 833.379 1648.87C916.566 1688.2 1031.84 1618.88 1090.85 1494.05Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_thenar)}
          />
          <path
            id='arriere_droit_paume'
            d='M324.5 1056.2L328.5 1085.7L332.2 1115L338.5 1178.6L342.1 1212.3L344.2 1240.7L346.3 1272.5L349 1305.9L351.5 1332.8L355 1363.7L357.7 1380.5L366.9 1417.6L373.9 1444.3L382.6 1472.5L394.1 1501.6L409.8 1539L418 1556.8L428.5 1576.6L436.7 1590.1L451.9 1622.1L453.6 1624.6L458.2 1626.8L484.6 1639.4L498.4 1645.6L510.6 1650.8L520.6 1654.9L533.9 1660.2L547.1 1664.9L567.3 1671.7L578.1 1675.6L592.1 1680L610.1 1684.8L630 1689.8L649.2 1693.9L670.2 1697.5L691.9 1700.1L717.3 1702.4L739.3 1703.3L748.7 1703.4L765.2 1702.9L785.5 1701.7L805 1699.3L824 1696.4L841.6 1692.7L856.5 1688.4L875.5 1682L891.9 1676.8L909.3 1669.4L924.5 1662.3L940.8 1653.9L959.1 1642.4L977.7 1629.2L966.8 1635.8L957.4 1640.9L946.5 1646.1L932.8 1651.5L915.2 1656.6L896.9 1659.6C896.9 1659.6 878.1 1661.8 860.2 1658.1C842.2 1654.4 827.8 1646.5 827.8 1646.5C827.8 1646.5 809.4 1637 798.8 1624.1C788.2 1611.3 781.8 1601.7 781.8 1601.7C781.8 1601.7 775.2 1591 771.3 1581.2C767.5 1571.4 765 1564.6 763.2 1557.5C761.4 1550.4 757.9 1531.8 757.9 1531.8C757.9 1531.8 755.5 1515.2 755.6 1505C755.7 1494.9 755.6 1487.2 755.6 1487.2L756.7 1469.7C756.7 1469.7 756.9 1465.4 758.1 1457.2C759.3 1449 760.6 1441.4 760.6 1441.4L763.8 1426L767.4 1411.6L771 1399.5L774.6 1388.5L778.3 1378.5L783.3 1366.2L787.5 1356.6L791.9 1347.3L796.3 1338.6L800.3 1331.1L804.3 1324L810.8 1313.1L818.4 1301.4L824.8 1292.3L830 1285.4L837.8 1275.6L844.4 1267.9L851.3 1260.3L858.9 1252.5L870.3 1241.8L883.5 1230.7L893.8 1223L903.8 1216.3L913.6 1210.4L923.8 1204.9L934.7 1199.8L942 1196.8L953.2 1192.9L964.7 1189.8L978.5 1187.3L986.7 1186.4L996.1 1186L1005.1 1186.3L1013.8 1187.2L1023.6 1189L1033.1 1191.6L1039.1 1193.7C1039.1 1193.7 1058.5 1201.7 1066.7 1209C1075 1216.3 1080.3 1221 1080.3 1221C1080.3 1221 1096.3 1238.2 1102.3 1251.2C1108.3 1264.2 1110.6 1269 1110.6 1269C1110.6 1269 1115.4 1280.4 1118.1 1292.4C1120.7 1304.4 1122.7 1316.6 1122.7 1316.6C1122.7 1316.6 1125.4 1335.5 1124.9 1351C1124.5 1366.5 1121.6 1394.3 1121.6 1394.3C1121.6 1394.3 1117.2 1421.7 1113.1 1434.7C1109 1447.6 1105.8 1458.1 1105.8 1458.1L1101 1471.1L1096.1 1482.9L1091.2 1493.7L1085 1506.3L1080.5 1514.7L1075.9 1522.8L1072.4 1528.6L1066.3 1538.3L1061.3 1545.8L1056.7 1552.3L1051.3 1559.6L1045.4 1567.1L1040.6 1572.9L1033.6 1580.9L1036.3 1580.2L1045.8 1571.8L1058.1 1560.3L1069.2 1546.7L1083.6 1527.2L1099.5 1502.2L1123 1466.1L1152.9 1423.1L1166.5 1402.7L1183.8 1377.3L1200.9 1352.1L1212.3 1335.2L1233.9 1302.9L1247.3 1280.8L1248.8 1277.7L1245.8 1279.8C1245.8 1279.8 1240.4 1285.6 1232.2 1287.5C1224 1289.4 1220.3 1289.3 1220.3 1289.3C1220.3 1289.3 1210.1 1290.3 1193.7 1286C1177.3 1281.7 1166.5 1276 1166.5 1276C1166.5 1276 1151.9 1268.8 1143.9 1263.4C1135.9 1258 1127.6 1251.7 1127.6 1251.7C1127.6 1251.7 1111 1238.5 1102.7 1227.8C1094.5 1217.1 1087.9 1206.6 1087.9 1206.6C1087.9 1206.6 1080.8 1195.4 1079.8 1181.7C1078.8 1168 1085.3 1161.7 1085.3 1161.7L1089.4 1157.7L1082 1160.2L1074.3 1163.3L1065.8 1162.2L1057 1156L1039 1134.5L1031.8 1121.8L1025.6 1099.9L1023.8 1081.6L1023.1 1060.9L1024 1033.9L1025.6 1003.1L1027.5 970.3L1025.6 971.9C1025.6 971.9 1022.2 979.3 1014.9 984.1C1007.6 988.9 1003 990.6 1003 990.6C1003 990.6 993.9 994.7 979.8 996.3C965.7 997.9 952.4 996.8 952.4 996.8C952.4 996.8 937.8 995.6 928.5 993.3C919.2 991.1 912.3 989 912.3 989C912.3 989 900 985.1 893 981.8C886 978.5 878.2 974.3 878.2 974.3C878.2 974.3 866.9 967.5 861.8 963C856.7 958.5 854.7 956.6 854.7 956.6L849.3 950.7L845.4 945.4C845.4 945.4 841.5 939.8 839.3 932C837.1 924.2 838.9 918.2 838.9 918.2C838.9 918.2 840.1 911.6 843.8 907.5L842.4 906.7L840 907.1L835.5 905.4L827.5 897.6L823.8 894.2L824.7 897.3C824.7 897.3 827.9 906.5 826.2 914.4C824.5 922.3 823.2 924.3 823.2 924.3C823.2 924.3 818.8 933.4 812.5 938.4C806.2 943.4 802.4 945.9 802.4 945.9C802.4 945.9 797.6 949 791.8 951.3C786 953.6 780.7 955.3 780.7 955.3C780.7 955.3 767.9 959.2 755.4 960C742.9 960.8 742.2 960.5 742.2 960.5C742.2 960.5 728.8 960.7 713.1 957.7C697.3 954.8 686.3 950.1 686.3 950.1C686.3 950.1 677.5 946.9 667.6 940.9C657.7 934.9 650.9 928.1 650.9 928.1C650.9 928.1 644 921.8 639.8 913.7C635.6 905.6 635 899.5 635 899.5C635 899.5 633.7 891.2 636.1 884.7C638.5 878.1 639.9 876 639.9 876L642.4 872.3L645.7 867.9L640.9 869.2H636L628.1 865.6L622.7 862.7L624.7 866.4C624.7 866.4 629.7 874.8 630.3 882C630.9 889.1 630.3 894 630.3 894L628.7 901.1C628.7 901.1 627.5 905.5 624.4 911.2C621.3 916.9 618.5 920 618.5 920C618.5 920 614.3 925.4 610.3 928.9C606.3 932.4 599.9 937.1 599.9 937.1C599.9 937.1 590.4 943.4 581.2 947C572 950.6 570.6 950.7 570.6 950.7C570.6 950.7 559 954.4 546.9 955.1C534.8 955.8 529.7 955.1 529.7 955.1C529.7 955.1 519.8 954.7 507.4 950.6C495.1 946.4 486.3 939.3 486.3 939.3C486.3 939.3 481.3 935.5 477.6 930.5C473.9 925.5 470.8 918.6 470.8 918.6L470.7 925L471.4 936L471.5 948.4C471.5 948.4 471.1 954 466.1 959.9C461.1 965.8 449.4 968.6 449.4 968.6L442 971.8L436.3 970.9C436.3 970.9 439.4 976.7 440 984.2C440.6 991.7 439.5 996.4 439.5 996.4C439.5 996.4 438.6 1001.8 436.7 1006C434.8 1010.3 432.4 1014.6 432.4 1014.6C432.4 1014.6 430.2 1019 425.8 1023.7C421.4 1028.4 418 1031.5 418 1031.5C418 1031.5 409.4 1038.8 402.8 1041.9C396.3 1045.1 390.1 1047.4 390.1 1047.4C390.1 1047.4 381.7 1050.9 368.2 1051.8C354.7 1052.8 342 1048.5 342 1048.5C342 1048.5 332.8 1045.6 325.6 1039.4C318.4 1033.2 317.3 1029.9 317.3 1029.9L320 1040.6L324.5 1056.2Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_paume)}
          />
        </g>
        <g id='mannequin_back_hand_right_global_v2'>
          <path
            id='ligne_de_la_main_2_'
            d='M436 1171.5C436 1171.5 699.4 1198.5 824.4 977.5'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <path
            id='ligne_de_la_main_1_'
            d='M436 1357.7C436 1357.7 642 1163.2 910.5 1126.3'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <path
            id='ligne_de_la_main'
            d='M972.4 1172.6C972.4 1172.6 646.2 1244.9 763.2 1624.6'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <g id='contour_main_1_'>
            <path
              id='Vector'
              d='M1006.3 1606.3C1012.6 1601.8 1026.7 1586.9 1033 1582.5C1039.6 1577.9 1045.1 1572.2 1051.1 1566.9C1065.4 1554.4 1075.6 1538.7 1085.8 1522.9C1097.3 1505.3 1108.9 1487.7 1120.6 1470.2C1157.9 1414.6 1196.1 1359.6 1233.3 1303.9C1254.2 1269.8 1275 1235.2 1292.7 1199.9C1308.9 1167.6 1330.8 1129.9 1344.4 1096.3C1357.7 1063.4 1371.7 1041.9 1384 1006C1388.5 992.8 1393.3 981 1396.5 967.3C1399.3 955.3 1408.9 930.9 1394.6 905.2C1387.7 892.8 1369.1 883.5 1357.9 880.6C1335.4 875 1321.8 879.9 1310.8 883C1277.6 892.4 1246.2 918.1 1229.4 948.1C1212.6 978.1 1195.7 1009 1178.8 1038.5C1170 1053.8 1161.8 1067.4 1150.9 1081.2C1128.1 1110.1 1114.8 1148.5 1077.5 1161.7C1068.3 1165 1061.9 1160.5 1055.7 1154C1045.7 1143.5 1036.3 1132.1 1030.9 1118.7C1024.5 1102.8 1024.3 1085.3 1023.4 1068.2C1021.3 1025.9 1053.5 605.5 1054.9 591.7C1057 571.5 1057 378.4 1055 367.1C1053.4 358.1 1050.5 348.7 1045.5 341.2C1029.2 316.6 996.5 296.6 966.4 306.9C952.9 311.5 941.6 321.6 933.8 333.6C924.6 347.9 917.7 367.5 914.5 384.1C912 396.9 906.7 466.9 906.9 488.7C907 515.1 894.7 674.8 892.2 689.4C886.8 721.2 868.9 875 857 892.1C854.5 895.7 851.7 899 848.7 902.1C843 908.1 838.1 908.3 832.3 902.4C824.2 894.2 819.2 883.9 818.4 872.6C816.8 848.6 814.5 706.1 814.6 677.7C814.7 661.3 811.1 382.7 808.8 359.4C804.1 311.7 797.7 293.8 777.9 272.9C763.7 257.9 748.2 256.3 724.7 257C715.3 257.3 705.2 259.3 697 263.8C688.7 268.4 676.1 282.6 672.4 302C669 319.5 668.6 337.5 667 355.3C665.8 369.2 664.9 383.2 664 397.1C662.9 414.7 662.4 432.4 660.9 449.9C659.6 465.6 659 497 659 497C659 497 657.6 601.4 656.7 631.3C656 656.6 656.1 682.2 655.6 707.6C655 735.2 658.3 817.6 656.4 831.4C655.1 840.6 652.8 849.7 649.9 858.6C646.4 869.5 638.8 871.8 629 865.6C618.5 859 613.6 848.1 609.3 837.4C600.8 816.3 596.8 794.2 594.9 771.5C593.3 752.8 589.7 734.4 588.1 715.7C586.2 693.6 582.9 669.8 579.5 647.8C577.5 635 558.1 512 553.3 488.8C551.8 481.3 544.4 436.7 541.9 421.9C539.9 409.8 537.3 397.7 534.6 385.7C530.8 368.8 527 351.5 516.8 337.3C502.4 317.2 478.6 305.5 452.6 317.5C440.3 323.2 433 334.6 427.4 346.5C416 370.8 421 486.9 423.2 516.4C425.8 552.1 429.5 605.5 430.2 641.3C430.6 659.4 433.3 690.3 433.6 693.1C435.2 710.8 442.2 765.7 443.3 774.3C445.6 791.7 454.4 829.8 459.9 858.9L471.1 923.9C472.6 937.8 471.5 939 471.2 946.6C470.9 954.9 466.8 960.7 459 963.9C454.8 965.6 450.6 967.5 446.6 969.5C442 971.8 437.6 970.9 434.9 967.2C427.7 957.6 377.9 851.3 360.8 807.6C355.7 794.6 341.5 764.9 332.8 743.2C321.5 715.2 310 687.1 300.8 658.4C293.7 636.1 282.8 617.5 263.2 604.8C246.1 593.8 226.4 593.9 211.1 607.2C202.7 614.5 197.4 628 196.2 633.8C193.4 648 192.9 661.7 194.5 675.7C196.3 690.9 198.9 706 201.7 721C204 733.5 206.7 746 210.1 758.3C214.8 775.4 219.6 792.5 225.5 809.2C232.4 828.5 240.6 847.2 248.2 866.3C257.8 890.4 266.5 914.9 277.1 938.5C287.2 960.9 301.6 990.2 310.5 1013.1C321.7 1041.9 322.1 1041.4 325.2 1061C329.7 1089.6 332.5 1117.1 335 1145.9C337.7 1176.6 342.3 1207.1 343.9 1237.8C345.2 1262.9 352.4 1361.1 358.7 1385.2C367.9 1420.6 375.4 1457.2 389.7 1491C404 1524.7 415.7 1557.3 435.7 1588.1C439.5 1594 448.9 1618.6 453.3 1623.9'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_2'
              d='M1006.3 1606.3C1006.3 1606.3 892.2 1760.6 913.1 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_3'
              d='M453.3 1623.5C453.3 1623.5 515.5 1789.5 467.9 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2HandLeft({ lesionnel }: FrontV2HandLeftProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_hand_left_vector'>
        <g id='mannequin_front_hand_left_global_v2'>
          <g id='avant_gauche_contour_main'>
            <path
              id='Vector'
              d='M998.8 1606.3C1005.1 1601.8 1019.2 1586.9 1025.5 1582.5C1032.1 1577.9 1037.6 1572.2 1043.6 1566.9C1057.9 1554.4 1068.1 1538.7 1078.3 1522.9C1089.8 1505.3 1101.4 1487.7 1113.1 1470.2C1150.4 1414.6 1188.6 1359.6 1225.8 1303.9C1246.7 1269.8 1267.5 1235.2 1285.2 1199.9C1301.4 1167.6 1323.3 1129.9 1336.9 1096.3C1350.2 1063.4 1364.2 1041.9 1376.5 1006C1381 992.8 1385.8 981 1389 967.3C1391.8 955.3 1401.4 930.9 1387.1 905.2C1380.2 892.8 1361.6 883.5 1350.4 880.6C1327.9 875 1314.3 879.9 1303.3 883C1270.1 892.4 1238.7 918.1 1221.9 948.1C1205.1 978.1 1188.2 1009 1171.3 1038.5C1162.5 1053.8 1154.3 1067.4 1143.4 1081.2C1120.6 1110.1 1107.3 1148.5 1070 1161.7C1060.8 1165 1054.4 1160.5 1048.2 1154C1038.2 1143.5 1028.8 1132.1 1023.4 1118.7C1017 1102.8 1016.8 1085.3 1015.9 1068.2C1013.8 1025.9 1046 605.5 1047.4 591.7C1049.5 571.5 1049.5 378.4 1047.5 367.1C1045.9 358.1 1043 348.7 1038 341.2C1021.7 316.6 989 296.6 958.9 306.9C945.4 311.5 934.1 321.6 926.3 333.6C917.1 347.9 910.2 367.5 907 384.1C904.5 396.9 899.2 466.9 899.4 488.7C899.5 515.1 887.2 674.8 884.7 689.4C879.3 721.2 861.4 875 849.5 892.1C847 895.7 844.2 899 841.2 902.1C835.5 908.1 830.6 908.3 824.8 902.4C816.7 894.2 811.7 883.9 810.9 872.6C809.3 848.6 807 706.1 807.1 677.7C807.2 661.3 803.6 382.7 801.3 359.4C796.6 311.7 790.2 293.8 770.4 272.9C756.2 257.9 740.7 256.3 717.2 257C707.8 257.3 697.7 259.3 689.5 263.8C681.2 268.4 668.6 282.6 664.9 302C661.5 319.5 661.1 337.5 659.5 355.3C658.3 369.2 657.4 383.2 656.5 397.1C655.4 414.7 654.9 432.4 653.4 449.9C652.1 465.6 651.5 497 651.5 497C651.5 497 650.1 601.4 649.2 631.3C648.5 656.6 648.6 682.2 648.1 707.6C647.5 735.2 650.8 817.6 648.9 831.4C647.6 840.6 645.3 849.7 642.4 858.6C638.9 869.5 631.3 871.8 621.5 865.6C611 859 606.1 848.1 601.8 837.4C593.3 816.3 589.3 794.2 587.4 771.5C585.8 752.8 582.2 734.4 580.6 715.7C578.7 693.6 575.4 669.8 572 647.8C570 635 550.6 512 545.8 488.8C544.3 481.3 536.9 436.7 534.4 421.9C532.4 409.8 529.8 397.7 527.1 385.7C523.3 368.8 519.5 351.5 509.3 337.3C494.9 317.2 471.1 305.5 445.1 317.5C432.8 323.2 425.5 334.6 419.9 346.5C408.5 370.8 413.5 486.9 415.7 516.4C418.3 552.1 422 605.5 422.7 641.3C423.1 659.4 425.8 690.3 426.1 693.1C427.7 710.8 434.7 765.7 435.8 774.3C438.1 791.7 446.9 829.8 452.4 858.9L463.6 923.9C465.1 937.8 464 939 463.7 946.6C463.4 954.9 459.3 960.7 451.5 963.9C447.3 965.6 443.1 967.5 439.1 969.5C434.5 971.8 430.1 970.9 427.4 967.2C420.2 957.6 370.4 851.3 353.3 807.6C348.2 794.6 334 764.9 325.3 743.2C314 715.2 302.5 687.1 293.3 658.4C286.2 636.1 275.3 617.5 255.7 604.8C238.6 593.8 218.9 593.9 203.6 607.2C195.2 614.5 189.9 628 188.7 633.8C185.9 648 185.4 661.7 187 675.7C188.8 690.9 191.4 706 194.2 721C196.5 733.5 199.2 746 202.6 758.3C207.3 775.4 212.1 792.5 218 809.2C224.9 828.5 233.1 847.2 240.7 866.3C250.3 890.4 259 914.9 269.6 938.5C279.7 960.9 294.1 990.2 303 1013.1C314.2 1041.9 314.6 1041.4 317.7 1061C322.2 1089.6 325 1117.1 327.5 1145.9C330.2 1176.6 334.8 1207.1 336.4 1237.8C337.7 1262.9 344.9 1361.1 351.2 1385.2C360.4 1420.6 367.9 1457.2 382.2 1491C396.5 1524.7 408.2 1557.3 428.2 1588.1C432 1594 441.4 1618.6 445.8 1623.9'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_2'
              d='M998.8 1606.3C998.8 1606.3 884.7 1760.6 905.6 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_3'
              d='M445.7 1623.5C445.7 1623.5 507.9 1789.5 460.3 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_front_hand_left_zones'>
          <path
            id='avant_gauche_paume'
            d='M1020.8 960.5C1020.69 962.348 1020.57 964.182 1020.46 966M1020.46 966C1017.28 1017.44 1015.33 1056.73 1015.9 1068.2C1016.8 1085.3 1017 1102.8 1023.4 1118.7C1028.8 1132.1 1038.2 1143.5 1048.2 1154C1054.4 1160.5 1060.8 1165 1070 1161.7C1076.71 1159.32 1082.65 1156.13 1088 1152.33C1090.45 1150.59 1092.78 1148.72 1095 1146.74L1088.5 1154L1090 1155L1085.5 1157.5L1082.5 1160L1079.5 1163L1077 1167L1075 1172L1074 1177V1182L1075 1188L1076 1193L1078 1198.5L1080 1203.5L1083 1209L1087 1215.5L1090 1220L1093.5 1224.5L1097.5 1229.5L1101.5 1234L1105 1237.5L1110.5 1243L1118 1249.5L1125.5 1255.5L1134 1261.5L1143.5 1267.5L1154 1273.5L1165.5 1279L1173.5 1282L1182.5 1285L1195 1288L1204.5 1289L1210 1289.5L1216.5 1289L1223 1288L1230 1285.5L1234.5 1283L1239 1279L1242 1274.5L1243.35 1275C1237.55 1284.68 1231.68 1294.31 1225.8 1303.9C1188.6 1359.6 1150.4 1414.6 1113.1 1470.2C1101.4 1487.7 1089.8 1505.3 1078.3 1522.9C1068.1 1538.7 1057.9 1554.4 1043.6 1566.9C1037.6 1572.2 1032.1 1577.9 1025.5 1582.5C1019.2 1586.9 1005.1 1601.8 998.8 1606.3L959 1637.5L926.5 1657.5L888.5 1674.5L841.5 1690.5L811.5 1697L777 1701L745 1703L726 1702.5L707.5 1701.5L672 1698L642.5 1693.5L614.5 1687.5L576.5 1677L531 1661.5L507 1652L484 1642L445.8 1623.9C441.4 1618.6 432 1594 428.2 1588.1C408.2 1557.3 396.5 1524.7 382.2 1491C367.9 1457.2 360.4 1420.6 351.2 1385.2C344.9 1361.1 337.7 1262.9 336.4 1237.8C334.8 1207.1 330.2 1176.6 327.5 1145.9C325 1117.1 322.2 1089.6 317.7 1061C315.362 1046.22 314.56 1042.87 309.5 1029.75L317 1038L325 1044L334 1048L344 1050.5L354.5 1051.5L367 1051L378.5 1048.5L390 1044.5L398.5 1040L408.5 1033L417 1025.5L424.5 1016L429.5 1005.5L432 998.5L433 991V986.5L432.5 980.5L430.5 974L427.4 967.2C430.1 970.9 434.5 971.8 439.1 969.5C443.1 967.5 447.3 965.6 451.5 963.9C459.3 960.7 463.4 954.9 463.7 946.6C464 939 465.1 937.8 463.6 923.9L460.912 908.299L465 921L469 928L472 932L477 937.5L482.5 941.5L489 945.5L498 949.5L508 952.5L517.5 954.5L530 955.5L542.5 954.5L555.5 952.5L569 948.5L584 942L595.5 935L604.5 927.5L609.5 922L614.5 915.5L619 908L622 900.5L623 896L623.5 890.5V884.5L623 880L621.5 875L620 871L618 866.5L616 863.5L613.5 860.5L611.5 856.218C614.183 859.819 617.418 863.034 621.5 865.6C631.3 871.8 638.9 869.5 642.4 858.6L641 865L638 868L636 870.5L633.5 873.5L632 876L630 880.5L628 887L627.5 891.5V895L628.5 901.5L630.5 909L635 917L641 925L649 932.5L659 939.5L667 944L675 948L690 953.5L705.5 957.5L719 959.5L730.5 960H745L757 958.5L766 957L775 954.5L785.5 950.5L794.5 946L802.5 940.5L809 934L815 926L818 918.5L819.5 912V908V904L819 901L817.5 895.5L815.5 889.464C817.828 894.169 820.967 898.52 824.8 902.4C830.6 908.3 835.5 908.1 841.2 902.1L837 906.5L835.5 908.5L834 911L833 914L832 917L831.5 920V923V926.5L832 929.5L833 934.5L835.5 940L839.5 946.5L843 951.5L847 955.5L851.5 960L856.5 964.5L861.5 968L868 972.5L872.5 975L878.5 978.5L885 981.5L893 985L900.5 987.5L908 990L915.5 992L924.5 994L936.5 996L949 997H964.5L975 996L986 993.5L996.5 990L1006 985L1011.5 980.5L1016.5 975L1020 968L1020.46 966Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_paume)}
          />
          <path
            id='avant_gauche_poignet_gauche'
            d='M998.8 1606.3L960.8 1670.1L930 1735.4C930 1735.4 918.4 1771.3 913.8 1783.4C906.8 1801.8 902.5 1849.2 903.2 1855.2C903.9 1861.2 905.6 1886.3 905.6 1886.3C823.5 1886.3 741.4 1886.7 659.2 1886.6C593.5 1886.5 528.2 1885 462.7 1881.2C462.7 1881.2 467.3 1877.4 469.9 1860.6C470.6 1856.2 473.3 1846.2 474 1841.4C475.6 1830.9 475.8 1818.7 477.1 1809.6C478.9 1797.3 477.2 1785.4 477.1 1784.7C476.9 1782.4 473 1743.8 472.9 1741.1C472.8 1738.4 467.7 1709.5 467.7 1709.5L460 1674.4L446 1624.5L477 1639.3C477 1639.3 489.9 1645.2 500.5 1649.6C508.9 1653.1 513.4 1654.9 518.2 1656.9C522.9 1658.8 521.1 1658.2 530 1661.5C539.8 1665.2 561.8 1672 570.5 1675.5C579.6 1679.1 592.1 1681.6 603.7 1685C615.4 1688.4 630.4 1691.2 630.4 1691.2C630.4 1691.2 644.9 1695 668 1698C683.3 1700 710.8 1702.3 717.7 1702.7C723.2 1703 737.2 1703.2 745.2 1703.1C752.5 1703 778 1701.3 778 1701.3L810.1 1697.4L841 1690.9C841 1690.9 867.7 1681.5 880.7 1677.7C892.5 1674.3 919.6 1660.5 923.6 1659.1C927.6 1657.7 956.3 1638.8 958.3 1638.2C960.3 1637.6 998.8 1606.3 998.8 1606.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_poignet_gauche)}
          />
          <g id='mannequin_front_hand_left_doigts'>
            <g id='mannequin_front_hand_left_pouce'>
              <path
                id='avant_gauche_phalange_pouce_proximale'
                d='M1095.3 1147.4L1103.7 1138.8L1114.7 1124.6L1128.9 1102.8L1137.3 1090.2L1152.7 1069.4L1163.2 1053.1C1163.2 1053.1 1162.1 1059.6 1162.3 1063C1162.5 1066.4 1163.1 1070.2 1163.5 1071.8C1163.9 1073.4 1165.5 1079.3 1168.7 1084.5C1171.9 1089.6 1177.7 1098.3 1184 1103.8C1190.3 1109.3 1195.9 1114.2 1202.1 1118C1208.3 1121.8 1210.7 1123.2 1210.7 1123.2C1210.7 1123.2 1223.3 1130 1228.7 1131.6C1234.2 1133.3 1240.6 1136.1 1248 1137.7C1255.4 1139.3 1270.6 1142.3 1281.4 1141.3C1292.2 1140.2 1296.7 1140.1 1306.5 1136.3C1316.3 1132.5 1320.2 1127.9 1320.2 1127.9L1325.6 1122.6L1294.4 1182.3L1268.7 1231.5L1243.1 1275.8L1243.9 1271.2C1243.9 1271.2 1245 1268.3 1245.4 1263.1C1245.8 1257.9 1244.1 1250.9 1244.1 1250.9C1244.1 1250.9 1242.8 1245 1239.2 1237.6C1235.6 1230.2 1231 1223.6 1231 1223.6L1224.8 1215.3C1224.8 1215.3 1222.4 1212.1 1218.3 1207.8C1214.3 1203.6 1208.6 1198.1 1208.6 1198.1C1208.6 1198.1 1198.4 1188.8 1196.7 1187.9C1195 1187 1193.4 1185.2 1188.9 1182.1C1184.4 1179 1185.6 1179.8 1185.6 1179.8L1179.6 1175.9L1174.1 1172.5L1168.6 1169.4L1163.2 1166.5L1157.7 1163.8L1152.4 1161.4L1147.5 1159.4L1141.3 1157.2L1136 1155.5L1129.6 1153.8L1123.8 1152.6L1116.3 1151.5L1111 1151.1H1103.8L1098.1 1151.7L1092.5 1153L1086.6 1155.3L1095.3 1147.4Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_pouce_proximale)}
              />
              <path
                id='avant_gauche_phalange_pouce_distale'
                d='M1189 1006.6L1205.3 977.2L1217.1 956L1227.1 938.8L1242.7 919.8L1246.8 924.5L1257.6 937.2L1263.9 943.8C1266.7 946.6 1269.7 949.4 1269.7 949.4L1274.6 953.7L1286.9 963.4L1297 970.4L1309.5 977.9L1320 983.4L1329.8 987.9L1351.7 996.3L1364.5 999.8L1377.8 1002.6L1363.5 1038.3L1348.7 1069.3L1329.5 1112.8C1329.5 1112.8 1333.4 1101.3 1328.2 1088.6C1323 1075.9 1316.7 1069.3 1316.7 1069.3C1316.7 1069.3 1310.8 1061.9 1304.2 1056.8C1297.7 1051.6 1293.9 1048.9 1293.9 1048.9C1293.9 1048.9 1285.4 1043.1 1279 1040C1272.6 1036.9 1266.6 1034.3 1266.6 1034.3C1266.6 1034.3 1258.8 1030.8 1248.1 1028.1C1237.3 1025.3 1230.2 1024.6 1230.2 1024.6C1230.2 1024.6 1219.1 1023 1207.3 1024.1C1195.5 1025.2 1190 1027.5 1190 1027.5C1190 1027.5 1180.5 1030.3 1171.5 1037.5L1189 1006.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_pouce_distale)}
              />
              <path
                id='avant_gauche_articulation_pouce_interne'
                d='M1132.23 1260.26C1087.42 1229.22 1063.45 1186.21 1078.7 1164.19C1093.96 1142.17 1142.65 1149.48 1187.46 1180.52C1232.27 1211.56 1256.24 1254.57 1240.99 1276.59C1225.73 1298.61 1177.04 1291.3 1132.23 1260.26Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_pouce_interne)}
              />
              <path
                id='avant_gauche_articulation_pouce_externe'
                d='M1227.23 1130.59C1182.04 1112.41 1154.09 1076.08 1164.8 1049.43C1175.52 1022.79 1220.84 1015.92 1266.04 1034.1C1311.23 1052.27 1339.18 1088.6 1328.47 1115.25C1317.75 1141.89 1272.43 1148.76 1227.23 1130.59Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_pouce_externe)}
              />
              <path
                id='avant_gauche_ongle_pouce'
                d='M1373.4 1001.8C1373.4 1001.8 1299.2 990.2 1249.4 927.6L1243.7 920.8C1243.7 920.8 1254 908.8 1264.7 901.8C1275.4 894.8 1297.5 886 1297.5 886C1297.5 886 1304.2 878 1337.1 878.5C1370 879 1387.1 905.3 1387.1 905.3C1387.1 905.3 1397.7 915.3 1396 940C1394.5 961.8 1377.7 1002.6 1377.7 1002.6L1373.4 1001.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_pouce)}
              />
            </g>
            <g id='mannequin_front_hand_left_auriculaire'>
              <path
                id='avant_gauche_phalange_auriculaire_proximale'
                d='M419 952.3L404.3 922.2L384.6 880.1L368.4 843.2L354.6 810.6L354.9 816.8C354.9 816.8 355.8 823.2 353.6 831.9C351.4 840.6 346.8 847.6 346.8 847.6C346.8 847.6 340.9 856.8 335 861.5C329.2 866.2 327.3 867.5 327.3 867.5C327.3 867.5 319.8 872.6 311.9 875.6C304 878.6 298.4 879.5 298.4 879.5C298.4 879.5 292.9 880.8 284 880.9C275.2 881 266.9 878.6 266.9 878.6C266.9 878.6 260.3 877.1 252.6 872.4C244.8 867.7 238.5 859.6 238.5 859.6L240.8 867L260.7 918.3L289.8 983.1L304.1 1016.7L303.9 1012.4C303.9 1012.4 303.2 1007 304.2 1001.2C305.2 995.4 306.5 992.1 306.5 992.1C306.5 992.1 309.2 984.4 312.7 979.6C316.2 974.7 317 973.7 317 973.7C317 973.7 321.1 968.8 323.8 966.4C326.5 964 329.6 961.5 329.6 961.5C329.6 961.5 334.1 958 338.1 955.8C342.1 953.6 345.9 951.7 345.9 951.7C345.9 951.7 353.6 948.1 358.1 947.2C358.1 947.2 364.1 945.5 366.7 945.2C366.7 945.2 373.4 944.1 377.5 944.1C381.6 944.1 383.3 944.1 383.3 944.1C383.3 944.1 387.1 944.1 392.3 945C397.6 945.9 403.2 947.9 403.2 947.9C403.2 947.9 408.8 949.8 414.2 953.5C419.6 957.1 422.3 960.4 422.3 960.4L419.1 952.5L419 952.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_auriculaire_proximale)}
              />
              <path
                id='avant_gauche_phalange_auriculaire_mediane'
                d='M198.7 741.9L202.8 760.4L212.2 791.9L219.7 814.1L231.3 843.4L231.8 840.1C231.8 840.1 231.1 836.9 232 829.2C232.9 821.5 236.6 814.3 236.6 814.3C236.6 814.3 239.9 807.1 245.3 801.1C250.6 795.1 253.9 792.7 253.9 792.7C253.9 792.7 260.9 786.9 268.7 783.3C276.5 779.7 279.6 779 279.6 779C279.6 779 286.4 776.3 299.3 775.5C312.2 774.8 323.2 778.9 323.2 778.9C323.2 778.9 330.3 781 337.2 786.2C344.1 791.4 348.3 797.3 348.3 797.3L347.4 794.5L336.7 770.5L324.8 742.6L315.1 718.4L312.1 710.1L311.5 714L311.7 718.4L311.4 722.6L310.7 725.3L309.5 728.9L307.2 733.7L304.6 737.8L299.5 744L296.6 746.8C290.5 753.3 277.6 759.4 277.6 759.4L271.6 762L264.5 764.4C264.5 764.4 259.1 765.9 258.1 766L251.6 767.1L245.7 767.7C245.7 767.7 241.5 767.8 238.6 767.8C235.6 767.8 228.8 766.7 228.8 766.7L225.1 765.9L221.3 764.8L217.4 763.3L214.3 761.8L210.6 759.6L206.6 756.4L203.4 752.8L201 748.8L198.7 741.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_auriculaire_mediane)}
              />
              <path
                id='avant_gauche_phalange_auriculaire_distale'
                d='M198.3 741.8L194.2 723.1L189.1 694L188 683.2C196.9 684.5 214.1 684.2 214.1 684.2C214.1 684.2 215.7 684.1 230.2 683C244.7 681.9 262.1 675.5 262.1 675.5C262.1 675.5 263.6 674.9 271.8 671.3C280.1 667.6 290.3 658.7 290.3 658.7L292.2 657L311.5 709.9L307.1 703.2L304.6 700.1L301.2 696.9L296.6 693.8L291.5 691.3L286.4 689.5L280.3 688.1L275.6 687.5L270.6 687.2C270.6 687.2 261.8 687.3 260.7 687.6L250.5 689.2C250.5 689.2 242.3 691.6 240.9 692.1C239.2 692.7 226.4 698.2 222.6 701.1C219.3 703.6 215.3 705.6 210.8 710.8C210.8 710.8 204.6 715.2 199.6 728.7C197.4 734.7 198.3 741.8 198.3 741.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_auriculaire_distale)}
              />
              <path
                id='avant_gauche_articulation_auriculaire_interne'
                d='M306.969 1023.52C296.08 997.427 314.771 964.788 348.717 950.623C382.664 936.458 419.01 946.131 429.9 972.228C440.789 998.325 422.098 1030.96 388.152 1045.13C354.205 1059.29 317.859 1049.62 306.969 1023.52Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_auriculaire_interne)}
              />
              <path
                id='avant_gauche_articulation_auriculaire_mediane'
                d='M234.392 850.727C224.249 824.334 242.437 792.788 275.017 780.268C307.597 767.747 342.23 778.994 352.373 805.388C362.516 831.781 344.328 863.327 311.748 875.848C279.168 888.368 244.534 877.121 234.392 850.727Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_auriculaire_mediane)}
              />
              <path
                id='avant_gauche_articulation_auriculaire_externe'
                d='M310.4 709.5C304 689.5 273.9 681.3 243.3 691.2C212.7 701.1 193.1 725.3 199.6 745.2C206 765.2 236.1 773.4 266.7 763.5C297.2 753.7 316.8 729.5 310.4 709.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_auriculaire_externe)}
              />
              <path
                id='avant_gauche_ongle_auriculaire'
                d='M292.6 656.8C292.6 656.8 289.6 644.1 280.6 630.8C275.2 622.8 266.6 615.5 258.3 608.2C235.1 587.8 206.3 604.1 199 612.5C191.6 620.9 181.1 654.4 188.4 683C188.4 683.1 255.9 692.5 292.6 656.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_auriculaire)}
              />
            </g>
            <g id='mannequin_front_hand_left_annulaire'>
              <path
                id='avant_gauche_phalange_annulaire_proximale'
                d='M597 823.9L593.2 809.7L589.8 791.5L585.6 754.7L579.5 703.5L572.8 652.8L567.7 618.2C567.7 618.2 566 626.5 565.7 627.6C565.4 628.6 562.7 635.8 560.3 639.3C557.8 642.7 555 647.6 544.4 655.2C533.9 662.8 523.6 665.6 523.6 665.6L516.3 667.7L506.9 669.6C506.9 669.6 495.4 671.3 487.5 670.7C479.6 670.1 471.1 668.7 471.1 668.7C471.1 668.7 458.3 666.3 448.5 660.4C438.7 654.5 437.6 652.9 437.6 652.9C437.6 652.9 431.8 648 428.1 641.9C424.4 635.8 423 629.2 423 629.2L422.8 639.2L424.4 670.6L426.7 698.5L429 719.2L432.3 746.5L435.8 773.9L438.3 789.3L442.9 812.1L447.6 834.5L454.3 869.3L458.5 893.5L461 908.1L461.7 904.6C461.7 904.6 461.5 900.3 463 893.9C464.6 887.5 468.1 881.1 468.1 881.1C468.1 881.1 470.3 876.8 473.5 873C476.7 869.2 480.3 865.4 480.3 865.4C480.3 865.4 483.6 861.7 489.3 857.8C495 853.9 497.2 852.6 497.2 852.6C497.2 852.6 502.3 849.4 509.4 846.4C516.6 843.4 519.2 842.8 519.2 842.8C519.2 842.8 527.8 839.6 540.8 838.1C553.8 836.6 564.2 837.8 564.2 837.8C564.2 837.8 572.6 838.3 583.5 841.7C594.4 845.1 601.6 850.3 601.6 850.3L612.2 858.2L605.1 845.6L599.4 831.4L597 823.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_annulaire_proximale)}
              />
              <path
                id='avant_gauche_phalange_annulaire_mediane'
                d='M414 488.6L414.5 501.1L417.4 544L419.5 576.3L421.6 616.2C421.6 616.2 423.8 606.2 430.9 596.7C438 587.2 449.2 580.8 449.2 580.8C449.2 580.8 457.1 575 475.4 570.6C493.7 566.2 509.6 568.9 509.6 568.9C509.6 568.9 525 569.9 535.9 576.2C546.8 582.5 554.4 588.9 554.4 588.9C554.4 588.9 561.3 596.1 564.6 603.4C567.9 610.7 561.8 586 561.8 586L551.6 523L542.3 470L542 479L541 484.4L538.6 490.4L534 497.3L528.2 503.4L520.6 509.2L511.8 514.1L504.6 517.2L497.5 519.5L488.7 521.6L481.6 522.6L474.5 523.1H466.3L462.1 522.8L457.7 522.3L453.7 521.6L447.4 520.1L441.5 518.1L436.5 515.9L431.7 513.2L427.7 510.4L424 507.1L420.7 503.2L418.2 499.2L416.4 495.1L414 488.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_annulaire_mediane)}
              />
              <path
                id='avant_gauche_phalange_annulaire_distale'
                d='M415.1 488.5L414.4 472.4L413.7 438.4V412.5L414.8 402.9C414.8 402.9 452 415.1 482.1 411.8C512.2 408.5 530.1 395.5 530.1 395.5L540.3 452L543.4 469.7L539.9 465.5C539.9 465.5 537 460.3 536.6 459.7C534.7 456.8 530.4 453.1 530.4 453.1L526.7 450.3L521.4 447.2L516.1 444.8L511.2 443.1L506.9 441.9L501.9 440.9C501.9 440.9 497.5 440.2 494.5 439.9C490.5 439.5 486.7 439.5 485.9 439.5C482.2 439.6 473.8 440.3 473 440.4C467.9 441 461.7 442.6 460.4 443C453.4 444.9 447.3 447.7 447.3 447.7C447.3 447.7 439.3 451.8 436.6 453.5C427.8 459.2 422.6 466.1 422.6 466.1L419.4 470.8L416.7 476.5L415 481.6L415.1 488.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_annulaire_distale)}
              />
              <path
                id='avant_gauche_articulation_annulaire_interne'
                d='M462.547 912.954C455.934 881.667 486.406 848.731 530.607 839.388C574.808 830.046 616.001 847.835 622.613 879.122C629.226 910.408 598.755 943.345 554.554 952.687C510.353 962.03 469.16 944.241 462.547 912.954Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_annulaire_interne)}
              />
              <path
                id='avant_gauche_articulation_annulaire_mediane'
                d='M422.178 623.978C420.412 595.758 451.419 570.85 491.435 568.346C531.45 565.841 565.321 586.688 567.088 614.908C568.854 643.129 537.846 668.036 497.831 670.541C457.815 673.045 423.944 652.198 422.178 623.978Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_annulaire_mediane)}
              />
              <path
                id='avant_gauche_articulation_annulaire_externe'
                d='M415.287 490.24C412.176 467.7 437.995 445.516 472.954 440.692C507.913 435.868 538.775 450.229 541.886 472.77C544.996 495.31 519.178 517.493 484.218 522.317C449.259 527.142 418.397 512.78 415.287 490.24Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_annulaire_externe)}
              />
              <path
                id='avant_gauche_ongle_annulaire'
                d='M529.3 395.6C529.3 395.6 525.5 363.9 506.3 333.7C487 303.5 444.1 312.1 434.4 325.1C430.3 330.5 422.5 339.4 418 353.1C413.5 366.7 412.2 385 414.1 403.1C414 403 477.1 428.9 529.3 395.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_annulaire)}
              />
            </g>
            <g id='mannequin_front_hand_left_majeur'>
              <path
                id='avant_gauche_phalange_majeur_proximale'
                d='M810.8 865.3L808.3 757.3L807 637.4V618L804.4 621.6C804.4 621.6 798.9 634.2 785.9 641.9C772.9 649.6 765.8 651.2 765.8 651.2C765.8 651.2 748 658.4 719 655.3C690.1 652.2 672.3 638.6 672.3 638.6C672.3 638.6 652.2 625.8 650.1 605.6L648.5 689.6L649.3 783.5L649.6 824L648.6 834.2L643.5 855.1L640.5 865C640.5 865 649 855.6 666.9 849.1C684.8 842.6 701.5 842 701.5 842C701.5 842 724.8 840.3 743.7 844.9C762.6 849.5 766.4 851.4 766.4 851.4C766.4 851.4 784.9 858.5 796.3 867.6C807.7 876.7 814.1 887.2 814.1 887.2L810.8 865.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_majeur_proximale)}
              />
              <path
                id='avant_gauche_phalange_majeur_mediane'
                d='M654.7 441.3L654.1 450.7L652.8 477.2L651.7 536.9L651 582.3L651.9 592.8L654.4 586.3C654.4 586.3 662.4 568.5 688.1 559.6C713.7 550.7 732.3 553.5 732.3 553.5C732.3 553.5 759.2 554 782.3 568.4C805.4 582.8 807.2 599.5 807.2 599.5L806.4 556.1L805.5 496.7L804.4 441.2L802.7 449.1L800.9 452.8L797.2 458.2L792.8 462.8C792.8 462.8 791.3 464.5 787.7 466.8C784.4 469 786.8 467.4 780.4 471.2C773.9 475 771.7 475 759.6 478.8C743.4 483.9 720.1 482 720.1 482L712.2 481.2L707.5 480.5C707.5 480.5 707.5 480.5 705.7 480.2C702.9 479.7 703.4 479.8 703.4 479.8C703.4 479.8 703.4 479.8 700.5 479.2C695 478 698.4 478.6 696 478.1C692.6 477.3 691.3 476.7 691.3 476.7L687.4 475.4C687.4 475.4 685.1 474.5 681.7 473.1C677.9 471.5 672.8 468.5 671.4 467.4C663.1 461.4 661.2 458.4 661.2 458.4L657.7 453.3L655.7 448.7C652.8 447.4 654.7 441.3 654.7 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_majeur_mediane)}
              />
              <path
                id='avant_gauche_phalange_majeur_distale'
                d='M654.5 441.3L656.8 403.3L660.5 346.5L670.8 350.1L679.5 352.7L690 355.3L699.7 357.3L709.5 358.9L729 360.8L747.7 360.5L765.6 358.1L779.4 354.5L789.6 350.7L800.5 345.3L802.1 371.7L803.9 412.3L804.5 441.5C804.5 441.5 802.8 433.4 802.6 432.9C801.9 431.2 800 427.8 800 427.8C800 427.8 794.3 420.7 793.8 420.5C793.3 420.3 787.5 415.4 786.3 414.7C785.1 414 778.1 410.2 778.1 410.2L767.6 406L759.1 403.6L752.2 402.2L743 400.9L734.2 400.3H725.5C725.5 400.3 711.1 401.4 708.7 401.9C700.7 403.4 697.9 404.2 697.1 404.4C696.7 404.5 693.5 405.3 690.2 406.5C687.7 407.4 683.8 409 683.8 409C683.8 409 680.8 410 676.2 412.7C672.8 414.8 670.3 416.7 669.2 417.3C666.5 418.6 662.6 423.8 661.6 424.5C660.6 425.2 656.1 433.4 656.1 433.4L654.5 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_majeur_distale)}
              />
              <path
                id='avant_gauche_articulation_majeur_interne'
                d='M716.734 959.056C663.866 952.784 624.099 921.647 627.912 889.51C631.724 857.373 677.672 836.404 730.54 842.676C783.407 848.948 823.175 880.084 819.362 912.222C815.55 944.359 769.601 965.327 716.734 959.056Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_majeur_interne)}
              />
              <path
                id='avant_gauche_articulation_majeur_mediane'
                d='M725.684 655.791C682.238 653.285 648.339 628.368 649.967 600.14C651.596 571.911 688.136 551.059 731.583 553.565C775.029 556.072 808.928 580.988 807.299 609.217C805.671 637.446 769.13 658.298 725.684 655.791Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_majeur_mediane)}
              />
              <path
                id='avant_gauche_articulation_majeur_externe'
                d='M729.3 482.5C688.044 482.5 654.6 464.054 654.6 441.3C654.6 418.546 688.044 400.1 729.3 400.1C770.556 400.1 804 418.546 804 441.3C804 464.054 770.556 482.5 729.3 482.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_majeur_externe)}
              />
              <path
                id='avant_gauche_ongle_majeur'
                d='M798.4 346C798.4 346 799.6 322.8 791.2 305.4C786.2 294.9 782.6 289.4 773.8 276.8C751.3 244.9 703.2 258.4 689.6 264.2C669.3 272.7 658.9 306.5 660.3 346.6C660.2 346.6 739.6 378.9 798.4 346Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_majeur)}
              />
            </g>
            <g id='mannequin_front_hand_left_index'>
              <path
                id='avant_gauche_phalange_index_proximale'
                d='M886.4 674.5L880.5 718.4L873.3 770.6L867.4 810.2L860 853.4L854.8 876.7L851.9 885.9L842.5 899.5C842.5 899.5 851.6 891.8 864.5 888.5C877.4 885.2 884.5 885 884.5 885C884.5 885 896 884.1 900.7 884.6C905.4 885.1 910.7 884.9 915.3 885.7C915.3 885.7 926.3 887 931.1 888.4C931.1 888.4 946.4 892 950.9 893.8C950.9 893.8 962.8 897.7 970.8 901.8C970.8 901.8 982.6 907.4 989.5 912.4C989.5 912.4 998.9 918.7 1005.5 925.5C1012 932.3 1013.7 935.3 1013.7 935.3L1017.3 941.4L1021.3 950.9L1023.4 921.9L1025.6 889.1L1028.8 843.2L1031 812.6L1034.4 765.6L1037 730.7L1039.9 691.4L1041.2 674.8L1039.4 675.5C1039.4 675.5 1037.4 681.3 1033.2 685.9C1029 690.4 1025 694 1025 694C1025 694 1020.7 697.6 1014.4 700.9C1008 704.2 1005.1 705.1 1005.1 705.1C1005.1 705.1 1001.5 706.9 990 709.3C978.5 711.7 965.7 711.2 965.7 711.2C965.7 711.2 949.7 710.6 940.8 707.8C931.9 705 927.3 704.1 917.1 698.4C906.9 692.7 901.4 686.6 901.4 686.6C901.4 686.6 893.9 678.9 891.3 671.8C888.7 664.7 888.1 662.1 888.1 662.1L886.4 674.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_index_proximale)}
              />
              <path
                id='avant_gauche_phalange_index_mediane'
                d='M1049.3 490V521.1L1048.8 565.3L1047.1 599.2L1044 638.4L1042.6 659L1040.4 651.9C1040.4 651.9 1038.2 642.2 1028.8 633.4C1019.5 624.6 1011 620.4 1011 620.4C1011 620.4 1000.8 614.5 984.8 611.1C968.8 607.7 956.2 608.8 956.2 608.8C956.2 608.8 939.1 609.2 924.2 615.3C909.2 621.4 902.5 628.3 902.5 628.3C902.5 628.3 899 631.1 895.3 636.3C891.6 641.5 889.1 647.5 889.1 647.5V646.6L893.9 585.1L897.8 528.9L899.5 498.5L900.1 481.5C900.1 481.5 897.7 487.6 902.7 494.7C907.7 501.8 909 503.3 909 503.3C909 503.3 918.7 514 936 519.8C953.4 525.6 971.8 527 971.8 527C971.8 527 989.2 528.4 1004.7 524.7C1020.2 521.1 1026 517.6 1026 517.6C1026 517.6 1047.8 507.9 1048.8 490.1'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_index_mediane)}
              />
              <path
                id='avant_gauche_phalange_index_distale'
                d='M899.5 481.6L900.2 460.7L902.9 420.8C902.9 420.8 903.7 408.4 906.2 392.4L911.7 396.7L926.2 403.1L939.4 407.3L952.6 410.5L967 412.9L976.3 413.8L988.2 414.3L1000.8 413.9L1009 413.1L1018.5 411.5L1034.3 407.3L1041.9 404.5L1048.2 401.8L1048.6 431.4V490C1048.6 490 1049.9 486.3 1046.3 478.3L1044.3 474.2L1040.7 469.4L1036.6 465.4L1031.3 461.3L1026.4 458.2L1020.7 455.2L1014.7 452.5L1009.7 450.6L1002.6 448.5L994.6 446.7L987.7 445.5L981 444.7L975.6 444.3L968.6 444.1L961.8 444.3L953 445.1C953 445.1 948.1 445.9 946.1 446.2C944.1 446.5 938.5 448 937.5 448.2C936.4 448.4 928.8 451 928.8 451L923 453.5L917.3 456.6L913.3 459.3C908.5 462.5 904.8 467.6 904.8 467.6L902 472.2L900.3 476.8L899.5 481.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_index_distale)}
              />
              <path
                id='avant_gauche_articulation_index_interne'
                d='M913.16 991.334C861.138 977.643 824.89 944.03 832.199 916.256C839.508 888.482 887.606 877.065 939.628 890.755C991.651 904.445 1027.9 938.059 1020.59 965.833C1013.28 993.607 965.183 1005.02 913.16 991.334Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_index_interne)}
              />
              <path
                id='avant_gauche_articulation_index_mediane'
                d='M961.877 711.285C919.423 708.835 886.328 683.966 887.957 655.737C889.586 627.508 925.321 606.61 967.775 609.059C1010.23 611.508 1043.32 636.378 1041.69 664.607C1040.07 692.836 1004.33 713.734 961.877 711.285Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_index_mediane)}
              />
              <path
                id='avant_gauche_articulation_index_externe'
                d='M971.853 526.808C930.668 524.432 898.343 504.091 899.654 481.376C900.964 458.66 935.414 442.172 976.6 444.549C1017.79 446.925 1050.11 467.266 1048.8 489.981C1047.49 512.697 1013.04 529.185 971.853 526.808Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_index_externe)}
              />
              <path
                id='avant_gauche_ongle_index'
                d='M1048.6 401.8C1048.6 401.8 1054.8 376.6 1038 341.3C1021.2 306 967.3 300.7 954.8 308.6C931.1 323.5 905.9 352.5 906.7 392.3C906.9 397.5 984 432.6 1048.6 401.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_index)}
              />
            </g>
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2HandLeft({ lesionnel }: BackV2HandLeftProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_hand_left_vector'>
        <g id='mannequin_back_hand_left_zones'>
          <g id='mannequin_back_hand_left_doigts'>
            <g id='mannequin_back_hand_left_index'>
              <path
                id='arriere_gauche_articulation_index_mediane'
                d='M539.433 664.729C537.804 636.5 570.9 611.631 613.353 609.181C655.807 606.732 691.543 627.63 693.171 655.859C694.8 684.088 661.705 708.958 619.251 711.407C576.798 713.857 541.062 692.958 539.433 664.729Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_index_mediane)}
              />
              <path
                id='arriere_gauche_phalange_index_distale'
                d='M682.6 481.6L681.9 460.7L679.2 420.8C679.2 420.8 678.4 408.4 675.9 392.4L673.3 376.2L665.8 351.4L652 328.4L636.3 313.6L617.8 304.7H599.7L585.7 308.1L572 314.7L562.2 321.6L548.6 335.2L539.5 350L534.5 367.4L533.7 402.1L533.3 431.7V490.3C533.3 490.3 532 486.6 535.6 478.6L537.6 474.5L541.2 469.7L545.3 465.7L550.6 461.6L555.5 458.5L561.2 455.5L567.2 452.8L572.2 450.9L579.3 448.8L587.3 447L594.2 445.8L600.9 445L606.3 444.6L613.3 444.4L620.1 444.6L628.9 445.4C628.9 445.4 633.8 446.2 635.8 446.5C637.8 446.8 643.4 448.3 644.4 448.5C645.5 448.7 653.1 451.3 653.1 451.3L658.9 453.8L664.6 456.9L668.6 459.6C673.4 462.8 677.1 467.9 677.1 467.9L679.9 472.5L681.6 477.1L682.6 481.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_index_distale)}
              />
              <path
                id='arriere_gauche_phalange_index_mediane'
                d='M531.8 490V521.1L532.3 565.3L534 599.2L537.1 638.4L538.5 659L540.7 651.9C540.7 651.9 542.9 642.2 552.3 633.4C561.6 624.6 570.1 620.4 570.1 620.4C570.1 620.4 580.3 614.5 596.3 611.1C612.3 607.7 624.9 608.8 624.9 608.8C624.9 608.8 642 609.2 656.9 615.3C671.9 621.4 678.6 628.3 678.6 628.3C678.6 628.3 682.1 631.1 685.8 636.3C689.5 641.5 692 647.5 692 647.5V646.6L687.2 585.1L683.3 528.9L681.6 498.5L681 481.5C681 481.5 683.4 487.6 678.4 494.7C673.4 501.8 672.1 503.3 672.1 503.3C672.1 503.3 662.4 514 645.1 519.8C627.7 525.6 609.3 527 609.3 527C609.3 527 591.9 528.4 576.4 524.7C560.9 521.1 555.1 517.6 555.1 517.6C555.1 517.6 533.3 507.9 532.3 490.1'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_index_mediane)}
              />
              <path
                id='arriere_gauche_phalange_index_proximale'
                d='M694.7 674.5L700.6 718.4L707.8 770.6L713.7 810.2L721.1 853.4L726.3 876.7L729.2 885.9L738.6 899.5C738.6 899.5 729.5 891.8 716.6 888.5C703.7 885.2 696.6 885 696.6 885C696.6 885 685.1 884.1 680.4 884.6C675.7 885.1 670.4 884.9 665.8 885.7C665.8 885.7 654.8 887 650 888.4C650 888.4 634.7 892 630.2 893.8C630.2 893.8 618.3 897.7 610.3 901.8C610.3 901.8 598.5 907.4 591.6 912.4C591.6 912.4 582.2 918.7 575.6 925.5C569.1 932.3 567.4 935.3 567.4 935.3L563.8 941.4L559.8 950.9L557.7 921.9L555.5 889.1L552.3 843.2L550.1 812.6L546.7 765.6L544.1 730.7L541.2 691.4L539.9 674.8L541.7 675.5C541.7 675.5 543.7 681.3 547.9 685.9C552.1 690.5 556.1 694 556.1 694C556.1 694 560.4 697.6 566.7 700.9C573.1 704.2 576 705.1 576 705.1C576 705.1 579.6 706.9 591.1 709.3C602.6 711.7 615.4 711.2 615.4 711.2C615.4 711.2 631.4 710.6 640.3 707.8C649.2 705 653.8 704.1 664 698.4C674.2 692.7 679.7 686.6 679.7 686.6C679.7 686.6 687.2 678.9 689.8 671.8C692.4 664.7 693 662.1 693 662.1L694.7 674.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_index_proximale)}
              />
              <path
                id='arriere_gauche_articulation_index_externe'
                d='M532.335 490.123C531.024 467.407 563.349 447.066 604.535 444.69C645.72 442.314 680.17 458.802 681.481 481.517C682.791 504.233 650.466 524.574 609.281 526.95C568.095 529.326 533.645 512.838 532.335 490.123Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_index_externe)}
              />
              <path
                id='arriere_gauche_articulation_index_interne'
                d='M561.617 966.384C554.42 939.038 590.759 905.771 642.782 892.08C694.804 878.39 742.811 889.461 750.008 916.808C757.204 944.154 720.865 977.421 668.843 991.112C616.82 1004.8 568.813 993.731 561.617 966.384Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_index_interne)}
              />
            </g>
            <g id='mannequin_back_hand_left_majeur'>
              <path
                id='arriere_gauche_articulation_majeur_mediane'
                d='M773.871 609.223C772.243 580.994 806.142 556.078 849.588 553.571C893.034 551.064 929.575 571.916 931.203 600.145C932.832 628.374 898.932 653.29 855.486 655.797C812.04 658.304 775.5 637.452 773.871 609.223Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_majeur_mediane)}
              />
              <path
                id='arriere_gauche_phalange_majeur_distale'
                d='M927.6 441.3L925.3 403.3L921.6 346.5L919.2 315.7L915.7 296.4L910.2 282L896.6 266.2L885.1 260.9L867.3 257.2L850.7 257.3L830 260.3L816.7 268.4L803.9 282L794.8 296.3L786.8 318.9L781.7 345.2L780.1 371.6L778.3 412.2L777.7 441.4C777.7 441.4 779.4 433.3 779.6 432.8C780.3 431.1 782.2 427.7 782.2 427.7C782.2 427.7 787.9 420.6 788.4 420.4C788.9 420.2 794.7 415.3 795.9 414.6C797.1 413.9 804.1 410.1 804.1 410.1L814.6 405.9L823.1 403.5L830 402.1L839.2 400.8L848 400.2H856.7C856.7 400.2 871.1 401.3 873.5 401.8C881.5 403.3 884.3 404.1 885.1 404.3C885.5 404.4 888.7 405.2 892 406.4C894.5 407.3 898.4 408.9 898.4 408.9C898.4 408.9 901.4 409.9 906 412.6C909.4 414.7 911.9 416.6 913 417.2C915.7 418.5 919.6 423.7 920.6 424.4C921.6 425.1 926.1 433.3 926.1 433.3L927.6 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_majeur_distale)}
              />
              <path
                id='arriere_gauche_phalange_majeur_mediane'
                d='M926.4 441.3L927 450.7L928.3 477.2L929.4 536.9L930.1 582.3L929.2 592.8L926.7 586.3C926.7 586.3 918.7 568.5 893 559.6C867.4 550.7 848.8 553.5 848.8 553.5C848.8 553.5 821.9 554 798.8 568.4C775.7 582.8 773.9 599.5 773.9 599.5L774.7 556.1L775.6 496.7L776.7 441.2L778.4 449.1L780.2 452.8L783.9 458.2L788.3 462.8C788.3 462.8 789.8 464.5 793.4 466.8C796.7 469 794.3 467.4 800.7 471.2C807.2 475 809.4 475 821.5 478.8C837.7 483.9 861 482 861 482L868.9 481.2L873.6 480.5C873.6 480.5 873.6 480.5 875.4 480.2C878.2 479.7 877.7 479.8 877.7 479.8C877.7 479.8 877.7 479.8 880.6 479.2C886.1 478 882.7 478.6 885.1 478.1C888.5 477.3 889.8 476.7 889.8 476.7L893.7 475.4C893.7 475.4 896 474.5 899.4 473.1C903.2 471.5 908.3 468.5 909.7 467.4C918 461.4 919.9 458.4 919.9 458.4L923.4 453.3L925.4 448.7C928.3 447.4 926.4 441.3 926.4 441.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_majeur_mediane)}
              />
              <path
                id='arriere_gauche_phalange_majeur_proximale'
                d='M770.3 865.3L772.8 757.3L774.1 637.4V618L776.7 621.6C776.7 621.6 782.2 634.2 795.2 641.9C808.2 649.6 815.3 651.2 815.3 651.2C815.3 651.2 833.1 658.4 862.1 655.3C891 652.2 908.8 638.6 908.8 638.6C908.8 638.6 928.9 625.8 931 605.6L932.6 689.6L931.8 783.5L931.6 824.1L932.6 834.3L937.7 855.2L940.7 865.1C940.7 865.1 932.2 855.7 914.3 849.2C896.4 842.8 879.7 842.1 879.7 842.1C879.7 842.1 856.4 840.4 837.5 845C818.6 849.6 814.8 851.5 814.8 851.5C814.8 851.5 796.3 858.6 784.9 867.7C773.5 876.8 767.1 887.3 767.1 887.3L770.3 865.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_majeur_proximale)}
              />
              <path
                id='arriere_gauche_articulation_majeur_externe'
                d='M851.8 482.5C810.544 482.5 777.1 464.054 777.1 441.3C777.1 418.546 810.544 400.1 851.8 400.1C893.056 400.1 926.5 418.546 926.5 441.3C926.5 464.054 893.056 482.5 851.8 482.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_majeur_externe)}
              />
              <path
                id='arriere_gauche_articulation_majeur_interne'
                d='M762.862 913.115C759.095 881.362 798.899 850.536 851.766 844.265C904.634 837.993 950.545 858.65 954.312 890.403C958.079 922.157 918.275 952.982 865.407 959.254C812.54 965.526 766.628 944.869 762.862 913.115Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_majeur_interne)}
              />
            </g>
            <g id='mannequin_back_hand_left_annulaire'>
              <path
                id='arriere_gauche_articulation_annulaire_mediane'
                d='M1083.33 670.469C1043.31 667.965 1012.3 643.057 1014.07 614.837C1015.84 586.617 1049.71 565.77 1089.72 568.274C1129.74 570.779 1160.74 595.686 1158.98 623.907C1157.21 652.127 1123.34 672.974 1083.33 670.469Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_annulaire_mediane)}
              />
              <path
                id='arriere_gauche_phalange_annulaire_mediane'
                d='M1167.1 488.6L1166.6 501.1L1163.7 544L1161.6 576.3L1159.5 616.2C1159.5 616.2 1157.3 606.2 1150.2 596.7C1143.1 587.2 1131.9 580.8 1131.9 580.8C1131.9 580.8 1124 575 1105.7 570.6C1087.4 566.2 1071.5 568.9 1071.5 568.9C1071.5 568.9 1056.1 569.9 1045.2 576.2C1034.2 582.5 1026.6 589 1026.6 589C1026.6 589 1019.7 596.2 1016.4 603.5C1013.1 610.8 1019.2 586.1 1019.2 586.1L1029.5 523L1038.8 470L1039.1 479L1040.1 484.4L1042.5 490.4L1047.1 497.3L1052.9 503.4L1060.5 509.2L1069.3 514.1L1076.5 517.2L1083.6 519.5L1092.4 521.6L1099.5 522.6L1106.6 523.1H1114.8L1119 522.8L1123.4 522.3L1127.4 521.6L1133.7 520.1L1139.6 518.1L1144.6 515.9L1149.4 513.2L1153.4 510.4L1157.1 507.1L1160.4 503.2L1162.9 499.2L1164.7 495.1L1167.1 488.6Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_annulaire_mediane)}
              />
              <path
                id='arriere_gauche_phalange_annulaire_distale'
                d='M1167 488.5L1167.7 472.4L1168.4 438.4L1169.1 405.8L1167.2 371.7C1167.2 371.7 1167.1 331.1 1134.8 316.9C1124.7 312.4 1116.8 310.8 1098.5 316.4C1087.7 319.7 1079.1 328.8 1071.1 339.9C1060.7 354.3 1051.9 395.5 1051.9 395.5L1041.7 452L1038.6 469.7L1042.1 465.5C1042.1 465.5 1045 460.3 1045.4 459.7C1047.3 456.8 1051.6 453.1 1051.6 453.1L1055.3 450.3L1060.6 447.2L1065.9 444.8L1070.8 443.1L1075.1 441.9L1080.1 440.9C1080.1 440.9 1084.5 440.2 1087.5 439.9C1091.5 439.5 1095.3 439.5 1096.1 439.5C1099.8 439.6 1108.2 440.3 1109 440.4C1114.1 441 1120.3 442.6 1121.6 443C1128.6 444.9 1134.7 447.7 1134.7 447.7C1134.7 447.7 1142.7 451.8 1145.4 453.5C1154.2 459.2 1159.4 466.1 1159.4 466.1L1162.6 470.8L1165.3 476.5L1167 481.6V488.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_annulaire_distale)}
              />
              <path
                id='arriere_gauche_phalange_annulaire_proximale'
                d='M984.1 823.9L987.9 809.7L991.3 791.5L995.5 754.7L1001.6 703.5L1008.3 652.8L1013.4 618.2C1013.4 618.2 1015.1 626.5 1015.4 627.6C1015.7 628.6 1018.4 635.8 1020.8 639.3C1023.3 642.7 1026.1 647.6 1036.7 655.2C1047.3 662.8 1057.5 665.6 1057.5 665.6L1064.8 667.7L1074.2 669.6C1074.2 669.6 1085.7 671.3 1093.6 670.7C1101.6 670.1 1110 668.7 1110 668.7C1110 668.7 1122.8 666.3 1132.6 660.4C1142.4 654.5 1143.5 652.9 1143.5 652.9C1143.5 652.9 1149.3 648 1153 641.9C1156.7 635.8 1158.1 629.2 1158.1 629.2L1158.3 639.2L1156.7 670.6L1154.4 698.5L1152.1 719.2L1148.8 746.5L1145.3 773.9L1142.8 789.3L1138.2 812.1L1133.5 834.5L1126.8 869.3L1122.6 893.5L1120.1 908.1L1119.4 904.6C1119.4 904.6 1119.6 900.3 1118.1 893.9C1116.5 887.5 1113 881.1 1113 881.1C1113 881.1 1110.8 876.8 1107.6 873C1104.4 869.2 1100.8 865.4 1100.8 865.4C1100.8 865.4 1097.5 861.7 1091.8 857.8C1086.1 853.9 1083.9 852.6 1083.9 852.6C1083.9 852.6 1078.8 849.4 1071.7 846.4C1064.5 843.4 1061.9 842.8 1061.9 842.8C1061.9 842.8 1053.3 839.6 1040.3 838.1C1027.3 836.6 1016.9 837.8 1016.9 837.8C1016.9 837.8 1008.5 838.3 997.6 841.7C986.7 845.1 979.5 850.3 979.5 850.3L968.9 858.2L976 845.6L981.7 831.4L984.1 823.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_annulaire_proximale)}
              />
              <path
                id='arriere_gauche_articulation_annulaire_externe'
                d='M1097.86 522.184C1062.91 517.36 1037.09 495.176 1040.2 472.636C1043.31 450.096 1074.17 435.734 1109.13 440.559C1144.09 445.383 1169.91 467.566 1166.8 490.106C1163.69 512.647 1132.82 527.008 1097.86 522.184Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_annulaire_externe)}
              />
              <path
                id='arriere_gauche_articulation_annulaire_interne'
                d='M1027.66 952.812C983.461 943.469 952.99 910.533 959.603 879.246C966.216 847.96 1007.41 830.171 1051.61 839.513C1095.81 848.856 1126.28 881.792 1119.67 913.079C1113.06 944.365 1071.86 962.154 1027.66 952.812Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_annulaire_interne)}
              />
            </g>
            <g id='mannequin_back_hand_left_auriculaire'>
              <path
                id='arriere_gauche_articulation_auriculaire_mediane'
                d='M1269.48 875.764C1236.9 863.244 1218.71 831.698 1228.85 805.304C1239 778.911 1273.63 767.664 1306.21 780.184C1338.79 792.704 1356.98 824.25 1346.84 850.644C1336.69 877.038 1302.06 888.285 1269.48 875.764Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_auriculaire_mediane)}
              />
              <path
                id='arriere_gauche_phalange_auriculaire_mediane'
                d='M1382.4 741.9L1378.3 760.4L1368.9 791.9L1361.4 814.1L1349.8 843.4L1349.3 840.1C1349.3 840.1 1350 836.9 1349.1 829.2C1348.2 821.5 1344.5 814.3 1344.5 814.3C1344.5 814.3 1341.2 807.1 1335.8 801.1C1330.5 795.1 1327.2 792.7 1327.2 792.7C1327.2 792.7 1320.2 786.9 1312.4 783.3C1304.6 779.7 1301.5 779 1301.5 779C1301.5 779 1294.7 776.3 1281.8 775.5C1268.9 774.8 1257.9 778.9 1257.9 778.9C1257.9 778.9 1250.8 781 1243.9 786.2C1237 791.4 1232.8 797.3 1232.8 797.3L1233.7 794.5L1244.4 770.5L1256.3 742.6L1266 718.4L1269 710.1L1269.6 714L1269.4 718.4L1269.7 722.6L1270.4 725.3L1271.6 728.9L1273.9 733.7L1276.5 737.8L1281.6 744L1284.5 746.8C1290.6 753.3 1303.5 759.4 1303.5 759.4L1309.5 762L1316.6 764.4C1316.6 764.4 1322 765.9 1323 766L1329.6 767L1335.5 767.6C1335.5 767.6 1339.7 767.7 1342.6 767.7C1345.6 767.7 1352.4 766.6 1352.4 766.6L1356.1 765.8L1359.9 764.7L1363.8 763.2L1366.9 761.7L1370.6 759.5L1374.6 756.3L1377.8 752.7L1380.2 748.7L1382.4 741.9Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_auriculaire_mediane)}
              />
              <path
                id='arriere_gauche_phalange_auriculaire_distale'
                d='M1382.8 741.8L1386.9 723.1L1392 694L1396 671.4C1396.5 651.9 1394.1 638.2 1394.1 638.2C1394.1 638.2 1387.4 609 1371.5 602.8C1365.8 600.6 1357.2 596.5 1348.5 597.6C1336.3 599.2 1324.4 606.8 1324.4 606.8C1324.4 606.8 1315.1 613 1309.9 619.6C1304.4 626.6 1293.7 645.7 1293.7 645.7L1288.7 657L1269.4 709.9L1273.8 703.2L1276.3 700.1L1279.7 696.9L1284.3 693.8L1289.4 691.3L1294.5 689.5L1300.6 688.1L1305.3 687.5L1310.3 687.2C1310.3 687.2 1319.1 687.3 1320.2 687.6L1330.4 689.2C1330.4 689.2 1338.6 691.6 1340 692.1C1341.7 692.7 1354.5 698.2 1358.3 701.1C1361.6 703.6 1365.6 705.6 1370.1 710.8C1370.1 710.8 1376.3 715.2 1381.3 728.7C1383.7 734.7 1382.8 741.8 1382.8 741.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_auriculaire_distale)}
              />
              <path
                id='arriere_gauche_phalange_auriculaire_proximale'
                d='M1162.1 952.3L1176.8 922.2L1196.5 880.1L1212.6 843.1L1226.4 810.5L1226.1 816.7C1226.1 816.7 1225.2 823.1 1227.4 831.8C1229.6 840.5 1234.2 847.5 1234.2 847.5C1234.2 847.5 1240.1 856.7 1246 861.4C1251.8 866.1 1253.7 867.4 1253.7 867.4C1253.7 867.4 1261.2 872.5 1269.1 875.5C1277 878.5 1282.6 879.4 1282.6 879.4C1282.6 879.4 1288.1 880.7 1297 880.8C1305.8 880.9 1314.1 878.5 1314.1 878.5C1314.1 878.5 1320.7 877 1328.4 872.3C1336.2 867.6 1342.5 859.5 1342.5 859.5L1340.2 866.9L1320.3 918.2L1291.2 983L1276.9 1016.6L1277.1 1012.3C1277.1 1012.3 1277.8 1006.9 1276.8 1001.1C1275.8 995.4 1274.5 992 1274.5 992C1274.5 992 1271.8 984.3 1268.3 979.5C1264.8 974.7 1264 973.6 1264 973.6C1264 973.6 1259.9 968.7 1257.2 966.3C1254.5 963.9 1251.4 961.4 1251.4 961.4C1251.4 961.4 1246.9 957.9 1242.9 955.7C1238.9 953.5 1235.1 951.6 1235.1 951.6C1235.1 951.6 1227.4 948 1222.9 947.1C1222.9 947.1 1216.9 945.4 1214.3 945.1C1214.3 945.1 1207.6 944 1203.5 944C1199.4 944 1197.7 944 1197.7 944C1197.7 944 1193.9 944 1188.7 944.9C1183.5 945.8 1177.8 947.8 1177.8 947.8C1177.8 947.8 1172.2 949.7 1166.8 953.4C1161.4 957 1158.7 960.3 1158.7 960.3L1161.9 952.4L1162.1 952.3Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_auriculaire_proximale)}
              />
              <path
                id='arriere_gauche_articulation_auriculaire_externe'
                d='M1270.7 709.5C1277.1 689.5 1307.2 681.3 1337.8 691.2C1368.4 701.1 1388 725.3 1381.5 745.2C1375.1 765.2 1345 773.4 1314.4 763.5C1283.9 753.7 1264.3 729.5 1270.7 709.5Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_auriculaire_externe)}
              />
              <path
                id='arriere_gauche_articulation_auriculaire_interne'
                d='M1193.88 1045.16C1159.94 1031 1141.25 998.358 1152.14 972.261C1163.03 946.164 1199.37 936.491 1233.32 950.656C1267.26 964.821 1285.96 997.46 1275.07 1023.56C1264.18 1049.65 1227.83 1059.33 1193.88 1045.16Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_auriculaire_interne)}
              />
            </g>
            <g id='mannequin_back_hand_left_pouce'>
              <path
                id='arriere_gauche_phalange_pouce_proximale'
                d='M486.9 1146.8L478.5 1138.2L467.5 1124L453.3 1102.2L444.9 1089.6L429.5 1068.8L419 1052.5C419 1052.5 420.1 1059 419.9 1062.4C419.7 1065.8 419.1 1069.6 418.7 1071.2C418.3 1072.8 416.7 1078.7 413.5 1083.9C410.3 1089 404.5 1097.7 398.2 1103.2C391.9 1108.8 386.3 1113.6 380.1 1117.4C373.9 1121.2 371.5 1122.6 371.5 1122.6C371.5 1122.6 358.9 1129.4 353.5 1131C348 1132.7 341.6 1135.5 334.2 1137.1C326.8 1138.7 311.6 1141.7 300.8 1140.7C290 1139.6 285.5 1139.5 275.7 1135.7C265.9 1131.9 262 1127.3 262 1127.3L256.6 1122L287.8 1181.7L313.5 1230.9L339.1 1275.2L338.3 1270.6C338.3 1270.6 337.2 1267.7 336.8 1262.5C336.4 1257.3 338.1 1250.3 338.1 1250.3C338.1 1250.3 339.4 1244.4 343 1237C346.6 1229.6 351.2 1223 351.2 1223L357.4 1214.7C357.4 1214.7 359.8 1211.5 363.9 1207.2C368 1202.9 373.6 1197.5 373.6 1197.5C373.6 1197.5 383.8 1188.2 385.5 1187.3C387.2 1186.4 388.8 1184.6 393.3 1181.5C397.8 1178.4 396.6 1179.2 396.6 1179.2L402.6 1175.3L408.1 1171.9L413.6 1168.8L419 1165.9L424.5 1163.2L429.8 1160.8L434.7 1158.8L440.9 1156.6L446.2 1154.9L452.6 1153.2L458.4 1152L465.9 1150.9L471.2 1150.5H478.4L484.1 1151.1L489.7 1152.4L495.6 1154.7L486.9 1146.8Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_pouce_proximale)}
              />
              <path
                id='arriere_gauche_phalange_pouce_distale'
                d='M393.5 1008.1L377.2 978.7L365.4 957.4L355.4 940.2L345.6 927.2L333.2 914.4C333.2 914.4 315.4 897 290.8 887.2C266.2 877.4 247.1 878.2 247.1 878.2C247.1 878.2 225.8 879.1 207.7 892C189.6 905 188.6 923.1 188.6 923.1C188.6 923.1 184.9 942.7 194.2 971.2C203.5 999.7 207.1 1009.9 207.1 1009.9L219.2 1039.6L234 1070.6L253.2 1114.1C253.2 1114.1 249.3 1102.6 254.5 1089.9C259.7 1077.2 266 1070.6 266 1070.6C266 1070.6 271.9 1063.2 278.5 1058.1C285 1052.9 288.8 1050.2 288.8 1050.2C288.8 1050.2 297.3 1044.4 303.7 1041.3C310.1 1038.2 316.1 1035.6 316.1 1035.6C316.1 1035.6 323.9 1032.1 334.6 1029.4C345.4 1026.6 352.5 1025.9 352.5 1025.9C352.5 1025.9 363.6 1024.3 375.4 1025.4C387.2 1026.5 392.7 1028.8 392.7 1028.8C392.7 1028.8 402.2 1031.6 411.2 1038.8L393.5 1008.1Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_pouce_distale)}
              />
              <path
                id='arriere_gauche_articulation_pouce_interne'
                d='M341.046 1276.64C325.794 1254.62 350.127 1211.35 395.394 1180C440.661 1148.65 489.721 1141.08 504.973 1163.1C520.225 1185.12 495.893 1228.39 450.625 1259.74C405.358 1291.1 356.298 1298.66 341.046 1276.64Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_pouce_interne)}
              />
              <path
                id='arriere_gauche_articulation_pouce_externe'
                d='M253.835 1115.86C243.285 1089.62 271.411 1053.6 316.657 1035.41C361.903 1017.21 407.134 1023.73 417.684 1049.97C428.235 1076.2 400.108 1112.22 354.862 1130.42C309.617 1148.61 264.385 1142.09 253.835 1115.86Z'
                stroke='black'
                strokeMiterlimit='10'
                fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_pouce_externe)}
              />
            </g>
          </g>
          <path
            id='arriere_gauche_poignet_gauche'
            d='M583.3 1606.3L621.3 1670.1L652.1 1735.4C652.1 1735.4 663.7 1771.3 668.3 1783.4C675.3 1801.8 679.6 1849.2 678.9 1855.2C678.2 1861.2 676.5 1886.3 676.5 1886.3C758.6 1886.3 840.7 1886.7 922.9 1886.6C988.6 1886.5 1053.9 1885 1119.4 1881.2C1119.4 1881.2 1114.8 1877.4 1112.2 1860.6C1111.5 1856.2 1108.8 1846.2 1108.1 1841.4C1106.5 1830.9 1106.3 1818.7 1105 1809.6C1103.2 1797.3 1104.9 1785.4 1105 1784.7C1105.2 1782.4 1109.1 1743.8 1109.2 1741.1C1109.3 1738.4 1114.4 1709.5 1114.4 1709.5L1122.1 1674.4L1136.1 1624.5L1105.1 1639.3C1105.1 1639.3 1092.2 1645.2 1081.6 1649.6C1073.2 1653.1 1068.7 1654.9 1063.9 1656.9C1059.2 1658.8 1061 1658.2 1052.1 1661.5C1042.3 1665.2 1020.3 1672 1011.6 1675.5C1002.5 1679.1 990 1681.6 978.4 1685C966.7 1688.4 951.7 1691.2 951.7 1691.2C951.7 1691.2 937.2 1695 914.1 1698C898.8 1700 871.3 1702.3 864.4 1702.7C858.9 1703 844.9 1703.2 836.9 1703.1C829.6 1703 804.1 1701.3 804.1 1701.3L772 1697.4L741.1 1690.9C741.1 1690.9 714.4 1681.5 701.4 1677.7C689.6 1674.3 662.5 1660.5 658.5 1659.1C654.5 1657.8 625.8 1638.8 623.8 1638.2C621.8 1637.6 583.3 1606.3 583.3 1606.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_poignet_gauche)}
          />
          <path
            id='arriere_gauche_thenar'
            d='M498.748 1494.05C439.736 1369.22 459.334 1236.15 542.521 1196.82C625.708 1157.5 740.982 1226.81 799.994 1351.64C859.006 1476.47 839.408 1609.55 756.221 1648.87C673.034 1688.2 557.76 1618.88 498.748 1494.05Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_thenar)}
          />
          <path
            id='arriere_gauche_paume'
            d='M1265.1 1056.2L1261.1 1085.7L1257.4 1115L1251.1 1178.6L1247.5 1212.3L1245.4 1240.7L1243.3 1272.5L1240.6 1305.9L1238.1 1332.8L1234.6 1363.7L1231.9 1380.5L1222.7 1417.6L1215.7 1444.3L1207 1472.5L1195.5 1501.6L1179.8 1539L1171.6 1556.8L1161.1 1576.6L1152.9 1590.1L1137.7 1622.1L1136 1624.6L1131.4 1626.8L1105 1639.4L1091.2 1645.6L1079 1650.8L1069 1654.9L1055.7 1660.2L1042.5 1664.9L1022.3 1671.7L1011.5 1675.6L997.5 1680L979.5 1684.8L959.6 1689.8L940.4 1693.9L919.4 1697.5L897.7 1700.1L872.3 1702.4L850.3 1703.3L840.9 1703.4L824.4 1702.9L804.1 1701.7L784.6 1699.3L765.6 1696.4L748 1692.7L733.1 1688.4L714.1 1682L697.7 1676.8L680.3 1669.4L665.1 1662.3L648.8 1653.9L630.5 1642.4L611.9 1629.2L622.8 1635.8L632.2 1640.9L643.1 1646.1L656.8 1651.5L674.4 1656.6L692.7 1659.6C692.7 1659.6 711.5 1661.8 729.4 1658.1C747.4 1654.4 761.8 1646.5 761.8 1646.5C761.8 1646.5 780.2 1637 790.8 1624.1C801.4 1611.3 807.8 1601.7 807.8 1601.7C807.8 1601.7 814.4 1591 818.3 1581.2C822.1 1571.4 824.6 1564.6 826.4 1557.5C828.2 1550.4 831.7 1531.8 831.7 1531.8C831.7 1531.8 834.1 1515.2 834 1505C833.9 1494.9 834 1487.2 834 1487.2L832.9 1469.7C832.9 1469.7 832.7 1465.4 831.5 1457.2C830.3 1449 829 1441.4 829 1441.4L825.8 1426L822.2 1411.6L818.6 1399.5L815 1388.5L811.3 1378.5L806.3 1366.2L802.1 1356.6L797.7 1347.3L793.3 1338.6L789.3 1331.1L785.3 1324L778.8 1313.1L771.2 1301.4L764.8 1292.3L759.6 1285.4L751.8 1275.6L745.2 1267.9L738.3 1260.3L730.7 1252.5L719.3 1241.8L706.1 1230.7L695.8 1223L685.8 1216.3L676 1210.4L665.8 1204.9L654.9 1199.8L647.6 1196.8L636.4 1192.9L624.9 1189.8L611.1 1187.3L602.9 1186.4L593.5 1186L584.5 1186.3L575.8 1187.2L566 1189L556.5 1191.6L550.5 1193.7C550.5 1193.7 531.1 1201.7 522.9 1209C514.6 1216.3 509.3 1221 509.3 1221C509.3 1221 493.3 1238.2 487.3 1251.2C481.3 1264.2 479 1269 479 1269C479 1269 474.2 1280.4 471.5 1292.4C468.9 1304.4 466.9 1316.6 466.9 1316.6C466.9 1316.6 464.2 1335.5 464.7 1351C465.1 1366.5 468 1394.3 468 1394.3C468 1394.3 472.4 1421.7 476.5 1434.7C480.6 1447.6 483.8 1458.1 483.8 1458.1L488.6 1471.1L493.5 1482.9L498.4 1493.7L504.6 1506.3L509.1 1514.7L513.7 1522.8L517.2 1528.6L523.3 1538.3L528.3 1545.8L532.9 1552.3L538.3 1559.6L544.2 1567.1L549 1572.9L556 1580.9L553.3 1580.2L543.8 1571.8L531.5 1560.3L520.4 1546.7L506 1527.2L490.1 1502.2L466.6 1466.1L436.7 1423.1L423.1 1402.7L405.8 1377.3L388.7 1352.1L377.3 1335.2L355.7 1302.9L342.3 1280.8L340.8 1277.7L343.8 1279.8C343.8 1279.8 349.2 1285.6 357.4 1287.5C365.6 1289.4 369.3 1289.3 369.3 1289.3C369.3 1289.3 379.5 1290.3 395.9 1286C412.3 1281.7 423.1 1276 423.1 1276C423.1 1276 437.7 1268.8 445.7 1263.4C453.7 1258 462 1251.7 462 1251.7C462 1251.7 478.6 1238.5 486.9 1227.8C495.1 1217.1 501.7 1206.6 501.7 1206.6C501.7 1206.6 508.8 1195.4 509.8 1181.7C510.8 1168 504.3 1161.7 504.3 1161.7L500.2 1157.7L507.6 1160.2L515.3 1163.3L523.8 1162.2L532.6 1156L550.6 1134.5L557.8 1121.8L564 1099.9L565.8 1081.6L566.5 1060.9L565.6 1033.9L564 1003.1L562.1 970.3L564 971.9C564 971.9 567.4 979.3 574.7 984.1C582 988.9 586.6 990.6 586.6 990.6C586.6 990.6 595.7 994.7 609.8 996.3C623.9 997.9 637.2 996.8 637.2 996.8C637.2 996.8 651.8 995.6 661.1 993.3C670.4 991.1 677.3 989 677.3 989C677.3 989 689.6 985.1 696.6 981.8C703.6 978.5 711.4 974.3 711.4 974.3C711.4 974.3 722.7 967.5 727.8 963C732.9 958.5 734.9 956.6 734.9 956.6L740.3 950.7L744.2 945.4C744.2 945.4 748.1 939.8 750.3 932C752.5 924.2 750.7 918.2 750.7 918.2C750.7 918.2 749.5 911.6 745.8 907.5L747.2 906.7L749.6 907.1L754.1 905.4L762.1 897.6L765.8 894.2L764.9 897.3C764.9 897.3 761.7 906.5 763.4 914.4C765.1 922.3 766.4 924.3 766.4 924.3C766.4 924.3 770.8 933.4 777.1 938.4C783.4 943.4 787.2 945.9 787.2 945.9C787.2 945.9 792 949 797.8 951.3C803.6 953.6 808.9 955.3 808.9 955.3C808.9 955.3 821.7 959.2 834.2 960C846.7 960.8 847.4 960.5 847.4 960.5C847.4 960.5 860.8 960.7 876.5 957.7C892.3 954.8 903.3 950.1 903.3 950.1C903.3 950.1 912.1 946.9 922 940.9C931.9 934.9 938.7 928.1 938.7 928.1C938.7 928.1 945.6 921.8 949.8 913.7C954 905.6 954.6 899.5 954.6 899.5C954.6 899.5 955.9 891.2 953.5 884.7C951.1 878.1 949.7 876 949.7 876L947.2 872.3L943.9 867.9L948.7 869.2H953.6L961.5 865.6L966.9 862.7L964.9 866.4C964.9 866.4 959.9 874.8 959.3 882C958.7 889.1 959.3 894 959.3 894L960.9 901.1C960.9 901.1 962.1 905.5 965.2 911.2C968.3 916.9 971.1 920 971.1 920C971.1 920 975.3 925.4 979.3 928.9C983.3 932.4 989.7 937.1 989.7 937.1C989.7 937.1 999.2 943.4 1008.4 947C1017.6 950.6 1019 950.7 1019 950.7C1019 950.7 1030.6 954.4 1042.7 955.1C1054.8 955.8 1059.9 955.1 1059.9 955.1C1059.9 955.1 1069.8 954.7 1082.2 950.6C1094.5 946.4 1103.3 939.3 1103.3 939.3C1103.3 939.3 1108.3 935.5 1112 930.5C1115.7 925.5 1118.8 918.6 1118.8 918.6L1118.9 925L1118.2 936L1118.1 948.4C1118.1 948.4 1118.5 954 1123.5 959.9C1128.5 965.8 1140.2 968.6 1140.2 968.6L1147.6 971.8L1153.3 970.9C1153.3 970.9 1150.2 976.7 1149.6 984.2C1149 991.7 1150.1 996.4 1150.1 996.4C1150.1 996.4 1151 1001.8 1152.9 1006C1154.8 1010.3 1157.2 1014.6 1157.2 1014.6C1157.2 1014.6 1159.4 1019 1163.8 1023.7C1168.2 1028.4 1171.6 1031.5 1171.6 1031.5C1171.6 1031.5 1180.2 1038.8 1186.8 1041.9C1193.3 1045.1 1199.5 1047.4 1199.5 1047.4C1199.5 1047.4 1207.9 1050.9 1221.4 1051.8C1234.9 1052.8 1247.6 1048.5 1247.6 1048.5C1247.6 1048.5 1256.8 1045.6 1264 1039.4C1271.2 1033.2 1272.3 1029.9 1272.3 1029.9L1269.6 1040.6L1265.1 1056.2Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_paume)}
          />
        </g>
        <g id='mannequin_back_hand_left_global_v2'>
          <path
            id='ligne_de_la_main_2_'
            d='M1153.6 1171.5C1153.6 1171.5 890.2 1198.5 765.2 977.5'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <path
            id='ligne_de_la_main_1_'
            d='M1153.6 1357.7C1153.6 1357.7 947.6 1163.2 679.1 1126.3'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <path
            id='ligne_de_la_main'
            d='M617.2 1172.6C617.2 1172.6 943.4 1244.9 826.4 1624.6'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
          />
          <g id='contour_main_1_'>
            <path
              id='Vector'
              d='M583.3 1606.3C577 1601.8 562.9 1586.9 556.6 1582.5C550 1577.9 544.5 1572.2 538.5 1566.9C524.2 1554.4 514 1538.7 503.8 1522.9C492.3 1505.3 480.7 1487.7 469 1470.2C431.7 1414.6 393.5 1359.6 356.3 1303.9C335.4 1269.8 314.6 1235.2 296.9 1199.9C280.7 1167.6 258.8 1129.9 245.2 1096.3C231.9 1063.4 217.9 1041.9 205.6 1006C201.1 992.8 196.3 981 193.1 967.3C190.3 955.3 180.7 930.9 195 905.2C201.9 892.8 220.5 883.5 231.7 880.6C254.2 875 267.8 879.9 278.8 883C312 892.4 343.4 918.1 360.2 948.1C377 978.1 393.9 1009 410.8 1038.5C419.6 1053.8 427.8 1067.4 438.7 1081.2C461.5 1110.1 474.8 1148.5 512.1 1161.7C521.3 1165 527.7 1160.5 533.9 1154C543.9 1143.5 553.3 1132.1 558.7 1118.7C565.1 1102.8 565.3 1085.3 566.2 1068.2C568.3 1025.9 536.1 605.5 534.7 591.7C532.6 571.5 532.6 378.4 534.6 367.1C536.2 358.1 539.1 348.7 544.1 341.2C560.4 316.6 593.1 296.6 623.2 306.9C636.7 311.5 648 321.6 655.8 333.6C665 347.9 671.9 367.5 675.1 384.1C677.6 396.9 682.9 466.9 682.7 488.7C682.6 515.1 694.9 674.8 697.4 689.4C702.8 721.2 720.7 875 732.6 892.1C735.1 895.7 737.9 899 740.9 902.1C746.6 908.1 751.5 908.3 757.3 902.4C765.4 894.2 770.4 883.9 771.2 872.6C772.8 848.6 775.1 706.1 775 677.7C774.9 661.3 778.5 382.7 780.8 359.4C785.5 311.7 791.9 293.8 811.7 272.9C825.9 257.9 841.4 256.3 864.9 257C874.3 257.3 884.4 259.3 892.6 263.8C900.9 268.4 913.5 282.6 917.2 302C920.6 319.5 921 337.5 922.6 355.3C923.8 369.2 924.7 383.2 925.6 397.1C926.7 414.7 927.2 432.4 928.7 449.9C930 465.6 930.6 497 930.6 497C930.6 497 932 601.4 932.9 631.3C933.6 656.6 933.5 682.2 934 707.6C934.6 735.2 931.3 817.6 933.2 831.4C934.5 840.6 936.8 849.7 939.7 858.6C943.2 869.5 950.8 871.8 960.6 865.6C971.1 859 976 848.1 980.3 837.4C988.8 816.3 992.8 794.2 994.7 771.5C996.3 752.8 999.9 734.4 1001.5 715.7C1003.4 693.6 1006.7 669.8 1010.1 647.8C1012.1 635 1031.5 512 1036.3 488.8C1037.8 481.3 1045.2 436.7 1047.7 421.9C1049.7 409.8 1052.3 397.7 1055 385.7C1058.8 368.8 1062.6 351.5 1072.8 337.3C1087.2 317.2 1111 305.5 1137 317.5C1149.3 323.2 1156.6 334.6 1162.2 346.5C1173.6 370.8 1168.6 486.9 1166.4 516.4C1163.8 552.1 1160.1 605.5 1159.4 641.3C1159 659.4 1156.3 690.3 1156 693.1C1154.4 710.8 1147.4 765.7 1146.3 774.3C1144 791.7 1135.2 829.8 1129.7 858.9L1118.5 923.9C1117 937.8 1118.1 939 1118.4 946.6C1118.7 954.9 1122.8 960.7 1130.6 963.9C1134.8 965.6 1139 967.5 1143 969.5C1147.6 971.8 1152 970.9 1154.7 967.2C1161.9 957.6 1211.7 851.3 1228.8 807.6C1233.9 794.6 1248.1 764.9 1256.8 743.2C1268.1 715.2 1279.6 687.1 1288.8 658.4C1295.9 636.1 1306.8 617.5 1326.4 604.8C1343.5 593.8 1363.2 593.9 1378.5 607.2C1386.9 614.5 1392.2 628 1393.4 633.8C1396.2 648 1396.7 661.7 1395.1 675.7C1393.3 690.9 1390.7 706 1387.9 721C1385.6 733.5 1382.9 746 1379.5 758.3C1374.8 775.4 1370 792.5 1364.1 809.2C1357.2 828.5 1349 847.2 1341.4 866.3C1331.8 890.4 1323.1 914.9 1312.5 938.5C1302.4 960.9 1288 990.2 1279.1 1013.1C1267.9 1041.9 1267.5 1041.4 1264.4 1061C1259.9 1089.6 1257.1 1117.1 1254.6 1145.9C1251.9 1176.6 1247.3 1207.1 1245.7 1237.8C1244.4 1262.9 1237.2 1361.1 1230.9 1385.2C1221.7 1420.6 1214.2 1457.2 1199.9 1491C1185.6 1524.7 1173.9 1557.3 1153.9 1588.1C1150.1 1594 1140.7 1618.6 1136.3 1623.9'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_2'
              d='M583.3 1606.3C583.3 1606.3 697.4 1760.6 676.5 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
            <path
              id='Vector_3'
              d='M1136.3 1623.5C1136.3 1623.5 1074.1 1789.5 1121.7 1886.3'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2FootRight({ lesionnel }: FrontV2FootRightProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_foot_right_vector'>
        <g id='mannequin_front_foot_right_global_v2'>
          <g id='Silhouette_pied_dessus'>
            <path
              id='Vector'
              d='M166.7 152.4C166.7 169.4 170.9 185.4 179.3 200.3C179.8 201.2 180.4 202.2 180.9 203.1C184.7 209.6 185.1 216.2 182.3 223.2C179.8 229.4 177.2 235.7 175.2 242.1C171.2 255.4 171.2 269.2 171.5 282.9C171.9 311.9 179.3 339.2 190.3 365.8C196.6 381.2 203 396.6 208.2 412.3C215.6 434.6 217.7 457.7 216.8 481.1C215.7 509.4 211.2 537.2 205.9 564.9C202.7 581.9 199.7 599.1 197.3 616.2C195.5 629.5 194.3 643 195.1 656.5C197.7 700.3 226.3 733.6 266.4 741.8C290.5 746.7 313.7 743.6 334.1 728.5C346.4 719.4 354.9 707.1 361.5 693.5C371.4 672.9 377.6 651.2 380.1 628.6C382.2 609.6 382.6 590.4 384.1 571.3C385.4 553.9 386.8 536.5 388.9 519.1C392.5 489 399.5 459.4 406.1 429.8C412.3 402.2 418.6 374.5 424.1 346.7C427.9 327.2 430.9 307.4 429.8 287.4C429.2 275.7 427.7 264 426.1 252.4C424.8 243 425.9 234.5 432.2 227.1C435.2 223.5 436.8 219.2 436.8 214.4C436.9 205.8 436.3 197.2 432.6 189.2C430.4 184.4 427.3 180.4 421.8 179.4C415.1 178.1 410.2 181.3 406.5 186.6C402.9 191.6 401.8 197.5 401.5 203.6C401.4 206.4 401.7 209.4 401 212C400.3 214.6 398.8 217.2 397.1 219.3C395 221.9 392 221.9 389.3 219.8C385.8 217 384.4 213.1 385 208.9C385.6 204.8 387 200.7 388.5 196.8C389.8 193.2 391.9 189.9 393.3 186.4C396.9 177.4 398.1 168 395 158.6C392.2 150.2 385.7 145.6 377.4 143.5C371.7 142.1 366.2 145.1 363.3 150.6C359.4 157.8 359.4 165.6 360 173.5C360.3 177.1 361 180.8 361 184.4C361 192.4 355.8 195.3 348.9 191.2C344.1 188.4 341.8 182.3 343.4 176.1C344.2 173.1 345.3 170.2 346.5 167.4C350.3 158.5 352.1 149.3 350.1 139.7C347.6 127.7 335.4 118.8 323.8 120.3C318.4 121 315 124.3 312.6 128.9C310.2 133.5 309.1 138.5 309.2 143.6C309.5 151.5 310.5 159.3 310.9 167.2C311.1 171.4 311 175.7 310 179.8C308.6 185.7 299 188.8 294.2 185C292.8 183.9 291.9 181.5 291.7 179.6C291.1 173.3 293.1 167.3 295 161.3C297.9 152.2 299.5 143.1 298.6 133.6C297.7 124.5 294.4 116.7 286.7 111.3C278.7 105.8 270.1 106.1 262.5 112.2C255.1 118.2 251.7 126.1 251.2 135.4C250.8 141.5 252.1 147.5 253.8 153.3C256.3 161.6 257.7 170.1 257.1 178.9C257 180.1 256.9 181.2 256.6 182.3C255.2 188.3 249.2 191.4 243.5 189.1C239.7 187.5 238.6 184.1 238.9 180.5C239.4 174.6 240.4 168.8 241.5 163C243 154.9 244.8 146.7 243.2 138.5C239.8 122.1 231.6 108.7 216.8 100.4C208.8 95.9 200.3 95.9 192.5 101.2C176.8 111.8 168.8 127 167 145.6C166.5 148 166.7 150.2 166.7 152.4Z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_front_foot_right_zones'>
          <path
            id='avant_droit_os'
            d='M266.5 455.4C243.027 455.4 224 431.044 224 401C224 370.956 243.027 346.6 266.5 346.6C289.972 346.6 309 370.956 309 401C309 431.044 289.972 455.4 266.5 455.4Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_os)}
          />
          <path
            id='avant_droit_avant_interne'
            d='M295.8 361.9L292.2 358L288.8 354.9L284.6 351.9L280.9 349.9L276.4 348.1L271.2 346.9L265.2 346.5L260 347C260 347 242.8 348.8 231.3 369.6C229.3 373.2 224.8 387.6 223.9 393.8C223.5 396.6 224 408.9 224 408.9L207.7 412.1L198.9 388L187.2 359.1L177.6 330.5L175.7 323.3L173.9 313L171.5 293.9L171 268.4L172.2 251.5L176.9 235.3L182.9 219.4L183.7 211.3C186.3 219.9 198.4 221.2 198.4 221.2C205 222.6 214.8 220.5 214.8 220.5C214.8 220.5 221.4 219.2 228.1 215.8C234.9 212.5 238.2 208.6 238.2 208.6C238.2 208.6 242.4 204.4 243.4 200.4C244.4 196.4 243.7 195 243.2 193.3C242.7 191.6 241.1 189.5 241.1 189.5L240.8 188.3C248.6 192.7 255.1 185.8 255.1 185.8C252.6 193.1 259.9 197.2 259.9 197.2C259.9 197.2 263.5 199.4 268.5 200.3C273.5 201.1 278.2 200 278.2 200C278.2 200 286.2 198.3 289.7 194C293.2 189.7 292.5 186.9 292.5 186.9L292.4 184.3C295.3 186.6 298.2 186.9 300.7 186.5L295.8 361.9Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_avant_interne)}
          />
          <path
            id='avant_droit_avant_externe'
            d='M296 361.7L301.5 370L305.4 379L307.7 387.9L308.5 393.7L308.9 403.5L324.9 404.5L346.6 406.9L364.5 409.8L382.8 413.6L401.9 418.8L407.8 420.8L420.1 364.8L425 340L426.5 332.6L429.6 310V295.6L429.2 284.1L427.7 267.9L425.9 254.2L425.4 241.8L422.9 243.3L421.1 244.3C421.1 244.3 418.4 245.7 414.4 245.7C410.4 245.7 407 244.7 407 244.7C407 244.7 403 243.5 400.7 242.1C398.4 240.7 395.9 238.8 395.9 238.8C395.9 238.8 393 236.1 392.1 234.4C391.2 232.7 390.8 231.8 390.8 231.8C390.8 231.8 389.8 229.5 390.5 227.2C391.1 224.9 392.3 223.6 393.4 223C394.4 222.3 394.9 222.1 394.9 222.1L394.3 221.2C394.3 221.2 391 222.5 388.6 219.4C388.6 219.4 384.9 216.5 384.2 211.8L383 214C383 214 381.2 220 372.7 220.6C364.2 221.3 357.8 217.3 357.8 217.3C357.8 217.3 352.3 214.2 349.9 210.3C349.9 210.3 347.2 206.2 347.6 202.9C348.1 199.6 349.3 198.3 349.3 198.3C349.3 198.3 351.8 195 355.4 194.4L355.3 193C355.3 193 348.9 193.2 344.3 187.5L343.3 188.8C343.3 188.8 345.3 192.1 343.7 196C342.1 199.9 337.6 202 337.6 202C337.6 202 332.1 204.7 326.2 204.7C320.3 204.7 319.3 204.1 319.3 204.1C319.3 204.1 313.2 203 309.5 199.9C305.7 196.8 305 194.1 305 194.1C305 194.1 303.2 188.6 307.4 185.1L306.4 184.5C306.4 184.5 304.2 186.1 301.2 186.7L296 361.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_avant_externe)}
          />
          <path
            id='avant_droit_arriere_externe'
            d='M280.3 743.6C299 744.4 314.1 739 314.1 739C314.1 739 335.5 731.9 347.7 714.6C359.9 697.3 365.7 682.5 365.7 682.5C365.7 682.5 372 668.8 375 653.8C378 638.8 378.1 635.9 378.1 635.9L382.6 594L384 571.2L387.4 531.5L391.2 502L395.1 480L408 420.9L399.3 418.2L380.2 413.2L343.5 406.7L325.1 404.7L309.1 403.7C309.1 403.7 309.1 411.3 306.2 420.6C304.1 427.4 302.1 431.2 299.7 434.9C297.6 438.3 295.1 441.6 292.7 443.8L280.3 743.6Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_arriere_externe)}
          />
          <path
            id='avant_droit_arriere_interne'
            d='M280.3 743.7C276.2 743.5 271.8 743.1 267.4 742.2C243.2 737.3 230.8 726.4 230.8 726.4C230.8 726.4 210.6 711.5 199.4 682.5C188.2 653.5 198.8 603.1 198.8 603.1L208.3 552.1L212 528.6L215.7 496.5L216.8 476L216.3 455.4L213.5 433.4L208 412.3L224.3 409.1C224.3 409.1 226.4 422.8 230.1 429.4C232.5 433.7 233.9 438.1 243.1 446.5C251.2 453.9 264 457.7 276.6 453.9C283.7 451.7 288 448 292.7 443.9L280.3 743.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_droit_arriere_interne)}
          />
          <g id='mannequin_front_foot_right_quintus'>
            <path
              id='avant_droit_ongle_quintus'
              d='M434.8 205.9C434.8 205.9 419.1 208.9 403.5 198.1L401.7 196.9C401.7 196.9 402.6 193.3 404.1 190.8C405.6 188.3 409.1 184.6 409.1 184.6C409.1 184.6 409.7 182.2 416.2 179.8C422.7 177.4 428.5 182.2 428.5 182.2C428.5 182.2 431.5 183.7 433.4 189.6C435.1 194.8 435.5 205.7 435.5 205.7L434.8 205.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_quintus)}
            />
            <path
              id='avant_droit_articulation_quintus_interne'
              d='M404.128 243.587C394.546 239.734 388.649 231.958 390.957 226.219C393.265 220.48 402.904 218.951 412.486 222.804C422.068 226.658 427.965 234.434 425.657 240.173C423.349 245.912 413.71 247.44 404.128 243.587Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_quintus_interne)}
            />
            <path
              id='avant_droit_phalange_quintus_proximale'
              d='M398.2 217.8L400.5 213L401.2 208.4L401.6 200L401.8 197L405.6 199.5L407.3 200.5L409.4 201.6L411.6 202.6L413.4 203.3L415.1 203.9L420.3 205.3L426.5 206.3H431.5L436.2 205.3L436.5 211.8L436.1 219L434.6 223.4L431.4 228.1L428.8 231.3L426.5 237.5L424.7 233.1C424.7 233.1 422.2 229.1 420.8 228.3C420.8 228.3 419.2 226.7 417.1 225.5C415 224.3 412.5 223.2 412.5 223.2C412.5 223.2 408.8 221.6 406.3 221.4C406.3 221.4 403.7 220.9 402 221C402 221 401.9 220.7 395.2 221.8L398.2 217.8Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_quintus_proximale)}
            />
          </g>
          <g id='mannequin_front_foot_right_quartus'>
            <path
              id='avant_droit_ongle_quartus'
              d='M394.8 164.1C394.8 164.1 395.8 159.7 391.8 152.2C387.8 144.6 375.2 142.5 372.2 144.2C366.4 147.5 360.3 153.7 360.4 162.3C360.4 163.4 379 170.8 394.8 164.1Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_quartus)}
            />
            <path
              id='avant_droit_articulation_quartus_externe'
              d='M376.564 188.898C367.294 187.41 360.374 182.491 361.109 177.911C361.844 173.33 369.955 170.822 379.225 172.309C388.496 173.796 395.416 178.716 394.681 183.296C393.946 187.877 385.835 190.385 376.564 188.898Z'
              stroke='black'
              strokeMiterlimit='10.0002'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_quartus_externe)}
            />
            <path
              id='avant_droit_articulation_quartus_interne'
              d='M361.076 218.803C351.494 214.949 345.798 206.675 348.353 200.321C350.908 193.967 360.747 191.94 370.329 195.793C379.911 199.647 385.608 207.921 383.053 214.275C380.498 220.629 370.659 222.656 361.076 218.803Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_quartus_interne)}
            />
            <path
              id='avant_droit_phalange_quartus_proximale'
              d='M361.109 177.911C360.374 182.491 367.294 187.41 376.564 188.898C385.835 190.385 393.946 187.877 394.681 183.296L387 201L383.663 211C383.621 205.31 378.33 199.011 370.329 195.793C365.455 193.833 360.515 193.395 356.5 194.273L360 189.5L361.109 177.911Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_quartus_proximale)}
            />
            <path
              id='avant_droit_phalange_quartus_distale'
              d='M359.599 170.3V162.2L361.999 163.3L364.499 164.3L370.199 165.8L374.699 166.5L377.599 166.7L383.899 166.6L389.299 165.7L392.599 164.7L395.699 163.2L396.399 166.3L396.199 174.1L395.299 179.1L394.499 182C394.499 182 394.599 180.5 392.799 178.6C390.999 176.7 387.599 174.9 387.599 174.9C387.599 174.9 384.499 173.5 382.799 173.1C382.799 173.1 380.599 172.5 379.199 172.3C379.199 172.3 377.499 172 375.399 171.8C373.199 171.6 370.299 172 370.299 172C370.299 172 368.099 172.2 366.499 172.8C366.499 172.8 364.399 173.5 363.599 174.2C363.599 174.2 360.599 176.2 360.099 179.3L359.599 170.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_quartus_distale)}
            />
          </g>
          <g id='mannequin_front_foot_right_tertius'>
            <path
              id='avant_droit_ongle_tertius'
              d='M349.1 139.4C349.1 139.4 348.7 135.4 346.4 131.6C345 129.3 341.4 127 338.9 124.2C332.7 117.2 322.3 120.5 318.3 121.9C312.4 124 309.1 131.7 309.1 140.7C309.1 140.7 331.7 147.3 349.1 139.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_tertius)}
            />
            <path
              id='avant_droit_articulation_tertius_externe'
              d='M327.385 171.334C317.02 170.104 309.076 165.239 309.642 160.468C310.208 155.697 319.069 152.826 329.434 154.056C339.8 155.285 347.743 160.15 347.177 164.921C346.611 169.692 337.75 172.563 327.385 171.334Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_tertius_externe)}
            />
            <path
              id='avant_droit_articulation_tertius_interne'
              d='M323.896 204.571C312.869 203.935 304.249 197.877 304.644 191.04C305.038 184.203 314.297 179.177 325.324 179.813C336.351 180.449 344.97 186.507 344.576 193.344C344.181 200.181 334.922 205.207 323.896 204.571Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_tertius_interne)}
            />
            <path
              id='avant_droit_phalange_tertius_proximale'
              d='M309.642 160.468C309.076 165.24 317.02 170.104 327.385 171.334C337.75 172.563 346.611 169.692 347.177 164.921L343 177L343.324 188.5C340.575 183.85 333.633 180.292 325.324 179.813C318.755 179.434 312.814 181.064 309 183.89L311 174L309.642 160.468Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_tertius_proximale)}
            />
            <path
              id='avant_droit_phalange_tertius_distale'
              d='M309.1 140.7L312 141.4L316.6 142.3L322.3 143L326.2 143.2H330.7L336.7 142.7L341.7 141.8L346 140.6L349.1 139.3L350 140.6L350.7 146.2L350.4 151.1L349.8 157L347.5 163.5L347.3 164.3C347.3 164.3 347 162.2 345.4 160.5C343.7 158.8 341.7 157.6 340.7 157.2C339.7 156.7 336.6 155.6 336.6 155.6L334.5 155L331 154.3L328.4 154L325.8 153.8H323.5L321.9 153.9L319.4 154.2L317.8 154.5L316 155L314.1 155.7L312.3 156.6L311 157.6L309.9 159L309 147.2L309.1 140.7Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_tertius_distale)}
            />
          </g>
          <g id='mannequin_front_foot_right_secundus'>
            <path
              id='avant_droit_ongle_secundus'
              d='M297.2 125.6C297.2 125.6 296.7 118.6 290.2 112.4C283.6 106.2 266.5 109.6 262.3 112.8C260.5 114.1 257.2 116.4 255 119.6C252.8 122.8 251.7 127 251.8 131C251.8 131 275.7 134.7 297.2 125.6Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_secundus)}
            />
            <path
              id='avant_droit_articulation_secundus_externe'
              d='M276 167.5C265.065 167.5 256.2 163.068 256.2 157.6C256.2 152.132 265.065 147.7 276 147.7C286.935 147.7 295.8 152.132 295.8 157.6C295.8 163.068 286.935 167.5 276 167.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_secundus_externe)}
            />
            <path
              id='avant_droit_articulation_secundus_interne'
              d='M255.256 189.582C254.828 182.747 262.971 176.675 273.443 176.02C283.916 175.364 292.752 180.374 293.18 187.208C293.608 194.043 285.465 200.115 274.993 200.77C264.52 201.426 255.684 196.417 255.256 189.582Z'
              stroke='black'
              strokeMiterlimit='9.9995'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_secundus_interne)}
            />
            <path
              id='avant_droit_phalange_secundus_proximale'
              d='M256.855 184C259.69 179.71 265.974 176.487 273.443 176.02C281.392 175.522 288.397 178.288 291.5 182.638V174.5L295.8 157.6C295.8 163.068 286.935 167.5 276 167.5C265.064 167.5 256.2 163.068 256.2 157.6L256.855 183.5'
              stroke='black'
              strokeMiterlimit='9.9995'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_secundus_proximale)}
            />
            <path
              id='avant_droit_phalange_secundus_distale'
              d='M255.799 131.4L260.399 131.6H265.699L271.499 131.5L276.999 130.9L281.599 130.2L289.599 128.3L296.799 125.7C298.599 134.6 297.599 150.6 297.599 150.6L295.799 157.8C295.799 157.8 295.899 155.3 293.499 153.2C291.099 151.1 287.699 149.5 285.799 149.2C285.799 149.2 282.399 148.3 280.699 148.2C278.999 148 276.599 147.9 275.299 147.9C273.999 147.9 270.499 148 268.799 148.6C267.099 149.1 265.799 149.1 263.499 150.1C261.199 151.1 259.999 151.9 259.999 151.9C259.999 151.9 258.499 152.7 257.299 154.4C255.999 156.1 255.399 160.1 255.399 160.1L251.799 146.8L250.799 135.1L251.799 131L255.799 131.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_secundus_distale)}
            />
          </g>
          <g id='mannequin_front_foot_right_hallux'>
            <path
              id='avant_droit_ongle_hallux'
              d='M239.8 126.3C239.8 126.3 237.6 122.4 234.6 116.2C232.8 112.5 226.8 108 223 104.3C212.5 94 199.6 97.7 193.4 100.7C187.2 103.7 172 117.3 171.1 129.8C171 129.8 209.9 138.5 239.8 126.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_ongle_hallux)}
            />
            <path
              id='avant_droit_articulation_hallux_interne'
              d='M184.246 211.542C181.617 202.241 192.928 190.902 209.509 186.215C226.091 181.528 241.664 185.269 244.293 194.569C246.922 203.87 235.611 215.209 219.029 219.896C202.448 224.583 186.875 220.843 184.246 211.542Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_hallux_interne)}
            />
            <path
              id='avant_droit_articulation_hallux_externe'
              d='M204.191 172.069C183.295 170.863 166.724 163.494 167.179 155.61C167.634 147.725 184.942 142.311 205.838 143.517C226.734 144.723 243.305 152.092 242.85 159.976C242.395 167.86 225.087 173.274 204.191 172.069Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_articulation_hallux_externe)}
            />
            <path
              id='avant_droit_phalange_hallux_proximale'
              d='M209.51 186.215C192.928 190.902 181.617 202.241 184.246 211.542L179 200L173.5 188.5L168.5 172.068L167.179 155.61C166.724 163.494 183.295 170.863 204.191 172.068C225.087 173.274 242.395 167.86 242.85 159.976L238.5 181L239.837 188.5C233.511 183.894 221.786 182.745 209.51 186.215Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_hallux_proximale)}
            />
            <path
              id='avant_droit_phalange_hallux_distale'
              d='M166.599 149.9C166.599 149.9 166.299 138.4 170.199 129.7L176.299 130.8L185 131.9L196.799 132.8H207.4L215.199 132.1L226.099 130.4L234.199 128.3L239.099 126.3C242.299 134.7 243.5 143.5 243.5 143.5L242.299 157.7C242.299 157.7 242.3 156.1 238 152.7C233.7 149.3 223.199 146.4 223.199 146.4C223.199 146.4 219.1 145 212.4 144.4C205.8 143.8 204.4 143.7 202.4 143.7C200.4 143.7 195.099 143.6 193.799 143.9C192.399 144.2 187.599 144.2 183.299 145.3C178.999 146.4 177.2 146.9 175.4 147.7C173.6 148.5 170.499 149.1 166.699 154.8L166.599 149.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_droit_phalange_hallux_distale)}
            />
          </g>
        </g>
        <path
          id='avant_droit_cheville'
          d='M283.017 725.586C238.744 723.032 205.716 671.349 209.247 610.15C212.778 548.95 251.531 501.409 295.804 503.964C340.077 506.518 373.105 558.201 369.574 619.4C366.043 680.6 327.29 728.141 283.017 725.586Z'
          stroke='black'
          strokeMiterlimit='10'
          fill={syoUtils.colorFiller(lesionnel.avant_droit_cheville)}
        />
      </g>
    );
  }, [lesionnel]);
}

export function BackV2FootRight({ lesionnel }: BackV2FootRightProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_foot_right_vector'>
        <g id='mannequin_back_foot_right_global_v2'>
          <g id='Silhouette_pied_dessous'>
            <path
              id='Vector'
              d='M432.5 152.6C432.5 169.6 428.3 185.6 419.9 200.5C419.4 201.4 418.8 202.4 418.3 203.3C414.5 209.8 414.1 216.4 416.9 223.4C419.4 229.6 422 235.9 424 242.3C428 255.6 428 269.4 427.7 283.1C427.3 312.1 419.9 339.4 408.9 366C402.6 381.4 396.2 396.8 391 412.5C383.6 434.8 381.5 457.9 382.4 481.3C383.5 509.6 388 537.4 393.3 565.1C396.5 582.1 399.5 599.3 401.9 616.4C403.7 629.7 404.9 643.2 404.1 656.7C401.5 700.5 372.9 733.8 332.8 742C308.7 746.9 285.5 743.8 265.1 728.7C252.8 719.6 244.3 707.3 237.7 693.7C227.8 673.1 221.6 651.4 219.1 628.8C217 609.8 216.6 590.6 215.1 571.5C213.8 554.1 212.4 536.7 210.3 519.3C206.7 489.2 199.7 459.6 193.1 430C186.9 402.4 180.6 374.7 175.1 346.9C171.3 327.4 168.3 307.6 169.4 287.6C170 275.9 171.5 264.2 173.1 252.6C174.4 243.2 173.3 234.7 167 227.3C164 223.7 162.4 219.4 162.4 214.6C162.3 206 162.9 197.4 166.6 189.4C168.8 184.6 171.9 180.6 177.4 179.6C184.1 178.3 189 181.5 192.7 186.8C196.3 191.8 197.4 197.7 197.7 203.8C197.8 206.6 197.5 209.6 198.2 212.2C198.9 214.8 200.4 217.4 202.1 219.5C204.2 222.1 207.2 222.1 209.9 220C213.4 217.2 214.8 213.3 214.2 209.1C213.6 205 212.2 200.9 210.7 197C209.4 193.4 207.3 190.1 205.9 186.6C202.3 177.6 201.1 168.2 204.2 158.8C207 150.4 213.5 145.8 221.8 143.7C227.5 142.3 233 145.3 235.9 150.8C239.8 158 239.8 165.8 239.2 173.7C238.9 177.3 238.2 181 238.2 184.6C238.2 192.6 243.4 195.5 250.3 191.4C255.1 188.6 257.4 182.5 255.8 176.3C255 173.3 253.9 170.4 252.7 167.6C248.9 158.7 247.1 149.5 249.1 139.9C251.6 127.9 263.8 119 275.4 120.5C280.8 121.2 284.2 124.5 286.6 129.1C289 133.7 290.1 138.7 290 143.8C289.7 151.7 288.7 159.5 288.3 167.4C288.1 171.6 288.2 175.9 289.2 180C290.6 185.9 300.2 189 305 185.2C306.4 184.1 307.3 181.7 307.5 179.8C308.1 173.5 306.1 167.5 304.2 161.5C301.3 152.4 299.7 143.3 300.6 133.8C301.5 124.7 304.8 116.9 312.5 111.5C320.5 106 329.1 106.3 336.7 112.4C344.1 118.4 347.5 126.3 348 135.6C348.4 141.7 347.1 147.7 345.4 153.5C342.9 161.8 341.5 170.3 342.1 179.1C342.2 180.3 342.3 181.4 342.6 182.5C344 188.5 350 191.6 355.7 189.3C359.5 187.7 360.6 184.3 360.3 180.7C359.8 174.8 358.8 169 357.7 163.2C356.2 155.1 354.4 146.9 356 138.7C359.4 122.3 367.6 108.9 382.4 100.6C390.4 96.1 398.9 96.1 406.7 101.4C422.4 112 430.4 127.2 432.2 145.8C432.7 148.3 432.5 150.5 432.5 152.6Z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_back_foot_right_zones'>
          <path
            id='arriere_droit_talon_externe'
            d='M331.8 742.7C307.6 747.6 285.1 739.7 285.1 739.7C285.1 739.7 263.7 732.6 251.5 715.3C239.3 698 233.5 683.2 233.5 683.2C233.5 683.2 227.2 669.5 224.2 654.5C221.2 639.5 221.1 636.6 221.1 636.6C248.4 613.9 277.4 602.7 304 597.9L331.8 742.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_talon_externe)}
          />
          <path
            id='arriere_droit_talon_interne'
            d='M331.9 742.7C356.1 737.8 368.5 726.9 368.5 726.9C368.5 726.9 388.7 712 399.9 683C411.1 654 400.5 603.6 400.5 603.6C400.5 603.6 357.2 588.1 304.2 597.8L331.9 742.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_talon_interne)}
          />
          <path
            id='arriere_droit_medio_interne'
            d='M296 323.8C296 323.8 269.1 406.9 303.5 597.5C303.5 597.5 330.8 593.3 347.5 594.5C364.2 595.8 376.9 596.8 399.9 603.3L390.7 549.7L385.9 518.9L384.5 506.7L382.8 484.7L382.5 465.7L384 445.3L386.4 430.6L388.6 421.3L394.3 403.8L403.5 379.9L414.9 351.2L419.8 336L420.9 331.9C420.9 331.9 395.5 327 370.4 326.4C370.2 326.4 316.6 323.9 296 323.8Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_medio_interne)}
          />
          <path
            id='arriere_droit_medio_externe'
            d='M174 340.3C174 340.3 222.5 325.5 280.7 323.9L296 323.7L294.4 329.5L292.2 340.2L290.6 349.9L289.3 359.5L288.5 366.6L287.9 373.5L287.2 383.3L286.7 393.1L286.3 403.1L286.1 413.6L286 425.6L286.2 438L286.5 447.4L286.8 455.7L287.3 465.8L287.9 476L288.6 485.4L289.5 495.6L290.3 504.1L291.3 514L292.2 522.3L293.6 532.1L295.3 545.2L297.1 557.9L298.8 569L300.5 579.5L301.6 586.3L302.8 593.1L303.6 597.4L298.5 598.5L288.9 600.8L278.2 604C278.2 604 263.5 609.1 257.2 612.6C250.9 616.1 247.2 617.4 240.2 622C233.2 626.6 239.4 621.8 220.3 636.3L217.7 609.6L215.4 571.6L212.9 541.2L210.8 520.7L207.4 497.3L203.8 477.9L198.6 453.5L194.4 434.7L189.9 414.7L185.1 393.3L180.8 373.7L176.3 352.1L174 340.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_medio_externe)}
          />
          <path
            id='arriere_droit_plante_rond'
            d='M368.1 326.3C338.829 326.3 315.1 305.526 315.1 279.9C315.1 254.274 338.829 233.5 368.1 233.5C397.371 233.5 421.1 254.274 421.1 279.9C421.1 305.526 397.371 326.3 368.1 326.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_plante_rond)}
          />
          <path
            id='arriere_droit_plante_externe'
            d='M296 324H290.1H282.5L273.1 324.2L264.7 324.6L257 325.2L247.5 326.1L240.2 327L232.1 328.1L223.1 329.5L210.8 331.7L199.2 334.1L186.4 337.1L178.9 339L174 340.4L172.5 333L169.4 310.4V296L169.8 284.5L171.3 268.3L173.1 254.6L173.6 242.2L176.1 243.7L177.9 244.7C177.9 244.7 180.6 246.1 184.6 246.1C188.6 246.1 192 245.1 192 245.1C192 245.1 196 243.9 198.3 242.5C200.6 241.1 203.1 239.2 203.1 239.2C203.1 239.2 206 236.5 206.9 234.8C207.8 233.1 208.2 232.2 208.2 232.2C208.2 232.2 209.2 229.9 208.5 227.6C207.9 225.3 206.7 224 205.6 223.4C204.6 222.7 204.1 222.5 204.1 222.5L204.7 221.6C204.7 221.6 208 222.9 210.4 219.8C210.4 219.8 214.1 216.9 214.8 212.2L216 214.4C216 214.4 217.8 220.4 226.3 221C234.8 221.7 241.2 217.7 241.2 217.7C241.2 217.7 246.7 214.6 249.1 210.7C249.1 210.7 251.8 206.6 251.4 203.3C250.9 200 249.7 198.7 249.7 198.7C249.7 198.7 247.2 195.4 243.6 194.8L243.7 193.4C243.7 193.4 250.1 193.6 254.7 187.9L255.7 189.2C255.7 189.2 253.7 192.5 255.3 196.4C256.9 200.3 261.4 202.4 261.4 202.4C261.4 202.4 266.9 205.1 272.8 205.1C278.7 205 279.7 204.5 279.7 204.5C279.7 204.5 285.8 203.4 289.5 200.3C293.3 197.2 294 194.5 294 194.5C294 194.5 295.8 189 291.6 185.5L292.6 184.9C292.6 184.9 295 186.7 298.2 187.1L296 324Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_plante_externe)}
          />
          <path
            id='arriere_droit_plante_interne'
            d='M295.9 324H305.1L310.3 323.8L318.8 324L351.4 325.4L357.8 325.7L355.8 325.1C348.3 324 338.3 318.3 338.3 318.3C338.3 318.3 332.9 314.6 331.1 313.1C329.3 311.6 325 307.5 321.8 302.5C318.6 297.5 317.9 294.8 316.7 291.1C315.5 287.4 315.1 280.5 315.1 280.5C315.1 280.5 314.8 274.8 316.7 268.6C318.6 262.4 318.8 263 322.1 256.9C325.4 250.8 333.8 244.6 333.8 244.6C333.8 244.6 343.3 237.5 353.5 235.4C363.7 233.3 365.2 233.5 373.3 233.9C381.4 234.2 390.4 238 390.4 238C390.4 238 396.3 240.4 401.5 244.1C406.7 247.8 409.5 250.7 412.7 255.1C415.9 259.5 415.9 260.1 417.4 263.2C418.9 266.3 419.5 269.6 420.2 272C420.9 274.4 421 279.1 421 281.7C421 284.3 420 290.1 418.5 294.2C416.9 298.3 416.5 298.8 413.8 303.5C411.1 308.1 405.3 312.8 403.8 314.3C402.3 315.7 399.1 317.6 395.5 319.7C391.9 321.8 385.8 323.7 383.1 324.5C380.4 325.3 374.2 326.4 374.2 326.4L397 328.5L407.9 329.9L419.5 331.8L421 331L422.9 323.8L424.7 313.5L427.1 294.4L427.6 268.9L426.4 252L421.7 235.8L415.7 219.9L414.9 211.8C412.3 220.4 400.2 221.7 400.2 221.7C393.6 223.1 383.8 221 383.8 221C383.8 221 377.2 219.7 370.5 216.3C363.7 213 360.4 209.1 360.4 209.1C360.4 209.1 356.2 204.9 355.2 200.9C354.2 196.9 354.9 195.5 355.4 193.8C355.9 192.1 357.5 190 357.5 190L357.8 188.8C350 193.2 343.5 186.3 343.5 186.3C346 193.6 338.7 197.7 338.7 197.7C338.7 197.7 335.1 199.9 330.1 200.8C325.1 201.6 320.4 200.5 320.4 200.5C320.4 200.5 312.4 198.8 308.9 194.5C305.4 190.2 306.1 187.4 306.1 187.4L306.2 184.8C303.5 187 300.7 187.4 298.4 187L295.9 324Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_droit_plante_interne)}
          />
          <g id='mannequin_back_foot_right_hallux'>
            <path
              id='arriere_droit_articulation_hallux_externe'
              d='M356.406 160.251C355.951 152.366 372.522 144.998 393.418 143.792C414.314 142.586 431.622 148 432.077 155.885C432.532 163.769 415.961 171.138 395.065 172.343C374.169 173.549 356.861 168.135 356.406 160.251Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_hallux_externe)}
            />
            <path
              id='arriere_droit_articulation_hallux_interne'
              d='M380.248 220.148C363.667 215.462 352.356 204.122 354.984 194.822C357.613 185.521 373.187 181.781 389.768 186.468C406.35 191.155 417.661 202.494 415.032 211.795C412.403 221.095 396.83 224.835 380.248 220.148Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_hallux_interne)}
            />
            <path
              id='arriere_droit_phalange_hallux_distale'
              d='M432.6 150C432.6 150 432.9 138.5 429 129.8C425 121 425.8 121.1 419.4 112.8C413 104.5 407 101.7 407 101.7C407 101.7 397.6 94.2 385.5 99.5C373.4 104.8 367.8 113.3 367.8 113.3C367.8 113.3 362.5 119.8 359.3 128.2C356.1 136.6 355.6 143.5 355.6 143.5L356.8 157.7C356.8 157.7 356.8 156.1 361.1 152.7C365.4 149.3 375.9 146.4 375.9 146.4C375.9 146.4 380 145 386.7 144.4C393.3 143.8 394.7 143.7 396.7 143.7C398.7 143.7 404 143.6 405.3 143.9C406.6 144.2 411.5 144.2 415.8 145.3C420.1 146.4 421.9 146.9 423.7 147.7C425.5 148.5 428.6 149.1 432.4 154.8L432.6 150Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_hallux_distale)}
            />
            <path
              id='arriere_droit_phalange_hallux_proximale'
              d='M428.2 181.5C428.2 181.5 420.3 201.7 416.3 207.6L415.7 208.3C415.7 208.3 414.9 203.7 412.1 200.5C409.3 197.3 408.3 196.3 408.3 196.3L404 193L398.4 189.8L392.8 187.5L388.7 186.2L384.6 185.3L380.1 184.7L375.4 184.5L371.5 184.7L367.9 185.3L364.3 186.3L360.7 187.9L358.5 189.4L357.7 188.9L360.3 184.8L360.5 177.3L357.7 164.3L360.2 166.1C360.2 166.1 366.8 171.4 382.3 172.3C397.8 173.2 407.1 170.9 407.1 170.9C407.1 170.9 414.3 169.8 421.4 166.7C428.5 163.5 432.3 158.8 432.3 158.8L430.9 170.3L428.2 181.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_hallux_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_right_quintus'>
            <path
              id='arriere_droit_articulation_quintus_interne'
              d='M173.672 240.518C171.364 234.779 177.261 227.002 186.843 223.149C196.425 219.296 206.064 220.825 208.372 226.564C210.679 232.303 204.782 240.079 195.2 243.932C185.618 247.785 175.98 246.257 173.672 240.518Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_quintus_interne)}
            />
            <path
              id='arriere_droit_phalange_quintus_distale'
              d='M201 217.9L198.7 213.1L198 208.5L197.6 200.1L196 193L192.8 186.9L188.7 182.6L184.2 180.2L179.7 179.7L174.4 181L170.6 183.8L167.2 188.8L165.4 192.9L163.7 198.9L162.8 205.4L162.5 211.9L162.9 219.1L164.4 223.5L167.6 228.2L170.2 231.4L172.5 237.6L174.3 233.2C174.3 233.2 176.8 229.2 178.2 228.4C178.2 228.4 179.8 226.8 181.9 225.6C184 224.4 186.5 223.3 186.5 223.3C186.5 223.3 190.2 221.7 192.7 221.5C192.7 221.5 195.3 221 197 221.1C197 221.1 197.1 220.8 203.8 221.9L201 217.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_quintus_distale)}
            />
          </g>
          <g id='mannequin_back_foot_right_quartus'>
            <path
              id='arriere_droit_articulation_quartus_externe'
              d='M204.525 183.573C203.79 178.992 210.709 174.073 219.98 172.586C229.25 171.099 237.361 173.607 238.096 178.187C238.831 182.768 231.911 187.687 222.641 189.174C213.37 190.661 205.259 188.154 204.525 183.573Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_quartus_externe)}
            />
            <path
              id='arriere_droit_articulation_quartus_interne'
              d='M216.201 214.531C213.646 208.177 219.342 199.902 228.924 196.049C238.506 192.196 248.345 194.223 250.9 200.577C253.456 206.931 247.759 215.205 238.177 219.058C228.595 222.912 218.756 220.885 216.201 214.531Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_quartus_interne)}
            />
            <path
              id='arriere_droit_phalange_quartus_distale'
              d='M239.7 170.4V163.2L238.1 155.6L236.1 150.9L232.6 146.5L227.7 144L222.5 143.7L216.8 145.8L211.4 148.8L207.1 153.4L204.1 160.4L202.7 166.6L202.9 174.4L203.8 179.4L204.6 182.3C204.6 182.3 204.5 180.8 206.3 178.9C208.1 176.9 211.5 175.2 211.5 175.2C211.5 175.2 214.6 173.8 216.3 173.4C216.3 173.4 218.5 172.8 219.9 172.6C219.9 172.6 221.6 172.3 223.7 172.1C225.9 171.9 228.8 172.3 228.8 172.3C228.8 172.3 231 172.5 232.6 173.1C232.6 173.1 234.7 173.8 235.5 174.5C235.5 174.5 238.5 176.5 239 179.6L239.7 170.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_quartus_distale)}
            />
            <path
              id='arriere_droit_phalange_quartus_proximale'
              d='M238.4 183.5V186.5L239 189.3L241 192.2L242.9 193.6L242.3 194.3L238.8 194.1C238.8 194.1 234.2 194 230.3 195.5C226.4 197 224.7 198.1 224.7 198.1C224.7 198.1 220.4 200.6 218.8 203.1C218.8 203.1 216.2 206.6 215.8 208.6L214.9 210.5L213.2 204.7L209.6 193.8L206 187.1L207.8 187.7C207.8 187.7 211.1 189.3 214.4 189.5C217.7 189.6 220.4 189.6 224.4 188.8C228.4 188 231.4 186.4 231.4 186.4C231.4 186.4 234.6 184.9 236.4 182.7C238.2 180.5 238.5 180.6 238.5 180.6L238.4 183.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_quartus_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_right_tertius'>
            <path
              id='arriere_droit_articulation_tertius_externe'
              d='M252.073 165.227C251.507 160.456 259.45 155.591 269.815 154.361C280.181 153.132 289.042 156.003 289.608 160.774C290.174 165.545 282.23 170.41 271.865 171.64C261.5 172.869 252.639 169.998 252.073 165.227Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_tertius_externe)}
            />
            <path
              id='arriere_droit_articulation_tertius_interne'
              d='M254.71 193.677C254.316 186.84 262.935 180.782 273.962 180.146C284.989 179.51 294.248 184.536 294.642 191.373C295.037 198.209 286.417 204.267 275.39 204.904C264.364 205.54 255.105 200.513 254.71 193.677Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_tertius_interne)}
            />
            <path
              id='arriere_droit_phalange_tertius_distale'
              d='M290.1 138L287.1 129.8L282.8 123.4L277.3 121L272 120.6L266 121.8L260 124.8L256.4 127.7L253 131.8L250.7 136.2L249.4 140.7L248.7 146.3L249 151.2L249.6 157.1L251.9 163.6L252.1 164.4C252.1 164.4 252.4 162.3 254 160.6C255.7 158.9 257.7 157.7 258.7 157.3C259.7 156.9 262.8 155.7 262.8 155.7L264.9 155.1L268.4 154.4L271 154.1L273.6 153.9H275.9L277.5 154L280 154.3L281.6 154.6L283.4 155.1L285.3 155.8L287.1 156.7L288.4 157.7L289.5 159.1L290.4 147.3V138H290.1Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_tertius_distale)}
            />
            <path
              id='arriere_droit_phalange_tertius_proximale'
              d='M288.5 170.3L288.7 175.6L289.7 181.1L291.1 184.2L288 182.7C288 182.7 282.1 179.8 277.2 180C272.3 180.2 271.6 180.3 271.6 180.3C271.6 180.3 267.2 180.8 263.6 182.5C260 184.2 258.4 185.9 258.4 185.9C258.4 185.9 256.7 187.4 256.2 188.5L254.9 187.1L256.6 182.3L256.5 176.8L253.6 169.2L255.1 169.1C255.1 169.1 257.9 170.9 261.5 171.4C265.1 171.8 267.4 172.1 270.5 171.7C273.6 171.3 276.7 170.8 279.6 169.9C282.5 169 284.9 167.9 286.5 166.4C288.1 164.9 289.2 163.8 289.2 163.8L288.5 170.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_tertius_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_right_secundus'>
            <path
              id='arriere_droit_articulation_secundus_externe'
              d='M323.3 167.8C312.364 167.8 303.5 163.368 303.5 157.9C303.5 152.432 312.364 148 323.3 148C334.235 148 343.1 152.432 343.1 157.9C343.1 163.368 334.235 167.8 323.3 167.8Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_secundus_externe)}
            />
            <path
              id='arriere_droit_articulation_secundus_interne'
              d='M324.34 200.967C313.868 200.312 305.725 194.24 306.153 187.405C306.581 180.571 315.417 175.561 325.89 176.217C336.362 176.872 344.505 182.944 344.077 189.779C343.649 196.613 334.813 201.623 324.34 200.967Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_articulation_secundus_interne)}
            />
            <path
              id='arriere_droit_phalange_secundus_distale'
              d='M340.4 115.9C340.4 115.9 335.8 110.2 330.8 109C325.8 107.8 319.1 106.2 313.4 111.3C307.6 116.4 303.5 119.9 301.7 128.9C299.9 137.8 301.7 150.7 301.7 150.7L303.5 157.9C303.5 157.9 303.4 155.4 305.8 153.3C308.2 151.2 311.6 149.6 313.5 149.3C313.5 149.3 316.9 148.4 318.6 148.3C320.3 148.1 322.7 148 324 148C325.3 148 328.8 148.1 330.5 148.7C332.2 149.2 333.5 149.2 335.8 150.2C338.1 151.2 339.3 152 339.3 152C339.3 152 340.8 152.8 342 154.5C343.3 156.2 343.9 160.2 343.9 160.2L347.5 146.9L348.5 135.2L346.1 125.1L340.4 115.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_secundus_distale)}
            />
            <path
              id='arriere_droit_phalange_secondus_proximale'
              d='M343.8 161.2L342.5 170V180.3L342.8 184L339.6 181.1C339.6 181.1 334.6 177.3 329.9 176.8C325.2 176.2 324.7 176.2 324.7 176.2C324.7 176.2 320.1 176.1 317.1 177.1C314.1 178.1 311.7 178.7 307 183.1L308.2 175.5L306.8 168.5L304.7 162.3L306.4 162.9L309.1 164.7C309.1 164.7 313.3 167 318 167.4C322.7 167.8 324 168 328.1 167.5C332.2 167 336.5 165.3 336.5 165.3C336.5 165.3 339.4 164.3 341.9 161.5C344.2 158.8 343.8 161.2 343.8 161.2Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_droit_phalange_secondus_proximale)}
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2FootLeft({ lesionnel }: FrontV2FootLeftProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_foot_left_vector'>
        <g id='mannequin_front_foot_left_global_v2'>
          <g id='Silhouette_pied_gauche_dessus'>
            <path
              id='Vector'
              d='M428.6 152.4C428.6 169.4 424.4 185.4 416 200.3C415.5 201.2 414.9 202.2 414.4 203.1C410.6 209.6 410.2 216.2 413 223.2C415.5 229.4 418.1 235.7 420.1 242.1C424.1 255.4 424.1 269.2 423.8 282.9C423.4 311.9 416 339.2 405 365.8C398.7 381.2 392.3 396.6 387.1 412.3C379.7 434.6 377.6 457.7 378.5 481.1C379.6 509.4 384.1 537.2 389.4 564.9C392.6 581.9 395.6 599.1 398 616.2C399.8 629.5 401 643 400.2 656.5C397.6 700.3 369 733.6 328.9 741.8C304.8 746.7 281.6 743.6 261.2 728.5C248.9 719.4 240.4 707.1 233.8 693.5C223.9 672.9 217.7 651.2 215.2 628.6C213.1 609.6 212.7 590.4 211.2 571.3C209.9 553.9 208.5 536.5 206.4 519.1C202.8 489 195.8 459.4 189.2 429.8C183 402.2 176.7 374.5 171.2 346.7C167.4 327.2 164.4 307.4 165.5 287.4C166.1 275.7 167.6 264 169.2 252.4C170.5 243 169.4 234.5 163.1 227.1C160.1 223.5 158.5 219.2 158.5 214.4C158.4 205.8 159 197.2 162.7 189.2C164.9 184.4 168 180.4 173.5 179.4C180.2 178.1 185.1 181.3 188.8 186.6C192.4 191.6 193.5 197.5 193.8 203.6C193.9 206.4 193.6 209.4 194.3 212C195 214.6 196.5 217.2 198.2 219.3C200.3 221.9 203.3 221.9 206 219.8C209.5 217 210.9 213.1 210.3 208.9C209.7 204.8 208.3 200.7 206.8 196.8C205.5 193.2 203.4 189.9 202 186.4C198.4 177.4 197.2 168 200.3 158.6C203.1 150.2 209.6 145.6 217.9 143.5C223.6 142.1 229.1 145.1 232 150.6C235.9 157.8 235.9 165.6 235.3 173.5C235 177.1 234.3 180.8 234.3 184.4C234.3 192.4 239.5 195.3 246.4 191.2C251.2 188.4 253.5 182.3 251.9 176.1C251.1 173.1 250 170.2 248.8 167.4C245 158.5 243.2 149.3 245.2 139.7C247.7 127.7 259.9 118.8 271.5 120.3C276.9 121 280.3 124.3 282.7 128.9C285.1 133.5 286.2 138.5 286.1 143.6C285.8 151.5 284.8 159.3 284.4 167.2C284.2 171.4 284.3 175.7 285.3 179.8C286.7 185.7 296.3 188.8 301.1 185C302.5 183.9 303.4 181.5 303.6 179.6C304.2 173.3 302.2 167.3 300.3 161.3C297.4 152.2 295.8 143.1 296.7 133.6C297.6 124.5 300.9 116.7 308.6 111.3C316.6 105.8 325.2 106.1 332.8 112.2C340.2 118.2 343.6 126.1 344.1 135.4C344.5 141.5 343.2 147.5 341.5 153.3C339 161.6 337.6 170.1 338.2 178.9C338.3 180.1 338.4 181.2 338.7 182.3C340.1 188.3 346.1 191.4 351.8 189.1C355.6 187.5 356.7 184.1 356.4 180.5C355.9 174.6 354.9 168.8 353.8 163C352.3 154.9 350.5 146.7 352.1 138.5C355.5 122.1 363.7 108.7 378.5 100.4C386.5 95.9 395 95.9 402.8 101.2C418.5 111.8 426.5 127 428.3 145.6C428.8 148 428.6 150.2 428.6 152.4Z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_front_foot_left_zones'>
          <path
            id='avant_gauche_os'
            d='M328.8 455.4C352.272 455.4 371.3 431.044 371.3 401C371.3 370.956 352.272 346.6 328.8 346.6C305.328 346.6 286.3 370.956 286.3 401C286.3 431.044 305.328 455.4 328.8 455.4Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_os)}
          />
          <path
            id='avant_gauche_avant_interne'
            d='M299.5 361.9L303.1 358L306.5 354.9L310.7 351.9L314.4 349.9L318.9 348.1L324.1 346.9L330.1 346.5L335.3 347C335.3 347 352.5 348.8 364 369.6C366 373.2 370.5 387.6 371.4 393.8C371.8 396.6 371.3 408.9 371.3 408.9L387.6 412.1L396.4 388L408.1 359.1L417.7 330.5L419.6 323.3L421.4 313L423.8 293.9L424.3 268.4L423.1 251.5L418.4 235.3L412.4 219.4L411.6 211.3C409 219.9 396.9 221.2 396.9 221.2C390.3 222.6 380.5 220.5 380.5 220.5C380.5 220.5 373.9 219.2 367.2 215.8C360.4 212.5 357.1 208.6 357.1 208.6C357.1 208.6 352.9 204.4 351.9 200.4C350.9 196.4 351.6 195 352.1 193.3C352.6 191.6 354.2 189.5 354.2 189.5L354.5 188.3C346.7 192.7 340.2 185.8 340.2 185.8C342.7 193.1 335.4 197.2 335.4 197.2C335.4 197.2 331.8 199.4 326.8 200.3C321.8 201.1 317.1 200 317.1 200C317.1 200 309.1 198.3 305.6 194C302.1 189.7 302.8 186.9 302.8 186.9L302.9 184.3C300 186.6 297.1 186.9 294.6 186.5L299.5 361.9Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_avant_interne)}
          />
          <path
            id='avant_gauche_avant_externe'
            d='M299.3 361.7L293.8 370L289.9 379L287.6 387.9L286.8 393.7L286.4 403.5L270.4 404.5L248.7 406.9L230.8 409.8L212.5 413.6L193.4 418.8L187.5 420.8L175.2 364.8L170.3 340L168.8 332.6L165.7 310V295.6L166.1 284.1L167.6 267.9L169.4 254.2L169.9 241.8L172.4 243.3L174.2 244.3C174.2 244.3 176.9 245.7 180.9 245.7C184.9 245.7 188.3 244.7 188.3 244.7C188.3 244.7 192.3 243.5 194.6 242.1C196.9 240.7 199.4 238.8 199.4 238.8C199.4 238.8 202.3 236.1 203.2 234.4C204.1 232.7 204.5 231.8 204.5 231.8C204.5 231.8 205.5 229.5 204.8 227.2C204.2 224.9 203 223.6 201.9 223C200.9 222.3 200.4 222.1 200.4 222.1L201 221.2C201 221.2 204.3 222.5 206.7 219.4C206.7 219.4 210.4 216.5 211.1 211.8L212.3 214C212.3 214 214.1 220 222.6 220.6C231.1 221.3 237.5 217.3 237.5 217.3C237.5 217.3 243 214.2 245.4 210.3C245.4 210.3 248.1 206.2 247.7 202.9C247.2 199.6 246 198.3 246 198.3C246 198.3 243.5 195 239.9 194.4L240 193C240 193 246.4 193.2 251 187.5L252 188.8C252 188.8 250 192.1 251.6 196C253.2 199.9 257.7 202 257.7 202C257.7 202 263.2 204.7 269.1 204.7C275 204.7 276 204.1 276 204.1C276 204.1 282.1 203 285.8 199.9C289.6 196.8 290.3 194.1 290.3 194.1C290.3 194.1 292.1 188.6 287.9 185.1L288.9 184.5C288.9 184.5 291.1 186.1 294.1 186.7L299.3 361.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_avant_externe)}
          />
          <path
            id='avant_gauche_arriere_externe'
            d='M315 743.6C296.3 744.4 281.2 739 281.2 739C281.2 739 259.8 731.9 247.6 714.6C235.4 697.3 229.6 682.5 229.6 682.5C229.6 682.5 223.3 668.8 220.3 653.8C217.3 638.8 217.2 635.9 217.2 635.9L212.7 594L211.3 571.2L207.9 531.5L204.1 502L200.2 480L187.3 420.9L196 418.2L215.1 413.2L251.8 406.7L270.2 404.7L286.2 403.7C286.2 403.7 286.2 411.3 289.1 420.6C291.2 427.4 293.2 431.2 295.6 434.9C297.7 438.3 300.2 441.6 302.6 443.8L315 743.6Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_arriere_externe)}
          />
          <path
            id='avant_gauche_arriere_interne'
            d='M315 743.7C319.1 743.5 323.5 743.1 327.9 742.2C352.1 737.3 364.5 726.4 364.5 726.4C364.5 726.4 384.7 711.5 395.9 682.5C407.1 653.5 396.5 603.1 396.5 603.1L387 552.1L383.3 528.6L379.6 496.5L378.5 476L379 455.4L381.8 433.4L387.3 412.3L371 409.1C371 409.1 368.9 422.8 365.2 429.4C362.8 433.7 361.4 438.1 352.2 446.5C344.1 453.9 331.3 457.7 318.7 453.9C311.6 451.7 307.3 448 302.6 443.9L315 743.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_arriere_interne)}
          />
          <g id='mannequin_front_foot_left_quintus'>
            <path
              id='avant_gauche_ongle_quintus'
              d='M160.5 205.9C160.5 205.9 176.2 208.9 191.8 198.1L193.6 196.9C193.6 196.9 192.7 193.3 191.2 190.8C189.7 188.3 186.2 184.6 186.2 184.6C186.2 184.6 185.6 182.2 179.1 179.8C172.6 177.4 166.8 182.2 166.8 182.2C166.8 182.2 163.8 183.7 161.9 189.6C160.2 194.8 159.8 205.7 159.8 205.7L160.5 205.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_quintus)}
            />
            <path
              id='avant_gauche_articulation_quintus_interne'
              d='M191.172 243.587C200.754 239.734 206.651 231.958 204.343 226.219C202.035 220.48 192.396 218.951 182.814 222.804C173.232 226.658 167.335 234.434 169.643 240.173C171.951 245.912 181.59 247.44 191.172 243.587Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_quintus_interne)}
            />
            <path
              id='avant_gauche_phalange_quintus_proximale'
              d='M197.1 217.8L194.8 213L194.1 208.4L193.7 200L193.5 197L189.7 199.5L188 200.5L185.9 201.6L183.7 202.6L181.9 203.3L180.2 203.9L175 205.3L168.8 206.3H163.8L159.1 205.3L158.8 211.8L159.2 219L160.7 223.4L163.9 228.1L166.5 231.3L168.8 237.5L170.6 233.1C170.6 233.1 173.1 229.1 174.5 228.3C174.5 228.3 176.1 226.7 178.2 225.5C180.3 224.3 182.8 223.2 182.8 223.2C182.8 223.2 186.5 221.6 189 221.4C189 221.4 191.6 220.9 193.3 221C193.3 221 193.4 220.7 200.1 221.8L197.1 217.8Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_quintus_proximale)}
            />
          </g>
          <g id='mannequin_front_foot_left_quartus'>
            <path
              id='avant_gauche_ongle_quartus'
              d='M200.5 164.1C200.5 164.1 199.5 159.7 203.5 152.2C207.5 144.6 220.1 142.5 223.1 144.2C228.9 147.5 235 153.7 234.9 162.3C234.9 163.4 216.3 170.8 200.5 164.1Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_quartus)}
            />
            <path
              id='avant_gauche_articulation_quartus_externe'
              d='M218.735 188.898C228.006 187.41 234.926 182.491 234.191 177.911C233.456 173.33 225.345 170.822 216.074 172.309C206.804 173.796 199.884 178.716 200.619 183.296C201.354 187.877 209.465 190.385 218.735 188.898Z'
              stroke='black'
              strokeMiterlimit='10.0002'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_quartus_externe)}
            />
            <path
              id='avant_gauche_articulation_quartus_interne'
              d='M234.223 218.803C243.805 214.949 249.502 206.675 246.947 200.321C244.392 193.967 234.553 191.94 224.97 195.793C215.388 199.647 209.692 207.921 212.247 214.275C214.802 220.629 224.641 222.656 234.223 218.803Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_quartus_interne)}
            />
            <path
              id='avant_gauche_phalange_quartus_proximale'
              d='M211.697 210C211.703 209.942 211.711 209.883 211.718 209.825M211.718 209.825C212.415 204.462 217.518 198.79 224.97 195.793C229.724 193.882 234.541 193.417 238.5 194.211L235 189L234.191 177.911C234.926 182.491 228.006 187.41 218.736 188.898C209.465 190.385 201.354 187.877 200.619 183.296L208.5 201.5L211.718 209.825Z'
              stroke='black'
              strokeMiterlimit='10.0001'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_quartus_proximale)}
            />
            <path
              id='avant_gauche_phalange_quartus_distale'
              d='M235.7 170.3V162.2L233.3 163.3L230.8 164.3L225.1 165.8L220.6 166.5L217.7 166.7L211.4 166.6L206 165.7L202.7 164.7L199.6 163.2L198.9 166.3L199.1 174.1L200 179.1L200.8 182C200.8 182 200.7 180.5 202.5 178.6C204.3 176.7 207.7 174.9 207.7 174.9C207.7 174.9 210.8 173.5 212.5 173.1C212.5 173.1 214.7 172.5 216.1 172.3C216.1 172.3 217.8 172 219.9 171.8C222.1 171.6 225 172 225 172C225 172 227.2 172.2 228.8 172.8C228.8 172.8 230.9 173.5 231.7 174.2C231.7 174.2 234.7 176.2 235.2 179.3L235.7 170.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_quartus_distale)}
            />
          </g>
          <g id='mannequin_front_foot_left_tertius'>
            <path
              id='avant_gauche_ongle_tertius'
              d='M246.2 139.4C246.2 139.4 246.6 135.4 248.9 131.6C250.3 129.3 253.9 127 256.4 124.2C262.6 117.2 273 120.5 277 121.9C282.9 124 286.2 131.7 286.2 140.7C286.2 140.7 263.6 147.3 246.2 139.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_tertius)}
            />
            <path
              id='avant_gauche_articulation_tertius_externe'
              d='M267.915 171.334C278.28 170.104 286.224 165.239 285.658 160.468C285.092 155.697 276.23 152.826 265.865 154.056C255.5 155.285 247.557 160.15 248.123 164.921C248.689 169.692 257.55 172.563 267.915 171.334Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_tertius_externe)}
            />
            <path
              id='avant_gauche_articulation_tertius_interne'
              d='M271.404 204.571C282.431 203.935 291.051 197.877 290.656 191.04C290.262 184.203 281.003 179.177 269.976 179.813C258.949 180.449 250.33 186.507 250.724 193.344C251.118 200.181 260.377 205.207 271.404 204.571Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_tertius_interne)}
            />
            <path
              id='avant_gauche_phalange_tertius_proximale'
              d='M285.658 160.468C286.224 165.24 278.28 170.104 267.915 171.334C257.55 172.563 248.689 169.692 248.123 164.921L252 179V188.46C254.765 183.83 261.691 180.291 269.976 179.813C281 179.5 284.5 182.5 288 185.5L284.5 176.5L285.658 160.468Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_tertius_proximale)}
            />
            <path
              id='avant_gauche_phalange_tertius_distale'
              d='M286.2 140.7L283.3 141.4L278.7 142.3L273 143L269.1 143.2H264.6L258.6 142.7L253.6 141.8L249.3 140.6L246.2 139.3L245.3 140.6L244.6 146.2L244.9 151.1L245.5 157L247.8 163.5L248 164.3C248 164.3 248.3 162.2 249.9 160.5C251.6 158.8 253.6 157.6 254.6 157.2C255.6 156.7 258.7 155.6 258.7 155.6L260.8 155L264.3 154.3L266.9 154L269.5 153.8H271.8L273.4 153.9L275.9 154.2L277.5 154.5L279.3 155L281.2 155.7L283 156.6L284.3 157.6L285.4 159L286.3 147.2L286.2 140.7Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_tertius_distale)}
            />
          </g>
          <g id='mannequin_front_foot_left_secundus'>
            <path
              id='avant_gauche_ongle_secundus'
              d='M298.1 125.6C298.1 125.6 298.6 118.6 305.1 112.4C311.7 106.2 328.8 109.6 333 112.8C334.8 114.1 338.1 116.4 340.3 119.6C342.5 122.8 343.6 127 343.5 131C343.5 131 319.6 134.7 298.1 125.6Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_secundus)}
            />
            <path
              id='avant_gauche_articulation_secundus_externe'
              d='M319.3 167.5C330.235 167.5 339.1 163.068 339.1 157.6C339.1 152.132 330.235 147.7 319.3 147.7C308.365 147.7 299.5 152.132 299.5 157.6C299.5 163.068 308.365 167.5 319.3 167.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_secundus_externe)}
            />
            <path
              id='avant_gauche_articulation_secundus_interne'
              d='M340.044 189.582C340.472 182.747 332.329 176.675 321.856 176.02C311.384 175.364 302.548 180.374 302.12 187.208C301.692 194.043 309.835 200.115 320.307 200.77C330.78 201.426 339.616 196.417 340.044 189.582Z'
              stroke='black'
              strokeMiterlimit='9.9995'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_secundus_interne)}
            />
            <path
              id='avant_gauche_phalange_secundus_proximale'
              d='M339.1 157.6C339.1 163.068 330.235 167.5 319.3 167.5C308.365 167.5 299.5 163.068 299.5 157.6L303.5 174.5L303 183.5C305.5 180 311.384 175.364 321.856 176.02C331.5 176.623 336.5 180.5 340 186.5L338 177.5L339.1 157.6Z'
              stroke='black'
              strokeMiterlimit='9.9995'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_secundus_proximale)}
            />
            <path
              id='avant_gauche_phalange_secundus_distale'
              d='M339.5 131.4L334.9 131.6H329.6L323.8 131.5L318.3 130.9L313.7 130.2L305.7 128.3L298.5 125.7C296.7 134.6 297.7 150.6 297.7 150.6L299.5 157.8C299.5 157.8 299.4 155.3 301.8 153.2C304.2 151.1 307.6 149.5 309.5 149.2C309.5 149.2 312.9 148.3 314.6 148.2C316.3 148 318.7 147.9 320 147.9C321.3 147.9 324.8 148 326.5 148.6C328.2 149.1 329.5 149.1 331.8 150.1C334.1 151.1 335.3 151.9 335.3 151.9C335.3 151.9 336.8 152.7 338 154.4C339.3 156.1 339.9 160.1 339.9 160.1L343.5 146.8L344.5 135.1L343.5 131L339.5 131.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_secundus_distale)}
            />
          </g>
          <g id='mannequin_front_foot_left_hallux'>
            <path
              id='avant_gauche_ongle_hallux'
              d='M355.5 126.3C355.5 126.3 357.7 122.4 360.7 116.2C362.5 112.5 368.5 108 372.3 104.3C382.8 94 395.7 97.7 401.9 100.7C408.1 103.7 423.3 117.3 424.2 129.8C424.3 129.8 385.4 138.5 355.5 126.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_ongle_hallux)}
            />
            <path
              id='avant_gauche_articulation_hallux_interne'
              d='M411.054 211.542C413.683 202.241 402.372 190.902 385.79 186.215C369.209 181.528 353.635 185.269 351.007 194.569C348.378 203.87 359.689 215.209 376.27 219.896C392.852 224.583 408.425 220.843 411.054 211.542Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_hallux_interne)}
            />
            <path
              id='avant_gauche_articulation_hallux_externe'
              d='M391.109 172.069C412.005 170.863 428.576 163.494 428.121 155.61C427.666 147.725 410.358 142.311 389.462 143.517C368.566 144.723 351.995 152.092 352.45 159.976C352.905 167.86 370.213 173.274 391.109 172.069Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_articulation_hallux_externe)}
            />
            <path
              id='avant_gauche_phalange_hallux_proximale'
              d='M385.79 186.215C402.372 190.902 413.683 202.241 411.054 211.542L421.5 188.5L427 170.5L428.121 155.61C428.576 163.494 412.005 170.863 391.109 172.068C370.213 173.274 352.905 167.86 352.45 159.976L356.5 181L356 185L354.5 189.5C359 185 370.877 182 385.79 186.215Z'
              stroke='black'
              strokeMiterlimit='9.9996'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_hallux_proximale)}
            />
            <path
              id='avant_gauche_phalange_hallux_distale'
              d='M428.7 149.9C428.7 149.9 429 138.4 425.1 129.7L419 130.8L410.3 131.9L398.5 132.8H387.9L380.1 132.1L369.2 130.4L361.1 128.3L356.2 126.3C353 134.7 351.8 143.5 351.8 143.5L353 157.7C353 157.7 353 156.1 357.3 152.7C361.6 149.3 372.1 146.4 372.1 146.4C372.1 146.4 376.2 145 382.9 144.4C389.5 143.8 390.9 143.7 392.9 143.7C394.9 143.7 400.2 143.6 401.5 143.9C402.9 144.2 407.7 144.2 412 145.3C416.3 146.4 418.1 146.9 419.9 147.7C421.7 148.5 424.8 149.1 428.6 154.8L428.7 149.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.avant_gauche_phalange_hallux_distale)}
            />
          </g>
          <path
            id='avant_gauche_cheville'
            d='M312.283 725.586C356.556 723.032 389.584 671.349 386.053 610.15C382.522 548.95 343.769 501.409 299.496 503.964C255.222 506.518 222.195 558.201 225.726 619.4C229.257 680.6 268.01 728.141 312.283 725.586Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.avant_gauche_cheville)}
          />
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function BackV2FootLeft({ lesionnel }: BackV2FootLeftProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_back_foot_left_vector'>
        <g id='mannequin_back_foot_left_global_v2'>
          <g id='Silhouette_pied_dessous_gauche'>
            <path
              id='Vector'
              d='M162.8 152.6C162.8 169.6 167 185.6 175.4 200.5C175.9 201.4 176.5 202.4 177 203.3C180.8 209.8 181.2 216.4 178.4 223.4C175.9 229.6 173.3 235.9 171.3 242.3C167.3 255.6 167.3 269.4 167.6 283.1C168 312.1 175.4 339.4 186.4 366C192.7 381.4 199.1 396.8 204.3 412.5C211.7 434.8 213.8 457.9 212.9 481.3C211.8 509.6 207.3 537.4 202 565.1C198.8 582.1 195.8 599.3 193.4 616.4C191.6 629.7 190.4 643.2 191.2 656.7C193.8 700.5 222.4 733.8 262.5 742C286.6 746.9 309.8 743.8 330.2 728.7C342.5 719.6 351 707.3 357.6 693.7C367.5 673.1 373.7 651.4 376.2 628.8C378.3 609.8 378.7 590.6 380.2 571.5C381.5 554.1 382.9 536.7 385 519.3C388.6 489.2 395.6 459.6 402.2 430C408.4 402.4 414.7 374.7 420.2 346.9C424 327.4 427 307.6 425.9 287.6C425.3 275.9 423.8 264.2 422.2 252.6C420.9 243.2 422 234.7 428.3 227.3C431.3 223.7 432.9 219.4 432.9 214.6C433 206 432.4 197.4 428.7 189.4C426.5 184.6 423.4 180.6 417.9 179.6C411.2 178.3 406.3 181.5 402.6 186.8C399 191.8 397.9 197.7 397.6 203.8C397.5 206.6 397.8 209.6 397.1 212.2C396.4 214.8 394.9 217.4 393.2 219.5C391.1 222.1 388.1 222.1 385.4 220C381.9 217.2 380.5 213.3 381.1 209.1C381.7 205 383.1 200.9 384.6 197C385.9 193.4 388 190.1 389.4 186.6C393 177.6 394.2 168.2 391.1 158.8C388.3 150.4 381.8 145.8 373.5 143.7C367.8 142.3 362.3 145.3 359.4 150.8C355.5 158 355.5 165.8 356.1 173.7C356.4 177.3 357.1 181 357.1 184.6C357.1 192.6 351.9 195.5 345 191.4C340.2 188.6 337.9 182.5 339.5 176.3C340.3 173.3 341.4 170.4 342.6 167.6C346.4 158.7 348.2 149.5 346.2 139.9C343.7 127.9 331.5 119 319.9 120.5C314.5 121.2 311.1 124.5 308.7 129.1C306.3 133.7 305.2 138.7 305.3 143.8C305.6 151.7 306.6 159.5 307 167.4C307.2 171.6 307.1 175.9 306.1 180C304.7 185.9 295.1 189 290.3 185.2C288.9 184.1 288 181.7 287.8 179.8C287.2 173.5 289.2 167.5 291.1 161.5C294 152.4 295.6 143.3 294.7 133.8C293.8 124.7 290.5 116.9 282.8 111.5C274.8 106 266.2 106.3 258.6 112.4C251.2 118.4 247.8 126.3 247.3 135.6C246.9 141.7 248.2 147.7 249.9 153.5C252.4 161.8 253.8 170.3 253.2 179.1C253.1 180.3 253 181.4 252.7 182.5C251.3 188.5 245.3 191.6 239.6 189.3C235.8 187.7 234.7 184.3 235 180.7C235.5 174.8 236.5 169 237.6 163.2C239.1 155.1 240.9 146.9 239.3 138.7C235.9 122.3 227.7 108.9 212.9 100.6C204.9 96.1 196.4 96.1 188.6 101.4C172.9 112 164.9 127.2 163.1 145.8C162.6 148.3 162.8 150.5 162.8 152.6Z'
              stroke='black'
              strokeWidth='3'
              strokeMiterlimit='10'
            />
          </g>
        </g>
        <g id='mannequin_back_foot_left_zones'>
          <path
            id='arriere_gauche_talon_externe'
            d='M263.5 742.7C287.7 747.6 310.2 739.7 310.2 739.7C310.2 739.7 331.6 732.6 343.8 715.3C356 698 361.8 683.2 361.8 683.2C361.8 683.2 368.1 669.5 371.1 654.5C374.1 639.5 374.2 636.6 374.2 636.6C346.9 613.9 317.9 602.7 291.3 597.9L263.5 742.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_talon_externe)}
          />
          <path
            id='arriere_gauche_talon_interne'
            d='M263.4 742.7C239.2 737.8 226.8 726.9 226.8 726.9C226.8 726.9 206.6 712 195.4 683C184.2 654 194.8 603.6 194.8 603.6C194.8 603.6 238.1 588.1 291.1 597.8L263.4 742.7Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_talon_interne)}
          />
          <path
            id='arriere_gauche_medio_interne'
            d='M299.3 323.8C299.3 323.8 326.2 406.9 291.8 597.5C291.8 597.5 264.5 593.3 247.8 594.5C231.1 595.8 218.4 596.8 195.4 603.3L204.6 549.7L209.4 518.9L210.8 506.7L212.5 484.7L212.8 465.7L211.3 445.3L208.9 430.6L206.7 421.3L201 403.8L191.8 379.9L180.4 351.2L175.5 336L174.4 331.9C174.4 331.9 199.8 327 224.9 326.4C225.1 326.4 278.7 323.9 299.3 323.8Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_medio_interne)}
          />
          <path
            id='arriere_gauche_medio_externe'
            d='M421.3 340.3C421.3 340.3 372.8 325.5 314.6 323.9L299.3 323.7L300.9 329.5L303.1 340.2L304.7 349.9L306 359.5L306.8 366.6L307.4 373.5L308.1 383.3L308.6 393.1L309 403.1L309.2 413.6L309.3 425.6L309.1 438L308.8 447.4L308.5 455.7L308 465.8L307.4 476L306.7 485.4L305.8 495.6L305 504.1L304 514L303.1 522.3L301.7 532.1L300 545.2L298.2 557.9L296.5 569L294.8 579.5L293.7 586.3L292.5 593.1L291.7 597.4L296.8 598.5L306.4 600.8L317.1 604C317.1 604 331.8 609.1 338.1 612.6C344.4 616.1 348.1 617.4 355.1 622C362.1 626.6 355.9 621.8 375 636.3L377.6 609.6L379.9 571.6L382.4 541.2L384.5 520.7L387.9 497.3L391.5 477.9L396.7 453.5L400.9 434.7L405.4 414.7L410.2 393.3L414.5 373.7L419 352.1L421.3 340.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_medio_externe)}
          />
          <path
            id='arriere_gauche_plante_rond'
            d='M227.2 326.3C256.471 326.3 280.2 305.526 280.2 279.9C280.2 254.274 256.471 233.5 227.2 233.5C197.929 233.5 174.2 254.274 174.2 279.9C174.2 305.526 197.929 326.3 227.2 326.3Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_plante_rond)}
          />
          <path
            id='arriere_gauche_plante_externe'
            d='M299.3 324H305.2H312.8L322.2 324.2L330.6 324.6L338.3 325.2L347.8 326.1L355.1 327L363.2 328.1L372.2 329.5L384.5 331.7L396.1 334.1L408.9 337.1L416.4 339L421.3 340.4L422.8 333L425.9 310.4V296L425.5 284.5L424 268.3L422.2 254.6L421.7 242.2L419.2 243.7L417.4 244.7C417.4 244.7 414.7 246.1 410.7 246.1C406.7 246.1 403.3 245.1 403.3 245.1C403.3 245.1 399.3 243.9 397 242.5C394.7 241.1 392.2 239.2 392.2 239.2C392.2 239.2 389.3 236.5 388.4 234.8C387.5 233.1 387.1 232.2 387.1 232.2C387.1 232.2 386.1 229.9 386.8 227.6C387.4 225.3 388.6 224 389.7 223.4C390.7 222.7 391.2 222.5 391.2 222.5L390.6 221.6C390.6 221.6 387.3 222.9 384.9 219.8C384.9 219.8 381.2 216.9 380.5 212.2L379.3 214.4C379.3 214.4 377.5 220.4 369 221C360.5 221.7 354.1 217.7 354.1 217.7C354.1 217.7 348.6 214.6 346.2 210.7C346.2 210.7 343.5 206.6 343.9 203.3C344.4 200 345.6 198.7 345.6 198.7C345.6 198.7 348.1 195.4 351.7 194.8L351.6 193.4C351.6 193.4 345.2 193.6 340.6 187.9L339.6 189.2C339.6 189.2 341.6 192.5 340 196.4C338.4 200.3 333.9 202.4 333.9 202.4C333.9 202.4 328.4 205.1 322.5 205.1C316.6 205 315.6 204.5 315.6 204.5C315.6 204.5 309.5 203.4 305.8 200.3C302 197.2 301.3 194.5 301.3 194.5C301.3 194.5 299.5 189 303.7 185.5L302.7 184.9C302.7 184.9 300.3 186.7 297.1 187.1L299.3 324Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_plante_externe)}
          />
          <path
            id='arriere_gauche_plante_interne'
            d='M299.4 324H290.2L285 323.8L276.5 324L243.9 325.4L237.5 325.7L239.5 325.1C247 324 257 318.3 257 318.3C257 318.3 262.4 314.6 264.2 313.1C266 311.6 270.3 307.5 273.5 302.5C276.7 297.5 277.4 294.8 278.6 291.1C279.8 287.4 280.2 280.5 280.2 280.5C280.2 280.5 280.5 274.8 278.6 268.6C276.7 262.4 276.5 263 273.2 256.9C269.9 250.8 261.5 244.6 261.5 244.6C261.5 244.6 252 237.5 241.8 235.4C231.6 233.3 230.1 233.5 222 233.9C213.9 234.2 204.9 238 204.9 238C204.9 238 199 240.4 193.8 244.1C188.6 247.8 185.8 250.7 182.6 255.1C179.4 259.5 179.4 260.1 177.9 263.2C176.4 266.3 175.8 269.6 175.1 272C174.4 274.4 174.3 279.1 174.3 281.7C174.3 284.3 175.3 290.1 176.8 294.2C178.4 298.3 178.8 298.8 181.5 303.5C184.2 308.1 190 312.8 191.5 314.3C193 315.7 196.2 317.6 199.8 319.7C203.4 321.8 209.5 323.7 212.2 324.5C214.9 325.3 221.1 326.4 221.1 326.4L198.3 328.5L187.4 329.9L175.8 331.8L174.3 331L172.4 323.8L170.6 313.5L168.2 294.4L167.7 268.9L168.9 252L173.6 235.8L179.6 219.9L180.4 211.8C183 220.4 195.1 221.7 195.1 221.7C201.7 223.1 211.5 221 211.5 221C211.5 221 218.1 219.7 224.8 216.3C231.6 213 234.9 209.1 234.9 209.1C234.9 209.1 239.1 204.9 240.1 200.9C241.1 196.9 240.4 195.5 239.9 193.8C239.4 192.1 237.8 190 237.8 190L237.5 188.8C245.3 193.2 251.8 186.3 251.8 186.3C249.3 193.6 256.6 197.7 256.6 197.7C256.6 197.7 260.2 199.9 265.2 200.8C270.2 201.6 274.9 200.5 274.9 200.5C274.9 200.5 282.9 198.8 286.4 194.5C289.9 190.2 289.2 187.4 289.2 187.4L289.1 184.8C291.8 187 294.6 187.4 296.9 187L299.4 324Z'
            stroke='black'
            strokeMiterlimit='10'
            fill={syoUtils.colorFiller(lesionnel.arriere_gauche_plante_interne)}
          />
          <g id='mannequin_back_foot_left_hallux'>
            <path
              id='arriere_gauche_articulation_hallux_externe'
              d='M238.894 160.251C239.349 152.366 222.778 144.998 201.882 143.792C180.986 142.586 163.677 148 163.223 155.885C162.768 163.769 179.338 171.138 200.235 172.343C221.131 173.549 238.439 168.135 238.894 160.251Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_hallux_externe)}
            />
            <path
              id='arriere_gauche_articulation_hallux_interne'
              d='M215.052 220.148C231.633 215.462 242.944 204.122 240.315 194.822C237.686 185.521 222.113 181.781 205.532 186.468C188.95 191.155 177.639 202.494 180.268 211.795C182.897 221.095 198.47 224.835 215.052 220.148Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_hallux_interne)}
            />
            <path
              id='arriere_gauche_phalange_hallux_distale'
              d='M162.7 150C162.7 150 162.4 138.5 166.3 129.8C170.3 121 169.5 121.1 175.9 112.8C182.3 104.5 188.3 101.7 188.3 101.7C188.3 101.7 197.7 94.2 209.8 99.5C221.9 104.8 227.5 113.3 227.5 113.3C227.5 113.3 232.8 119.8 236 128.2C239.2 136.6 239.7 143.5 239.7 143.5L238.5 157.7C238.5 157.7 238.5 156.1 234.2 152.7C229.9 149.3 219.4 146.4 219.4 146.4C219.4 146.4 215.3 145 208.6 144.4C202 143.8 200.6 143.7 198.6 143.7C196.6 143.7 191.3 143.6 190 143.9C188.7 144.2 183.8 144.2 179.5 145.3C175.2 146.4 173.4 146.9 171.6 147.7C169.8 148.5 166.7 149.1 162.9 154.8L162.7 150Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_hallux_distale)}
            />
            <path
              id='arriere_gauche_phalange_hallux_proximale'
              d='M167.1 181.5C167.1 181.5 175 201.7 179 207.6L179.6 208.3C179.6 208.3 180.4 203.7 183.2 200.5C186 197.3 187 196.3 187 196.3L191.3 193L196.9 189.8L202.5 187.5L206.6 186.2L210.7 185.3L215.2 184.7L219.9 184.5L223.8 184.7L227.4 185.3L231 186.3L234.6 187.9L236.8 189.4L237.6 188.9L235 184.8L234.8 177.3L237.6 164.3L235.1 166.1C235.1 166.1 228.5 171.4 213 172.3C197.5 173.2 188.2 170.9 188.2 170.9C188.2 170.9 181 169.8 173.9 166.7C166.8 163.5 163 158.8 163 158.8L164.4 170.3L167.1 181.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_hallux_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_left_quintus'>
            <path
              id='arriere_gauche_articulation_quintus_interne'
              d='M421.628 240.518C423.936 234.779 418.039 227.002 408.457 223.149C398.875 219.296 389.236 220.825 386.928 226.564C384.62 232.303 390.517 240.079 400.099 243.932C409.681 247.785 419.32 246.257 421.628 240.518Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_quintus_interne)}
            />
            <path
              id='arriere_gauche_phalange_quintus_distale'
              d='M394.3 217.9L396.6 213.1L397.3 208.5L397.7 200.1L399.3 193L402.5 186.9L406.6 182.6L411.1 180.2L415.6 179.7L420.9 181L424.7 183.8L428.1 188.8L429.9 192.9L431.6 198.9L432.5 205.4L432.8 211.9L432.4 219.1L430.9 223.5L427.7 228.2L425.1 231.4L422.8 237.6L421 233.2C421 233.2 418.5 229.2 417.1 228.4C417.1 228.4 415.5 226.8 413.4 225.6C411.3 224.4 408.8 223.3 408.8 223.3C408.8 223.3 405.1 221.7 402.6 221.5C402.6 221.5 400 221 398.3 221.1C398.3 221.1 398.2 220.8 391.5 221.9L394.3 217.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_quintus_distale)}
            />
          </g>
          <g id='mannequin_back_foot_left_quartus'>
            <path
              id='arriere_gauche_articulation_quartus_externe'
              d='M390.775 183.573C391.51 178.992 384.591 174.073 375.32 172.586C366.049 171.099 357.938 173.607 357.204 178.187C356.469 182.768 363.388 187.687 372.659 189.174C381.929 190.661 390.04 188.154 390.775 183.573Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_quartus_externe)}
            />
            <path
              id='arriere_gauche_articulation_quartus_interne'
              d='M379.099 214.531C381.654 208.177 375.958 199.902 366.376 196.049C356.794 192.196 346.954 194.223 344.399 200.577C341.844 206.931 347.541 215.205 357.123 219.058C366.705 222.912 376.544 220.885 379.099 214.531Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_quartus_interne)}
            />
            <path
              id='arriere_gauche_phalange_quartus_distale'
              d='M355.6 170.4V163.2L357.2 155.6L359.2 150.9L362.7 146.5L367.6 144L372.8 143.7L378.5 145.8L383.9 148.8L388.2 153.4L391.2 160.4L392.6 166.6L392.4 174.4L391.5 179.4L390.7 182.3C390.7 182.3 390.8 180.8 389 178.9C387.2 176.9 383.8 175.2 383.8 175.2C383.8 175.2 380.7 173.8 379 173.4C379 173.4 376.8 172.8 375.4 172.6C375.4 172.6 373.7 172.3 371.6 172.1C369.4 171.9 366.5 172.3 366.5 172.3C366.5 172.3 364.3 172.5 362.7 173.1C362.7 173.1 360.6 173.8 359.8 174.5C359.8 174.5 356.8 176.5 356.3 179.6L355.6 170.4Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_quartus_distale)}
            />
            <path
              id='arriere_gauche_phalange_quartus_proximale'
              d='M356.9 183.5V186.5L356.3 189.3L354.3 192.2L352.4 193.6L353 194.3L356.5 194.1C356.5 194.1 361.1 194 365 195.5C368.9 197 370.6 198.1 370.6 198.1C370.6 198.1 374.9 200.6 376.5 203.1C376.5 203.1 379.1 206.6 379.5 208.6L380.4 210.5L382.1 204.7L385.7 193.8L389.3 187.1L387.5 187.7C387.5 187.7 384.2 189.3 380.9 189.5C377.6 189.6 374.9 189.6 370.9 188.8C366.9 188 363.9 186.4 363.9 186.4C363.9 186.4 360.7 184.9 358.9 182.7C357.1 180.5 356.8 180.6 356.8 180.6L356.9 183.5Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_quartus_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_left_tertius'>
            <path
              id='arriere_gauche_articulation_tertius_externe'
              d='M343.227 165.227C343.793 160.456 335.85 155.591 325.484 154.361C315.119 153.132 306.258 156.003 305.692 160.774C305.126 165.545 313.07 170.41 323.435 171.64C333.8 172.869 342.661 169.998 343.227 165.227Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_tertius_externe)}
            />
            <path
              id='arriere_gauche_articulation_tertius_interne'
              d='M340.59 193.677C340.984 186.84 332.365 180.782 321.338 180.146C310.311 179.51 301.052 184.536 300.658 191.373C300.263 198.209 308.882 204.267 319.909 204.904C330.936 205.54 340.195 200.513 340.59 193.677Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_tertius_interne)}
            />
            <path
              id='arriere_gauche_phalange_tertius_distale'
              d='M305.2 138L308.2 129.8L312.5 123.4L318 121L323.3 120.6L329.3 121.8L335.3 124.8L338.9 127.7L342.3 131.8L344.6 136.2L345.9 140.7L346.6 146.3L346.3 151.2L345.7 157.1L343.4 163.6L343.2 164.4C343.2 164.4 342.9 162.3 341.3 160.6C339.6 158.9 337.6 157.7 336.6 157.3C335.6 156.9 332.5 155.7 332.5 155.7L330.4 155.1L326.9 154.4L324.3 154.1L321.7 153.9H319.4L317.8 154L315.3 154.3L313.7 154.6L311.9 155.1L310 155.8L308.2 156.7L306.9 157.7L305.8 159.1L304.9 147.3V138H305.2Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_tertius_distale)}
            />
            <path
              id='arriere_gauche_phalange_tertius_proximale'
              d='M306.8 170.3L306.6 175.6L305.6 181.1L304.2 184.2L307.3 182.7C307.3 182.7 313.2 179.8 318.1 180C323 180.2 323.7 180.3 323.7 180.3C323.7 180.3 328.1 180.8 331.7 182.5C335.3 184.2 336.9 185.9 336.9 185.9C336.9 185.9 338.6 187.4 339.1 188.5L340.4 187.1L338.7 182.3L338.8 176.8L341.7 169.2L340.2 169.1C340.2 169.1 337.4 170.9 333.8 171.4C330.2 171.8 327.9 172.1 324.8 171.7C321.7 171.3 318.6 170.8 315.7 169.9C312.8 169 310.4 167.9 308.8 166.4C307.2 164.9 306.1 163.8 306.1 163.8L306.8 170.3Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_tertius_proximale)}
            />
          </g>
          <g id='mannequin_back_foot_left_secundus'>
            <path
              id='arriere_gauche_articulation_secundus_externe'
              d='M272 167.8C282.935 167.8 291.8 163.368 291.8 157.9C291.8 152.432 282.935 148 272 148C261.065 148 252.2 152.432 252.2 157.9C252.2 163.368 261.065 167.8 272 167.8Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_secundus_externe)}
            />
            <path
              id='arriere_gauche_articulation_secundus_interne'
              d='M270.959 200.967C281.432 200.312 289.575 194.24 289.147 187.405C288.719 180.571 279.883 175.561 269.41 176.217C258.938 176.872 250.795 182.944 251.223 189.779C251.651 196.613 260.487 201.623 270.959 200.967Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_articulation_secundus_interne)}
            />
            <path
              id='arriere_gauche_phalange_secundus_distale'
              d='M254.9 115.9C254.9 115.9 259.5 110.2 264.5 109C269.5 107.8 276.2 106.2 281.9 111.3C287.7 116.4 291.8 119.9 293.6 128.9C295.4 137.8 293.6 150.7 293.6 150.7L291.8 157.9C291.8 157.9 291.9 155.4 289.5 153.3C287.1 151.2 283.7 149.6 281.8 149.3C281.8 149.3 278.4 148.4 276.7 148.3C275 148.1 272.6 148 271.3 148C270 148 266.5 148.1 264.8 148.7C263.1 149.2 261.8 149.2 259.5 150.2C257.2 151.2 256 152 256 152C256 152 254.5 152.8 253.3 154.5C252 156.2 251.4 160.2 251.4 160.2L247.8 146.9L246.8 135.2L249.2 125.1L254.9 115.9Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_secundus_distale)}
            />
            <path
              id='arriere_gauche_phalange_secondus_proximale'
              d='M251.5 161.2L252.8 170V180.3L252.5 184L255.7 181.1C255.7 181.1 260.7 177.3 265.4 176.8C270.1 176.2 270.6 176.2 270.6 176.2C270.6 176.2 275.2 176.1 278.2 177.1C281.2 178.1 283.6 178.7 288.3 183.1L287.1 175.5L288.5 168.5L290.6 162.3L288.9 162.9L286.2 164.7C286.2 164.7 282 167 277.3 167.4C272.6 167.8 271.3 168 267.2 167.5C263.1 167 258.8 165.3 258.8 165.3C258.8 165.3 255.9 164.3 253.4 161.5C251.1 158.8 251.5 161.2 251.5 161.2Z'
              stroke='black'
              strokeMiterlimit='10'
              fill={syoUtils.colorFiller(lesionnel.arriere_gauche_phalange_secondus_proximale)}
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2Head({ lesionnel }: FrontV2HeadProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_head'>
        <g id='mannequin_front_head_zones'>
          <path
            id='avant_front_milieu'
            fill={syoUtils.colorFiller(lesionnel.avant_front_milieu)}
            d='M306.3 151H233.9V65.2L244.1 63.3L257.5 61.2L270.1 60.5H283.6L293.8 61.4L306.3 63.3V151Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_front_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_front_gauche)}
            d='M396.7 151H306.3V63.2998L322.4 67.6998L336.9 73.7998L347.8 80.0998L359.8 89.3998L364.8 94.2998L368.6 98.2998L373.2 103.9L378.3 111.1L386.2 123.9L392.6 139.2L396.7 151Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_front_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_front_droit)}
            d='M233.9 151H146.2L153.2 134.3L161 119.4L165.2 113.2L169.6 106.7L174.7 100.6L180.1 94.9002L189.7 86.5002L201.6 78.4002L212.4 72.7002L224.9 67.8002L233.9 65.2002V151Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_entre_sourcils'
            fill={syoUtils.colorFiller(lesionnel.avant_entre_sourcils)}
            d='M295.7 151H244.1V200.5H295.7V151Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_arcade_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_arcade_gauche)}
            d='M405.6 200.5H295.7V151H396.7L398.6 158.9L401.2 168.8L403.7 183.3L405.6 200.5Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_arcade_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_arcade_droit)}
            d='M244.1 200.5H136.6L138.5 185.2L140.2 175.7L141.9 167.7L144.2 158.9L146.2 151H244.1V200.5Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_orbite_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_orbite_droit)}
            d='M244.1 260.6L137.5 260.4L136.4 253.9L135.8 246.4L135.3 238.7L136 204.4L136.3 200.5H244.1V260.6Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_orbite_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_orbite_gauche)}
            d='M404.4 260.4L295.7 260.6V200.5H406.5V236.8L406.1 247L405.3 253.8L404.4 260.4Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_zone_nez'
            fill={syoUtils.colorFiller(lesionnel.avant_zone_nez)}
            d='M306.3 260.4H233.9V322.6H306.3V260.4Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_pommette_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_pommette_gauche)}
            d='M393.3 322.8L306.3 322.5V260.4H403.9L401.7 274.1L399.8 284.6L398.3 293.1L396.9 300.8L396 306.4L394.6 314L393.3 322.8Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_pommette_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_pommette_droit)}
            d='M233.9 322.5L147.2 321.8L146.2 315.1L145.1 308.1L142.6 291.5L140.4 277.9L138 260.4H233.9V322.5Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_joue_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_joue_gauche)}
            d='M374.6 396.7L372.2 401.3L367.7 408.1L360.8 416.2L313.4 415.9V322.8H393.3L391 339.4L388 358.3L383.7 375.3L381.6 381.8L379.2 387.4L376.6 393.5L374.6 396.7Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_joue_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_joue_droit)}
            d='M225.9 416L182.1 416.3L175.1 408.6L171 403.2L168.2 399L165.6 395.3L162.6 390.1L160.4 384.3L157.2 375.8L154.1 365.3L151.6 352.8L149.1 336.4L147.2 321.8L225.9 322.5V416Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_menton'
            fill={syoUtils.colorFiller(lesionnel.avant_menton)}
            d='M332.4 435.7L328.8 437.1L323.8 439.6L315 442.4L295.3 446.6L272.2 448.7L243.5 446.3L220.7 440.5L212.2 437.2L205.1 434.1L199.3 431.1L194.7 427.5L190.1 424.6L186.7 420.9L182.6 416.2H360.8L356.7 420.3L348.4 426.8L342.4 430.5L337.6 433.1L332.4 435.7Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_entre_yeux'
            fill={syoUtils.colorFiller(lesionnel.avant_entre_yeux)}
            d='M295.7 200.5H244.1V260.4H295.7V200.5Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <path
            id='avant_cou_milieu'
            fill={syoUtils.colorFiller(lesionnel.avant_cou_milieu)}
            d='M305.1 493.5H235.2V444.4L252.4 447L269.2 447.4L281.7 446.8L293.9 445.5L305.1 443.5V493.5Z'
            stroke='black'
          />
          <path
            id='avant_cou_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_cou_droit)}
            d='M235.2 493.5L181.4 493.7L182.4 482.6L183.3 469.5L184.1 455.7L186 421.1L190.1 424.6L197.1 429.9L206.7 434.9L213.4 437.8L220.7 440.5L226.6 442.3L235.2 444.4V493.5Z'
            stroke='black'
          />
          <path
            id='avant_cou_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_cou_gauche)}
            d='M362.4 493.6H305.1V443.7L309.9 442.6L317.3 441.1L324.8 438.7L333.2 435.4L341 431.3L346.6 428.1L352 424.1L356.7 420.3L360.2 416.4L360.7 442.2L360.8 456.8L360.9 474.2L361.2 487.7L362.4 493.6Z'
            stroke='black'
          />
          <path
            id='avant_oreille_gauche'
            fill={syoUtils.colorFiller(lesionnel.avant_oreille_gauche)}
            d='M404.7 257.1C404.7 257.1 429.9 245.2 428.2 274.6C428.2 274.6 428.7 300.5 425.8 316.3C422.9 331.9 401.9 361.4 391 334.3L404.7 257.1Z'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='avant_oreille_droit'
            fill={syoUtils.colorFiller(lesionnel.avant_oreille_droit)}
            d='M137.2 257.2C137.2 257.2 110.3 245.2 112 274.6C112 274.6 111.5 300.5 114.4 316.3C117.3 332.1 138.3 361.4 149.2 334.3L137.2 257.2Z'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='avant_zone_bouche'
            fill={syoUtils.colorFiller(lesionnel.avant_zone_bouche)}
            d='M313.4 322.5H225.9V416.3H313.4V322.5Z'
            stroke='black'
            strokeMiterlimit='10'
          />
          <g id='mannequin_front_head_mouth_details'>
            <path
              id='bouche_langue'
              fill={syoUtils.colorFiller(lesionnel.bouche_langue)}
              d='M240.631 381.1C240.631 381.1 241.576 376.374 248.451 374.768C255.35 373.161 256.271 373.256 260.146 373.445C264.021 373.634 269.762 374.862 269.762 374.862C269.762 374.862 274.298 373.35 277.582 373.35C277.582 373.35 281.646 372.925 284.741 373.35C287.859 373.775 291.002 373.728 294.498 376.303C297.995 378.879 298.397 381.808 298.397 381.808L296.318 386.557C296.318 386.557 295.278 386.864 294.12 387.762C294.12 387.762 293.553 388.424 293.577 389.085C293.577 389.085 291.663 390.03 291.427 392.7C291.427 392.7 286.418 392.724 287.127 395.913C287.127 395.913 284.15 394.236 283.252 397.165C283.252 397.165 278.433 395.913 277.653 398.701C277.653 398.701 277.393 397.756 276.046 397.85C274.7 397.945 270.754 398.134 270.754 398.134C270.754 398.134 269.903 398.158 269.927 399.741C269.927 399.741 270.116 398.299 268.982 398.252C267.848 398.229 263.17 397.969 263.17 397.969C263.17 397.969 262.249 397.898 262.036 398.796C262.036 398.796 262.06 397.851 260.737 397.567C259.413 397.283 258.634 397.165 258.634 397.165C258.634 397.165 256.933 396.905 256.271 397.52C256.271 397.52 256.248 396.315 254.735 395.701C254.735 395.701 253.578 395.204 252.373 396.244C252.373 396.244 253.247 392.889 248.356 393.291C248.356 393.291 247.411 390.503 246.584 390.243C246.584 390.243 246.112 389.747 245.805 389.085C245.498 388.424 244.033 387.408 244.033 387.408L243.159 387.101L240.631 381.1Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='bouche_palais'
              fill={syoUtils.colorFiller(lesionnel.bouche_palais)}
              d='M238.41 365.86C238.41 365.86 237.796 371.058 238.646 374.389C239.497 377.744 240.631 381.099 240.631 381.099C240.631 381.099 241.316 378.311 243.891 376.752C246.466 375.193 248.049 374.885 248.049 374.885L252.68 373.869C252.68 373.869 256.177 373.208 257.712 373.373L260.17 373.468L263.052 373.728L265.698 374.106L269.809 374.862L272.195 374.177L273.991 373.775L275.716 373.491L277.346 373.35L279.85 373.161L282.567 373.184L284.646 373.326L286.489 373.539L288.426 373.799L290.647 374.318C290.647 374.318 294.026 375.287 296.058 377.602C298.09 379.894 298.491 381.832 298.491 381.832C298.491 381.832 300.074 378.595 300.83 373.846C301.586 369.097 300.83 365.033 300.83 365.033C300.83 365.033 299.294 364.395 298.633 362.836C297.971 361.253 297.806 361.395 297.806 361.395C297.806 361.395 296.696 360.544 296.507 358.134C296.507 358.134 291.64 358.607 291.073 354.874C291.073 354.874 290.198 355.583 287.954 355.37C287.954 355.37 286.631 355.016 286.229 353.575C286.229 353.575 285.78 354.26 283.937 353.976L281.244 353.456C281.244 353.456 279.968 353.338 279.897 352.204C279.897 352.204 279.827 353.22 277.984 353.102C276.141 352.984 272.077 353.031 272.077 353.031L270.471 352.984C270.471 352.984 269.573 353.291 269.644 351.448C269.644 351.448 269.88 353.149 268.25 353.078L260.642 353.291C260.642 353.291 259.555 353.456 259.083 352.441C259.083 352.441 259.106 353.386 257.831 353.645L254.948 354.236C254.948 354.236 253.649 354.638 252.893 353.905C252.893 353.905 251.451 357.402 247.978 355.347C247.978 355.347 248.191 359.221 242.828 358.796C242.828 358.796 242.615 361.088 241.41 362.245C241.41 362.245 240.772 362.907 240.82 363.568C240.843 364.206 238.41 365.86 238.41 365.86Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='bouche_dents_bas'
              fill={syoUtils.colorFiller(lesionnel.bouche_dents_bas)}
              d='M267.092 402.623C267.092 402.623 271.392 403.284 276.094 402.15C280.795 401.016 281.622 400.26 281.622 400.26C281.622 400.26 285.591 398.37 287.623 396.905C289.655 395.441 292.49 392.511 292.49 392.511L295.798 387.88L296.389 386.557C296.389 386.557 293.79 387.242 293.648 389.062C293.648 389.062 291.687 389.841 291.498 392.676C291.498 392.676 286.489 392.653 287.198 395.889C287.198 395.889 284.221 394.212 283.323 397.142C283.323 397.142 278.527 395.842 277.724 398.677C277.724 398.677 277.417 397.756 276.117 397.827C274.818 397.898 271.203 398.087 271.203 398.087C271.203 398.087 269.951 397.921 270.022 399.717C270.022 399.717 270.282 398.205 268.935 398.228L264.281 398.016C264.281 398.016 262.414 397.496 262.131 398.772C262.131 398.772 262.201 397.85 261.115 397.614C260.028 397.378 258.256 397.094 258.256 397.094C258.256 397.094 257.075 396.882 256.389 397.496C256.389 397.496 255.515 394.165 252.491 396.197C252.491 396.197 252.775 394.944 252.019 394.118C251.263 393.291 249.916 393.22 249.916 393.22H248.475L247.789 391.566C247.789 391.566 247.222 390.266 246.703 390.172L246.112 389.369C246.112 389.369 245.876 388.802 245.427 388.4C244.978 387.998 244.151 387.337 244.151 387.337L243.277 387.03C243.277 387.03 244.482 389.321 246.088 391.235C247.695 393.149 250.199 395.441 250.199 395.441C250.199 395.441 254.547 398.465 255.373 398.89C256.2 399.339 259.154 400.922 260.689 401.371C262.225 401.82 262.91 402.009 262.91 402.009L267.092 402.623Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='bouche_levres_inferieures'
              fill={syoUtils.colorFiller(lesionnel.bouche_levres_inferieures)}
              d='M236.685 377.673C238.764 385.824 240.678 394.968 246.065 401.701C249.325 405.789 252.538 408.317 252.538 408.317C252.538 408.317 258.327 412.664 264.729 413.278C271.132 413.916 274.912 413.278 274.912 413.278C279.59 412.498 284.268 410.561 287.93 407.561C294.428 402.221 298.161 395.204 300.192 387.171C301.303 382.753 302.201 378.264 303.146 373.799V373.775L303.406 371.271H301.043C301.043 371.271 300.783 376.988 298.42 381.832L296.176 386.935C296.176 386.935 293.719 391.967 289.301 395.535C284.883 399.102 279.449 401.205 279.449 401.205C279.449 401.205 275.739 403.048 267.872 402.812C260.004 402.575 255.799 399.22 255.799 399.22L252.704 397.26C252.704 397.26 249.231 395.11 246.774 392.133C244.316 389.156 243.23 387.077 243.23 387.077L241.221 382.493L239.237 376.657L238.41 373.397L238.174 371.247H236C236.024 371.247 235.953 374.767 236.685 377.673Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='bouche_dents_haut'
              fill={syoUtils.colorFiller(lesionnel.bouche_dents_haut)}
              d='M298.066 354.236C298.113 354.355 298.161 354.425 298.161 354.425L299.247 357.568L299.838 359.434L300.358 362.553L300.759 365.01C300.759 365.01 299.2 364.608 298.161 361.891L297.759 361.372C297.759 361.372 296.932 361.395 296.459 358.111C296.459 358.111 291.427 358.442 291.025 354.851C291.025 354.851 287.222 356.812 286.206 353.551C286.206 353.551 285.733 354.142 284.646 354.024C283.56 353.929 281.528 353.551 281.528 353.551C281.528 353.551 280.205 353.622 279.898 352.181C279.898 352.181 279.756 352.937 278.716 353.055C277.7 353.173 275.952 353.008 275.952 353.008L271.132 352.984L270.164 352.961C270.164 352.961 269.644 352.937 269.644 351.425C269.644 351.425 269.738 352.748 268.864 352.961C268.014 353.173 264.281 353.15 264.281 353.15L260.642 353.244C260.642 353.244 259.555 353.386 259.083 352.394C259.083 352.394 259.059 353.031 258.421 353.386L254.925 354.189C254.925 354.189 253.483 354.591 252.869 353.858C252.869 353.858 252.279 355.087 251.357 355.583C251.357 355.583 249.845 356.505 247.955 355.3C247.955 355.3 247.979 357.119 246.585 357.993C245.191 358.867 243.962 358.773 243.962 358.773L242.804 358.749L242.379 360.521L241.977 361.419C241.977 361.419 240.914 362.647 240.867 363.073C240.796 363.498 240.843 363.71 240.56 364.018C240.276 364.325 238.315 365.86 238.315 365.86L238.599 363.143C238.599 363.143 239.26 359.93 239.828 358.276C240.158 357.331 240.56 356.174 240.985 355.134H241.127C241.127 355.134 241.623 355.016 241.741 355.252C241.741 355.252 242.048 352.866 243.844 352.134C245.64 351.401 246.774 351.685 246.774 351.685C246.774 351.685 246.986 350.055 248.073 349.44C249.16 348.802 249.845 348.519 250.861 348.472C251.877 348.401 252.16 349.015 252.16 349.015C252.16 349.015 252.066 346.96 253.956 346.251C255.846 345.518 256.933 345.944 256.933 345.944C256.933 345.944 258.327 346.062 258.847 346.889C258.847 346.889 258.988 344.384 261.209 343.628C263.43 342.872 265.604 343.108 265.604 343.108C265.604 343.108 268.888 342.565 269.573 344.621C269.573 344.621 270.353 343.368 272.361 343.179C274.369 342.99 275.81 343.179 275.81 343.179C275.81 343.179 278.669 343.439 279.26 344.432C279.85 345.424 279.968 346.085 280.063 346.771C280.063 346.771 281.717 345.329 283.512 345.589C285.308 345.849 286.158 346.7 286.158 346.7C286.158 346.7 286.82 347.361 286.867 348.661C286.867 348.661 287.789 347.55 289.183 348.023C290.577 348.495 291.64 349.44 291.64 349.44C291.64 349.44 292.254 350.078 291.971 351.165C291.971 351.165 297.05 350.244 297.168 354.473C297.168 354.473 297.995 354.213 298.231 354.425'
              stroke='black'
              strokeMiterlimit='10'
            />
            <path
              id='bouche_levres_superieures'
              fill={syoUtils.colorFiller(lesionnel.bouche_levres_superieures)}
              d='M238.835 349.866C238.835 349.866 242.285 342.376 244.695 339.399C247.104 336.422 250.507 333.587 250.507 333.587C250.507 333.587 254.523 330.563 257.476 329.76C260.453 328.956 262.485 329.004 262.485 329.004C262.485 329.004 266.407 329.193 269.053 329.901C269.053 329.901 272.219 329.051 275.338 329.004C278.456 328.956 279.921 329.382 279.921 329.382C279.921 329.382 285.355 330.232 289.915 334.674C294.475 339.116 296.719 342.447 296.719 342.447C296.719 342.447 300.783 349.346 302.012 355.56C303.24 361.797 303.5 369.57 303.5 369.57V371.247H301.138C301.138 371.247 301.256 367.325 300.854 365.01C300.452 362.695 300.83 362.198 299.673 358.607C298.515 355.016 298.515 355.016 298.515 355.016C298.515 355.016 295.94 348.897 292.372 346.416C288.805 343.912 287.222 342.943 287.222 342.943C287.222 342.943 284.765 341.431 281.575 340.58C278.386 339.73 275.763 339.328 275.763 339.328C275.763 339.328 271.392 338.572 267.423 338.809C263.454 339.045 259.579 340.013 259.579 340.013C259.579 340.013 253.696 341.337 248.664 345.211C243.631 349.086 241.292 354.496 241.292 354.496C241.292 354.496 239.072 359.789 238.599 363.687C238.126 367.609 238.268 371.224 238.268 371.224H236.095C236.095 371.224 235.882 365.246 236.473 360.356C236.992 355.512 238.835 349.866 238.835 349.866Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='bouche_gencive_haut'
              fill={syoUtils.colorFiller(lesionnel.bouche_gencive_haut)}
              d='M298.066 354.237C297.83 353.717 297.074 352.205 295.656 350.031C293.861 347.314 291.758 346.038 291.758 346.038L289.135 344.243C289.135 344.243 286.347 342.022 281.953 340.723C277.582 339.423 273.046 338.998 273.046 338.998C273.046 338.998 271.51 338.691 266.832 338.856C262.154 339.021 256.838 340.841 256.838 340.841C256.838 340.841 255.964 341.053 252.089 342.967C248.215 344.881 245.191 348.472 245.191 348.472L243.49 350.669C243.49 350.669 242.592 352.039 241.954 353.126C241.718 353.552 241.434 354.142 241.151 354.827C241.103 354.945 241.056 355.04 241.009 355.158L241.741 355.182C241.741 355.182 242.355 352.654 243.702 352.205C245.072 351.756 244.694 351.638 246.797 351.685C246.797 351.685 246.986 349.842 248.451 349.228C249.916 348.614 249.987 348.59 249.987 348.59C249.987 348.59 251.664 348.047 252.16 349.015C252.16 349.015 252.208 347.55 252.916 346.936C253.625 346.322 254.476 346.062 254.476 346.062L255.444 345.849C255.444 345.849 257.736 345.613 258.823 346.889C258.823 346.889 259.012 344.928 260.288 344.101C261.564 343.251 263.69 343.132 263.69 343.132L265.084 343.061H266.809C266.809 343.061 269.148 343.014 269.573 344.644C269.573 344.644 270.4 343.581 271.368 343.392C272.337 343.203 272.692 343.156 272.692 343.156L274.44 343.109L275.574 343.18L276.732 343.345L278.126 343.723C278.126 343.723 279.827 344.125 280.016 346.794C280.016 346.794 281.764 345.424 283.111 345.589C284.457 345.755 285.072 346.062 285.072 346.062C285.072 346.062 286.796 346.535 286.82 348.661C286.82 348.661 287.789 347.692 288.734 347.928C289.679 348.165 290.388 348.59 290.388 348.59L291.522 349.37C291.522 349.37 292.278 350.078 291.947 351.165L292.585 351.094H293.53C293.53 351.094 294.664 351.165 295.207 351.472C295.774 351.756 296.176 352.087 296.176 352.087C296.176 352.087 297.286 353.221 297.145 354.497L298.066 354.237Z'
              stroke='black'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
        <g id='mannequin_front_head_global'>
          <path
            id='trace_cou'
            d='M201.9 432.7C196.3 430 190.6 425.1 186 421.1C186 421.1 184.4 443.6 184.3 450.9C184.1 462.6 182.1 487.2 182.1 487.2L181.4 493.7L362.4 493.5C361.2 490.5 361.2 487.1 361.1 483.9C360.7 463 361 437.2 360.3 416.3C360.4 417.9 348.3 427.2 346.7 428.1C341.7 430.7 337.2 433.9 332 436C321.9 440.1 311.3 443.1 300.5 445.1C278.7 449 256.9 448.9 235.3 444.6C223 442 212.4 437.7 201.9 432.7Z'
            stroke='black'
            strokeWidth='3'
          />
          <path
            id='Trace_tete'
            d='M404.7 257.1C404.7 257.1 432.6 58.5999 272.7 60.3999C112.8 62.1999 136.5 252.9 136.5 252.9L153.8 362.2C153.8 362.2 163.9 447.9 272.1 448.8C380.3 449.7 386.7 359.7 386.7 359.7L404.7 257.1Z'
            stroke='black'
            strokeWidth='3'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g id='oeil_droit'>
            <path
              id='Vector'
              d='M183.3 227.9C183.3 227.9 208.9 197.5 238.6 227.9C238.6 227.9 209.5 247.2 183.3 227.9Z'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_2'
              d='M210.9 236.2C215.153 236.2 218.6 231.32 218.6 225.3C218.6 219.28 215.153 214.4 210.9 214.4C206.647 214.4 203.2 219.28 203.2 225.3C203.2 231.32 206.647 236.2 210.9 236.2Z'
              fill='black'
              stroke='black'
              strokeMiterlimit='10'
            />
          </g>
          <g id='oeil_gauche'>
            <path
              id='Vector_3'
              d='M356.8 227.7C356.8 227.7 331.2 197.3 301.5 227.7C301.5 227.7 330.6 247 356.8 227.7Z'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_4'
              d='M329.2 236.1C333.453 236.1 336.9 231.22 336.9 225.2C336.9 219.18 333.453 214.3 329.2 214.3C324.947 214.3 321.5 219.18 321.5 225.2C321.5 231.22 324.947 236.1 329.2 236.1Z'
              fill='black'
              stroke='black'
              strokeMiterlimit='10'
            />
          </g>
          <g id='sourcils'>
            <path
              id='Vector_5'
              d='M182.5 188.5C182.5 188.5 211.2 176.9 239.5 180.4'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_6'
              d='M357.8 188.5C357.8 188.5 329.1 176.9 300.8 180.4'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='nez_1_'>
            <path
              id='Vector_7'
              d='M253.1 269.8L247.6 280.4L242.1 288C242.1 288 234.2 299.9 243.6 307.3'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_8'
              d='M286.3 270.6L291.8 281.2L297.3 288.8C297.3 288.8 305.2 300.7 295.8 308.1'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_9'
              d='M250.4 299.9C250.4 299.9 254.1 303.4 262.2 302.9'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_10'
              d='M289.5 299.9C289.5 299.9 285.8 303.4 277.7 302.9'
              stroke='black'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='Bouche'>
            <path
              id='Vector_11'
              d='M236 370.657V362.755C236 362.755 236.903 354.552 238.808 349.751C240.714 344.949 243.723 340.648 243.723 340.648C243.723 340.648 246.932 336.147 250.543 333.546C254.154 330.945 256.962 329.945 256.962 329.945L258.567 329.545C258.567 329.545 260.874 328.844 263.381 329.144C265.889 329.445 269.098 329.945 269.098 329.945L271.405 329.445C271.405 329.445 276.721 328.444 279.93 329.445C283.24 330.445 284.243 330.845 284.243 330.845C284.243 330.845 287.452 332.546 288.556 333.446C289.659 334.346 293.069 337.847 293.069 337.847L296.178 341.648L298.285 345.349L299.789 348.65L301.494 353.352L302.497 358.153L302.999 361.854L303.4 366.856L303.5 370.957L303.099 374.458L301.293 382.761L299.789 388.763C299.789 388.763 297.683 395.765 294.774 399.866C291.866 403.967 288.957 406.568 288.957 406.568C288.957 406.568 285.146 410.269 279.128 412.17C273.11 414.07 267.694 413.47 267.694 413.47C267.694 413.47 260.372 413.77 253.351 408.869C246.331 403.967 241.918 394.864 241.918 394.864L239.009 386.862L236.903 379.06L236.201 375.659L236 370.657Z'
              stroke='#1F1E21'
              strokeMiterlimit='10'
            />
          </g>
        </g>
      </g>
    );
  }, [lesionnel]);
}

export function FrontV2HeadMouth({ lesionnel }: FrontV2HeadProps) {
  return useMemo(() => {
    return (
      <g id='mannequin_front_head_mouth_vector'>
        <path
          id='bouche_langue'
          fill={syoUtils.colorFiller(lesionnel.bouche_langue)}
          d='M160.4 325C160.4 325 164.4 305 193.5 298.2C222.7 291.4 226.6 291.8 243 292.6C259.4 293.4 283.7 298.6 283.7 298.6C283.7 298.6 302.9 292.2 316.8 292.2C316.8 292.2 334 290.4 347.1 292.2C360.3 294 373.6 293.8 388.4 304.7C403.2 315.6 404.9 328 404.9 328L396.1 348.1C396.1 348.1 391.7 349.4 386.8 353.2C386.8 353.2 384.4 356 384.5 358.8C384.5 358.8 376.4 362.8 375.4 374.1C375.4 374.1 354.2 374.2 357.2 387.7C357.2 387.7 344.6 380.6 340.8 393C340.8 393 320.4 387.7 317.1 399.5C317.1 399.5 316 395.5 310.3 395.9C304.6 396.3 287.9 397.1 287.9 397.1C287.9 397.1 284.3 397.2 284.4 403.9C284.4 403.9 285.2 397.8 280.4 397.6C275.6 397.5 255.8 396.4 255.8 396.4C255.8 396.4 251.9 396.1 251 399.9C251 399.9 251.1 395.9 245.5 394.7C239.9 393.5 236.6 393 236.6 393C236.6 393 229.4 391.9 226.6 394.5C226.6 394.5 226.5 389.4 220.1 386.8C220.1 386.8 215.2 384.7 210.1 389.1C210.1 389.1 213.8 374.9 193.1 376.6C193.1 376.6 189.1 364.8 185.6 363.7C185.6 363.7 183.6 361.6 182.3 358.8C181 356 174.8 351.7 174.8 351.7L171.1 350.4L160.4 325Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='bouche_palais'
          fill={syoUtils.colorFiller(lesionnel.bouche_palais)}
          d='M151 260.5C151 260.5 148.4 282.5 152 296.6C155.6 310.8 160.4 325 160.4 325C160.4 325 163.3 313.2 174.2 306.6C185.1 300 191.8 298.7 191.8 298.7L211.4 294.4C211.4 294.4 226.2 291.6 232.7 292.3L243.1 292.7L255.3 293.8L266.5 295.4L283.9 298.6L294 295.7L301.6 294L308.9 292.8L315.8 292.2L326.4 291.4L337.9 291.5L346.7 292.1L354.5 293L362.7 294.1L372.1 296.3C372.1 296.3 386.4 300.4 395 310.2C403.6 319.9 405.3 328.1 405.3 328.1C405.3 328.1 412 314.4 415.2 294.3C418.4 274.2 415.2 257 415.2 257C415.2 257 408.7 254.3 405.9 247.7C403.1 241 402.4 241.6 402.4 241.6C402.4 241.6 397.7 238 396.9 227.8C396.9 227.8 376.3 229.8 373.9 214C373.9 214 370.2 217 360.7 216.1C360.7 216.1 355.1 214.6 353.4 208.5C353.4 208.5 351.5 211.4 343.7 210.2L332.3 208C332.3 208 326.9 207.5 326.6 202.7C326.6 202.7 326.3 207 318.5 206.5C310.7 206 293.5 206.2 293.5 206.2L286.7 206C286.7 206 282.9 207.3 283.2 199.5C283.2 199.5 284.2 206.7 277.3 206.4L245.1 207.3C245.1 207.3 240.5 208 238.5 203.7C238.5 203.7 238.6 207.7 233.2 208.8L221 211.3C221 211.3 215.5 213 212.3 209.9C212.3 209.9 206.2 224.7 191.5 216C191.5 216 192.4 232.4 169.7 230.6C169.7 230.6 168.8 240.3 163.7 245.2C163.7 245.2 161 248 161.2 250.8C161.3 253.5 151 260.5 151 260.5Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='bouche_dents_bas'
          fill={syoUtils.colorFiller(lesionnel.bouche_dents_bas)}
          d='M272.4 416.1C272.4 416.1 290.6 418.9 310.5 414.1C330.4 409.3 333.9 406.1 333.9 406.1C333.9 406.1 350.7 398.1 359.3 391.9C367.9 385.7 379.9 373.3 379.9 373.3L393.9 353.7L396.4 348.1C396.4 348.1 385.4 351 384.8 358.7C384.8 358.7 376.5 362 375.7 374C375.7 374 354.5 373.9 357.5 387.6C357.5 387.6 344.9 380.5 341.1 392.9C341.1 392.9 320.8 387.4 317.4 399.4C317.4 399.4 316.1 395.5 310.6 395.8C305.1 396.1 289.8 396.9 289.8 396.9C289.8 396.9 284.5 396.2 284.8 403.8C284.8 403.8 285.9 397.4 280.2 397.5L260.5 396.6C260.5 396.6 252.6 394.4 251.4 399.8C251.4 399.8 251.7 395.9 247.1 394.9C242.5 393.9 235 392.7 235 392.7C235 392.7 230 391.8 227.1 394.4C227.1 394.4 223.4 380.3 210.6 388.9C210.6 388.9 211.8 383.6 208.6 380.1C205.4 376.6 199.7 376.3 199.7 376.3H193.6L190.7 369.3C190.7 369.3 188.3 363.8 186.1 363.4L183.6 360C183.6 360 182.6 357.6 180.7 355.9C178.8 354.2 175.3 351.4 175.3 351.4L171.6 350.1C171.6 350.1 176.7 359.8 183.5 367.9C190.3 376 200.9 385.7 200.9 385.7C200.9 385.7 219.3 398.5 222.8 400.3C226.3 402.2 238.8 408.9 245.3 410.8C251.8 412.7 254.7 413.5 254.7 413.5L272.4 416.1Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='bouche_levres_inferieures'
          fill={syoUtils.colorFiller(lesionnel.bouche_levres_inferieures)}
          d='M143.7 310.5C152.5 345 160.6 383.7 183.4 412.2C197.2 429.5 210.8 440.2 210.8 440.2C210.8 440.2 235.3 458.6 262.4 461.2C289.5 463.9 305.5 461.2 305.5 461.2C325.3 457.9 345.1 449.7 360.6 437C388.1 414.4 403.9 384.7 412.5 350.7C417.2 332 421 313 425 294.1V294L426.1 283.4H416.1C416.1 283.4 415 307.6 405 328.1L395.5 349.7C395.5 349.7 385.1 371 366.4 386.1C347.7 401.2 324.7 410.1 324.7 410.1C324.7 410.1 309 417.9 275.7 416.9C242.4 415.9 224.6 401.7 224.6 401.7L211.5 393.4C211.5 393.4 196.8 384.3 186.4 371.7C176 359.1 171.4 350.3 171.4 350.3L162.9 330.9L154.5 306.2L151 292.4L150 283.3H140.8C140.9 283.3 140.6 298.2 143.7 310.5Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='bouche_dents_haut'
          fill={syoUtils.colorFiller(lesionnel.bouche_dents_haut)}
          d='M403.5 211.3C403.7 211.8 403.9 212.1 403.9 212.1L408.5 225.4L411 233.3L413.2 246.5L414.9 256.9C414.9 256.9 408.3 255.2 403.9 243.7L402.2 241.5C402.2 241.5 398.7 241.6 396.7 227.7C396.7 227.7 375.4 229.1 373.7 213.9C373.7 213.9 357.6 222.2 353.3 208.4C353.3 208.4 351.3 210.9 346.7 210.4C342.1 210 333.5 208.4 333.5 208.4C333.5 208.4 327.9 208.7 326.6 202.6C326.6 202.6 326 205.8 321.6 206.3C317.3 206.8 309.9 206.1 309.9 206.1L289.5 206L285.4 205.9C285.4 205.9 283.2 205.8 283.2 199.4C283.2 199.4 283.6 205 279.9 205.9C276.3 206.8 260.5 206.7 260.5 206.7L245.1 207.1C245.1 207.1 240.5 207.7 238.5 203.5C238.5 203.5 238.4 206.2 235.7 207.7L220.9 211.1C220.9 211.1 214.8 212.8 212.2 209.7C212.2 209.7 209.7 214.9 205.8 217C205.8 217 199.4 220.9 191.4 215.8C191.4 215.8 191.5 223.5 185.6 227.2C179.7 230.9 174.5 230.5 174.5 230.5L169.6 230.4L167.8 237.9L166.1 241.7C166.1 241.7 161.6 246.9 161.4 248.7C161.1 250.5 161.3 251.4 160.1 252.7C158.9 254 150.6 260.5 150.6 260.5L151.8 249C151.8 249 154.6 235.4 157 228.4C158.4 224.4 160.1 219.5 161.9 215.1H162.5C162.5 215.1 164.6 214.6 165.1 215.6C165.1 215.6 166.4 205.5 174 202.4C181.6 199.3 186.4 200.5 186.4 200.5C186.4 200.5 187.3 193.6 191.9 191C196.5 188.3 199.4 187.1 203.7 186.9C208 186.6 209.2 189.2 209.2 189.2C209.2 189.2 208.8 180.5 216.8 177.5C224.8 174.4 229.4 176.2 229.4 176.2C229.4 176.2 235.3 176.7 237.5 180.2C237.5 180.2 238.1 169.6 247.5 166.4C256.9 163.2 266.1 164.2 266.1 164.2C266.1 164.2 280 161.9 282.9 170.6C282.9 170.6 286.2 165.3 294.7 164.5C303.2 163.7 309.3 164.5 309.3 164.5C309.3 164.5 321.4 165.6 323.9 169.8C326.4 174 326.9 176.8 327.3 179.7C327.3 179.7 334.3 173.6 341.9 174.7C349.5 175.8 353.1 179.4 353.1 179.4C353.1 179.4 355.9 182.2 356.1 187.7C356.1 187.7 360 183 365.9 185C371.8 187 376.3 191 376.3 191C376.3 191 378.9 193.7 377.7 198.3C377.7 198.3 399.2 194.4 399.7 212.3C399.7 212.3 403.2 211.2 404.2 212.1'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
        />
        <path
          id='bouche_levres_superieures'
          fill={syoUtils.colorFiller(lesionnel.bouche_levres_superieures)}
          d='M152.8 192.8C152.8 192.8 167.4 161.1 177.6 148.5C187.8 135.9 202.2 123.9 202.2 123.9C202.2 123.9 219.2 111.1 231.7 107.7C244.3 104.3 252.9 104.5 252.9 104.5C252.9 104.5 269.5 105.3 280.7 108.3C280.7 108.3 294.1 104.7 307.3 104.5C320.5 104.3 326.7 106.1 326.7 106.1C326.7 106.1 349.7 109.7 369 128.5C388.3 147.3 397.8 161.4 397.8 161.4C397.8 161.4 415 190.6 420.2 216.9C425.4 243.3 426.5 276.2 426.5 276.2V283.3H416.5C416.5 283.3 417 266.7 415.3 256.9C413.6 247.1 415.2 245 410.3 229.8C405.4 214.6 405.4 214.6 405.4 214.6C405.4 214.6 394.5 188.7 379.4 178.2C364.3 167.6 357.6 163.5 357.6 163.5C357.6 163.5 347.2 157.1 333.7 153.5C320.2 149.9 309.1 148.2 309.1 148.2C309.1 148.2 290.6 145 273.8 146C257 147 240.6 151.1 240.6 151.1C240.6 151.1 215.7 156.7 194.4 173.1C173.1 189.5 163.2 212.4 163.2 212.4C163.2 212.4 153.8 234.8 151.8 251.3C149.8 267.9 150.4 283.2 150.4 283.2H141.2C141.2 283.2 140.3 257.9 142.8 237.2C145 216.7 152.8 192.8 152.8 192.8Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='bouche_gencive_haut'
          fill={syoUtils.colorFiller(lesionnel.bouche_gencive_haut)}
          d='M403.5 211.3C402.5 209.1 399.3 202.7 393.3 193.5C385.7 182 376.8 176.6 376.8 176.6L365.7 169C365.7 169 353.9 159.6 335.3 154.1C316.8 148.6 297.6 146.8 297.6 146.8C297.6 146.8 291.1 145.5 271.3 146.2C251.5 146.9 229 154.6 229 154.6C229 154.6 225.3 155.5 208.9 163.6C192.5 171.7 179.7 186.9 179.7 186.9L172.5 196.2C172.5 196.2 168.7 202 166 206.6C165 208.4 163.8 210.9 162.6 213.8C162.4 214.3 162.2 214.7 162 215.2L165.1 215.3C165.1 215.3 167.7 204.6 173.4 202.7C179.2 200.8 177.6 200.3 186.5 200.5C186.5 200.5 187.3 192.7 193.5 190.1C199.7 187.5 200 187.4 200 187.4C200 187.4 207.1 185.1 209.2 189.2C209.2 189.2 209.4 183 212.4 180.4C215.4 177.8 219 176.7 219 176.7L223.1 175.8C223.1 175.8 232.8 174.8 237.4 180.2C237.4 180.2 238.2 171.9 243.6 168.4C249 164.8 258 164.3 258 164.3L263.9 164H271.2C271.2 164 281.1 163.8 282.9 170.7C282.9 170.7 286.4 166.2 290.5 165.4C294.6 164.6 296.1 164.4 296.1 164.4L303.5 164.2L308.3 164.5L313.2 165.2L319.1 166.8C319.1 166.8 326.3 168.5 327.1 179.8C327.1 179.8 334.5 174 340.2 174.7C345.9 175.4 348.5 176.7 348.5 176.7C348.5 176.7 355.8 178.7 355.9 187.7C355.9 187.7 360 183.6 364 184.6C368 185.6 371 187.4 371 187.4L375.8 190.7C375.8 190.7 379 193.7 377.6 198.3L380.3 198H384.3C384.3 198 389.1 198.3 391.4 199.6C393.8 200.8 395.5 202.2 395.5 202.2C395.5 202.2 400.2 207 399.6 212.4L403.5 211.3Z'
          stroke='black'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    );
  }, [lesionnel]);
}
